/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = "NHnr");
/******/ })
/************************************************************************/
/******/ ({

/***/ "+E39":
/***/ (function(module, exports, __webpack_require__) {

// Thank's IE8 for his funny defineProperty
module.exports = !__webpack_require__("S82l")(function () {
  return Object.defineProperty({}, 'a', { get: function () { return 7; } }).a != 7;
});


/***/ }),

/***/ "+W95":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "+ZMJ":
/***/ (function(module, exports, __webpack_require__) {

// optional / simple context binding
var aFunction = __webpack_require__("lOnJ");
module.exports = function (fn, that, length) {
  aFunction(fn);
  if (that === undefined) return fn;
  switch (length) {
    case 1: return function (a) {
      return fn.call(that, a);
    };
    case 2: return function (a, b) {
      return fn.call(that, a, b);
    };
    case 3: return function (a, b, c) {
      return fn.call(that, a, b, c);
    };
  }
  return function (/* ...args */) {
    return fn.apply(that, arguments);
  };
};


/***/ }),

/***/ "/YgI":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "/ocq":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/**
  * vue-router v3.0.1
  * (c) 2017 Evan You
  * @license MIT
  */
/*  */

function assert (condition, message) {
  if (!condition) {
    throw new Error(("[vue-router] " + message))
  }
}

function warn (condition, message) {
  if (false) {
    typeof console !== 'undefined' && console.warn(("[vue-router] " + message));
  }
}

function isError (err) {
  return Object.prototype.toString.call(err).indexOf('Error') > -1
}

var View = {
  name: 'router-view',
  functional: true,
  props: {
    name: {
      type: String,
      default: 'default'
    }
  },
  render: function render (_, ref) {
    var props = ref.props;
    var children = ref.children;
    var parent = ref.parent;
    var data = ref.data;

    data.routerView = true;

    // directly use parent context's createElement() function
    // so that components rendered by router-view can resolve named slots
    var h = parent.$createElement;
    var name = props.name;
    var route = parent.$route;
    var cache = parent._routerViewCache || (parent._routerViewCache = {});

    // determine current view depth, also check to see if the tree
    // has been toggled inactive but kept-alive.
    var depth = 0;
    var inactive = false;
    while (parent && parent._routerRoot !== parent) {
      if (parent.$vnode && parent.$vnode.data.routerView) {
        depth++;
      }
      if (parent._inactive) {
        inactive = true;
      }
      parent = parent.$parent;
    }
    data.routerViewDepth = depth;

    // render previous view if the tree is inactive and kept-alive
    if (inactive) {
      return h(cache[name], data, children)
    }

    var matched = route.matched[depth];
    // render empty node if no matched route
    if (!matched) {
      cache[name] = null;
      return h()
    }

    var component = cache[name] = matched.components[name];

    // attach instance registration hook
    // this will be called in the instance's injected lifecycle hooks
    data.registerRouteInstance = function (vm, val) {
      // val could be undefined for unregistration
      var current = matched.instances[name];
      if (
        (val && current !== vm) ||
        (!val && current === vm)
      ) {
        matched.instances[name] = val;
      }
    }

    // also register instance in prepatch hook
    // in case the same component instance is reused across different routes
    ;(data.hook || (data.hook = {})).prepatch = function (_, vnode) {
      matched.instances[name] = vnode.componentInstance;
    };

    // resolve props
    var propsToPass = data.props = resolveProps(route, matched.props && matched.props[name]);
    if (propsToPass) {
      // clone to prevent mutation
      propsToPass = data.props = extend({}, propsToPass);
      // pass non-declared props as attrs
      var attrs = data.attrs = data.attrs || {};
      for (var key in propsToPass) {
        if (!component.props || !(key in component.props)) {
          attrs[key] = propsToPass[key];
          delete propsToPass[key];
        }
      }
    }

    return h(component, data, children)
  }
};

function resolveProps (route, config) {
  switch (typeof config) {
    case 'undefined':
      return
    case 'object':
      return config
    case 'function':
      return config(route)
    case 'boolean':
      return config ? route.params : undefined
    default:
      if (false) {
        warn(
          false,
          "props in \"" + (route.path) + "\" is a " + (typeof config) + ", " +
          "expecting an object, function or boolean."
        );
      }
  }
}

function extend (to, from) {
  for (var key in from) {
    to[key] = from[key];
  }
  return to
}

/*  */

var encodeReserveRE = /[!'()*]/g;
var encodeReserveReplacer = function (c) { return '%' + c.charCodeAt(0).toString(16); };
var commaRE = /%2C/g;

// fixed encodeURIComponent which is more conformant to RFC3986:
// - escapes [!'()*]
// - preserve commas
var encode = function (str) { return encodeURIComponent(str)
  .replace(encodeReserveRE, encodeReserveReplacer)
  .replace(commaRE, ','); };

var decode = decodeURIComponent;

function resolveQuery (
  query,
  extraQuery,
  _parseQuery
) {
  if ( extraQuery === void 0 ) extraQuery = {};

  var parse = _parseQuery || parseQuery;
  var parsedQuery;
  try {
    parsedQuery = parse(query || '');
  } catch (e) {
    "production" !== 'production' && warn(false, e.message);
    parsedQuery = {};
  }
  for (var key in extraQuery) {
    parsedQuery[key] = extraQuery[key];
  }
  return parsedQuery
}

function parseQuery (query) {
  var res = {};

  query = query.trim().replace(/^(\?|#|&)/, '');

  if (!query) {
    return res
  }

  query.split('&').forEach(function (param) {
    var parts = param.replace(/\+/g, ' ').split('=');
    var key = decode(parts.shift());
    var val = parts.length > 0
      ? decode(parts.join('='))
      : null;

    if (res[key] === undefined) {
      res[key] = val;
    } else if (Array.isArray(res[key])) {
      res[key].push(val);
    } else {
      res[key] = [res[key], val];
    }
  });

  return res
}

function stringifyQuery (obj) {
  var res = obj ? Object.keys(obj).map(function (key) {
    var val = obj[key];

    if (val === undefined) {
      return ''
    }

    if (val === null) {
      return encode(key)
    }

    if (Array.isArray(val)) {
      var result = [];
      val.forEach(function (val2) {
        if (val2 === undefined) {
          return
        }
        if (val2 === null) {
          result.push(encode(key));
        } else {
          result.push(encode(key) + '=' + encode(val2));
        }
      });
      return result.join('&')
    }

    return encode(key) + '=' + encode(val)
  }).filter(function (x) { return x.length > 0; }).join('&') : null;
  return res ? ("?" + res) : ''
}

/*  */


var trailingSlashRE = /\/?$/;

function createRoute (
  record,
  location,
  redirectedFrom,
  router
) {
  var stringifyQuery$$1 = router && router.options.stringifyQuery;

  var query = location.query || {};
  try {
    query = clone(query);
  } catch (e) {}

  var route = {
    name: location.name || (record && record.name),
    meta: (record && record.meta) || {},
    path: location.path || '/',
    hash: location.hash || '',
    query: query,
    params: location.params || {},
    fullPath: getFullPath(location, stringifyQuery$$1),
    matched: record ? formatMatch(record) : []
  };
  if (redirectedFrom) {
    route.redirectedFrom = getFullPath(redirectedFrom, stringifyQuery$$1);
  }
  return Object.freeze(route)
}

function clone (value) {
  if (Array.isArray(value)) {
    return value.map(clone)
  } else if (value && typeof value === 'object') {
    var res = {};
    for (var key in value) {
      res[key] = clone(value[key]);
    }
    return res
  } else {
    return value
  }
}

// the starting route that represents the initial state
var START = createRoute(null, {
  path: '/'
});

function formatMatch (record) {
  var res = [];
  while (record) {
    res.unshift(record);
    record = record.parent;
  }
  return res
}

function getFullPath (
  ref,
  _stringifyQuery
) {
  var path = ref.path;
  var query = ref.query; if ( query === void 0 ) query = {};
  var hash = ref.hash; if ( hash === void 0 ) hash = '';

  var stringify = _stringifyQuery || stringifyQuery;
  return (path || '/') + stringify(query) + hash
}

function isSameRoute (a, b) {
  if (b === START) {
    return a === b
  } else if (!b) {
    return false
  } else if (a.path && b.path) {
    return (
      a.path.replace(trailingSlashRE, '') === b.path.replace(trailingSlashRE, '') &&
      a.hash === b.hash &&
      isObjectEqual(a.query, b.query)
    )
  } else if (a.name && b.name) {
    return (
      a.name === b.name &&
      a.hash === b.hash &&
      isObjectEqual(a.query, b.query) &&
      isObjectEqual(a.params, b.params)
    )
  } else {
    return false
  }
}

function isObjectEqual (a, b) {
  if ( a === void 0 ) a = {};
  if ( b === void 0 ) b = {};

  // handle null value #1566
  if (!a || !b) { return a === b }
  var aKeys = Object.keys(a);
  var bKeys = Object.keys(b);
  if (aKeys.length !== bKeys.length) {
    return false
  }
  return aKeys.every(function (key) {
    var aVal = a[key];
    var bVal = b[key];
    // check nested equality
    if (typeof aVal === 'object' && typeof bVal === 'object') {
      return isObjectEqual(aVal, bVal)
    }
    return String(aVal) === String(bVal)
  })
}

function isIncludedRoute (current, target) {
  return (
    current.path.replace(trailingSlashRE, '/').indexOf(
      target.path.replace(trailingSlashRE, '/')
    ) === 0 &&
    (!target.hash || current.hash === target.hash) &&
    queryIncludes(current.query, target.query)
  )
}

function queryIncludes (current, target) {
  for (var key in target) {
    if (!(key in current)) {
      return false
    }
  }
  return true
}

/*  */

// work around weird flow bug
var toTypes = [String, Object];
var eventTypes = [String, Array];

var Link = {
  name: 'router-link',
  props: {
    to: {
      type: toTypes,
      required: true
    },
    tag: {
      type: String,
      default: 'a'
    },
    exact: Boolean,
    append: Boolean,
    replace: Boolean,
    activeClass: String,
    exactActiveClass: String,
    event: {
      type: eventTypes,
      default: 'click'
    }
  },
  render: function render (h) {
    var this$1 = this;

    var router = this.$router;
    var current = this.$route;
    var ref = router.resolve(this.to, current, this.append);
    var location = ref.location;
    var route = ref.route;
    var href = ref.href;

    var classes = {};
    var globalActiveClass = router.options.linkActiveClass;
    var globalExactActiveClass = router.options.linkExactActiveClass;
    // Support global empty active class
    var activeClassFallback = globalActiveClass == null
            ? 'router-link-active'
            : globalActiveClass;
    var exactActiveClassFallback = globalExactActiveClass == null
            ? 'router-link-exact-active'
            : globalExactActiveClass;
    var activeClass = this.activeClass == null
            ? activeClassFallback
            : this.activeClass;
    var exactActiveClass = this.exactActiveClass == null
            ? exactActiveClassFallback
            : this.exactActiveClass;
    var compareTarget = location.path
      ? createRoute(null, location, null, router)
      : route;

    classes[exactActiveClass] = isSameRoute(current, compareTarget);
    classes[activeClass] = this.exact
      ? classes[exactActiveClass]
      : isIncludedRoute(current, compareTarget);

    var handler = function (e) {
      if (guardEvent(e)) {
        if (this$1.replace) {
          router.replace(location);
        } else {
          router.push(location);
        }
      }
    };

    var on = { click: guardEvent };
    if (Array.isArray(this.event)) {
      this.event.forEach(function (e) { on[e] = handler; });
    } else {
      on[this.event] = handler;
    }

    var data = {
      class: classes
    };

    if (this.tag === 'a') {
      data.on = on;
      data.attrs = { href: href };
    } else {
      // find the first <a> child and apply listener and href
      var a = findAnchor(this.$slots.default);
      if (a) {
        // in case the <a> is a static node
        a.isStatic = false;
        var extend = _Vue.util.extend;
        var aData = a.data = extend({}, a.data);
        aData.on = on;
        var aAttrs = a.data.attrs = extend({}, a.data.attrs);
        aAttrs.href = href;
      } else {
        // doesn't have <a> child, apply listener to self
        data.on = on;
      }
    }

    return h(this.tag, data, this.$slots.default)
  }
};

function guardEvent (e) {
  // don't redirect with control keys
  if (e.metaKey || e.altKey || e.ctrlKey || e.shiftKey) { return }
  // don't redirect when preventDefault called
  if (e.defaultPrevented) { return }
  // don't redirect on right click
  if (e.button !== undefined && e.button !== 0) { return }
  // don't redirect if `target="_blank"`
  if (e.currentTarget && e.currentTarget.getAttribute) {
    var target = e.currentTarget.getAttribute('target');
    if (/\b_blank\b/i.test(target)) { return }
  }
  // this may be a Weex event which doesn't have this method
  if (e.preventDefault) {
    e.preventDefault();
  }
  return true
}

function findAnchor (children) {
  if (children) {
    var child;
    for (var i = 0; i < children.length; i++) {
      child = children[i];
      if (child.tag === 'a') {
        return child
      }
      if (child.children && (child = findAnchor(child.children))) {
        return child
      }
    }
  }
}

var _Vue;

function install (Vue) {
  if (install.installed && _Vue === Vue) { return }
  install.installed = true;

  _Vue = Vue;

  var isDef = function (v) { return v !== undefined; };

  var registerInstance = function (vm, callVal) {
    var i = vm.$options._parentVnode;
    if (isDef(i) && isDef(i = i.data) && isDef(i = i.registerRouteInstance)) {
      i(vm, callVal);
    }
  };

  Vue.mixin({
    beforeCreate: function beforeCreate () {
      if (isDef(this.$options.router)) {
        this._routerRoot = this;
        this._router = this.$options.router;
        this._router.init(this);
        Vue.util.defineReactive(this, '_route', this._router.history.current);
      } else {
        this._routerRoot = (this.$parent && this.$parent._routerRoot) || this;
      }
      registerInstance(this, this);
    },
    destroyed: function destroyed () {
      registerInstance(this);
    }
  });

  Object.defineProperty(Vue.prototype, '$router', {
    get: function get () { return this._routerRoot._router }
  });

  Object.defineProperty(Vue.prototype, '$route', {
    get: function get () { return this._routerRoot._route }
  });

  Vue.component('router-view', View);
  Vue.component('router-link', Link);

  var strats = Vue.config.optionMergeStrategies;
  // use the same hook merging strategy for route hooks
  strats.beforeRouteEnter = strats.beforeRouteLeave = strats.beforeRouteUpdate = strats.created;
}

/*  */

var inBrowser = typeof window !== 'undefined';

/*  */

function resolvePath (
  relative,
  base,
  append
) {
  var firstChar = relative.charAt(0);
  if (firstChar === '/') {
    return relative
  }

  if (firstChar === '?' || firstChar === '#') {
    return base + relative
  }

  var stack = base.split('/');

  // remove trailing segment if:
  // - not appending
  // - appending to trailing slash (last segment is empty)
  if (!append || !stack[stack.length - 1]) {
    stack.pop();
  }

  // resolve relative path
  var segments = relative.replace(/^\//, '').split('/');
  for (var i = 0; i < segments.length; i++) {
    var segment = segments[i];
    if (segment === '..') {
      stack.pop();
    } else if (segment !== '.') {
      stack.push(segment);
    }
  }

  // ensure leading slash
  if (stack[0] !== '') {
    stack.unshift('');
  }

  return stack.join('/')
}

function parsePath (path) {
  var hash = '';
  var query = '';

  var hashIndex = path.indexOf('#');
  if (hashIndex >= 0) {
    hash = path.slice(hashIndex);
    path = path.slice(0, hashIndex);
  }

  var queryIndex = path.indexOf('?');
  if (queryIndex >= 0) {
    query = path.slice(queryIndex + 1);
    path = path.slice(0, queryIndex);
  }

  return {
    path: path,
    query: query,
    hash: hash
  }
}

function cleanPath (path) {
  return path.replace(/\/\//g, '/')
}

var isarray = Array.isArray || function (arr) {
  return Object.prototype.toString.call(arr) == '[object Array]';
};

/**
 * Expose `pathToRegexp`.
 */
var pathToRegexp_1 = pathToRegexp;
var parse_1 = parse;
var compile_1 = compile;
var tokensToFunction_1 = tokensToFunction;
var tokensToRegExp_1 = tokensToRegExp;

/**
 * The main path matching regexp utility.
 *
 * @type {RegExp}
 */
var PATH_REGEXP = new RegExp([
  // Match escaped characters that would otherwise appear in future matches.
  // This allows the user to escape special characters that won't transform.
  '(\\\\.)',
  // Match Express-style parameters and un-named parameters with a prefix
  // and optional suffixes. Matches appear as:
  //
  // "/:test(\\d+)?" => ["/", "test", "\d+", undefined, "?", undefined]
  // "/route(\\d+)"  => [undefined, undefined, undefined, "\d+", undefined, undefined]
  // "/*"            => ["/", undefined, undefined, undefined, undefined, "*"]
  '([\\/.])?(?:(?:\\:(\\w+)(?:\\(((?:\\\\.|[^\\\\()])+)\\))?|\\(((?:\\\\.|[^\\\\()])+)\\))([+*?])?|(\\*))'
].join('|'), 'g');

/**
 * Parse a string for the raw tokens.
 *
 * @param  {string}  str
 * @param  {Object=} options
 * @return {!Array}
 */
function parse (str, options) {
  var tokens = [];
  var key = 0;
  var index = 0;
  var path = '';
  var defaultDelimiter = options && options.delimiter || '/';
  var res;

  while ((res = PATH_REGEXP.exec(str)) != null) {
    var m = res[0];
    var escaped = res[1];
    var offset = res.index;
    path += str.slice(index, offset);
    index = offset + m.length;

    // Ignore already escaped sequences.
    if (escaped) {
      path += escaped[1];
      continue
    }

    var next = str[index];
    var prefix = res[2];
    var name = res[3];
    var capture = res[4];
    var group = res[5];
    var modifier = res[6];
    var asterisk = res[7];

    // Push the current path onto the tokens.
    if (path) {
      tokens.push(path);
      path = '';
    }

    var partial = prefix != null && next != null && next !== prefix;
    var repeat = modifier === '+' || modifier === '*';
    var optional = modifier === '?' || modifier === '*';
    var delimiter = res[2] || defaultDelimiter;
    var pattern = capture || group;

    tokens.push({
      name: name || key++,
      prefix: prefix || '',
      delimiter: delimiter,
      optional: optional,
      repeat: repeat,
      partial: partial,
      asterisk: !!asterisk,
      pattern: pattern ? escapeGroup(pattern) : (asterisk ? '.*' : '[^' + escapeString(delimiter) + ']+?')
    });
  }

  // Match any characters still remaining.
  if (index < str.length) {
    path += str.substr(index);
  }

  // If the path exists, push it onto the end.
  if (path) {
    tokens.push(path);
  }

  return tokens
}

/**
 * Compile a string to a template function for the path.
 *
 * @param  {string}             str
 * @param  {Object=}            options
 * @return {!function(Object=, Object=)}
 */
function compile (str, options) {
  return tokensToFunction(parse(str, options))
}

/**
 * Prettier encoding of URI path segments.
 *
 * @param  {string}
 * @return {string}
 */
function encodeURIComponentPretty (str) {
  return encodeURI(str).replace(/[\/?#]/g, function (c) {
    return '%' + c.charCodeAt(0).toString(16).toUpperCase()
  })
}

/**
 * Encode the asterisk parameter. Similar to `pretty`, but allows slashes.
 *
 * @param  {string}
 * @return {string}
 */
function encodeAsterisk (str) {
  return encodeURI(str).replace(/[?#]/g, function (c) {
    return '%' + c.charCodeAt(0).toString(16).toUpperCase()
  })
}

/**
 * Expose a method for transforming tokens into the path function.
 */
function tokensToFunction (tokens) {
  // Compile all the tokens into regexps.
  var matches = new Array(tokens.length);

  // Compile all the patterns before compilation.
  for (var i = 0; i < tokens.length; i++) {
    if (typeof tokens[i] === 'object') {
      matches[i] = new RegExp('^(?:' + tokens[i].pattern + ')$');
    }
  }

  return function (obj, opts) {
    var path = '';
    var data = obj || {};
    var options = opts || {};
    var encode = options.pretty ? encodeURIComponentPretty : encodeURIComponent;

    for (var i = 0; i < tokens.length; i++) {
      var token = tokens[i];

      if (typeof token === 'string') {
        path += token;

        continue
      }

      var value = data[token.name];
      var segment;

      if (value == null) {
        if (token.optional) {
          // Prepend partial segment prefixes.
          if (token.partial) {
            path += token.prefix;
          }

          continue
        } else {
          throw new TypeError('Expected "' + token.name + '" to be defined')
        }
      }

      if (isarray(value)) {
        if (!token.repeat) {
          throw new TypeError('Expected "' + token.name + '" to not repeat, but received `' + JSON.stringify(value) + '`')
        }

        if (value.length === 0) {
          if (token.optional) {
            continue
          } else {
            throw new TypeError('Expected "' + token.name + '" to not be empty')
          }
        }

        for (var j = 0; j < value.length; j++) {
          segment = encode(value[j]);

          if (!matches[i].test(segment)) {
            throw new TypeError('Expected all "' + token.name + '" to match "' + token.pattern + '", but received `' + JSON.stringify(segment) + '`')
          }

          path += (j === 0 ? token.prefix : token.delimiter) + segment;
        }

        continue
      }

      segment = token.asterisk ? encodeAsterisk(value) : encode(value);

      if (!matches[i].test(segment)) {
        throw new TypeError('Expected "' + token.name + '" to match "' + token.pattern + '", but received "' + segment + '"')
      }

      path += token.prefix + segment;
    }

    return path
  }
}

/**
 * Escape a regular expression string.
 *
 * @param  {string} str
 * @return {string}
 */
function escapeString (str) {
  return str.replace(/([.+*?=^!:${}()[\]|\/\\])/g, '\\$1')
}

/**
 * Escape the capturing group by escaping special characters and meaning.
 *
 * @param  {string} group
 * @return {string}
 */
function escapeGroup (group) {
  return group.replace(/([=!:$\/()])/g, '\\$1')
}

/**
 * Attach the keys as a property of the regexp.
 *
 * @param  {!RegExp} re
 * @param  {Array}   keys
 * @return {!RegExp}
 */
function attachKeys (re, keys) {
  re.keys = keys;
  return re
}

/**
 * Get the flags for a regexp from the options.
 *
 * @param  {Object} options
 * @return {string}
 */
function flags (options) {
  return options.sensitive ? '' : 'i'
}

/**
 * Pull out keys from a regexp.
 *
 * @param  {!RegExp} path
 * @param  {!Array}  keys
 * @return {!RegExp}
 */
function regexpToRegexp (path, keys) {
  // Use a negative lookahead to match only capturing groups.
  var groups = path.source.match(/\((?!\?)/g);

  if (groups) {
    for (var i = 0; i < groups.length; i++) {
      keys.push({
        name: i,
        prefix: null,
        delimiter: null,
        optional: false,
        repeat: false,
        partial: false,
        asterisk: false,
        pattern: null
      });
    }
  }

  return attachKeys(path, keys)
}

/**
 * Transform an array into a regexp.
 *
 * @param  {!Array}  path
 * @param  {Array}   keys
 * @param  {!Object} options
 * @return {!RegExp}
 */
function arrayToRegexp (path, keys, options) {
  var parts = [];

  for (var i = 0; i < path.length; i++) {
    parts.push(pathToRegexp(path[i], keys, options).source);
  }

  var regexp = new RegExp('(?:' + parts.join('|') + ')', flags(options));

  return attachKeys(regexp, keys)
}

/**
 * Create a path regexp from string input.
 *
 * @param  {string}  path
 * @param  {!Array}  keys
 * @param  {!Object} options
 * @return {!RegExp}
 */
function stringToRegexp (path, keys, options) {
  return tokensToRegExp(parse(path, options), keys, options)
}

/**
 * Expose a function for taking tokens and returning a RegExp.
 *
 * @param  {!Array}          tokens
 * @param  {(Array|Object)=} keys
 * @param  {Object=}         options
 * @return {!RegExp}
 */
function tokensToRegExp (tokens, keys, options) {
  if (!isarray(keys)) {
    options = /** @type {!Object} */ (keys || options);
    keys = [];
  }

  options = options || {};

  var strict = options.strict;
  var end = options.end !== false;
  var route = '';

  // Iterate over the tokens and create our regexp string.
  for (var i = 0; i < tokens.length; i++) {
    var token = tokens[i];

    if (typeof token === 'string') {
      route += escapeString(token);
    } else {
      var prefix = escapeString(token.prefix);
      var capture = '(?:' + token.pattern + ')';

      keys.push(token);

      if (token.repeat) {
        capture += '(?:' + prefix + capture + ')*';
      }

      if (token.optional) {
        if (!token.partial) {
          capture = '(?:' + prefix + '(' + capture + '))?';
        } else {
          capture = prefix + '(' + capture + ')?';
        }
      } else {
        capture = prefix + '(' + capture + ')';
      }

      route += capture;
    }
  }

  var delimiter = escapeString(options.delimiter || '/');
  var endsWithDelimiter = route.slice(-delimiter.length) === delimiter;

  // In non-strict mode we allow a slash at the end of match. If the path to
  // match already ends with a slash, we remove it for consistency. The slash
  // is valid at the end of a path match, not in the middle. This is important
  // in non-ending mode, where "/test/" shouldn't match "/test//route".
  if (!strict) {
    route = (endsWithDelimiter ? route.slice(0, -delimiter.length) : route) + '(?:' + delimiter + '(?=$))?';
  }

  if (end) {
    route += '$';
  } else {
    // In non-ending mode, we need the capturing groups to match as much as
    // possible by using a positive lookahead to the end or next path segment.
    route += strict && endsWithDelimiter ? '' : '(?=' + delimiter + '|$)';
  }

  return attachKeys(new RegExp('^' + route, flags(options)), keys)
}

/**
 * Normalize the given path string, returning a regular expression.
 *
 * An empty array can be passed in for the keys, which will hold the
 * placeholder key descriptions. For example, using `/user/:id`, `keys` will
 * contain `[{ name: 'id', delimiter: '/', optional: false, repeat: false }]`.
 *
 * @param  {(string|RegExp|Array)} path
 * @param  {(Array|Object)=}       keys
 * @param  {Object=}               options
 * @return {!RegExp}
 */
function pathToRegexp (path, keys, options) {
  if (!isarray(keys)) {
    options = /** @type {!Object} */ (keys || options);
    keys = [];
  }

  options = options || {};

  if (path instanceof RegExp) {
    return regexpToRegexp(path, /** @type {!Array} */ (keys))
  }

  if (isarray(path)) {
    return arrayToRegexp(/** @type {!Array} */ (path), /** @type {!Array} */ (keys), options)
  }

  return stringToRegexp(/** @type {string} */ (path), /** @type {!Array} */ (keys), options)
}

pathToRegexp_1.parse = parse_1;
pathToRegexp_1.compile = compile_1;
pathToRegexp_1.tokensToFunction = tokensToFunction_1;
pathToRegexp_1.tokensToRegExp = tokensToRegExp_1;

/*  */

// $flow-disable-line
var regexpCompileCache = Object.create(null);

function fillParams (
  path,
  params,
  routeMsg
) {
  try {
    var filler =
      regexpCompileCache[path] ||
      (regexpCompileCache[path] = pathToRegexp_1.compile(path));
    return filler(params || {}, { pretty: true })
  } catch (e) {
    if (false) {
      warn(false, ("missing param for " + routeMsg + ": " + (e.message)));
    }
    return ''
  }
}

/*  */

function createRouteMap (
  routes,
  oldPathList,
  oldPathMap,
  oldNameMap
) {
  // the path list is used to control path matching priority
  var pathList = oldPathList || [];
  // $flow-disable-line
  var pathMap = oldPathMap || Object.create(null);
  // $flow-disable-line
  var nameMap = oldNameMap || Object.create(null);

  routes.forEach(function (route) {
    addRouteRecord(pathList, pathMap, nameMap, route);
  });

  // ensure wildcard routes are always at the end
  for (var i = 0, l = pathList.length; i < l; i++) {
    if (pathList[i] === '*') {
      pathList.push(pathList.splice(i, 1)[0]);
      l--;
      i--;
    }
  }

  return {
    pathList: pathList,
    pathMap: pathMap,
    nameMap: nameMap
  }
}

function addRouteRecord (
  pathList,
  pathMap,
  nameMap,
  route,
  parent,
  matchAs
) {
  var path = route.path;
  var name = route.name;
  if (false) {
    assert(path != null, "\"path\" is required in a route configuration.");
    assert(
      typeof route.component !== 'string',
      "route config \"component\" for path: " + (String(path || name)) + " cannot be a " +
      "string id. Use an actual component instead."
    );
  }

  var pathToRegexpOptions = route.pathToRegexpOptions || {};
  var normalizedPath = normalizePath(
    path,
    parent,
    pathToRegexpOptions.strict
  );

  if (typeof route.caseSensitive === 'boolean') {
    pathToRegexpOptions.sensitive = route.caseSensitive;
  }

  var record = {
    path: normalizedPath,
    regex: compileRouteRegex(normalizedPath, pathToRegexpOptions),
    components: route.components || { default: route.component },
    instances: {},
    name: name,
    parent: parent,
    matchAs: matchAs,
    redirect: route.redirect,
    beforeEnter: route.beforeEnter,
    meta: route.meta || {},
    props: route.props == null
      ? {}
      : route.components
        ? route.props
        : { default: route.props }
  };

  if (route.children) {
    // Warn if route is named, does not redirect and has a default child route.
    // If users navigate to this route by name, the default child will
    // not be rendered (GH Issue #629)
    if (false) {
      if (route.name && !route.redirect && route.children.some(function (child) { return /^\/?$/.test(child.path); })) {
        warn(
          false,
          "Named Route '" + (route.name) + "' has a default child route. " +
          "When navigating to this named route (:to=\"{name: '" + (route.name) + "'\"), " +
          "the default child route will not be rendered. Remove the name from " +
          "this route and use the name of the default child route for named " +
          "links instead."
        );
      }
    }
    route.children.forEach(function (child) {
      var childMatchAs = matchAs
        ? cleanPath((matchAs + "/" + (child.path)))
        : undefined;
      addRouteRecord(pathList, pathMap, nameMap, child, record, childMatchAs);
    });
  }

  if (route.alias !== undefined) {
    var aliases = Array.isArray(route.alias)
      ? route.alias
      : [route.alias];

    aliases.forEach(function (alias) {
      var aliasRoute = {
        path: alias,
        children: route.children
      };
      addRouteRecord(
        pathList,
        pathMap,
        nameMap,
        aliasRoute,
        parent,
        record.path || '/' // matchAs
      );
    });
  }

  if (!pathMap[record.path]) {
    pathList.push(record.path);
    pathMap[record.path] = record;
  }

  if (name) {
    if (!nameMap[name]) {
      nameMap[name] = record;
    } else if (false) {
      warn(
        false,
        "Duplicate named routes definition: " +
        "{ name: \"" + name + "\", path: \"" + (record.path) + "\" }"
      );
    }
  }
}

function compileRouteRegex (path, pathToRegexpOptions) {
  var regex = pathToRegexp_1(path, [], pathToRegexpOptions);
  if (false) {
    var keys = Object.create(null);
    regex.keys.forEach(function (key) {
      warn(!keys[key.name], ("Duplicate param keys in route with path: \"" + path + "\""));
      keys[key.name] = true;
    });
  }
  return regex
}

function normalizePath (path, parent, strict) {
  if (!strict) { path = path.replace(/\/$/, ''); }
  if (path[0] === '/') { return path }
  if (parent == null) { return path }
  return cleanPath(((parent.path) + "/" + path))
}

/*  */


function normalizeLocation (
  raw,
  current,
  append,
  router
) {
  var next = typeof raw === 'string' ? { path: raw } : raw;
  // named target
  if (next.name || next._normalized) {
    return next
  }

  // relative params
  if (!next.path && next.params && current) {
    next = assign({}, next);
    next._normalized = true;
    var params = assign(assign({}, current.params), next.params);
    if (current.name) {
      next.name = current.name;
      next.params = params;
    } else if (current.matched.length) {
      var rawPath = current.matched[current.matched.length - 1].path;
      next.path = fillParams(rawPath, params, ("path " + (current.path)));
    } else if (false) {
      warn(false, "relative params navigation requires a current route.");
    }
    return next
  }

  var parsedPath = parsePath(next.path || '');
  var basePath = (current && current.path) || '/';
  var path = parsedPath.path
    ? resolvePath(parsedPath.path, basePath, append || next.append)
    : basePath;

  var query = resolveQuery(
    parsedPath.query,
    next.query,
    router && router.options.parseQuery
  );

  var hash = next.hash || parsedPath.hash;
  if (hash && hash.charAt(0) !== '#') {
    hash = "#" + hash;
  }

  return {
    _normalized: true,
    path: path,
    query: query,
    hash: hash
  }
}

function assign (a, b) {
  for (var key in b) {
    a[key] = b[key];
  }
  return a
}

/*  */


function createMatcher (
  routes,
  router
) {
  var ref = createRouteMap(routes);
  var pathList = ref.pathList;
  var pathMap = ref.pathMap;
  var nameMap = ref.nameMap;

  function addRoutes (routes) {
    createRouteMap(routes, pathList, pathMap, nameMap);
  }

  function match (
    raw,
    currentRoute,
    redirectedFrom
  ) {
    var location = normalizeLocation(raw, currentRoute, false, router);
    var name = location.name;

    if (name) {
      var record = nameMap[name];
      if (false) {
        warn(record, ("Route with name '" + name + "' does not exist"));
      }
      if (!record) { return _createRoute(null, location) }
      var paramNames = record.regex.keys
        .filter(function (key) { return !key.optional; })
        .map(function (key) { return key.name; });

      if (typeof location.params !== 'object') {
        location.params = {};
      }

      if (currentRoute && typeof currentRoute.params === 'object') {
        for (var key in currentRoute.params) {
          if (!(key in location.params) && paramNames.indexOf(key) > -1) {
            location.params[key] = currentRoute.params[key];
          }
        }
      }

      if (record) {
        location.path = fillParams(record.path, location.params, ("named route \"" + name + "\""));
        return _createRoute(record, location, redirectedFrom)
      }
    } else if (location.path) {
      location.params = {};
      for (var i = 0; i < pathList.length; i++) {
        var path = pathList[i];
        var record$1 = pathMap[path];
        if (matchRoute(record$1.regex, location.path, location.params)) {
          return _createRoute(record$1, location, redirectedFrom)
        }
      }
    }
    // no match
    return _createRoute(null, location)
  }

  function redirect (
    record,
    location
  ) {
    var originalRedirect = record.redirect;
    var redirect = typeof originalRedirect === 'function'
        ? originalRedirect(createRoute(record, location, null, router))
        : originalRedirect;

    if (typeof redirect === 'string') {
      redirect = { path: redirect };
    }

    if (!redirect || typeof redirect !== 'object') {
      if (false) {
        warn(
          false, ("invalid redirect option: " + (JSON.stringify(redirect)))
        );
      }
      return _createRoute(null, location)
    }

    var re = redirect;
    var name = re.name;
    var path = re.path;
    var query = location.query;
    var hash = location.hash;
    var params = location.params;
    query = re.hasOwnProperty('query') ? re.query : query;
    hash = re.hasOwnProperty('hash') ? re.hash : hash;
    params = re.hasOwnProperty('params') ? re.params : params;

    if (name) {
      // resolved named direct
      var targetRecord = nameMap[name];
      if (false) {
        assert(targetRecord, ("redirect failed: named route \"" + name + "\" not found."));
      }
      return match({
        _normalized: true,
        name: name,
        query: query,
        hash: hash,
        params: params
      }, undefined, location)
    } else if (path) {
      // 1. resolve relative redirect
      var rawPath = resolveRecordPath(path, record);
      // 2. resolve params
      var resolvedPath = fillParams(rawPath, params, ("redirect route with path \"" + rawPath + "\""));
      // 3. rematch with existing query and hash
      return match({
        _normalized: true,
        path: resolvedPath,
        query: query,
        hash: hash
      }, undefined, location)
    } else {
      if (false) {
        warn(false, ("invalid redirect option: " + (JSON.stringify(redirect))));
      }
      return _createRoute(null, location)
    }
  }

  function alias (
    record,
    location,
    matchAs
  ) {
    var aliasedPath = fillParams(matchAs, location.params, ("aliased route with path \"" + matchAs + "\""));
    var aliasedMatch = match({
      _normalized: true,
      path: aliasedPath
    });
    if (aliasedMatch) {
      var matched = aliasedMatch.matched;
      var aliasedRecord = matched[matched.length - 1];
      location.params = aliasedMatch.params;
      return _createRoute(aliasedRecord, location)
    }
    return _createRoute(null, location)
  }

  function _createRoute (
    record,
    location,
    redirectedFrom
  ) {
    if (record && record.redirect) {
      return redirect(record, redirectedFrom || location)
    }
    if (record && record.matchAs) {
      return alias(record, location, record.matchAs)
    }
    return createRoute(record, location, redirectedFrom, router)
  }

  return {
    match: match,
    addRoutes: addRoutes
  }
}

function matchRoute (
  regex,
  path,
  params
) {
  var m = path.match(regex);

  if (!m) {
    return false
  } else if (!params) {
    return true
  }

  for (var i = 1, len = m.length; i < len; ++i) {
    var key = regex.keys[i - 1];
    var val = typeof m[i] === 'string' ? decodeURIComponent(m[i]) : m[i];
    if (key) {
      params[key.name] = val;
    }
  }

  return true
}

function resolveRecordPath (path, record) {
  return resolvePath(path, record.parent ? record.parent.path : '/', true)
}

/*  */


var positionStore = Object.create(null);

function setupScroll () {
  // Fix for #1585 for Firefox
  window.history.replaceState({ key: getStateKey() }, '');
  window.addEventListener('popstate', function (e) {
    saveScrollPosition();
    if (e.state && e.state.key) {
      setStateKey(e.state.key);
    }
  });
}

function handleScroll (
  router,
  to,
  from,
  isPop
) {
  if (!router.app) {
    return
  }

  var behavior = router.options.scrollBehavior;
  if (!behavior) {
    return
  }

  if (false) {
    assert(typeof behavior === 'function', "scrollBehavior must be a function");
  }

  // wait until re-render finishes before scrolling
  router.app.$nextTick(function () {
    var position = getScrollPosition();
    var shouldScroll = behavior(to, from, isPop ? position : null);

    if (!shouldScroll) {
      return
    }

    if (typeof shouldScroll.then === 'function') {
      shouldScroll.then(function (shouldScroll) {
        scrollToPosition((shouldScroll), position);
      }).catch(function (err) {
        if (false) {
          assert(false, err.toString());
        }
      });
    } else {
      scrollToPosition(shouldScroll, position);
    }
  });
}

function saveScrollPosition () {
  var key = getStateKey();
  if (key) {
    positionStore[key] = {
      x: window.pageXOffset,
      y: window.pageYOffset
    };
  }
}

function getScrollPosition () {
  var key = getStateKey();
  if (key) {
    return positionStore[key]
  }
}

function getElementPosition (el, offset) {
  var docEl = document.documentElement;
  var docRect = docEl.getBoundingClientRect();
  var elRect = el.getBoundingClientRect();
  return {
    x: elRect.left - docRect.left - offset.x,
    y: elRect.top - docRect.top - offset.y
  }
}

function isValidPosition (obj) {
  return isNumber(obj.x) || isNumber(obj.y)
}

function normalizePosition (obj) {
  return {
    x: isNumber(obj.x) ? obj.x : window.pageXOffset,
    y: isNumber(obj.y) ? obj.y : window.pageYOffset
  }
}

function normalizeOffset (obj) {
  return {
    x: isNumber(obj.x) ? obj.x : 0,
    y: isNumber(obj.y) ? obj.y : 0
  }
}

function isNumber (v) {
  return typeof v === 'number'
}

function scrollToPosition (shouldScroll, position) {
  var isObject = typeof shouldScroll === 'object';
  if (isObject && typeof shouldScroll.selector === 'string') {
    var el = document.querySelector(shouldScroll.selector);
    if (el) {
      var offset = shouldScroll.offset && typeof shouldScroll.offset === 'object' ? shouldScroll.offset : {};
      offset = normalizeOffset(offset);
      position = getElementPosition(el, offset);
    } else if (isValidPosition(shouldScroll)) {
      position = normalizePosition(shouldScroll);
    }
  } else if (isObject && isValidPosition(shouldScroll)) {
    position = normalizePosition(shouldScroll);
  }

  if (position) {
    window.scrollTo(position.x, position.y);
  }
}

/*  */

var supportsPushState = inBrowser && (function () {
  var ua = window.navigator.userAgent;

  if (
    (ua.indexOf('Android 2.') !== -1 || ua.indexOf('Android 4.0') !== -1) &&
    ua.indexOf('Mobile Safari') !== -1 &&
    ua.indexOf('Chrome') === -1 &&
    ua.indexOf('Windows Phone') === -1
  ) {
    return false
  }

  return window.history && 'pushState' in window.history
})();

// use User Timing api (if present) for more accurate key precision
var Time = inBrowser && window.performance && window.performance.now
  ? window.performance
  : Date;

var _key = genKey();

function genKey () {
  return Time.now().toFixed(3)
}

function getStateKey () {
  return _key
}

function setStateKey (key) {
  _key = key;
}

function pushState (url, replace) {
  saveScrollPosition();
  // try...catch the pushState call to get around Safari
  // DOM Exception 18 where it limits to 100 pushState calls
  var history = window.history;
  try {
    if (replace) {
      history.replaceState({ key: _key }, '', url);
    } else {
      _key = genKey();
      history.pushState({ key: _key }, '', url);
    }
  } catch (e) {
    window.location[replace ? 'replace' : 'assign'](url);
  }
}

function replaceState (url) {
  pushState(url, true);
}

/*  */

function runQueue (queue, fn, cb) {
  var step = function (index) {
    if (index >= queue.length) {
      cb();
    } else {
      if (queue[index]) {
        fn(queue[index], function () {
          step(index + 1);
        });
      } else {
        step(index + 1);
      }
    }
  };
  step(0);
}

/*  */

function resolveAsyncComponents (matched) {
  return function (to, from, next) {
    var hasAsync = false;
    var pending = 0;
    var error = null;

    flatMapComponents(matched, function (def, _, match, key) {
      // if it's a function and doesn't have cid attached,
      // assume it's an async component resolve function.
      // we are not using Vue's default async resolving mechanism because
      // we want to halt the navigation until the incoming component has been
      // resolved.
      if (typeof def === 'function' && def.cid === undefined) {
        hasAsync = true;
        pending++;

        var resolve = once(function (resolvedDef) {
          if (isESModule(resolvedDef)) {
            resolvedDef = resolvedDef.default;
          }
          // save resolved on async factory in case it's used elsewhere
          def.resolved = typeof resolvedDef === 'function'
            ? resolvedDef
            : _Vue.extend(resolvedDef);
          match.components[key] = resolvedDef;
          pending--;
          if (pending <= 0) {
            next();
          }
        });

        var reject = once(function (reason) {
          var msg = "Failed to resolve async component " + key + ": " + reason;
          "production" !== 'production' && warn(false, msg);
          if (!error) {
            error = isError(reason)
              ? reason
              : new Error(msg);
            next(error);
          }
        });

        var res;
        try {
          res = def(resolve, reject);
        } catch (e) {
          reject(e);
        }
        if (res) {
          if (typeof res.then === 'function') {
            res.then(resolve, reject);
          } else {
            // new syntax in Vue 2.3
            var comp = res.component;
            if (comp && typeof comp.then === 'function') {
              comp.then(resolve, reject);
            }
          }
        }
      }
    });

    if (!hasAsync) { next(); }
  }
}

function flatMapComponents (
  matched,
  fn
) {
  return flatten(matched.map(function (m) {
    return Object.keys(m.components).map(function (key) { return fn(
      m.components[key],
      m.instances[key],
      m, key
    ); })
  }))
}

function flatten (arr) {
  return Array.prototype.concat.apply([], arr)
}

var hasSymbol =
  typeof Symbol === 'function' &&
  typeof Symbol.toStringTag === 'symbol';

function isESModule (obj) {
  return obj.__esModule || (hasSymbol && obj[Symbol.toStringTag] === 'Module')
}

// in Webpack 2, require.ensure now also returns a Promise
// so the resolve/reject functions may get called an extra time
// if the user uses an arrow function shorthand that happens to
// return that Promise.
function once (fn) {
  var called = false;
  return function () {
    var args = [], len = arguments.length;
    while ( len-- ) args[ len ] = arguments[ len ];

    if (called) { return }
    called = true;
    return fn.apply(this, args)
  }
}

/*  */

var History = function History (router, base) {
  this.router = router;
  this.base = normalizeBase(base);
  // start with a route object that stands for "nowhere"
  this.current = START;
  this.pending = null;
  this.ready = false;
  this.readyCbs = [];
  this.readyErrorCbs = [];
  this.errorCbs = [];
};

History.prototype.listen = function listen (cb) {
  this.cb = cb;
};

History.prototype.onReady = function onReady (cb, errorCb) {
  if (this.ready) {
    cb();
  } else {
    this.readyCbs.push(cb);
    if (errorCb) {
      this.readyErrorCbs.push(errorCb);
    }
  }
};

History.prototype.onError = function onError (errorCb) {
  this.errorCbs.push(errorCb);
};

History.prototype.transitionTo = function transitionTo (location, onComplete, onAbort) {
    var this$1 = this;

  var route = this.router.match(location, this.current);
  this.confirmTransition(route, function () {
    this$1.updateRoute(route);
    onComplete && onComplete(route);
    this$1.ensureURL();

    // fire ready cbs once
    if (!this$1.ready) {
      this$1.ready = true;
      this$1.readyCbs.forEach(function (cb) { cb(route); });
    }
  }, function (err) {
    if (onAbort) {
      onAbort(err);
    }
    if (err && !this$1.ready) {
      this$1.ready = true;
      this$1.readyErrorCbs.forEach(function (cb) { cb(err); });
    }
  });
};

History.prototype.confirmTransition = function confirmTransition (route, onComplete, onAbort) {
    var this$1 = this;

  var current = this.current;
  var abort = function (err) {
    if (isError(err)) {
      if (this$1.errorCbs.length) {
        this$1.errorCbs.forEach(function (cb) { cb(err); });
      } else {
        warn(false, 'uncaught error during route navigation:');
        console.error(err);
      }
    }
    onAbort && onAbort(err);
  };
  if (
    isSameRoute(route, current) &&
    // in the case the route map has been dynamically appended to
    route.matched.length === current.matched.length
  ) {
    this.ensureURL();
    return abort()
  }

  var ref = resolveQueue(this.current.matched, route.matched);
    var updated = ref.updated;
    var deactivated = ref.deactivated;
    var activated = ref.activated;

  var queue = [].concat(
    // in-component leave guards
    extractLeaveGuards(deactivated),
    // global before hooks
    this.router.beforeHooks,
    // in-component update hooks
    extractUpdateHooks(updated),
    // in-config enter guards
    activated.map(function (m) { return m.beforeEnter; }),
    // async components
    resolveAsyncComponents(activated)
  );

  this.pending = route;
  var iterator = function (hook, next) {
    if (this$1.pending !== route) {
      return abort()
    }
    try {
      hook(route, current, function (to) {
        if (to === false || isError(to)) {
          // next(false) -> abort navigation, ensure current URL
          this$1.ensureURL(true);
          abort(to);
        } else if (
          typeof to === 'string' ||
          (typeof to === 'object' && (
            typeof to.path === 'string' ||
            typeof to.name === 'string'
          ))
        ) {
          // next('/') or next({ path: '/' }) -> redirect
          abort();
          if (typeof to === 'object' && to.replace) {
            this$1.replace(to);
          } else {
            this$1.push(to);
          }
        } else {
          // confirm transition and pass on the value
          next(to);
        }
      });
    } catch (e) {
      abort(e);
    }
  };

  runQueue(queue, iterator, function () {
    var postEnterCbs = [];
    var isValid = function () { return this$1.current === route; };
    // wait until async components are resolved before
    // extracting in-component enter guards
    var enterGuards = extractEnterGuards(activated, postEnterCbs, isValid);
    var queue = enterGuards.concat(this$1.router.resolveHooks);
    runQueue(queue, iterator, function () {
      if (this$1.pending !== route) {
        return abort()
      }
      this$1.pending = null;
      onComplete(route);
      if (this$1.router.app) {
        this$1.router.app.$nextTick(function () {
          postEnterCbs.forEach(function (cb) { cb(); });
        });
      }
    });
  });
};

History.prototype.updateRoute = function updateRoute (route) {
  var prev = this.current;
  this.current = route;
  this.cb && this.cb(route);
  this.router.afterHooks.forEach(function (hook) {
    hook && hook(route, prev);
  });
};

function normalizeBase (base) {
  if (!base) {
    if (inBrowser) {
      // respect <base> tag
      var baseEl = document.querySelector('base');
      base = (baseEl && baseEl.getAttribute('href')) || '/';
      // strip full URL origin
      base = base.replace(/^https?:\/\/[^\/]+/, '');
    } else {
      base = '/';
    }
  }
  // make sure there's the starting slash
  if (base.charAt(0) !== '/') {
    base = '/' + base;
  }
  // remove trailing slash
  return base.replace(/\/$/, '')
}

function resolveQueue (
  current,
  next
) {
  var i;
  var max = Math.max(current.length, next.length);
  for (i = 0; i < max; i++) {
    if (current[i] !== next[i]) {
      break
    }
  }
  return {
    updated: next.slice(0, i),
    activated: next.slice(i),
    deactivated: current.slice(i)
  }
}

function extractGuards (
  records,
  name,
  bind,
  reverse
) {
  var guards = flatMapComponents(records, function (def, instance, match, key) {
    var guard = extractGuard(def, name);
    if (guard) {
      return Array.isArray(guard)
        ? guard.map(function (guard) { return bind(guard, instance, match, key); })
        : bind(guard, instance, match, key)
    }
  });
  return flatten(reverse ? guards.reverse() : guards)
}

function extractGuard (
  def,
  key
) {
  if (typeof def !== 'function') {
    // extend now so that global mixins are applied.
    def = _Vue.extend(def);
  }
  return def.options[key]
}

function extractLeaveGuards (deactivated) {
  return extractGuards(deactivated, 'beforeRouteLeave', bindGuard, true)
}

function extractUpdateHooks (updated) {
  return extractGuards(updated, 'beforeRouteUpdate', bindGuard)
}

function bindGuard (guard, instance) {
  if (instance) {
    return function boundRouteGuard () {
      return guard.apply(instance, arguments)
    }
  }
}

function extractEnterGuards (
  activated,
  cbs,
  isValid
) {
  return extractGuards(activated, 'beforeRouteEnter', function (guard, _, match, key) {
    return bindEnterGuard(guard, match, key, cbs, isValid)
  })
}

function bindEnterGuard (
  guard,
  match,
  key,
  cbs,
  isValid
) {
  return function routeEnterGuard (to, from, next) {
    return guard(to, from, function (cb) {
      next(cb);
      if (typeof cb === 'function') {
        cbs.push(function () {
          // #750
          // if a router-view is wrapped with an out-in transition,
          // the instance may not have been registered at this time.
          // we will need to poll for registration until current route
          // is no longer valid.
          poll(cb, match.instances, key, isValid);
        });
      }
    })
  }
}

function poll (
  cb, // somehow flow cannot infer this is a function
  instances,
  key,
  isValid
) {
  if (instances[key]) {
    cb(instances[key]);
  } else if (isValid()) {
    setTimeout(function () {
      poll(cb, instances, key, isValid);
    }, 16);
  }
}

/*  */


var HTML5History = (function (History$$1) {
  function HTML5History (router, base) {
    var this$1 = this;

    History$$1.call(this, router, base);

    var expectScroll = router.options.scrollBehavior;

    if (expectScroll) {
      setupScroll();
    }

    var initLocation = getLocation(this.base);
    window.addEventListener('popstate', function (e) {
      var current = this$1.current;

      // Avoiding first `popstate` event dispatched in some browsers but first
      // history route not updated since async guard at the same time.
      var location = getLocation(this$1.base);
      if (this$1.current === START && location === initLocation) {
        return
      }

      this$1.transitionTo(location, function (route) {
        if (expectScroll) {
          handleScroll(router, route, current, true);
        }
      });
    });
  }

  if ( History$$1 ) HTML5History.__proto__ = History$$1;
  HTML5History.prototype = Object.create( History$$1 && History$$1.prototype );
  HTML5History.prototype.constructor = HTML5History;

  HTML5History.prototype.go = function go (n) {
    window.history.go(n);
  };

  HTML5History.prototype.push = function push (location, onComplete, onAbort) {
    var this$1 = this;

    var ref = this;
    var fromRoute = ref.current;
    this.transitionTo(location, function (route) {
      pushState(cleanPath(this$1.base + route.fullPath));
      handleScroll(this$1.router, route, fromRoute, false);
      onComplete && onComplete(route);
    }, onAbort);
  };

  HTML5History.prototype.replace = function replace (location, onComplete, onAbort) {
    var this$1 = this;

    var ref = this;
    var fromRoute = ref.current;
    this.transitionTo(location, function (route) {
      replaceState(cleanPath(this$1.base + route.fullPath));
      handleScroll(this$1.router, route, fromRoute, false);
      onComplete && onComplete(route);
    }, onAbort);
  };

  HTML5History.prototype.ensureURL = function ensureURL (push) {
    if (getLocation(this.base) !== this.current.fullPath) {
      var current = cleanPath(this.base + this.current.fullPath);
      push ? pushState(current) : replaceState(current);
    }
  };

  HTML5History.prototype.getCurrentLocation = function getCurrentLocation () {
    return getLocation(this.base)
  };

  return HTML5History;
}(History));

function getLocation (base) {
  var path = window.location.pathname;
  if (base && path.indexOf(base) === 0) {
    path = path.slice(base.length);
  }
  return (path || '/') + window.location.search + window.location.hash
}

/*  */


var HashHistory = (function (History$$1) {
  function HashHistory (router, base, fallback) {
    History$$1.call(this, router, base);
    // check history fallback deeplinking
    if (fallback && checkFallback(this.base)) {
      return
    }
    ensureSlash();
  }

  if ( History$$1 ) HashHistory.__proto__ = History$$1;
  HashHistory.prototype = Object.create( History$$1 && History$$1.prototype );
  HashHistory.prototype.constructor = HashHistory;

  // this is delayed until the app mounts
  // to avoid the hashchange listener being fired too early
  HashHistory.prototype.setupListeners = function setupListeners () {
    var this$1 = this;

    var router = this.router;
    var expectScroll = router.options.scrollBehavior;
    var supportsScroll = supportsPushState && expectScroll;

    if (supportsScroll) {
      setupScroll();
    }

    window.addEventListener(supportsPushState ? 'popstate' : 'hashchange', function () {
      var current = this$1.current;
      if (!ensureSlash()) {
        return
      }
      this$1.transitionTo(getHash(), function (route) {
        if (supportsScroll) {
          handleScroll(this$1.router, route, current, true);
        }
        if (!supportsPushState) {
          replaceHash(route.fullPath);
        }
      });
    });
  };

  HashHistory.prototype.push = function push (location, onComplete, onAbort) {
    var this$1 = this;

    var ref = this;
    var fromRoute = ref.current;
    this.transitionTo(location, function (route) {
      pushHash(route.fullPath);
      handleScroll(this$1.router, route, fromRoute, false);
      onComplete && onComplete(route);
    }, onAbort);
  };

  HashHistory.prototype.replace = function replace (location, onComplete, onAbort) {
    var this$1 = this;

    var ref = this;
    var fromRoute = ref.current;
    this.transitionTo(location, function (route) {
      replaceHash(route.fullPath);
      handleScroll(this$1.router, route, fromRoute, false);
      onComplete && onComplete(route);
    }, onAbort);
  };

  HashHistory.prototype.go = function go (n) {
    window.history.go(n);
  };

  HashHistory.prototype.ensureURL = function ensureURL (push) {
    var current = this.current.fullPath;
    if (getHash() !== current) {
      push ? pushHash(current) : replaceHash(current);
    }
  };

  HashHistory.prototype.getCurrentLocation = function getCurrentLocation () {
    return getHash()
  };

  return HashHistory;
}(History));

function checkFallback (base) {
  var location = getLocation(base);
  if (!/^\/#/.test(location)) {
    window.location.replace(
      cleanPath(base + '/#' + location)
    );
    return true
  }
}

function ensureSlash () {
  var path = getHash();
  if (path.charAt(0) === '/') {
    return true
  }
  replaceHash('/' + path);
  return false
}

function getHash () {
  // We can't use window.location.hash here because it's not
  // consistent across browsers - Firefox will pre-decode it!
  var href = window.location.href;
  var index = href.indexOf('#');
  return index === -1 ? '' : href.slice(index + 1)
}

function getUrl (path) {
  var href = window.location.href;
  var i = href.indexOf('#');
  var base = i >= 0 ? href.slice(0, i) : href;
  return (base + "#" + path)
}

function pushHash (path) {
  if (supportsPushState) {
    pushState(getUrl(path));
  } else {
    window.location.hash = path;
  }
}

function replaceHash (path) {
  if (supportsPushState) {
    replaceState(getUrl(path));
  } else {
    window.location.replace(getUrl(path));
  }
}

/*  */


var AbstractHistory = (function (History$$1) {
  function AbstractHistory (router, base) {
    History$$1.call(this, router, base);
    this.stack = [];
    this.index = -1;
  }

  if ( History$$1 ) AbstractHistory.__proto__ = History$$1;
  AbstractHistory.prototype = Object.create( History$$1 && History$$1.prototype );
  AbstractHistory.prototype.constructor = AbstractHistory;

  AbstractHistory.prototype.push = function push (location, onComplete, onAbort) {
    var this$1 = this;

    this.transitionTo(location, function (route) {
      this$1.stack = this$1.stack.slice(0, this$1.index + 1).concat(route);
      this$1.index++;
      onComplete && onComplete(route);
    }, onAbort);
  };

  AbstractHistory.prototype.replace = function replace (location, onComplete, onAbort) {
    var this$1 = this;

    this.transitionTo(location, function (route) {
      this$1.stack = this$1.stack.slice(0, this$1.index).concat(route);
      onComplete && onComplete(route);
    }, onAbort);
  };

  AbstractHistory.prototype.go = function go (n) {
    var this$1 = this;

    var targetIndex = this.index + n;
    if (targetIndex < 0 || targetIndex >= this.stack.length) {
      return
    }
    var route = this.stack[targetIndex];
    this.confirmTransition(route, function () {
      this$1.index = targetIndex;
      this$1.updateRoute(route);
    });
  };

  AbstractHistory.prototype.getCurrentLocation = function getCurrentLocation () {
    var current = this.stack[this.stack.length - 1];
    return current ? current.fullPath : '/'
  };

  AbstractHistory.prototype.ensureURL = function ensureURL () {
    // noop
  };

  return AbstractHistory;
}(History));

/*  */

var VueRouter = function VueRouter (options) {
  if ( options === void 0 ) options = {};

  this.app = null;
  this.apps = [];
  this.options = options;
  this.beforeHooks = [];
  this.resolveHooks = [];
  this.afterHooks = [];
  this.matcher = createMatcher(options.routes || [], this);

  var mode = options.mode || 'hash';
  this.fallback = mode === 'history' && !supportsPushState && options.fallback !== false;
  if (this.fallback) {
    mode = 'hash';
  }
  if (!inBrowser) {
    mode = 'abstract';
  }
  this.mode = mode;

  switch (mode) {
    case 'history':
      this.history = new HTML5History(this, options.base);
      break
    case 'hash':
      this.history = new HashHistory(this, options.base, this.fallback);
      break
    case 'abstract':
      this.history = new AbstractHistory(this, options.base);
      break
    default:
      if (false) {
        assert(false, ("invalid mode: " + mode));
      }
  }
};

var prototypeAccessors = { currentRoute: { configurable: true } };

VueRouter.prototype.match = function match (
  raw,
  current,
  redirectedFrom
) {
  return this.matcher.match(raw, current, redirectedFrom)
};

prototypeAccessors.currentRoute.get = function () {
  return this.history && this.history.current
};

VueRouter.prototype.init = function init (app /* Vue component instance */) {
    var this$1 = this;

  "production" !== 'production' && assert(
    install.installed,
    "not installed. Make sure to call `Vue.use(VueRouter)` " +
    "before creating root instance."
  );

  this.apps.push(app);

  // main app already initialized.
  if (this.app) {
    return
  }

  this.app = app;

  var history = this.history;

  if (history instanceof HTML5History) {
    history.transitionTo(history.getCurrentLocation());
  } else if (history instanceof HashHistory) {
    var setupHashListener = function () {
      history.setupListeners();
    };
    history.transitionTo(
      history.getCurrentLocation(),
      setupHashListener,
      setupHashListener
    );
  }

  history.listen(function (route) {
    this$1.apps.forEach(function (app) {
      app._route = route;
    });
  });
};

VueRouter.prototype.beforeEach = function beforeEach (fn) {
  return registerHook(this.beforeHooks, fn)
};

VueRouter.prototype.beforeResolve = function beforeResolve (fn) {
  return registerHook(this.resolveHooks, fn)
};

VueRouter.prototype.afterEach = function afterEach (fn) {
  return registerHook(this.afterHooks, fn)
};

VueRouter.prototype.onReady = function onReady (cb, errorCb) {
  this.history.onReady(cb, errorCb);
};

VueRouter.prototype.onError = function onError (errorCb) {
  this.history.onError(errorCb);
};

VueRouter.prototype.push = function push (location, onComplete, onAbort) {
  this.history.push(location, onComplete, onAbort);
};

VueRouter.prototype.replace = function replace (location, onComplete, onAbort) {
  this.history.replace(location, onComplete, onAbort);
};

VueRouter.prototype.go = function go (n) {
  this.history.go(n);
};

VueRouter.prototype.back = function back () {
  this.go(-1);
};

VueRouter.prototype.forward = function forward () {
  this.go(1);
};

VueRouter.prototype.getMatchedComponents = function getMatchedComponents (to) {
  var route = to
    ? to.matched
      ? to
      : this.resolve(to).route
    : this.currentRoute;
  if (!route) {
    return []
  }
  return [].concat.apply([], route.matched.map(function (m) {
    return Object.keys(m.components).map(function (key) {
      return m.components[key]
    })
  }))
};

VueRouter.prototype.resolve = function resolve (
  to,
  current,
  append
) {
  var location = normalizeLocation(
    to,
    current || this.history.current,
    append,
    this
  );
  var route = this.match(location, current);
  var fullPath = route.redirectedFrom || route.fullPath;
  var base = this.history.base;
  var href = createHref(base, fullPath, this.mode);
  return {
    location: location,
    route: route,
    href: href,
    // for backwards compat
    normalizedTo: location,
    resolved: route
  }
};

VueRouter.prototype.addRoutes = function addRoutes (routes) {
  this.matcher.addRoutes(routes);
  if (this.history.current !== START) {
    this.history.transitionTo(this.history.getCurrentLocation());
  }
};

Object.defineProperties( VueRouter.prototype, prototypeAccessors );

function registerHook (list, fn) {
  list.push(fn);
  return function () {
    var i = list.indexOf(fn);
    if (i > -1) { list.splice(i, 1); }
  }
}

function createHref (base, fullPath, mode) {
  var path = mode === 'hash' ? '#' + fullPath : fullPath;
  return base ? cleanPath(base + '/' + path) : path
}

VueRouter.install = install;
VueRouter.version = '3.0.1';

if (inBrowser && window.Vue) {
  window.Vue.use(VueRouter);
}

/* harmony default export */ __webpack_exports__["default"] = (VueRouter);


/***/ }),

/***/ "06OY":
/***/ (function(module, exports, __webpack_require__) {

var META = __webpack_require__("3Eo+")('meta');
var isObject = __webpack_require__("EqjI");
var has = __webpack_require__("D2L2");
var setDesc = __webpack_require__("evD5").f;
var id = 0;
var isExtensible = Object.isExtensible || function () {
  return true;
};
var FREEZE = !__webpack_require__("S82l")(function () {
  return isExtensible(Object.preventExtensions({}));
});
var setMeta = function (it) {
  setDesc(it, META, { value: {
    i: 'O' + ++id, // object ID
    w: {}          // weak collections IDs
  } });
};
var fastKey = function (it, create) {
  // return primitive with prefix
  if (!isObject(it)) return typeof it == 'symbol' ? it : (typeof it == 'string' ? 'S' : 'P') + it;
  if (!has(it, META)) {
    // can't set metadata to uncaught frozen object
    if (!isExtensible(it)) return 'F';
    // not necessary to add metadata
    if (!create) return 'E';
    // add missing metadata
    setMeta(it);
  // return object ID
  } return it[META].i;
};
var getWeak = function (it, create) {
  if (!has(it, META)) {
    // can't set metadata to uncaught frozen object
    if (!isExtensible(it)) return true;
    // not necessary to add metadata
    if (!create) return false;
    // add missing metadata
    setMeta(it);
  // return hash weak collections IDs
  } return it[META].w;
};
// add metadata on freeze-family methods calling
var onFreeze = function (it) {
  if (FREEZE && meta.NEED && isExtensible(it) && !has(it, META)) setMeta(it);
  return it;
};
var meta = module.exports = {
  KEY: META,
  NEED: false,
  fastKey: fastKey,
  getWeak: getWeak,
  onFreeze: onFreeze
};


/***/ }),

/***/ "162o":
/***/ (function(module, exports, __webpack_require__) {

var apply = Function.prototype.apply;

// DOM APIs, for completeness

exports.setTimeout = function() {
  return new Timeout(apply.call(setTimeout, window, arguments), clearTimeout);
};
exports.setInterval = function() {
  return new Timeout(apply.call(setInterval, window, arguments), clearInterval);
};
exports.clearTimeout =
exports.clearInterval = function(timeout) {
  if (timeout) {
    timeout.close();
  }
};

function Timeout(id, clearFn) {
  this._id = id;
  this._clearFn = clearFn;
}
Timeout.prototype.unref = Timeout.prototype.ref = function() {};
Timeout.prototype.close = function() {
  this._clearFn.call(window, this._id);
};

// Does not start the time, just sets up the members needed.
exports.enroll = function(item, msecs) {
  clearTimeout(item._idleTimeoutId);
  item._idleTimeout = msecs;
};

exports.unenroll = function(item) {
  clearTimeout(item._idleTimeoutId);
  item._idleTimeout = -1;
};

exports._unrefActive = exports.active = function(item) {
  clearTimeout(item._idleTimeoutId);

  var msecs = item._idleTimeout;
  if (msecs >= 0) {
    item._idleTimeoutId = setTimeout(function onTimeout() {
      if (item._onTimeout)
        item._onTimeout();
    }, msecs);
  }
};

// setimmediate attaches itself to the global object
__webpack_require__("mypn");
exports.setImmediate = setImmediate;
exports.clearImmediate = clearImmediate;


/***/ }),

/***/ "1kS7":
/***/ (function(module, exports) {

exports.f = Object.getOwnPropertySymbols;


/***/ }),

/***/ "21It":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var createError = __webpack_require__("FtD3");

/**
 * Resolve or reject a Promise based on response status.
 *
 * @param {Function} resolve A function that resolves the promise.
 * @param {Function} reject A function that rejects the promise.
 * @param {object} response The response.
 */
module.exports = function settle(resolve, reject, response) {
  var validateStatus = response.config.validateStatus;
  // Note: status is not exposed by XDomainRequest
  if (!response.status || !validateStatus || validateStatus(response.status)) {
    resolve(response);
  } else {
    reject(createError(
      'Request failed with status code ' + response.status,
      response.config,
      null,
      response.request,
      response
    ));
  }
};


/***/ }),

/***/ "2ds3":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _messagebox = __webpack_require__("JxQx");

var _messagebox2 = _interopRequireDefault(_messagebox);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  data: function data() {
    return {};
  },

  methods: {
    showSMS: function showSMS() {
      _messagebox2.default.SMS({
        onSend: function onSend() {
          console.log('send');
        },
        onInput: function onInput(value) {
          console.log(value);
        },
        onCancel: function onCancel() {
          console.log('cancel');
        },
        onSubmit: function onSubmit() {
          console.log('submit');
          this.setWrong();
          // this.close();
        }
      });
    }
  },
  mounted: function mounted() {
    // eslint-disable-next-line
  }
}; //
//
//
//
//
//
//
//
//
//

module.exports = exports['default'];

/***/ }),

/***/ "3BAx":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "3Eo+":
/***/ (function(module, exports) {

var id = 0;
var px = Math.random();
module.exports = function (key) {
  return 'Symbol('.concat(key === undefined ? '' : key, ')_', (++id + px).toString(36));
};


/***/ }),

/***/ "52gC":
/***/ (function(module, exports) {

// 7.2.1 RequireObjectCoercible(argument)
module.exports = function (it) {
  if (it == undefined) throw TypeError("Can't call method on  " + it);
  return it;
};


/***/ }),

/***/ "5Tcv":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/views/ui/Panel.vue
var Panel = __webpack_require__("m0yP");
var Panel_default = /*#__PURE__*/__webpack_require__.n(Panel);

// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-bf5c2662","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/ui/Panel.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0,false,false)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"demo-panel"},[_c('h3',{staticClass:"demo-title"},[_vm._v("普通面板")]),_vm._v(" "),_c('div',{staticClass:"bx-panel"},[_c('div',{staticClass:"bx-panel-header"},[_vm._v("面板标题")]),_vm._v(" "),_c('div',{staticClass:"bx-panel-body"},[_c('div',{staticClass:"bx-panel-inner"},[_vm._v("面板正文")])]),_vm._v(" "),_c('div',{staticClass:"bx-panel-footer"},[_vm._v("面板底部")])])]),_vm._v(" "),_c('div',{staticClass:"demo-panel"},[_c('h3',{staticClass:"demo-title"},[_vm._v("普通面板")]),_vm._v(" "),_c('div',{staticClass:"bx-panel"},[_c('div',{staticClass:"bx-panel-header"},[_c('div',{staticClass:"bx-panel-title"},[_vm._v("个人信息")]),_vm._v(" "),_c('div',{staticClass:"bx-panel-extra"},[_vm._v("更多")]),_vm._v(" "),_c('div',{staticClass:"bx-panel-link"},[_c('i',{staticClass:"bx-icon bx-icon-arrows-right"})])]),_vm._v(" "),_c('div',{staticClass:"bx-panel-body"},[_c('div',{staticClass:"bx-panel-inner"},[_vm._v("面板正文")])]),_vm._v(" "),_c('div',{staticClass:"bx-panel-footer"},[_vm._v("面板底部")])])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var ui_Panel = (esExports);
// CONCATENATED MODULE: ./src/views/ui/Panel.vue
function injectStyle (ssrContext) {
  __webpack_require__("8HOu")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  Panel_default.a,
  ui_Panel,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var views_ui_Panel = __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "5VQ+":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__("cGG2");

module.exports = function normalizeHeaderName(headers, normalizedName) {
  utils.forEach(headers, function processHeader(value, name) {
    if (name !== normalizedName && name.toUpperCase() === normalizedName.toUpperCase()) {
      headers[normalizedName] = value;
      delete headers[name];
    }
  });
};


/***/ }),

/***/ "5X6r":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/views/ui/Flex.vue
var Flex = __webpack_require__("wDn8");
var Flex_default = /*#__PURE__*/__webpack_require__.n(Flex);

// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-343e6d5a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/ui/Flex.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0,false,false)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"demo-flex"},[_c('div',{staticClass:"demo-flex-group demo-flex-common-group"},[_c('h3',{staticClass:"demo-flex-title"},[_vm._v("基本")]),_vm._v(" "),_c('div',{staticClass:"bx-flex"},[_c('div',{staticClass:"bx-flex-item"}),_vm._v(" "),_c('div',{staticClass:"bx-flex-item"})]),_vm._v(" "),_c('div',{staticClass:"bx-flex"},[_c('div',{staticClass:"bx-flex-item"}),_vm._v(" "),_c('div',{staticClass:"bx-flex-item"}),_vm._v(" "),_c('div',{staticClass:"bx-flex-item"})]),_vm._v(" "),_c('div',{staticClass:"bx-flex"},[_c('div',{staticClass:"bx-flex-item"}),_vm._v(" "),_c('div',{staticClass:"bx-flex-item"}),_vm._v(" "),_c('div',{staticClass:"bx-flex-item"}),_vm._v(" "),_c('div',{staticClass:"bx-flex-item"}),_vm._v(" "),_c('div',{staticClass:"bx-flex-item"})])]),_vm._v(" "),_c('div',{staticClass:"demo-flex-group demo-flex-wrap-group"},[_c('h3',{staticClass:"demo-flex-title"},[_vm._v("换行")]),_vm._v(" "),_c('div',{staticClass:"bx-flex bx-flex--wrap"},[_c('div',{staticClass:"item"}),_vm._v(" "),_c('div',{staticClass:"item"}),_vm._v(" "),_c('div',{staticClass:"item"}),_vm._v(" "),_c('div',{staticClass:"item"}),_vm._v(" "),_c('div',{staticClass:"item"}),_vm._v(" "),_c('div',{staticClass:"item"})])]),_vm._v(" "),_c('div',{staticClass:"demo-flex-group demo-flex-align-group"},[_c('h3',{staticClass:"demo-flex-title"},[_vm._v("主轴对齐")]),_vm._v(" "),_c('div',{staticClass:"bx-flex bx-flex-main--start"},[_c('div',{staticClass:"item"}),_vm._v(" "),_c('div',{staticClass:"item"}),_vm._v(" "),_c('div',{staticClass:"item"})]),_vm._v(" "),_c('div',{staticClass:"bx-flex bx-flex-main--end"},[_c('div',{staticClass:"item"}),_vm._v(" "),_c('div',{staticClass:"item"}),_vm._v(" "),_c('div',{staticClass:"item"})]),_vm._v(" "),_c('div',{staticClass:"bx-flex bx-flex-main--center"},[_c('div',{staticClass:"item"}),_vm._v(" "),_c('div',{staticClass:"item"}),_vm._v(" "),_c('div',{staticClass:"item"})]),_vm._v(" "),_c('div',{staticClass:"bx-flex bx-flex-main--space-between"},[_c('div',{staticClass:"item"}),_vm._v(" "),_c('div',{staticClass:"item"}),_vm._v(" "),_c('div',{staticClass:"item"})]),_vm._v(" "),_c('div',{staticClass:"bx-flex bx-flex-main--space-around"},[_c('div',{staticClass:"item"}),_vm._v(" "),_c('div',{staticClass:"item"}),_vm._v(" "),_c('div',{staticClass:"item"})])]),_vm._v(" "),_c('div',{staticClass:"demo-flex-group demo-flex-align-group demo-flex-align-cross"},[_c('h3',{staticClass:"demo-flex-title"},[_vm._v("交叉轴对齐")]),_vm._v(" "),_c('div',{staticClass:"bx-flex bx-flex-cross--start"},[_c('div',{staticClass:"item"}),_vm._v(" "),_c('div',{staticClass:"item"}),_vm._v(" "),_c('div',{staticClass:"item"})]),_vm._v(" "),_c('div',{staticClass:"bx-flex bx-flex-cross--end"},[_c('div',{staticClass:"item"}),_vm._v(" "),_c('div',{staticClass:"item"}),_vm._v(" "),_c('div',{staticClass:"item"})]),_vm._v(" "),_c('div',{staticClass:"bx-flex bx-flex-cross--center"},[_c('div',{staticClass:"item"}),_vm._v(" "),_c('div',{staticClass:"item"}),_vm._v(" "),_c('div',{staticClass:"item"})]),_vm._v(" "),_c('div',{staticClass:"bx-flex bx-flex-cross--baseline"},[_c('div',{staticClass:"item"},[_vm._v("保险师")]),_vm._v(" "),_c('div',{staticClass:"item"},[_vm._v("UI")]),_vm._v(" "),_c('div',{staticClass:"item"},[_vm._v("1.0")])]),_vm._v(" "),_c('div',{staticClass:"bx-flex bx-flex-cross--stretch"},[_c('div',{staticClass:"item"}),_vm._v(" "),_c('div',{staticClass:"item"}),_vm._v(" "),_c('div',{staticClass:"item"})])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var ui_Flex = (esExports);
// CONCATENATED MODULE: ./src/views/ui/Flex.vue
function injectStyle (ssrContext) {
  __webpack_require__("XXfZ")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  Flex_default.a,
  ui_Flex,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var views_ui_Flex = __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "7+uW":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function(global, setImmediate) {/*!
 * Vue.js v2.5.9
 * (c) 2014-2017 Evan You
 * Released under the MIT License.
 */
/*  */

var emptyObject = Object.freeze({});

// these helpers produces better vm code in JS engines due to their
// explicitness and function inlining
function isUndef (v) {
  return v === undefined || v === null
}

function isDef (v) {
  return v !== undefined && v !== null
}

function isTrue (v) {
  return v === true
}

function isFalse (v) {
  return v === false
}

/**
 * Check if value is primitive
 */
function isPrimitive (value) {
  return (
    typeof value === 'string' ||
    typeof value === 'number' ||
    typeof value === 'boolean'
  )
}

/**
 * Quick object check - this is primarily used to tell
 * Objects from primitive values when we know the value
 * is a JSON-compliant type.
 */
function isObject (obj) {
  return obj !== null && typeof obj === 'object'
}

/**
 * Get the raw type string of a value e.g. [object Object]
 */
var _toString = Object.prototype.toString;

function toRawType (value) {
  return _toString.call(value).slice(8, -1)
}

/**
 * Strict object type check. Only returns true
 * for plain JavaScript objects.
 */
function isPlainObject (obj) {
  return _toString.call(obj) === '[object Object]'
}

function isRegExp (v) {
  return _toString.call(v) === '[object RegExp]'
}

/**
 * Check if val is a valid array index.
 */
function isValidArrayIndex (val) {
  var n = parseFloat(String(val));
  return n >= 0 && Math.floor(n) === n && isFinite(val)
}

/**
 * Convert a value to a string that is actually rendered.
 */
function toString (val) {
  return val == null
    ? ''
    : typeof val === 'object'
      ? JSON.stringify(val, null, 2)
      : String(val)
}

/**
 * Convert a input value to a number for persistence.
 * If the conversion fails, return original string.
 */
function toNumber (val) {
  var n = parseFloat(val);
  return isNaN(n) ? val : n
}

/**
 * Make a map and return a function for checking if a key
 * is in that map.
 */
function makeMap (
  str,
  expectsLowerCase
) {
  var map = Object.create(null);
  var list = str.split(',');
  for (var i = 0; i < list.length; i++) {
    map[list[i]] = true;
  }
  return expectsLowerCase
    ? function (val) { return map[val.toLowerCase()]; }
    : function (val) { return map[val]; }
}

/**
 * Check if a tag is a built-in tag.
 */
var isBuiltInTag = makeMap('slot,component', true);

/**
 * Check if a attribute is a reserved attribute.
 */
var isReservedAttribute = makeMap('key,ref,slot,slot-scope,is');

/**
 * Remove an item from an array
 */
function remove (arr, item) {
  if (arr.length) {
    var index = arr.indexOf(item);
    if (index > -1) {
      return arr.splice(index, 1)
    }
  }
}

/**
 * Check whether the object has the property.
 */
var hasOwnProperty = Object.prototype.hasOwnProperty;
function hasOwn (obj, key) {
  return hasOwnProperty.call(obj, key)
}

/**
 * Create a cached version of a pure function.
 */
function cached (fn) {
  var cache = Object.create(null);
  return (function cachedFn (str) {
    var hit = cache[str];
    return hit || (cache[str] = fn(str))
  })
}

/**
 * Camelize a hyphen-delimited string.
 */
var camelizeRE = /-(\w)/g;
var camelize = cached(function (str) {
  return str.replace(camelizeRE, function (_, c) { return c ? c.toUpperCase() : ''; })
});

/**
 * Capitalize a string.
 */
var capitalize = cached(function (str) {
  return str.charAt(0).toUpperCase() + str.slice(1)
});

/**
 * Hyphenate a camelCase string.
 */
var hyphenateRE = /\B([A-Z])/g;
var hyphenate = cached(function (str) {
  return str.replace(hyphenateRE, '-$1').toLowerCase()
});

/**
 * Simple bind, faster than native
 */
function bind (fn, ctx) {
  function boundFn (a) {
    var l = arguments.length;
    return l
      ? l > 1
        ? fn.apply(ctx, arguments)
        : fn.call(ctx, a)
      : fn.call(ctx)
  }
  // record original fn length
  boundFn._length = fn.length;
  return boundFn
}

/**
 * Convert an Array-like object to a real Array.
 */
function toArray (list, start) {
  start = start || 0;
  var i = list.length - start;
  var ret = new Array(i);
  while (i--) {
    ret[i] = list[i + start];
  }
  return ret
}

/**
 * Mix properties into target object.
 */
function extend (to, _from) {
  for (var key in _from) {
    to[key] = _from[key];
  }
  return to
}

/**
 * Merge an Array of Objects into a single Object.
 */
function toObject (arr) {
  var res = {};
  for (var i = 0; i < arr.length; i++) {
    if (arr[i]) {
      extend(res, arr[i]);
    }
  }
  return res
}

/**
 * Perform no operation.
 * Stubbing args to make Flow happy without leaving useless transpiled code
 * with ...rest (https://flow.org/blog/2017/05/07/Strict-Function-Call-Arity/)
 */
function noop (a, b, c) {}

/**
 * Always return false.
 */
var no = function (a, b, c) { return false; };

/**
 * Return same value
 */
var identity = function (_) { return _; };

/**
 * Generate a static keys string from compiler modules.
 */
function genStaticKeys (modules) {
  return modules.reduce(function (keys, m) {
    return keys.concat(m.staticKeys || [])
  }, []).join(',')
}

/**
 * Check if two values are loosely equal - that is,
 * if they are plain objects, do they have the same shape?
 */
function looseEqual (a, b) {
  if (a === b) { return true }
  var isObjectA = isObject(a);
  var isObjectB = isObject(b);
  if (isObjectA && isObjectB) {
    try {
      var isArrayA = Array.isArray(a);
      var isArrayB = Array.isArray(b);
      if (isArrayA && isArrayB) {
        return a.length === b.length && a.every(function (e, i) {
          return looseEqual(e, b[i])
        })
      } else if (!isArrayA && !isArrayB) {
        var keysA = Object.keys(a);
        var keysB = Object.keys(b);
        return keysA.length === keysB.length && keysA.every(function (key) {
          return looseEqual(a[key], b[key])
        })
      } else {
        /* istanbul ignore next */
        return false
      }
    } catch (e) {
      /* istanbul ignore next */
      return false
    }
  } else if (!isObjectA && !isObjectB) {
    return String(a) === String(b)
  } else {
    return false
  }
}

function looseIndexOf (arr, val) {
  for (var i = 0; i < arr.length; i++) {
    if (looseEqual(arr[i], val)) { return i }
  }
  return -1
}

/**
 * Ensure a function is called only once.
 */
function once (fn) {
  var called = false;
  return function () {
    if (!called) {
      called = true;
      fn.apply(this, arguments);
    }
  }
}

var SSR_ATTR = 'data-server-rendered';

var ASSET_TYPES = [
  'component',
  'directive',
  'filter'
];

var LIFECYCLE_HOOKS = [
  'beforeCreate',
  'created',
  'beforeMount',
  'mounted',
  'beforeUpdate',
  'updated',
  'beforeDestroy',
  'destroyed',
  'activated',
  'deactivated',
  'errorCaptured'
];

/*  */

var config = ({
  /**
   * Option merge strategies (used in core/util/options)
   */
  optionMergeStrategies: Object.create(null),

  /**
   * Whether to suppress warnings.
   */
  silent: false,

  /**
   * Show production mode tip message on boot?
   */
  productionTip: "production" !== 'production',

  /**
   * Whether to enable devtools
   */
  devtools: "production" !== 'production',

  /**
   * Whether to record perf
   */
  performance: false,

  /**
   * Error handler for watcher errors
   */
  errorHandler: null,

  /**
   * Warn handler for watcher warns
   */
  warnHandler: null,

  /**
   * Ignore certain custom elements
   */
  ignoredElements: [],

  /**
   * Custom user key aliases for v-on
   */
  keyCodes: Object.create(null),

  /**
   * Check if a tag is reserved so that it cannot be registered as a
   * component. This is platform-dependent and may be overwritten.
   */
  isReservedTag: no,

  /**
   * Check if an attribute is reserved so that it cannot be used as a component
   * prop. This is platform-dependent and may be overwritten.
   */
  isReservedAttr: no,

  /**
   * Check if a tag is an unknown element.
   * Platform-dependent.
   */
  isUnknownElement: no,

  /**
   * Get the namespace of an element
   */
  getTagNamespace: noop,

  /**
   * Parse the real tag name for the specific platform.
   */
  parsePlatformTagName: identity,

  /**
   * Check if an attribute must be bound using property, e.g. value
   * Platform-dependent.
   */
  mustUseProp: no,

  /**
   * Exposed for legacy reasons
   */
  _lifecycleHooks: LIFECYCLE_HOOKS
});

/*  */

/**
 * Check if a string starts with $ or _
 */
function isReserved (str) {
  var c = (str + '').charCodeAt(0);
  return c === 0x24 || c === 0x5F
}

/**
 * Define a property.
 */
function def (obj, key, val, enumerable) {
  Object.defineProperty(obj, key, {
    value: val,
    enumerable: !!enumerable,
    writable: true,
    configurable: true
  });
}

/**
 * Parse simple path.
 */
var bailRE = /[^\w.$]/;
function parsePath (path) {
  if (bailRE.test(path)) {
    return
  }
  var segments = path.split('.');
  return function (obj) {
    for (var i = 0; i < segments.length; i++) {
      if (!obj) { return }
      obj = obj[segments[i]];
    }
    return obj
  }
}

/*  */


// can we use __proto__?
var hasProto = '__proto__' in {};

// Browser environment sniffing
var inBrowser = typeof window !== 'undefined';
var inWeex = typeof WXEnvironment !== 'undefined' && !!WXEnvironment.platform;
var weexPlatform = inWeex && WXEnvironment.platform.toLowerCase();
var UA = inBrowser && window.navigator.userAgent.toLowerCase();
var isIE = UA && /msie|trident/.test(UA);
var isIE9 = UA && UA.indexOf('msie 9.0') > 0;
var isEdge = UA && UA.indexOf('edge/') > 0;
var isAndroid = (UA && UA.indexOf('android') > 0) || (weexPlatform === 'android');
var isIOS = (UA && /iphone|ipad|ipod|ios/.test(UA)) || (weexPlatform === 'ios');
var isChrome = UA && /chrome\/\d+/.test(UA) && !isEdge;

// Firefox has a "watch" function on Object.prototype...
var nativeWatch = ({}).watch;

var supportsPassive = false;
if (inBrowser) {
  try {
    var opts = {};
    Object.defineProperty(opts, 'passive', ({
      get: function get () {
        /* istanbul ignore next */
        supportsPassive = true;
      }
    })); // https://github.com/facebook/flow/issues/285
    window.addEventListener('test-passive', null, opts);
  } catch (e) {}
}

// this needs to be lazy-evaled because vue may be required before
// vue-server-renderer can set VUE_ENV
var _isServer;
var isServerRendering = function () {
  if (_isServer === undefined) {
    /* istanbul ignore if */
    if (!inBrowser && typeof global !== 'undefined') {
      // detect presence of vue-server-renderer and avoid
      // Webpack shimming the process
      _isServer = global['process'].env.VUE_ENV === 'server';
    } else {
      _isServer = false;
    }
  }
  return _isServer
};

// detect devtools
var devtools = inBrowser && window.__VUE_DEVTOOLS_GLOBAL_HOOK__;

/* istanbul ignore next */
function isNative (Ctor) {
  return typeof Ctor === 'function' && /native code/.test(Ctor.toString())
}

var hasSymbol =
  typeof Symbol !== 'undefined' && isNative(Symbol) &&
  typeof Reflect !== 'undefined' && isNative(Reflect.ownKeys);

var _Set;
/* istanbul ignore if */ // $flow-disable-line
if (typeof Set !== 'undefined' && isNative(Set)) {
  // use native Set when available.
  _Set = Set;
} else {
  // a non-standard Set polyfill that only works with primitive keys.
  _Set = (function () {
    function Set () {
      this.set = Object.create(null);
    }
    Set.prototype.has = function has (key) {
      return this.set[key] === true
    };
    Set.prototype.add = function add (key) {
      this.set[key] = true;
    };
    Set.prototype.clear = function clear () {
      this.set = Object.create(null);
    };

    return Set;
  }());
}

/*  */

var warn = noop;
var tip = noop;
var generateComponentTrace = (noop); // work around flow check
var formatComponentName = (noop);

if (false) {
  var hasConsole = typeof console !== 'undefined';
  var classifyRE = /(?:^|[-_])(\w)/g;
  var classify = function (str) { return str
    .replace(classifyRE, function (c) { return c.toUpperCase(); })
    .replace(/[-_]/g, ''); };

  warn = function (msg, vm) {
    var trace = vm ? generateComponentTrace(vm) : '';

    if (config.warnHandler) {
      config.warnHandler.call(null, msg, vm, trace);
    } else if (hasConsole && (!config.silent)) {
      console.error(("[Vue warn]: " + msg + trace));
    }
  };

  tip = function (msg, vm) {
    if (hasConsole && (!config.silent)) {
      console.warn("[Vue tip]: " + msg + (
        vm ? generateComponentTrace(vm) : ''
      ));
    }
  };

  formatComponentName = function (vm, includeFile) {
    if (vm.$root === vm) {
      return '<Root>'
    }
    var options = typeof vm === 'function' && vm.cid != null
      ? vm.options
      : vm._isVue
        ? vm.$options || vm.constructor.options
        : vm || {};
    var name = options.name || options._componentTag;
    var file = options.__file;
    if (!name && file) {
      var match = file.match(/([^/\\]+)\.vue$/);
      name = match && match[1];
    }

    return (
      (name ? ("<" + (classify(name)) + ">") : "<Anonymous>") +
      (file && includeFile !== false ? (" at " + file) : '')
    )
  };

  var repeat = function (str, n) {
    var res = '';
    while (n) {
      if (n % 2 === 1) { res += str; }
      if (n > 1) { str += str; }
      n >>= 1;
    }
    return res
  };

  generateComponentTrace = function (vm) {
    if (vm._isVue && vm.$parent) {
      var tree = [];
      var currentRecursiveSequence = 0;
      while (vm) {
        if (tree.length > 0) {
          var last = tree[tree.length - 1];
          if (last.constructor === vm.constructor) {
            currentRecursiveSequence++;
            vm = vm.$parent;
            continue
          } else if (currentRecursiveSequence > 0) {
            tree[tree.length - 1] = [last, currentRecursiveSequence];
            currentRecursiveSequence = 0;
          }
        }
        tree.push(vm);
        vm = vm.$parent;
      }
      return '\n\nfound in\n\n' + tree
        .map(function (vm, i) { return ("" + (i === 0 ? '---> ' : repeat(' ', 5 + i * 2)) + (Array.isArray(vm)
            ? ((formatComponentName(vm[0])) + "... (" + (vm[1]) + " recursive calls)")
            : formatComponentName(vm))); })
        .join('\n')
    } else {
      return ("\n\n(found in " + (formatComponentName(vm)) + ")")
    }
  };
}

/*  */


var uid = 0;

/**
 * A dep is an observable that can have multiple
 * directives subscribing to it.
 */
var Dep = function Dep () {
  this.id = uid++;
  this.subs = [];
};

Dep.prototype.addSub = function addSub (sub) {
  this.subs.push(sub);
};

Dep.prototype.removeSub = function removeSub (sub) {
  remove(this.subs, sub);
};

Dep.prototype.depend = function depend () {
  if (Dep.target) {
    Dep.target.addDep(this);
  }
};

Dep.prototype.notify = function notify () {
  // stabilize the subscriber list first
  var subs = this.subs.slice();
  for (var i = 0, l = subs.length; i < l; i++) {
    subs[i].update();
  }
};

// the current target watcher being evaluated.
// this is globally unique because there could be only one
// watcher being evaluated at any time.
Dep.target = null;
var targetStack = [];

function pushTarget (_target) {
  if (Dep.target) { targetStack.push(Dep.target); }
  Dep.target = _target;
}

function popTarget () {
  Dep.target = targetStack.pop();
}

/*  */

var VNode = function VNode (
  tag,
  data,
  children,
  text,
  elm,
  context,
  componentOptions,
  asyncFactory
) {
  this.tag = tag;
  this.data = data;
  this.children = children;
  this.text = text;
  this.elm = elm;
  this.ns = undefined;
  this.context = context;
  this.fnContext = undefined;
  this.fnOptions = undefined;
  this.fnScopeId = undefined;
  this.key = data && data.key;
  this.componentOptions = componentOptions;
  this.componentInstance = undefined;
  this.parent = undefined;
  this.raw = false;
  this.isStatic = false;
  this.isRootInsert = true;
  this.isComment = false;
  this.isCloned = false;
  this.isOnce = false;
  this.asyncFactory = asyncFactory;
  this.asyncMeta = undefined;
  this.isAsyncPlaceholder = false;
};

var prototypeAccessors = { child: { configurable: true } };

// DEPRECATED: alias for componentInstance for backwards compat.
/* istanbul ignore next */
prototypeAccessors.child.get = function () {
  return this.componentInstance
};

Object.defineProperties( VNode.prototype, prototypeAccessors );

var createEmptyVNode = function (text) {
  if ( text === void 0 ) text = '';

  var node = new VNode();
  node.text = text;
  node.isComment = true;
  return node
};

function createTextVNode (val) {
  return new VNode(undefined, undefined, undefined, String(val))
}

// optimized shallow clone
// used for static nodes and slot nodes because they may be reused across
// multiple renders, cloning them avoids errors when DOM manipulations rely
// on their elm reference.
function cloneVNode (vnode, deep) {
  var componentOptions = vnode.componentOptions;
  var cloned = new VNode(
    vnode.tag,
    vnode.data,
    vnode.children,
    vnode.text,
    vnode.elm,
    vnode.context,
    componentOptions,
    vnode.asyncFactory
  );
  cloned.ns = vnode.ns;
  cloned.isStatic = vnode.isStatic;
  cloned.key = vnode.key;
  cloned.isComment = vnode.isComment;
  cloned.fnContext = vnode.fnContext;
  cloned.fnOptions = vnode.fnOptions;
  cloned.fnScopeId = vnode.fnScopeId;
  cloned.isCloned = true;
  if (deep) {
    if (vnode.children) {
      cloned.children = cloneVNodes(vnode.children, true);
    }
    if (componentOptions && componentOptions.children) {
      componentOptions.children = cloneVNodes(componentOptions.children, true);
    }
  }
  return cloned
}

function cloneVNodes (vnodes, deep) {
  var len = vnodes.length;
  var res = new Array(len);
  for (var i = 0; i < len; i++) {
    res[i] = cloneVNode(vnodes[i], deep);
  }
  return res
}

/*
 * not type checking this file because flow doesn't play well with
 * dynamically accessing methods on Array prototype
 */

var arrayProto = Array.prototype;
var arrayMethods = Object.create(arrayProto);[
  'push',
  'pop',
  'shift',
  'unshift',
  'splice',
  'sort',
  'reverse'
]
.forEach(function (method) {
  // cache original method
  var original = arrayProto[method];
  def(arrayMethods, method, function mutator () {
    var args = [], len = arguments.length;
    while ( len-- ) args[ len ] = arguments[ len ];

    var result = original.apply(this, args);
    var ob = this.__ob__;
    var inserted;
    switch (method) {
      case 'push':
      case 'unshift':
        inserted = args;
        break
      case 'splice':
        inserted = args.slice(2);
        break
    }
    if (inserted) { ob.observeArray(inserted); }
    // notify change
    ob.dep.notify();
    return result
  });
});

/*  */

var arrayKeys = Object.getOwnPropertyNames(arrayMethods);

/**
 * By default, when a reactive property is set, the new value is
 * also converted to become reactive. However when passing down props,
 * we don't want to force conversion because the value may be a nested value
 * under a frozen data structure. Converting it would defeat the optimization.
 */
var observerState = {
  shouldConvert: true
};

/**
 * Observer class that are attached to each observed
 * object. Once attached, the observer converts target
 * object's property keys into getter/setters that
 * collect dependencies and dispatches updates.
 */
var Observer = function Observer (value) {
  this.value = value;
  this.dep = new Dep();
  this.vmCount = 0;
  def(value, '__ob__', this);
  if (Array.isArray(value)) {
    var augment = hasProto
      ? protoAugment
      : copyAugment;
    augment(value, arrayMethods, arrayKeys);
    this.observeArray(value);
  } else {
    this.walk(value);
  }
};

/**
 * Walk through each property and convert them into
 * getter/setters. This method should only be called when
 * value type is Object.
 */
Observer.prototype.walk = function walk (obj) {
  var keys = Object.keys(obj);
  for (var i = 0; i < keys.length; i++) {
    defineReactive(obj, keys[i], obj[keys[i]]);
  }
};

/**
 * Observe a list of Array items.
 */
Observer.prototype.observeArray = function observeArray (items) {
  for (var i = 0, l = items.length; i < l; i++) {
    observe(items[i]);
  }
};

// helpers

/**
 * Augment an target Object or Array by intercepting
 * the prototype chain using __proto__
 */
function protoAugment (target, src, keys) {
  /* eslint-disable no-proto */
  target.__proto__ = src;
  /* eslint-enable no-proto */
}

/**
 * Augment an target Object or Array by defining
 * hidden properties.
 */
/* istanbul ignore next */
function copyAugment (target, src, keys) {
  for (var i = 0, l = keys.length; i < l; i++) {
    var key = keys[i];
    def(target, key, src[key]);
  }
}

/**
 * Attempt to create an observer instance for a value,
 * returns the new observer if successfully observed,
 * or the existing observer if the value already has one.
 */
function observe (value, asRootData) {
  if (!isObject(value) || value instanceof VNode) {
    return
  }
  var ob;
  if (hasOwn(value, '__ob__') && value.__ob__ instanceof Observer) {
    ob = value.__ob__;
  } else if (
    observerState.shouldConvert &&
    !isServerRendering() &&
    (Array.isArray(value) || isPlainObject(value)) &&
    Object.isExtensible(value) &&
    !value._isVue
  ) {
    ob = new Observer(value);
  }
  if (asRootData && ob) {
    ob.vmCount++;
  }
  return ob
}

/**
 * Define a reactive property on an Object.
 */
function defineReactive (
  obj,
  key,
  val,
  customSetter,
  shallow
) {
  var dep = new Dep();

  var property = Object.getOwnPropertyDescriptor(obj, key);
  if (property && property.configurable === false) {
    return
  }

  // cater for pre-defined getter/setters
  var getter = property && property.get;
  var setter = property && property.set;

  var childOb = !shallow && observe(val);
  Object.defineProperty(obj, key, {
    enumerable: true,
    configurable: true,
    get: function reactiveGetter () {
      var value = getter ? getter.call(obj) : val;
      if (Dep.target) {
        dep.depend();
        if (childOb) {
          childOb.dep.depend();
          if (Array.isArray(value)) {
            dependArray(value);
          }
        }
      }
      return value
    },
    set: function reactiveSetter (newVal) {
      var value = getter ? getter.call(obj) : val;
      /* eslint-disable no-self-compare */
      if (newVal === value || (newVal !== newVal && value !== value)) {
        return
      }
      /* eslint-enable no-self-compare */
      if (false) {
        customSetter();
      }
      if (setter) {
        setter.call(obj, newVal);
      } else {
        val = newVal;
      }
      childOb = !shallow && observe(newVal);
      dep.notify();
    }
  });
}

/**
 * Set a property on an object. Adds the new property and
 * triggers change notification if the property doesn't
 * already exist.
 */
function set (target, key, val) {
  if (Array.isArray(target) && isValidArrayIndex(key)) {
    target.length = Math.max(target.length, key);
    target.splice(key, 1, val);
    return val
  }
  if (key in target && !(key in Object.prototype)) {
    target[key] = val;
    return val
  }
  var ob = (target).__ob__;
  if (target._isVue || (ob && ob.vmCount)) {
    "production" !== 'production' && warn(
      'Avoid adding reactive properties to a Vue instance or its root $data ' +
      'at runtime - declare it upfront in the data option.'
    );
    return val
  }
  if (!ob) {
    target[key] = val;
    return val
  }
  defineReactive(ob.value, key, val);
  ob.dep.notify();
  return val
}

/**
 * Delete a property and trigger change if necessary.
 */
function del (target, key) {
  if (Array.isArray(target) && isValidArrayIndex(key)) {
    target.splice(key, 1);
    return
  }
  var ob = (target).__ob__;
  if (target._isVue || (ob && ob.vmCount)) {
    "production" !== 'production' && warn(
      'Avoid deleting properties on a Vue instance or its root $data ' +
      '- just set it to null.'
    );
    return
  }
  if (!hasOwn(target, key)) {
    return
  }
  delete target[key];
  if (!ob) {
    return
  }
  ob.dep.notify();
}

/**
 * Collect dependencies on array elements when the array is touched, since
 * we cannot intercept array element access like property getters.
 */
function dependArray (value) {
  for (var e = (void 0), i = 0, l = value.length; i < l; i++) {
    e = value[i];
    e && e.__ob__ && e.__ob__.dep.depend();
    if (Array.isArray(e)) {
      dependArray(e);
    }
  }
}

/*  */

/**
 * Option overwriting strategies are functions that handle
 * how to merge a parent option value and a child option
 * value into the final value.
 */
var strats = config.optionMergeStrategies;

/**
 * Options with restrictions
 */
if (false) {
  strats.el = strats.propsData = function (parent, child, vm, key) {
    if (!vm) {
      warn(
        "option \"" + key + "\" can only be used during instance " +
        'creation with the `new` keyword.'
      );
    }
    return defaultStrat(parent, child)
  };
}

/**
 * Helper that recursively merges two data objects together.
 */
function mergeData (to, from) {
  if (!from) { return to }
  var key, toVal, fromVal;
  var keys = Object.keys(from);
  for (var i = 0; i < keys.length; i++) {
    key = keys[i];
    toVal = to[key];
    fromVal = from[key];
    if (!hasOwn(to, key)) {
      set(to, key, fromVal);
    } else if (isPlainObject(toVal) && isPlainObject(fromVal)) {
      mergeData(toVal, fromVal);
    }
  }
  return to
}

/**
 * Data
 */
function mergeDataOrFn (
  parentVal,
  childVal,
  vm
) {
  if (!vm) {
    // in a Vue.extend merge, both should be functions
    if (!childVal) {
      return parentVal
    }
    if (!parentVal) {
      return childVal
    }
    // when parentVal & childVal are both present,
    // we need to return a function that returns the
    // merged result of both functions... no need to
    // check if parentVal is a function here because
    // it has to be a function to pass previous merges.
    return function mergedDataFn () {
      return mergeData(
        typeof childVal === 'function' ? childVal.call(this) : childVal,
        typeof parentVal === 'function' ? parentVal.call(this) : parentVal
      )
    }
  } else {
    return function mergedInstanceDataFn () {
      // instance merge
      var instanceData = typeof childVal === 'function'
        ? childVal.call(vm)
        : childVal;
      var defaultData = typeof parentVal === 'function'
        ? parentVal.call(vm)
        : parentVal;
      if (instanceData) {
        return mergeData(instanceData, defaultData)
      } else {
        return defaultData
      }
    }
  }
}

strats.data = function (
  parentVal,
  childVal,
  vm
) {
  if (!vm) {
    if (childVal && typeof childVal !== 'function') {
      "production" !== 'production' && warn(
        'The "data" option should be a function ' +
        'that returns a per-instance value in component ' +
        'definitions.',
        vm
      );

      return parentVal
    }
    return mergeDataOrFn(parentVal, childVal)
  }

  return mergeDataOrFn(parentVal, childVal, vm)
};

/**
 * Hooks and props are merged as arrays.
 */
function mergeHook (
  parentVal,
  childVal
) {
  return childVal
    ? parentVal
      ? parentVal.concat(childVal)
      : Array.isArray(childVal)
        ? childVal
        : [childVal]
    : parentVal
}

LIFECYCLE_HOOKS.forEach(function (hook) {
  strats[hook] = mergeHook;
});

/**
 * Assets
 *
 * When a vm is present (instance creation), we need to do
 * a three-way merge between constructor options, instance
 * options and parent options.
 */
function mergeAssets (
  parentVal,
  childVal,
  vm,
  key
) {
  var res = Object.create(parentVal || null);
  if (childVal) {
    "production" !== 'production' && assertObjectType(key, childVal, vm);
    return extend(res, childVal)
  } else {
    return res
  }
}

ASSET_TYPES.forEach(function (type) {
  strats[type + 's'] = mergeAssets;
});

/**
 * Watchers.
 *
 * Watchers hashes should not overwrite one
 * another, so we merge them as arrays.
 */
strats.watch = function (
  parentVal,
  childVal,
  vm,
  key
) {
  // work around Firefox's Object.prototype.watch...
  if (parentVal === nativeWatch) { parentVal = undefined; }
  if (childVal === nativeWatch) { childVal = undefined; }
  /* istanbul ignore if */
  if (!childVal) { return Object.create(parentVal || null) }
  if (false) {
    assertObjectType(key, childVal, vm);
  }
  if (!parentVal) { return childVal }
  var ret = {};
  extend(ret, parentVal);
  for (var key$1 in childVal) {
    var parent = ret[key$1];
    var child = childVal[key$1];
    if (parent && !Array.isArray(parent)) {
      parent = [parent];
    }
    ret[key$1] = parent
      ? parent.concat(child)
      : Array.isArray(child) ? child : [child];
  }
  return ret
};

/**
 * Other object hashes.
 */
strats.props =
strats.methods =
strats.inject =
strats.computed = function (
  parentVal,
  childVal,
  vm,
  key
) {
  if (childVal && "production" !== 'production') {
    assertObjectType(key, childVal, vm);
  }
  if (!parentVal) { return childVal }
  var ret = Object.create(null);
  extend(ret, parentVal);
  if (childVal) { extend(ret, childVal); }
  return ret
};
strats.provide = mergeDataOrFn;

/**
 * Default strategy.
 */
var defaultStrat = function (parentVal, childVal) {
  return childVal === undefined
    ? parentVal
    : childVal
};

/**
 * Validate component names
 */
function checkComponents (options) {
  for (var key in options.components) {
    var lower = key.toLowerCase();
    if (isBuiltInTag(lower) || config.isReservedTag(lower)) {
      warn(
        'Do not use built-in or reserved HTML elements as component ' +
        'id: ' + key
      );
    }
  }
}

/**
 * Ensure all props option syntax are normalized into the
 * Object-based format.
 */
function normalizeProps (options, vm) {
  var props = options.props;
  if (!props) { return }
  var res = {};
  var i, val, name;
  if (Array.isArray(props)) {
    i = props.length;
    while (i--) {
      val = props[i];
      if (typeof val === 'string') {
        name = camelize(val);
        res[name] = { type: null };
      } else if (false) {
        warn('props must be strings when using array syntax.');
      }
    }
  } else if (isPlainObject(props)) {
    for (var key in props) {
      val = props[key];
      name = camelize(key);
      res[name] = isPlainObject(val)
        ? val
        : { type: val };
    }
  } else if (false) {
    warn(
      "Invalid value for option \"props\": expected an Array or an Object, " +
      "but got " + (toRawType(props)) + ".",
      vm
    );
  }
  options.props = res;
}

/**
 * Normalize all injections into Object-based format
 */
function normalizeInject (options, vm) {
  var inject = options.inject;
  var normalized = options.inject = {};
  if (Array.isArray(inject)) {
    for (var i = 0; i < inject.length; i++) {
      normalized[inject[i]] = { from: inject[i] };
    }
  } else if (isPlainObject(inject)) {
    for (var key in inject) {
      var val = inject[key];
      normalized[key] = isPlainObject(val)
        ? extend({ from: key }, val)
        : { from: val };
    }
  } else if (false) {
    warn(
      "Invalid value for option \"inject\": expected an Array or an Object, " +
      "but got " + (toRawType(inject)) + ".",
      vm
    );
  }
}

/**
 * Normalize raw function directives into object format.
 */
function normalizeDirectives (options) {
  var dirs = options.directives;
  if (dirs) {
    for (var key in dirs) {
      var def = dirs[key];
      if (typeof def === 'function') {
        dirs[key] = { bind: def, update: def };
      }
    }
  }
}

function assertObjectType (name, value, vm) {
  if (!isPlainObject(value)) {
    warn(
      "Invalid value for option \"" + name + "\": expected an Object, " +
      "but got " + (toRawType(value)) + ".",
      vm
    );
  }
}

/**
 * Merge two option objects into a new one.
 * Core utility used in both instantiation and inheritance.
 */
function mergeOptions (
  parent,
  child,
  vm
) {
  if (false) {
    checkComponents(child);
  }

  if (typeof child === 'function') {
    child = child.options;
  }

  normalizeProps(child, vm);
  normalizeInject(child, vm);
  normalizeDirectives(child);
  var extendsFrom = child.extends;
  if (extendsFrom) {
    parent = mergeOptions(parent, extendsFrom, vm);
  }
  if (child.mixins) {
    for (var i = 0, l = child.mixins.length; i < l; i++) {
      parent = mergeOptions(parent, child.mixins[i], vm);
    }
  }
  var options = {};
  var key;
  for (key in parent) {
    mergeField(key);
  }
  for (key in child) {
    if (!hasOwn(parent, key)) {
      mergeField(key);
    }
  }
  function mergeField (key) {
    var strat = strats[key] || defaultStrat;
    options[key] = strat(parent[key], child[key], vm, key);
  }
  return options
}

/**
 * Resolve an asset.
 * This function is used because child instances need access
 * to assets defined in its ancestor chain.
 */
function resolveAsset (
  options,
  type,
  id,
  warnMissing
) {
  /* istanbul ignore if */
  if (typeof id !== 'string') {
    return
  }
  var assets = options[type];
  // check local registration variations first
  if (hasOwn(assets, id)) { return assets[id] }
  var camelizedId = camelize(id);
  if (hasOwn(assets, camelizedId)) { return assets[camelizedId] }
  var PascalCaseId = capitalize(camelizedId);
  if (hasOwn(assets, PascalCaseId)) { return assets[PascalCaseId] }
  // fallback to prototype chain
  var res = assets[id] || assets[camelizedId] || assets[PascalCaseId];
  if (false) {
    warn(
      'Failed to resolve ' + type.slice(0, -1) + ': ' + id,
      options
    );
  }
  return res
}

/*  */

function validateProp (
  key,
  propOptions,
  propsData,
  vm
) {
  var prop = propOptions[key];
  var absent = !hasOwn(propsData, key);
  var value = propsData[key];
  // handle boolean props
  if (isType(Boolean, prop.type)) {
    if (absent && !hasOwn(prop, 'default')) {
      value = false;
    } else if (!isType(String, prop.type) && (value === '' || value === hyphenate(key))) {
      value = true;
    }
  }
  // check default value
  if (value === undefined) {
    value = getPropDefaultValue(vm, prop, key);
    // since the default value is a fresh copy,
    // make sure to observe it.
    var prevShouldConvert = observerState.shouldConvert;
    observerState.shouldConvert = true;
    observe(value);
    observerState.shouldConvert = prevShouldConvert;
  }
  if (false) {
    assertProp(prop, key, value, vm, absent);
  }
  return value
}

/**
 * Get the default value of a prop.
 */
function getPropDefaultValue (vm, prop, key) {
  // no default, return undefined
  if (!hasOwn(prop, 'default')) {
    return undefined
  }
  var def = prop.default;
  // warn against non-factory defaults for Object & Array
  if (false) {
    warn(
      'Invalid default value for prop "' + key + '": ' +
      'Props with type Object/Array must use a factory function ' +
      'to return the default value.',
      vm
    );
  }
  // the raw prop value was also undefined from previous render,
  // return previous default value to avoid unnecessary watcher trigger
  if (vm && vm.$options.propsData &&
    vm.$options.propsData[key] === undefined &&
    vm._props[key] !== undefined
  ) {
    return vm._props[key]
  }
  // call factory function for non-Function types
  // a value is Function if its prototype is function even across different execution context
  return typeof def === 'function' && getType(prop.type) !== 'Function'
    ? def.call(vm)
    : def
}

/**
 * Assert whether a prop is valid.
 */
function assertProp (
  prop,
  name,
  value,
  vm,
  absent
) {
  if (prop.required && absent) {
    warn(
      'Missing required prop: "' + name + '"',
      vm
    );
    return
  }
  if (value == null && !prop.required) {
    return
  }
  var type = prop.type;
  var valid = !type || type === true;
  var expectedTypes = [];
  if (type) {
    if (!Array.isArray(type)) {
      type = [type];
    }
    for (var i = 0; i < type.length && !valid; i++) {
      var assertedType = assertType(value, type[i]);
      expectedTypes.push(assertedType.expectedType || '');
      valid = assertedType.valid;
    }
  }
  if (!valid) {
    warn(
      "Invalid prop: type check failed for prop \"" + name + "\"." +
      " Expected " + (expectedTypes.map(capitalize).join(', ')) +
      ", got " + (toRawType(value)) + ".",
      vm
    );
    return
  }
  var validator = prop.validator;
  if (validator) {
    if (!validator(value)) {
      warn(
        'Invalid prop: custom validator check failed for prop "' + name + '".',
        vm
      );
    }
  }
}

var simpleCheckRE = /^(String|Number|Boolean|Function|Symbol)$/;

function assertType (value, type) {
  var valid;
  var expectedType = getType(type);
  if (simpleCheckRE.test(expectedType)) {
    var t = typeof value;
    valid = t === expectedType.toLowerCase();
    // for primitive wrapper objects
    if (!valid && t === 'object') {
      valid = value instanceof type;
    }
  } else if (expectedType === 'Object') {
    valid = isPlainObject(value);
  } else if (expectedType === 'Array') {
    valid = Array.isArray(value);
  } else {
    valid = value instanceof type;
  }
  return {
    valid: valid,
    expectedType: expectedType
  }
}

/**
 * Use function string name to check built-in types,
 * because a simple equality check will fail when running
 * across different vms / iframes.
 */
function getType (fn) {
  var match = fn && fn.toString().match(/^\s*function (\w+)/);
  return match ? match[1] : ''
}

function isType (type, fn) {
  if (!Array.isArray(fn)) {
    return getType(fn) === getType(type)
  }
  for (var i = 0, len = fn.length; i < len; i++) {
    if (getType(fn[i]) === getType(type)) {
      return true
    }
  }
  /* istanbul ignore next */
  return false
}

/*  */

function handleError (err, vm, info) {
  if (vm) {
    var cur = vm;
    while ((cur = cur.$parent)) {
      var hooks = cur.$options.errorCaptured;
      if (hooks) {
        for (var i = 0; i < hooks.length; i++) {
          try {
            var capture = hooks[i].call(cur, err, vm, info) === false;
            if (capture) { return }
          } catch (e) {
            globalHandleError(e, cur, 'errorCaptured hook');
          }
        }
      }
    }
  }
  globalHandleError(err, vm, info);
}

function globalHandleError (err, vm, info) {
  if (config.errorHandler) {
    try {
      return config.errorHandler.call(null, err, vm, info)
    } catch (e) {
      logError(e, null, 'config.errorHandler');
    }
  }
  logError(err, vm, info);
}

function logError (err, vm, info) {
  if (false) {
    warn(("Error in " + info + ": \"" + (err.toString()) + "\""), vm);
  }
  /* istanbul ignore else */
  if ((inBrowser || inWeex) && typeof console !== 'undefined') {
    console.error(err);
  } else {
    throw err
  }
}

/*  */
/* globals MessageChannel */

var callbacks = [];
var pending = false;

function flushCallbacks () {
  pending = false;
  var copies = callbacks.slice(0);
  callbacks.length = 0;
  for (var i = 0; i < copies.length; i++) {
    copies[i]();
  }
}

// Here we have async deferring wrappers using both micro and macro tasks.
// In < 2.4 we used micro tasks everywhere, but there are some scenarios where
// micro tasks have too high a priority and fires in between supposedly
// sequential events (e.g. #4521, #6690) or even between bubbling of the same
// event (#6566). However, using macro tasks everywhere also has subtle problems
// when state is changed right before repaint (e.g. #6813, out-in transitions).
// Here we use micro task by default, but expose a way to force macro task when
// needed (e.g. in event handlers attached by v-on).
var microTimerFunc;
var macroTimerFunc;
var useMacroTask = false;

// Determine (macro) Task defer implementation.
// Technically setImmediate should be the ideal choice, but it's only available
// in IE. The only polyfill that consistently queues the callback after all DOM
// events triggered in the same loop is by using MessageChannel.
/* istanbul ignore if */
if (typeof setImmediate !== 'undefined' && isNative(setImmediate)) {
  macroTimerFunc = function () {
    setImmediate(flushCallbacks);
  };
} else if (typeof MessageChannel !== 'undefined' && (
  isNative(MessageChannel) ||
  // PhantomJS
  MessageChannel.toString() === '[object MessageChannelConstructor]'
)) {
  var channel = new MessageChannel();
  var port = channel.port2;
  channel.port1.onmessage = flushCallbacks;
  macroTimerFunc = function () {
    port.postMessage(1);
  };
} else {
  /* istanbul ignore next */
  macroTimerFunc = function () {
    setTimeout(flushCallbacks, 0);
  };
}

// Determine MicroTask defer implementation.
/* istanbul ignore next, $flow-disable-line */
if (typeof Promise !== 'undefined' && isNative(Promise)) {
  var p = Promise.resolve();
  microTimerFunc = function () {
    p.then(flushCallbacks);
    // in problematic UIWebViews, Promise.then doesn't completely break, but
    // it can get stuck in a weird state where callbacks are pushed into the
    // microtask queue but the queue isn't being flushed, until the browser
    // needs to do some other work, e.g. handle a timer. Therefore we can
    // "force" the microtask queue to be flushed by adding an empty timer.
    if (isIOS) { setTimeout(noop); }
  };
} else {
  // fallback to macro
  microTimerFunc = macroTimerFunc;
}

/**
 * Wrap a function so that if any code inside triggers state change,
 * the changes are queued using a Task instead of a MicroTask.
 */
function withMacroTask (fn) {
  return fn._withTask || (fn._withTask = function () {
    useMacroTask = true;
    var res = fn.apply(null, arguments);
    useMacroTask = false;
    return res
  })
}

function nextTick (cb, ctx) {
  var _resolve;
  callbacks.push(function () {
    if (cb) {
      try {
        cb.call(ctx);
      } catch (e) {
        handleError(e, ctx, 'nextTick');
      }
    } else if (_resolve) {
      _resolve(ctx);
    }
  });
  if (!pending) {
    pending = true;
    if (useMacroTask) {
      macroTimerFunc();
    } else {
      microTimerFunc();
    }
  }
  // $flow-disable-line
  if (!cb && typeof Promise !== 'undefined') {
    return new Promise(function (resolve) {
      _resolve = resolve;
    })
  }
}

/*  */

var mark;
var measure;

if (false) {
  var perf = inBrowser && window.performance;
  /* istanbul ignore if */
  if (
    perf &&
    perf.mark &&
    perf.measure &&
    perf.clearMarks &&
    perf.clearMeasures
  ) {
    mark = function (tag) { return perf.mark(tag); };
    measure = function (name, startTag, endTag) {
      perf.measure(name, startTag, endTag);
      perf.clearMarks(startTag);
      perf.clearMarks(endTag);
      perf.clearMeasures(name);
    };
  }
}

/* not type checking this file because flow doesn't play well with Proxy */

var initProxy;

if (false) {
  var allowedGlobals = makeMap(
    'Infinity,undefined,NaN,isFinite,isNaN,' +
    'parseFloat,parseInt,decodeURI,decodeURIComponent,encodeURI,encodeURIComponent,' +
    'Math,Number,Date,Array,Object,Boolean,String,RegExp,Map,Set,JSON,Intl,' +
    'require' // for Webpack/Browserify
  );

  var warnNonPresent = function (target, key) {
    warn(
      "Property or method \"" + key + "\" is not defined on the instance but " +
      'referenced during render. Make sure that this property is reactive, ' +
      'either in the data option, or for class-based components, by ' +
      'initializing the property. ' +
      'See: https://vuejs.org/v2/guide/reactivity.html#Declaring-Reactive-Properties.',
      target
    );
  };

  var hasProxy =
    typeof Proxy !== 'undefined' &&
    Proxy.toString().match(/native code/);

  if (hasProxy) {
    var isBuiltInModifier = makeMap('stop,prevent,self,ctrl,shift,alt,meta,exact');
    config.keyCodes = new Proxy(config.keyCodes, {
      set: function set (target, key, value) {
        if (isBuiltInModifier(key)) {
          warn(("Avoid overwriting built-in modifier in config.keyCodes: ." + key));
          return false
        } else {
          target[key] = value;
          return true
        }
      }
    });
  }

  var hasHandler = {
    has: function has (target, key) {
      var has = key in target;
      var isAllowed = allowedGlobals(key) || key.charAt(0) === '_';
      if (!has && !isAllowed) {
        warnNonPresent(target, key);
      }
      return has || !isAllowed
    }
  };

  var getHandler = {
    get: function get (target, key) {
      if (typeof key === 'string' && !(key in target)) {
        warnNonPresent(target, key);
      }
      return target[key]
    }
  };

  initProxy = function initProxy (vm) {
    if (hasProxy) {
      // determine which proxy handler to use
      var options = vm.$options;
      var handlers = options.render && options.render._withStripped
        ? getHandler
        : hasHandler;
      vm._renderProxy = new Proxy(vm, handlers);
    } else {
      vm._renderProxy = vm;
    }
  };
}

/*  */

var seenObjects = new _Set();

/**
 * Recursively traverse an object to evoke all converted
 * getters, so that every nested property inside the object
 * is collected as a "deep" dependency.
 */
function traverse (val) {
  _traverse(val, seenObjects);
  seenObjects.clear();
}

function _traverse (val, seen) {
  var i, keys;
  var isA = Array.isArray(val);
  if ((!isA && !isObject(val)) || Object.isFrozen(val)) {
    return
  }
  if (val.__ob__) {
    var depId = val.__ob__.dep.id;
    if (seen.has(depId)) {
      return
    }
    seen.add(depId);
  }
  if (isA) {
    i = val.length;
    while (i--) { _traverse(val[i], seen); }
  } else {
    keys = Object.keys(val);
    i = keys.length;
    while (i--) { _traverse(val[keys[i]], seen); }
  }
}

/*  */

var normalizeEvent = cached(function (name) {
  var passive = name.charAt(0) === '&';
  name = passive ? name.slice(1) : name;
  var once$$1 = name.charAt(0) === '~'; // Prefixed last, checked first
  name = once$$1 ? name.slice(1) : name;
  var capture = name.charAt(0) === '!';
  name = capture ? name.slice(1) : name;
  return {
    name: name,
    once: once$$1,
    capture: capture,
    passive: passive
  }
});

function createFnInvoker (fns) {
  function invoker () {
    var arguments$1 = arguments;

    var fns = invoker.fns;
    if (Array.isArray(fns)) {
      var cloned = fns.slice();
      for (var i = 0; i < cloned.length; i++) {
        cloned[i].apply(null, arguments$1);
      }
    } else {
      // return handler return value for single handlers
      return fns.apply(null, arguments)
    }
  }
  invoker.fns = fns;
  return invoker
}

function updateListeners (
  on,
  oldOn,
  add,
  remove$$1,
  vm
) {
  var name, cur, old, event;
  for (name in on) {
    cur = on[name];
    old = oldOn[name];
    event = normalizeEvent(name);
    if (isUndef(cur)) {
      "production" !== 'production' && warn(
        "Invalid handler for event \"" + (event.name) + "\": got " + String(cur),
        vm
      );
    } else if (isUndef(old)) {
      if (isUndef(cur.fns)) {
        cur = on[name] = createFnInvoker(cur);
      }
      add(event.name, cur, event.once, event.capture, event.passive);
    } else if (cur !== old) {
      old.fns = cur;
      on[name] = old;
    }
  }
  for (name in oldOn) {
    if (isUndef(on[name])) {
      event = normalizeEvent(name);
      remove$$1(event.name, oldOn[name], event.capture);
    }
  }
}

/*  */

function mergeVNodeHook (def, hookKey, hook) {
  if (def instanceof VNode) {
    def = def.data.hook || (def.data.hook = {});
  }
  var invoker;
  var oldHook = def[hookKey];

  function wrappedHook () {
    hook.apply(this, arguments);
    // important: remove merged hook to ensure it's called only once
    // and prevent memory leak
    remove(invoker.fns, wrappedHook);
  }

  if (isUndef(oldHook)) {
    // no existing hook
    invoker = createFnInvoker([wrappedHook]);
  } else {
    /* istanbul ignore if */
    if (isDef(oldHook.fns) && isTrue(oldHook.merged)) {
      // already a merged invoker
      invoker = oldHook;
      invoker.fns.push(wrappedHook);
    } else {
      // existing plain hook
      invoker = createFnInvoker([oldHook, wrappedHook]);
    }
  }

  invoker.merged = true;
  def[hookKey] = invoker;
}

/*  */

function extractPropsFromVNodeData (
  data,
  Ctor,
  tag
) {
  // we are only extracting raw values here.
  // validation and default values are handled in the child
  // component itself.
  var propOptions = Ctor.options.props;
  if (isUndef(propOptions)) {
    return
  }
  var res = {};
  var attrs = data.attrs;
  var props = data.props;
  if (isDef(attrs) || isDef(props)) {
    for (var key in propOptions) {
      var altKey = hyphenate(key);
      if (false) {
        var keyInLowerCase = key.toLowerCase();
        if (
          key !== keyInLowerCase &&
          attrs && hasOwn(attrs, keyInLowerCase)
        ) {
          tip(
            "Prop \"" + keyInLowerCase + "\" is passed to component " +
            (formatComponentName(tag || Ctor)) + ", but the declared prop name is" +
            " \"" + key + "\". " +
            "Note that HTML attributes are case-insensitive and camelCased " +
            "props need to use their kebab-case equivalents when using in-DOM " +
            "templates. You should probably use \"" + altKey + "\" instead of \"" + key + "\"."
          );
        }
      }
      checkProp(res, props, key, altKey, true) ||
      checkProp(res, attrs, key, altKey, false);
    }
  }
  return res
}

function checkProp (
  res,
  hash,
  key,
  altKey,
  preserve
) {
  if (isDef(hash)) {
    if (hasOwn(hash, key)) {
      res[key] = hash[key];
      if (!preserve) {
        delete hash[key];
      }
      return true
    } else if (hasOwn(hash, altKey)) {
      res[key] = hash[altKey];
      if (!preserve) {
        delete hash[altKey];
      }
      return true
    }
  }
  return false
}

/*  */

// The template compiler attempts to minimize the need for normalization by
// statically analyzing the template at compile time.
//
// For plain HTML markup, normalization can be completely skipped because the
// generated render function is guaranteed to return Array<VNode>. There are
// two cases where extra normalization is needed:

// 1. When the children contains components - because a functional component
// may return an Array instead of a single root. In this case, just a simple
// normalization is needed - if any child is an Array, we flatten the whole
// thing with Array.prototype.concat. It is guaranteed to be only 1-level deep
// because functional components already normalize their own children.
function simpleNormalizeChildren (children) {
  for (var i = 0; i < children.length; i++) {
    if (Array.isArray(children[i])) {
      return Array.prototype.concat.apply([], children)
    }
  }
  return children
}

// 2. When the children contains constructs that always generated nested Arrays,
// e.g. <template>, <slot>, v-for, or when the children is provided by user
// with hand-written render functions / JSX. In such cases a full normalization
// is needed to cater to all possible types of children values.
function normalizeChildren (children) {
  return isPrimitive(children)
    ? [createTextVNode(children)]
    : Array.isArray(children)
      ? normalizeArrayChildren(children)
      : undefined
}

function isTextNode (node) {
  return isDef(node) && isDef(node.text) && isFalse(node.isComment)
}

function normalizeArrayChildren (children, nestedIndex) {
  var res = [];
  var i, c, lastIndex, last;
  for (i = 0; i < children.length; i++) {
    c = children[i];
    if (isUndef(c) || typeof c === 'boolean') { continue }
    lastIndex = res.length - 1;
    last = res[lastIndex];
    //  nested
    if (Array.isArray(c)) {
      if (c.length > 0) {
        c = normalizeArrayChildren(c, ((nestedIndex || '') + "_" + i));
        // merge adjacent text nodes
        if (isTextNode(c[0]) && isTextNode(last)) {
          res[lastIndex] = createTextVNode(last.text + (c[0]).text);
          c.shift();
        }
        res.push.apply(res, c);
      }
    } else if (isPrimitive(c)) {
      if (isTextNode(last)) {
        // merge adjacent text nodes
        // this is necessary for SSR hydration because text nodes are
        // essentially merged when rendered to HTML strings
        res[lastIndex] = createTextVNode(last.text + c);
      } else if (c !== '') {
        // convert primitive to vnode
        res.push(createTextVNode(c));
      }
    } else {
      if (isTextNode(c) && isTextNode(last)) {
        // merge adjacent text nodes
        res[lastIndex] = createTextVNode(last.text + c.text);
      } else {
        // default key for nested array children (likely generated by v-for)
        if (isTrue(children._isVList) &&
          isDef(c.tag) &&
          isUndef(c.key) &&
          isDef(nestedIndex)) {
          c.key = "__vlist" + nestedIndex + "_" + i + "__";
        }
        res.push(c);
      }
    }
  }
  return res
}

/*  */

function ensureCtor (comp, base) {
  if (
    comp.__esModule ||
    (hasSymbol && comp[Symbol.toStringTag] === 'Module')
  ) {
    comp = comp.default;
  }
  return isObject(comp)
    ? base.extend(comp)
    : comp
}

function createAsyncPlaceholder (
  factory,
  data,
  context,
  children,
  tag
) {
  var node = createEmptyVNode();
  node.asyncFactory = factory;
  node.asyncMeta = { data: data, context: context, children: children, tag: tag };
  return node
}

function resolveAsyncComponent (
  factory,
  baseCtor,
  context
) {
  if (isTrue(factory.error) && isDef(factory.errorComp)) {
    return factory.errorComp
  }

  if (isDef(factory.resolved)) {
    return factory.resolved
  }

  if (isTrue(factory.loading) && isDef(factory.loadingComp)) {
    return factory.loadingComp
  }

  if (isDef(factory.contexts)) {
    // already pending
    factory.contexts.push(context);
  } else {
    var contexts = factory.contexts = [context];
    var sync = true;

    var forceRender = function () {
      for (var i = 0, l = contexts.length; i < l; i++) {
        contexts[i].$forceUpdate();
      }
    };

    var resolve = once(function (res) {
      // cache resolved
      factory.resolved = ensureCtor(res, baseCtor);
      // invoke callbacks only if this is not a synchronous resolve
      // (async resolves are shimmed as synchronous during SSR)
      if (!sync) {
        forceRender();
      }
    });

    var reject = once(function (reason) {
      "production" !== 'production' && warn(
        "Failed to resolve async component: " + (String(factory)) +
        (reason ? ("\nReason: " + reason) : '')
      );
      if (isDef(factory.errorComp)) {
        factory.error = true;
        forceRender();
      }
    });

    var res = factory(resolve, reject);

    if (isObject(res)) {
      if (typeof res.then === 'function') {
        // () => Promise
        if (isUndef(factory.resolved)) {
          res.then(resolve, reject);
        }
      } else if (isDef(res.component) && typeof res.component.then === 'function') {
        res.component.then(resolve, reject);

        if (isDef(res.error)) {
          factory.errorComp = ensureCtor(res.error, baseCtor);
        }

        if (isDef(res.loading)) {
          factory.loadingComp = ensureCtor(res.loading, baseCtor);
          if (res.delay === 0) {
            factory.loading = true;
          } else {
            setTimeout(function () {
              if (isUndef(factory.resolved) && isUndef(factory.error)) {
                factory.loading = true;
                forceRender();
              }
            }, res.delay || 200);
          }
        }

        if (isDef(res.timeout)) {
          setTimeout(function () {
            if (isUndef(factory.resolved)) {
              reject(
                 false
                  ? ("timeout (" + (res.timeout) + "ms)")
                  : null
              );
            }
          }, res.timeout);
        }
      }
    }

    sync = false;
    // return in case resolved synchronously
    return factory.loading
      ? factory.loadingComp
      : factory.resolved
  }
}

/*  */

function isAsyncPlaceholder (node) {
  return node.isComment && node.asyncFactory
}

/*  */

function getFirstComponentChild (children) {
  if (Array.isArray(children)) {
    for (var i = 0; i < children.length; i++) {
      var c = children[i];
      if (isDef(c) && (isDef(c.componentOptions) || isAsyncPlaceholder(c))) {
        return c
      }
    }
  }
}

/*  */

/*  */

function initEvents (vm) {
  vm._events = Object.create(null);
  vm._hasHookEvent = false;
  // init parent attached events
  var listeners = vm.$options._parentListeners;
  if (listeners) {
    updateComponentListeners(vm, listeners);
  }
}

var target;

function add (event, fn, once) {
  if (once) {
    target.$once(event, fn);
  } else {
    target.$on(event, fn);
  }
}

function remove$1 (event, fn) {
  target.$off(event, fn);
}

function updateComponentListeners (
  vm,
  listeners,
  oldListeners
) {
  target = vm;
  updateListeners(listeners, oldListeners || {}, add, remove$1, vm);
  target = undefined;
}

function eventsMixin (Vue) {
  var hookRE = /^hook:/;
  Vue.prototype.$on = function (event, fn) {
    var this$1 = this;

    var vm = this;
    if (Array.isArray(event)) {
      for (var i = 0, l = event.length; i < l; i++) {
        this$1.$on(event[i], fn);
      }
    } else {
      (vm._events[event] || (vm._events[event] = [])).push(fn);
      // optimize hook:event cost by using a boolean flag marked at registration
      // instead of a hash lookup
      if (hookRE.test(event)) {
        vm._hasHookEvent = true;
      }
    }
    return vm
  };

  Vue.prototype.$once = function (event, fn) {
    var vm = this;
    function on () {
      vm.$off(event, on);
      fn.apply(vm, arguments);
    }
    on.fn = fn;
    vm.$on(event, on);
    return vm
  };

  Vue.prototype.$off = function (event, fn) {
    var this$1 = this;

    var vm = this;
    // all
    if (!arguments.length) {
      vm._events = Object.create(null);
      return vm
    }
    // array of events
    if (Array.isArray(event)) {
      for (var i = 0, l = event.length; i < l; i++) {
        this$1.$off(event[i], fn);
      }
      return vm
    }
    // specific event
    var cbs = vm._events[event];
    if (!cbs) {
      return vm
    }
    if (!fn) {
      vm._events[event] = null;
      return vm
    }
    if (fn) {
      // specific handler
      var cb;
      var i$1 = cbs.length;
      while (i$1--) {
        cb = cbs[i$1];
        if (cb === fn || cb.fn === fn) {
          cbs.splice(i$1, 1);
          break
        }
      }
    }
    return vm
  };

  Vue.prototype.$emit = function (event) {
    var vm = this;
    if (false) {
      var lowerCaseEvent = event.toLowerCase();
      if (lowerCaseEvent !== event && vm._events[lowerCaseEvent]) {
        tip(
          "Event \"" + lowerCaseEvent + "\" is emitted in component " +
          (formatComponentName(vm)) + " but the handler is registered for \"" + event + "\". " +
          "Note that HTML attributes are case-insensitive and you cannot use " +
          "v-on to listen to camelCase events when using in-DOM templates. " +
          "You should probably use \"" + (hyphenate(event)) + "\" instead of \"" + event + "\"."
        );
      }
    }
    var cbs = vm._events[event];
    if (cbs) {
      cbs = cbs.length > 1 ? toArray(cbs) : cbs;
      var args = toArray(arguments, 1);
      for (var i = 0, l = cbs.length; i < l; i++) {
        try {
          cbs[i].apply(vm, args);
        } catch (e) {
          handleError(e, vm, ("event handler for \"" + event + "\""));
        }
      }
    }
    return vm
  };
}

/*  */

/**
 * Runtime helper for resolving raw children VNodes into a slot object.
 */
function resolveSlots (
  children,
  context
) {
  var slots = {};
  if (!children) {
    return slots
  }
  for (var i = 0, l = children.length; i < l; i++) {
    var child = children[i];
    var data = child.data;
    // remove slot attribute if the node is resolved as a Vue slot node
    if (data && data.attrs && data.attrs.slot) {
      delete data.attrs.slot;
    }
    // named slots should only be respected if the vnode was rendered in the
    // same context.
    if ((child.context === context || child.fnContext === context) &&
      data && data.slot != null
    ) {
      var name = child.data.slot;
      var slot = (slots[name] || (slots[name] = []));
      if (child.tag === 'template') {
        slot.push.apply(slot, child.children);
      } else {
        slot.push(child);
      }
    } else {
      (slots.default || (slots.default = [])).push(child);
    }
  }
  // ignore slots that contains only whitespace
  for (var name$1 in slots) {
    if (slots[name$1].every(isWhitespace)) {
      delete slots[name$1];
    }
  }
  return slots
}

function isWhitespace (node) {
  return (node.isComment && !node.asyncFactory) || node.text === ' '
}

function resolveScopedSlots (
  fns, // see flow/vnode
  res
) {
  res = res || {};
  for (var i = 0; i < fns.length; i++) {
    if (Array.isArray(fns[i])) {
      resolveScopedSlots(fns[i], res);
    } else {
      res[fns[i].key] = fns[i].fn;
    }
  }
  return res
}

/*  */

var activeInstance = null;
var isUpdatingChildComponent = false;

function initLifecycle (vm) {
  var options = vm.$options;

  // locate first non-abstract parent
  var parent = options.parent;
  if (parent && !options.abstract) {
    while (parent.$options.abstract && parent.$parent) {
      parent = parent.$parent;
    }
    parent.$children.push(vm);
  }

  vm.$parent = parent;
  vm.$root = parent ? parent.$root : vm;

  vm.$children = [];
  vm.$refs = {};

  vm._watcher = null;
  vm._inactive = null;
  vm._directInactive = false;
  vm._isMounted = false;
  vm._isDestroyed = false;
  vm._isBeingDestroyed = false;
}

function lifecycleMixin (Vue) {
  Vue.prototype._update = function (vnode, hydrating) {
    var vm = this;
    if (vm._isMounted) {
      callHook(vm, 'beforeUpdate');
    }
    var prevEl = vm.$el;
    var prevVnode = vm._vnode;
    var prevActiveInstance = activeInstance;
    activeInstance = vm;
    vm._vnode = vnode;
    // Vue.prototype.__patch__ is injected in entry points
    // based on the rendering backend used.
    if (!prevVnode) {
      // initial render
      vm.$el = vm.__patch__(
        vm.$el, vnode, hydrating, false /* removeOnly */,
        vm.$options._parentElm,
        vm.$options._refElm
      );
      // no need for the ref nodes after initial patch
      // this prevents keeping a detached DOM tree in memory (#5851)
      vm.$options._parentElm = vm.$options._refElm = null;
    } else {
      // updates
      vm.$el = vm.__patch__(prevVnode, vnode);
    }
    activeInstance = prevActiveInstance;
    // update __vue__ reference
    if (prevEl) {
      prevEl.__vue__ = null;
    }
    if (vm.$el) {
      vm.$el.__vue__ = vm;
    }
    // if parent is an HOC, update its $el as well
    if (vm.$vnode && vm.$parent && vm.$vnode === vm.$parent._vnode) {
      vm.$parent.$el = vm.$el;
    }
    // updated hook is called by the scheduler to ensure that children are
    // updated in a parent's updated hook.
  };

  Vue.prototype.$forceUpdate = function () {
    var vm = this;
    if (vm._watcher) {
      vm._watcher.update();
    }
  };

  Vue.prototype.$destroy = function () {
    var vm = this;
    if (vm._isBeingDestroyed) {
      return
    }
    callHook(vm, 'beforeDestroy');
    vm._isBeingDestroyed = true;
    // remove self from parent
    var parent = vm.$parent;
    if (parent && !parent._isBeingDestroyed && !vm.$options.abstract) {
      remove(parent.$children, vm);
    }
    // teardown watchers
    if (vm._watcher) {
      vm._watcher.teardown();
    }
    var i = vm._watchers.length;
    while (i--) {
      vm._watchers[i].teardown();
    }
    // remove reference from data ob
    // frozen object may not have observer.
    if (vm._data.__ob__) {
      vm._data.__ob__.vmCount--;
    }
    // call the last hook...
    vm._isDestroyed = true;
    // invoke destroy hooks on current rendered tree
    vm.__patch__(vm._vnode, null);
    // fire destroyed hook
    callHook(vm, 'destroyed');
    // turn off all instance listeners.
    vm.$off();
    // remove __vue__ reference
    if (vm.$el) {
      vm.$el.__vue__ = null;
    }
    // release circular reference (#6759)
    if (vm.$vnode) {
      vm.$vnode.parent = null;
    }
  };
}

function mountComponent (
  vm,
  el,
  hydrating
) {
  vm.$el = el;
  if (!vm.$options.render) {
    vm.$options.render = createEmptyVNode;
    if (false) {
      /* istanbul ignore if */
      if ((vm.$options.template && vm.$options.template.charAt(0) !== '#') ||
        vm.$options.el || el) {
        warn(
          'You are using the runtime-only build of Vue where the template ' +
          'compiler is not available. Either pre-compile the templates into ' +
          'render functions, or use the compiler-included build.',
          vm
        );
      } else {
        warn(
          'Failed to mount component: template or render function not defined.',
          vm
        );
      }
    }
  }
  callHook(vm, 'beforeMount');

  var updateComponent;
  /* istanbul ignore if */
  if (false) {
    updateComponent = function () {
      var name = vm._name;
      var id = vm._uid;
      var startTag = "vue-perf-start:" + id;
      var endTag = "vue-perf-end:" + id;

      mark(startTag);
      var vnode = vm._render();
      mark(endTag);
      measure(("vue " + name + " render"), startTag, endTag);

      mark(startTag);
      vm._update(vnode, hydrating);
      mark(endTag);
      measure(("vue " + name + " patch"), startTag, endTag);
    };
  } else {
    updateComponent = function () {
      vm._update(vm._render(), hydrating);
    };
  }

  // we set this to vm._watcher inside the watcher's constructor
  // since the watcher's initial patch may call $forceUpdate (e.g. inside child
  // component's mounted hook), which relies on vm._watcher being already defined
  new Watcher(vm, updateComponent, noop, null, true /* isRenderWatcher */);
  hydrating = false;

  // manually mounted instance, call mounted on self
  // mounted is called for render-created child components in its inserted hook
  if (vm.$vnode == null) {
    vm._isMounted = true;
    callHook(vm, 'mounted');
  }
  return vm
}

function updateChildComponent (
  vm,
  propsData,
  listeners,
  parentVnode,
  renderChildren
) {
  if (false) {
    isUpdatingChildComponent = true;
  }

  // determine whether component has slot children
  // we need to do this before overwriting $options._renderChildren
  var hasChildren = !!(
    renderChildren ||               // has new static slots
    vm.$options._renderChildren ||  // has old static slots
    parentVnode.data.scopedSlots || // has new scoped slots
    vm.$scopedSlots !== emptyObject // has old scoped slots
  );

  vm.$options._parentVnode = parentVnode;
  vm.$vnode = parentVnode; // update vm's placeholder node without re-render

  if (vm._vnode) { // update child tree's parent
    vm._vnode.parent = parentVnode;
  }
  vm.$options._renderChildren = renderChildren;

  // update $attrs and $listeners hash
  // these are also reactive so they may trigger child update if the child
  // used them during render
  vm.$attrs = (parentVnode.data && parentVnode.data.attrs) || emptyObject;
  vm.$listeners = listeners || emptyObject;

  // update props
  if (propsData && vm.$options.props) {
    observerState.shouldConvert = false;
    var props = vm._props;
    var propKeys = vm.$options._propKeys || [];
    for (var i = 0; i < propKeys.length; i++) {
      var key = propKeys[i];
      props[key] = validateProp(key, vm.$options.props, propsData, vm);
    }
    observerState.shouldConvert = true;
    // keep a copy of raw propsData
    vm.$options.propsData = propsData;
  }

  // update listeners
  if (listeners) {
    var oldListeners = vm.$options._parentListeners;
    vm.$options._parentListeners = listeners;
    updateComponentListeners(vm, listeners, oldListeners);
  }
  // resolve slots + force update if has children
  if (hasChildren) {
    vm.$slots = resolveSlots(renderChildren, parentVnode.context);
    vm.$forceUpdate();
  }

  if (false) {
    isUpdatingChildComponent = false;
  }
}

function isInInactiveTree (vm) {
  while (vm && (vm = vm.$parent)) {
    if (vm._inactive) { return true }
  }
  return false
}

function activateChildComponent (vm, direct) {
  if (direct) {
    vm._directInactive = false;
    if (isInInactiveTree(vm)) {
      return
    }
  } else if (vm._directInactive) {
    return
  }
  if (vm._inactive || vm._inactive === null) {
    vm._inactive = false;
    for (var i = 0; i < vm.$children.length; i++) {
      activateChildComponent(vm.$children[i]);
    }
    callHook(vm, 'activated');
  }
}

function deactivateChildComponent (vm, direct) {
  if (direct) {
    vm._directInactive = true;
    if (isInInactiveTree(vm)) {
      return
    }
  }
  if (!vm._inactive) {
    vm._inactive = true;
    for (var i = 0; i < vm.$children.length; i++) {
      deactivateChildComponent(vm.$children[i]);
    }
    callHook(vm, 'deactivated');
  }
}

function callHook (vm, hook) {
  var handlers = vm.$options[hook];
  if (handlers) {
    for (var i = 0, j = handlers.length; i < j; i++) {
      try {
        handlers[i].call(vm);
      } catch (e) {
        handleError(e, vm, (hook + " hook"));
      }
    }
  }
  if (vm._hasHookEvent) {
    vm.$emit('hook:' + hook);
  }
}

/*  */


var MAX_UPDATE_COUNT = 100;

var queue = [];
var activatedChildren = [];
var has = {};
var circular = {};
var waiting = false;
var flushing = false;
var index = 0;

/**
 * Reset the scheduler's state.
 */
function resetSchedulerState () {
  index = queue.length = activatedChildren.length = 0;
  has = {};
  if (false) {
    circular = {};
  }
  waiting = flushing = false;
}

/**
 * Flush both queues and run the watchers.
 */
function flushSchedulerQueue () {
  flushing = true;
  var watcher, id;

  // Sort queue before flush.
  // This ensures that:
  // 1. Components are updated from parent to child. (because parent is always
  //    created before the child)
  // 2. A component's user watchers are run before its render watcher (because
  //    user watchers are created before the render watcher)
  // 3. If a component is destroyed during a parent component's watcher run,
  //    its watchers can be skipped.
  queue.sort(function (a, b) { return a.id - b.id; });

  // do not cache length because more watchers might be pushed
  // as we run existing watchers
  for (index = 0; index < queue.length; index++) {
    watcher = queue[index];
    id = watcher.id;
    has[id] = null;
    watcher.run();
    // in dev build, check and stop circular updates.
    if (false) {
      circular[id] = (circular[id] || 0) + 1;
      if (circular[id] > MAX_UPDATE_COUNT) {
        warn(
          'You may have an infinite update loop ' + (
            watcher.user
              ? ("in watcher with expression \"" + (watcher.expression) + "\"")
              : "in a component render function."
          ),
          watcher.vm
        );
        break
      }
    }
  }

  // keep copies of post queues before resetting state
  var activatedQueue = activatedChildren.slice();
  var updatedQueue = queue.slice();

  resetSchedulerState();

  // call component updated and activated hooks
  callActivatedHooks(activatedQueue);
  callUpdatedHooks(updatedQueue);

  // devtool hook
  /* istanbul ignore if */
  if (devtools && config.devtools) {
    devtools.emit('flush');
  }
}

function callUpdatedHooks (queue) {
  var i = queue.length;
  while (i--) {
    var watcher = queue[i];
    var vm = watcher.vm;
    if (vm._watcher === watcher && vm._isMounted) {
      callHook(vm, 'updated');
    }
  }
}

/**
 * Queue a kept-alive component that was activated during patch.
 * The queue will be processed after the entire tree has been patched.
 */
function queueActivatedComponent (vm) {
  // setting _inactive to false here so that a render function can
  // rely on checking whether it's in an inactive tree (e.g. router-view)
  vm._inactive = false;
  activatedChildren.push(vm);
}

function callActivatedHooks (queue) {
  for (var i = 0; i < queue.length; i++) {
    queue[i]._inactive = true;
    activateChildComponent(queue[i], true /* true */);
  }
}

/**
 * Push a watcher into the watcher queue.
 * Jobs with duplicate IDs will be skipped unless it's
 * pushed when the queue is being flushed.
 */
function queueWatcher (watcher) {
  var id = watcher.id;
  if (has[id] == null) {
    has[id] = true;
    if (!flushing) {
      queue.push(watcher);
    } else {
      // if already flushing, splice the watcher based on its id
      // if already past its id, it will be run next immediately.
      var i = queue.length - 1;
      while (i > index && queue[i].id > watcher.id) {
        i--;
      }
      queue.splice(i + 1, 0, watcher);
    }
    // queue the flush
    if (!waiting) {
      waiting = true;
      nextTick(flushSchedulerQueue);
    }
  }
}

/*  */

var uid$2 = 0;

/**
 * A watcher parses an expression, collects dependencies,
 * and fires callback when the expression value changes.
 * This is used for both the $watch() api and directives.
 */
var Watcher = function Watcher (
  vm,
  expOrFn,
  cb,
  options,
  isRenderWatcher
) {
  this.vm = vm;
  if (isRenderWatcher) {
    vm._watcher = this;
  }
  vm._watchers.push(this);
  // options
  if (options) {
    this.deep = !!options.deep;
    this.user = !!options.user;
    this.lazy = !!options.lazy;
    this.sync = !!options.sync;
  } else {
    this.deep = this.user = this.lazy = this.sync = false;
  }
  this.cb = cb;
  this.id = ++uid$2; // uid for batching
  this.active = true;
  this.dirty = this.lazy; // for lazy watchers
  this.deps = [];
  this.newDeps = [];
  this.depIds = new _Set();
  this.newDepIds = new _Set();
  this.expression =  false
    ? expOrFn.toString()
    : '';
  // parse expression for getter
  if (typeof expOrFn === 'function') {
    this.getter = expOrFn;
  } else {
    this.getter = parsePath(expOrFn);
    if (!this.getter) {
      this.getter = function () {};
      "production" !== 'production' && warn(
        "Failed watching path: \"" + expOrFn + "\" " +
        'Watcher only accepts simple dot-delimited paths. ' +
        'For full control, use a function instead.',
        vm
      );
    }
  }
  this.value = this.lazy
    ? undefined
    : this.get();
};

/**
 * Evaluate the getter, and re-collect dependencies.
 */
Watcher.prototype.get = function get () {
  pushTarget(this);
  var value;
  var vm = this.vm;
  try {
    value = this.getter.call(vm, vm);
  } catch (e) {
    if (this.user) {
      handleError(e, vm, ("getter for watcher \"" + (this.expression) + "\""));
    } else {
      throw e
    }
  } finally {
    // "touch" every property so they are all tracked as
    // dependencies for deep watching
    if (this.deep) {
      traverse(value);
    }
    popTarget();
    this.cleanupDeps();
  }
  return value
};

/**
 * Add a dependency to this directive.
 */
Watcher.prototype.addDep = function addDep (dep) {
  var id = dep.id;
  if (!this.newDepIds.has(id)) {
    this.newDepIds.add(id);
    this.newDeps.push(dep);
    if (!this.depIds.has(id)) {
      dep.addSub(this);
    }
  }
};

/**
 * Clean up for dependency collection.
 */
Watcher.prototype.cleanupDeps = function cleanupDeps () {
    var this$1 = this;

  var i = this.deps.length;
  while (i--) {
    var dep = this$1.deps[i];
    if (!this$1.newDepIds.has(dep.id)) {
      dep.removeSub(this$1);
    }
  }
  var tmp = this.depIds;
  this.depIds = this.newDepIds;
  this.newDepIds = tmp;
  this.newDepIds.clear();
  tmp = this.deps;
  this.deps = this.newDeps;
  this.newDeps = tmp;
  this.newDeps.length = 0;
};

/**
 * Subscriber interface.
 * Will be called when a dependency changes.
 */
Watcher.prototype.update = function update () {
  /* istanbul ignore else */
  if (this.lazy) {
    this.dirty = true;
  } else if (this.sync) {
    this.run();
  } else {
    queueWatcher(this);
  }
};

/**
 * Scheduler job interface.
 * Will be called by the scheduler.
 */
Watcher.prototype.run = function run () {
  if (this.active) {
    var value = this.get();
    if (
      value !== this.value ||
      // Deep watchers and watchers on Object/Arrays should fire even
      // when the value is the same, because the value may
      // have mutated.
      isObject(value) ||
      this.deep
    ) {
      // set new value
      var oldValue = this.value;
      this.value = value;
      if (this.user) {
        try {
          this.cb.call(this.vm, value, oldValue);
        } catch (e) {
          handleError(e, this.vm, ("callback for watcher \"" + (this.expression) + "\""));
        }
      } else {
        this.cb.call(this.vm, value, oldValue);
      }
    }
  }
};

/**
 * Evaluate the value of the watcher.
 * This only gets called for lazy watchers.
 */
Watcher.prototype.evaluate = function evaluate () {
  this.value = this.get();
  this.dirty = false;
};

/**
 * Depend on all deps collected by this watcher.
 */
Watcher.prototype.depend = function depend () {
    var this$1 = this;

  var i = this.deps.length;
  while (i--) {
    this$1.deps[i].depend();
  }
};

/**
 * Remove self from all dependencies' subscriber list.
 */
Watcher.prototype.teardown = function teardown () {
    var this$1 = this;

  if (this.active) {
    // remove self from vm's watcher list
    // this is a somewhat expensive operation so we skip it
    // if the vm is being destroyed.
    if (!this.vm._isBeingDestroyed) {
      remove(this.vm._watchers, this);
    }
    var i = this.deps.length;
    while (i--) {
      this$1.deps[i].removeSub(this$1);
    }
    this.active = false;
  }
};

/*  */

var sharedPropertyDefinition = {
  enumerable: true,
  configurable: true,
  get: noop,
  set: noop
};

function proxy (target, sourceKey, key) {
  sharedPropertyDefinition.get = function proxyGetter () {
    return this[sourceKey][key]
  };
  sharedPropertyDefinition.set = function proxySetter (val) {
    this[sourceKey][key] = val;
  };
  Object.defineProperty(target, key, sharedPropertyDefinition);
}

function initState (vm) {
  vm._watchers = [];
  var opts = vm.$options;
  if (opts.props) { initProps(vm, opts.props); }
  if (opts.methods) { initMethods(vm, opts.methods); }
  if (opts.data) {
    initData(vm);
  } else {
    observe(vm._data = {}, true /* asRootData */);
  }
  if (opts.computed) { initComputed(vm, opts.computed); }
  if (opts.watch && opts.watch !== nativeWatch) {
    initWatch(vm, opts.watch);
  }
}

function initProps (vm, propsOptions) {
  var propsData = vm.$options.propsData || {};
  var props = vm._props = {};
  // cache prop keys so that future props updates can iterate using Array
  // instead of dynamic object key enumeration.
  var keys = vm.$options._propKeys = [];
  var isRoot = !vm.$parent;
  // root instance props should be converted
  observerState.shouldConvert = isRoot;
  var loop = function ( key ) {
    keys.push(key);
    var value = validateProp(key, propsOptions, propsData, vm);
    /* istanbul ignore else */
    if (false) {
      var hyphenatedKey = hyphenate(key);
      if (isReservedAttribute(hyphenatedKey) ||
          config.isReservedAttr(hyphenatedKey)) {
        warn(
          ("\"" + hyphenatedKey + "\" is a reserved attribute and cannot be used as component prop."),
          vm
        );
      }
      defineReactive(props, key, value, function () {
        if (vm.$parent && !isUpdatingChildComponent) {
          warn(
            "Avoid mutating a prop directly since the value will be " +
            "overwritten whenever the parent component re-renders. " +
            "Instead, use a data or computed property based on the prop's " +
            "value. Prop being mutated: \"" + key + "\"",
            vm
          );
        }
      });
    } else {
      defineReactive(props, key, value);
    }
    // static props are already proxied on the component's prototype
    // during Vue.extend(). We only need to proxy props defined at
    // instantiation here.
    if (!(key in vm)) {
      proxy(vm, "_props", key);
    }
  };

  for (var key in propsOptions) loop( key );
  observerState.shouldConvert = true;
}

function initData (vm) {
  var data = vm.$options.data;
  data = vm._data = typeof data === 'function'
    ? getData(data, vm)
    : data || {};
  if (!isPlainObject(data)) {
    data = {};
    "production" !== 'production' && warn(
      'data functions should return an object:\n' +
      'https://vuejs.org/v2/guide/components.html#data-Must-Be-a-Function',
      vm
    );
  }
  // proxy data on instance
  var keys = Object.keys(data);
  var props = vm.$options.props;
  var methods = vm.$options.methods;
  var i = keys.length;
  while (i--) {
    var key = keys[i];
    if (false) {
      if (methods && hasOwn(methods, key)) {
        warn(
          ("Method \"" + key + "\" has already been defined as a data property."),
          vm
        );
      }
    }
    if (props && hasOwn(props, key)) {
      "production" !== 'production' && warn(
        "The data property \"" + key + "\" is already declared as a prop. " +
        "Use prop default value instead.",
        vm
      );
    } else if (!isReserved(key)) {
      proxy(vm, "_data", key);
    }
  }
  // observe data
  observe(data, true /* asRootData */);
}

function getData (data, vm) {
  try {
    return data.call(vm, vm)
  } catch (e) {
    handleError(e, vm, "data()");
    return {}
  }
}

var computedWatcherOptions = { lazy: true };

function initComputed (vm, computed) {
  var watchers = vm._computedWatchers = Object.create(null);
  // computed properties are just getters during SSR
  var isSSR = isServerRendering();

  for (var key in computed) {
    var userDef = computed[key];
    var getter = typeof userDef === 'function' ? userDef : userDef.get;
    if (false) {
      warn(
        ("Getter is missing for computed property \"" + key + "\"."),
        vm
      );
    }

    if (!isSSR) {
      // create internal watcher for the computed property.
      watchers[key] = new Watcher(
        vm,
        getter || noop,
        noop,
        computedWatcherOptions
      );
    }

    // component-defined computed properties are already defined on the
    // component prototype. We only need to define computed properties defined
    // at instantiation here.
    if (!(key in vm)) {
      defineComputed(vm, key, userDef);
    } else if (false) {
      if (key in vm.$data) {
        warn(("The computed property \"" + key + "\" is already defined in data."), vm);
      } else if (vm.$options.props && key in vm.$options.props) {
        warn(("The computed property \"" + key + "\" is already defined as a prop."), vm);
      }
    }
  }
}

function defineComputed (
  target,
  key,
  userDef
) {
  var shouldCache = !isServerRendering();
  if (typeof userDef === 'function') {
    sharedPropertyDefinition.get = shouldCache
      ? createComputedGetter(key)
      : userDef;
    sharedPropertyDefinition.set = noop;
  } else {
    sharedPropertyDefinition.get = userDef.get
      ? shouldCache && userDef.cache !== false
        ? createComputedGetter(key)
        : userDef.get
      : noop;
    sharedPropertyDefinition.set = userDef.set
      ? userDef.set
      : noop;
  }
  if (false) {
    sharedPropertyDefinition.set = function () {
      warn(
        ("Computed property \"" + key + "\" was assigned to but it has no setter."),
        this
      );
    };
  }
  Object.defineProperty(target, key, sharedPropertyDefinition);
}

function createComputedGetter (key) {
  return function computedGetter () {
    var watcher = this._computedWatchers && this._computedWatchers[key];
    if (watcher) {
      if (watcher.dirty) {
        watcher.evaluate();
      }
      if (Dep.target) {
        watcher.depend();
      }
      return watcher.value
    }
  }
}

function initMethods (vm, methods) {
  var props = vm.$options.props;
  for (var key in methods) {
    if (false) {
      if (methods[key] == null) {
        warn(
          "Method \"" + key + "\" has an undefined value in the component definition. " +
          "Did you reference the function correctly?",
          vm
        );
      }
      if (props && hasOwn(props, key)) {
        warn(
          ("Method \"" + key + "\" has already been defined as a prop."),
          vm
        );
      }
      if ((key in vm) && isReserved(key)) {
        warn(
          "Method \"" + key + "\" conflicts with an existing Vue instance method. " +
          "Avoid defining component methods that start with _ or $."
        );
      }
    }
    vm[key] = methods[key] == null ? noop : bind(methods[key], vm);
  }
}

function initWatch (vm, watch) {
  for (var key in watch) {
    var handler = watch[key];
    if (Array.isArray(handler)) {
      for (var i = 0; i < handler.length; i++) {
        createWatcher(vm, key, handler[i]);
      }
    } else {
      createWatcher(vm, key, handler);
    }
  }
}

function createWatcher (
  vm,
  keyOrFn,
  handler,
  options
) {
  if (isPlainObject(handler)) {
    options = handler;
    handler = handler.handler;
  }
  if (typeof handler === 'string') {
    handler = vm[handler];
  }
  return vm.$watch(keyOrFn, handler, options)
}

function stateMixin (Vue) {
  // flow somehow has problems with directly declared definition object
  // when using Object.defineProperty, so we have to procedurally build up
  // the object here.
  var dataDef = {};
  dataDef.get = function () { return this._data };
  var propsDef = {};
  propsDef.get = function () { return this._props };
  if (false) {
    dataDef.set = function (newData) {
      warn(
        'Avoid replacing instance root $data. ' +
        'Use nested data properties instead.',
        this
      );
    };
    propsDef.set = function () {
      warn("$props is readonly.", this);
    };
  }
  Object.defineProperty(Vue.prototype, '$data', dataDef);
  Object.defineProperty(Vue.prototype, '$props', propsDef);

  Vue.prototype.$set = set;
  Vue.prototype.$delete = del;

  Vue.prototype.$watch = function (
    expOrFn,
    cb,
    options
  ) {
    var vm = this;
    if (isPlainObject(cb)) {
      return createWatcher(vm, expOrFn, cb, options)
    }
    options = options || {};
    options.user = true;
    var watcher = new Watcher(vm, expOrFn, cb, options);
    if (options.immediate) {
      cb.call(vm, watcher.value);
    }
    return function unwatchFn () {
      watcher.teardown();
    }
  };
}

/*  */

function initProvide (vm) {
  var provide = vm.$options.provide;
  if (provide) {
    vm._provided = typeof provide === 'function'
      ? provide.call(vm)
      : provide;
  }
}

function initInjections (vm) {
  var result = resolveInject(vm.$options.inject, vm);
  if (result) {
    observerState.shouldConvert = false;
    Object.keys(result).forEach(function (key) {
      /* istanbul ignore else */
      if (false) {
        defineReactive(vm, key, result[key], function () {
          warn(
            "Avoid mutating an injected value directly since the changes will be " +
            "overwritten whenever the provided component re-renders. " +
            "injection being mutated: \"" + key + "\"",
            vm
          );
        });
      } else {
        defineReactive(vm, key, result[key]);
      }
    });
    observerState.shouldConvert = true;
  }
}

function resolveInject (inject, vm) {
  if (inject) {
    // inject is :any because flow is not smart enough to figure out cached
    var result = Object.create(null);
    var keys = hasSymbol
        ? Reflect.ownKeys(inject).filter(function (key) {
          /* istanbul ignore next */
          return Object.getOwnPropertyDescriptor(inject, key).enumerable
        })
        : Object.keys(inject);

    for (var i = 0; i < keys.length; i++) {
      var key = keys[i];
      var provideKey = inject[key].from;
      var source = vm;
      while (source) {
        if (source._provided && provideKey in source._provided) {
          result[key] = source._provided[provideKey];
          break
        }
        source = source.$parent;
      }
      if (!source) {
        if ('default' in inject[key]) {
          var provideDefault = inject[key].default;
          result[key] = typeof provideDefault === 'function'
            ? provideDefault.call(vm)
            : provideDefault;
        } else if (false) {
          warn(("Injection \"" + key + "\" not found"), vm);
        }
      }
    }
    return result
  }
}

/*  */

/**
 * Runtime helper for rendering v-for lists.
 */
function renderList (
  val,
  render
) {
  var ret, i, l, keys, key;
  if (Array.isArray(val) || typeof val === 'string') {
    ret = new Array(val.length);
    for (i = 0, l = val.length; i < l; i++) {
      ret[i] = render(val[i], i);
    }
  } else if (typeof val === 'number') {
    ret = new Array(val);
    for (i = 0; i < val; i++) {
      ret[i] = render(i + 1, i);
    }
  } else if (isObject(val)) {
    keys = Object.keys(val);
    ret = new Array(keys.length);
    for (i = 0, l = keys.length; i < l; i++) {
      key = keys[i];
      ret[i] = render(val[key], key, i);
    }
  }
  if (isDef(ret)) {
    (ret)._isVList = true;
  }
  return ret
}

/*  */

/**
 * Runtime helper for rendering <slot>
 */
function renderSlot (
  name,
  fallback,
  props,
  bindObject
) {
  var scopedSlotFn = this.$scopedSlots[name];
  var nodes;
  if (scopedSlotFn) { // scoped slot
    props = props || {};
    if (bindObject) {
      if (false) {
        warn(
          'slot v-bind without argument expects an Object',
          this
        );
      }
      props = extend(extend({}, bindObject), props);
    }
    nodes = scopedSlotFn(props) || fallback;
  } else {
    var slotNodes = this.$slots[name];
    // warn duplicate slot usage
    if (slotNodes) {
      if (false) {
        warn(
          "Duplicate presence of slot \"" + name + "\" found in the same render tree " +
          "- this will likely cause render errors.",
          this
        );
      }
      slotNodes._rendered = true;
    }
    nodes = slotNodes || fallback;
  }

  var target = props && props.slot;
  if (target) {
    return this.$createElement('template', { slot: target }, nodes)
  } else {
    return nodes
  }
}

/*  */

/**
 * Runtime helper for resolving filters
 */
function resolveFilter (id) {
  return resolveAsset(this.$options, 'filters', id, true) || identity
}

/*  */

/**
 * Runtime helper for checking keyCodes from config.
 * exposed as Vue.prototype._k
 * passing in eventKeyName as last argument separately for backwards compat
 */
function checkKeyCodes (
  eventKeyCode,
  key,
  builtInAlias,
  eventKeyName
) {
  var keyCodes = config.keyCodes[key] || builtInAlias;
  if (keyCodes) {
    if (Array.isArray(keyCodes)) {
      return keyCodes.indexOf(eventKeyCode) === -1
    } else {
      return keyCodes !== eventKeyCode
    }
  } else if (eventKeyName) {
    return hyphenate(eventKeyName) !== key
  }
}

/*  */

/**
 * Runtime helper for merging v-bind="object" into a VNode's data.
 */
function bindObjectProps (
  data,
  tag,
  value,
  asProp,
  isSync
) {
  if (value) {
    if (!isObject(value)) {
      "production" !== 'production' && warn(
        'v-bind without argument expects an Object or Array value',
        this
      );
    } else {
      if (Array.isArray(value)) {
        value = toObject(value);
      }
      var hash;
      var loop = function ( key ) {
        if (
          key === 'class' ||
          key === 'style' ||
          isReservedAttribute(key)
        ) {
          hash = data;
        } else {
          var type = data.attrs && data.attrs.type;
          hash = asProp || config.mustUseProp(tag, type, key)
            ? data.domProps || (data.domProps = {})
            : data.attrs || (data.attrs = {});
        }
        if (!(key in hash)) {
          hash[key] = value[key];

          if (isSync) {
            var on = data.on || (data.on = {});
            on[("update:" + key)] = function ($event) {
              value[key] = $event;
            };
          }
        }
      };

      for (var key in value) loop( key );
    }
  }
  return data
}

/*  */

/**
 * Runtime helper for rendering static trees.
 */
function renderStatic (
  index,
  isInFor,
  isOnce
) {
  // render fns generated by compiler < 2.5.4 does not provide v-once
  // information to runtime so be conservative
  var isOldVersion = arguments.length < 3;
  // if a static tree is generated by v-once, it is cached on the instance;
  // otherwise it is purely static and can be cached on the shared options
  // across all instances.
  var renderFns = this.$options.staticRenderFns;
  var cached = isOldVersion || isOnce
    ? (this._staticTrees || (this._staticTrees = []))
    : (renderFns.cached || (renderFns.cached = []));
  var tree = cached[index];
  // if has already-rendered static tree and not inside v-for,
  // we can reuse the same tree by doing a shallow clone.
  if (tree && !isInFor) {
    return Array.isArray(tree)
      ? cloneVNodes(tree)
      : cloneVNode(tree)
  }
  // otherwise, render a fresh tree.
  tree = cached[index] = renderFns[index].call(this._renderProxy, null, this);
  markStatic(tree, ("__static__" + index), false);
  return tree
}

/**
 * Runtime helper for v-once.
 * Effectively it means marking the node as static with a unique key.
 */
function markOnce (
  tree,
  index,
  key
) {
  markStatic(tree, ("__once__" + index + (key ? ("_" + key) : "")), true);
  return tree
}

function markStatic (
  tree,
  key,
  isOnce
) {
  if (Array.isArray(tree)) {
    for (var i = 0; i < tree.length; i++) {
      if (tree[i] && typeof tree[i] !== 'string') {
        markStaticNode(tree[i], (key + "_" + i), isOnce);
      }
    }
  } else {
    markStaticNode(tree, key, isOnce);
  }
}

function markStaticNode (node, key, isOnce) {
  node.isStatic = true;
  node.key = key;
  node.isOnce = isOnce;
}

/*  */

function bindObjectListeners (data, value) {
  if (value) {
    if (!isPlainObject(value)) {
      "production" !== 'production' && warn(
        'v-on without argument expects an Object value',
        this
      );
    } else {
      var on = data.on = data.on ? extend({}, data.on) : {};
      for (var key in value) {
        var existing = on[key];
        var ours = value[key];
        on[key] = existing ? [].concat(existing, ours) : ours;
      }
    }
  }
  return data
}

/*  */

function installRenderHelpers (target) {
  target._o = markOnce;
  target._n = toNumber;
  target._s = toString;
  target._l = renderList;
  target._t = renderSlot;
  target._q = looseEqual;
  target._i = looseIndexOf;
  target._m = renderStatic;
  target._f = resolveFilter;
  target._k = checkKeyCodes;
  target._b = bindObjectProps;
  target._v = createTextVNode;
  target._e = createEmptyVNode;
  target._u = resolveScopedSlots;
  target._g = bindObjectListeners;
}

/*  */

function FunctionalRenderContext (
  data,
  props,
  children,
  parent,
  Ctor
) {
  var options = Ctor.options;
  this.data = data;
  this.props = props;
  this.children = children;
  this.parent = parent;
  this.listeners = data.on || emptyObject;
  this.injections = resolveInject(options.inject, parent);
  this.slots = function () { return resolveSlots(children, parent); };

  // ensure the createElement function in functional components
  // gets a unique context - this is necessary for correct named slot check
  var contextVm = Object.create(parent);
  var isCompiled = isTrue(options._compiled);
  var needNormalization = !isCompiled;

  // support for compiled functional template
  if (isCompiled) {
    // exposing $options for renderStatic()
    this.$options = options;
    // pre-resolve slots for renderSlot()
    this.$slots = this.slots();
    this.$scopedSlots = data.scopedSlots || emptyObject;
  }

  if (options._scopeId) {
    this._c = function (a, b, c, d) {
      var vnode = createElement(contextVm, a, b, c, d, needNormalization);
      if (vnode) {
        vnode.fnScopeId = options._scopeId;
        vnode.fnContext = parent;
      }
      return vnode
    };
  } else {
    this._c = function (a, b, c, d) { return createElement(contextVm, a, b, c, d, needNormalization); };
  }
}

installRenderHelpers(FunctionalRenderContext.prototype);

function createFunctionalComponent (
  Ctor,
  propsData,
  data,
  contextVm,
  children
) {
  var options = Ctor.options;
  var props = {};
  var propOptions = options.props;
  if (isDef(propOptions)) {
    for (var key in propOptions) {
      props[key] = validateProp(key, propOptions, propsData || emptyObject);
    }
  } else {
    if (isDef(data.attrs)) { mergeProps(props, data.attrs); }
    if (isDef(data.props)) { mergeProps(props, data.props); }
  }

  var renderContext = new FunctionalRenderContext(
    data,
    props,
    children,
    contextVm,
    Ctor
  );

  var vnode = options.render.call(null, renderContext._c, renderContext);

  if (vnode instanceof VNode) {
    vnode.fnContext = contextVm;
    vnode.fnOptions = options;
    if (data.slot) {
      (vnode.data || (vnode.data = {})).slot = data.slot;
    }
  }

  return vnode
}

function mergeProps (to, from) {
  for (var key in from) {
    to[camelize(key)] = from[key];
  }
}

/*  */

// hooks to be invoked on component VNodes during patch
var componentVNodeHooks = {
  init: function init (
    vnode,
    hydrating,
    parentElm,
    refElm
  ) {
    if (!vnode.componentInstance || vnode.componentInstance._isDestroyed) {
      var child = vnode.componentInstance = createComponentInstanceForVnode(
        vnode,
        activeInstance,
        parentElm,
        refElm
      );
      child.$mount(hydrating ? vnode.elm : undefined, hydrating);
    } else if (vnode.data.keepAlive) {
      // kept-alive components, treat as a patch
      var mountedNode = vnode; // work around flow
      componentVNodeHooks.prepatch(mountedNode, mountedNode);
    }
  },

  prepatch: function prepatch (oldVnode, vnode) {
    var options = vnode.componentOptions;
    var child = vnode.componentInstance = oldVnode.componentInstance;
    updateChildComponent(
      child,
      options.propsData, // updated props
      options.listeners, // updated listeners
      vnode, // new parent vnode
      options.children // new children
    );
  },

  insert: function insert (vnode) {
    var context = vnode.context;
    var componentInstance = vnode.componentInstance;
    if (!componentInstance._isMounted) {
      componentInstance._isMounted = true;
      callHook(componentInstance, 'mounted');
    }
    if (vnode.data.keepAlive) {
      if (context._isMounted) {
        // vue-router#1212
        // During updates, a kept-alive component's child components may
        // change, so directly walking the tree here may call activated hooks
        // on incorrect children. Instead we push them into a queue which will
        // be processed after the whole patch process ended.
        queueActivatedComponent(componentInstance);
      } else {
        activateChildComponent(componentInstance, true /* direct */);
      }
    }
  },

  destroy: function destroy (vnode) {
    var componentInstance = vnode.componentInstance;
    if (!componentInstance._isDestroyed) {
      if (!vnode.data.keepAlive) {
        componentInstance.$destroy();
      } else {
        deactivateChildComponent(componentInstance, true /* direct */);
      }
    }
  }
};

var hooksToMerge = Object.keys(componentVNodeHooks);

function createComponent (
  Ctor,
  data,
  context,
  children,
  tag
) {
  if (isUndef(Ctor)) {
    return
  }

  var baseCtor = context.$options._base;

  // plain options object: turn it into a constructor
  if (isObject(Ctor)) {
    Ctor = baseCtor.extend(Ctor);
  }

  // if at this stage it's not a constructor or an async component factory,
  // reject.
  if (typeof Ctor !== 'function') {
    if (false) {
      warn(("Invalid Component definition: " + (String(Ctor))), context);
    }
    return
  }

  // async component
  var asyncFactory;
  if (isUndef(Ctor.cid)) {
    asyncFactory = Ctor;
    Ctor = resolveAsyncComponent(asyncFactory, baseCtor, context);
    if (Ctor === undefined) {
      // return a placeholder node for async component, which is rendered
      // as a comment node but preserves all the raw information for the node.
      // the information will be used for async server-rendering and hydration.
      return createAsyncPlaceholder(
        asyncFactory,
        data,
        context,
        children,
        tag
      )
    }
  }

  data = data || {};

  // resolve constructor options in case global mixins are applied after
  // component constructor creation
  resolveConstructorOptions(Ctor);

  // transform component v-model data into props & events
  if (isDef(data.model)) {
    transformModel(Ctor.options, data);
  }

  // extract props
  var propsData = extractPropsFromVNodeData(data, Ctor, tag);

  // functional component
  if (isTrue(Ctor.options.functional)) {
    return createFunctionalComponent(Ctor, propsData, data, context, children)
  }

  // extract listeners, since these needs to be treated as
  // child component listeners instead of DOM listeners
  var listeners = data.on;
  // replace with listeners with .native modifier
  // so it gets processed during parent component patch.
  data.on = data.nativeOn;

  if (isTrue(Ctor.options.abstract)) {
    // abstract components do not keep anything
    // other than props & listeners & slot

    // work around flow
    var slot = data.slot;
    data = {};
    if (slot) {
      data.slot = slot;
    }
  }

  // merge component management hooks onto the placeholder node
  mergeHooks(data);

  // return a placeholder vnode
  var name = Ctor.options.name || tag;
  var vnode = new VNode(
    ("vue-component-" + (Ctor.cid) + (name ? ("-" + name) : '')),
    data, undefined, undefined, undefined, context,
    { Ctor: Ctor, propsData: propsData, listeners: listeners, tag: tag, children: children },
    asyncFactory
  );
  return vnode
}

function createComponentInstanceForVnode (
  vnode, // we know it's MountedComponentVNode but flow doesn't
  parent, // activeInstance in lifecycle state
  parentElm,
  refElm
) {
  var vnodeComponentOptions = vnode.componentOptions;
  var options = {
    _isComponent: true,
    parent: parent,
    propsData: vnodeComponentOptions.propsData,
    _componentTag: vnodeComponentOptions.tag,
    _parentVnode: vnode,
    _parentListeners: vnodeComponentOptions.listeners,
    _renderChildren: vnodeComponentOptions.children,
    _parentElm: parentElm || null,
    _refElm: refElm || null
  };
  // check inline-template render functions
  var inlineTemplate = vnode.data.inlineTemplate;
  if (isDef(inlineTemplate)) {
    options.render = inlineTemplate.render;
    options.staticRenderFns = inlineTemplate.staticRenderFns;
  }
  return new vnodeComponentOptions.Ctor(options)
}

function mergeHooks (data) {
  if (!data.hook) {
    data.hook = {};
  }
  for (var i = 0; i < hooksToMerge.length; i++) {
    var key = hooksToMerge[i];
    var fromParent = data.hook[key];
    var ours = componentVNodeHooks[key];
    data.hook[key] = fromParent ? mergeHook$1(ours, fromParent) : ours;
  }
}

function mergeHook$1 (one, two) {
  return function (a, b, c, d) {
    one(a, b, c, d);
    two(a, b, c, d);
  }
}

// transform component v-model info (value and callback) into
// prop and event handler respectively.
function transformModel (options, data) {
  var prop = (options.model && options.model.prop) || 'value';
  var event = (options.model && options.model.event) || 'input';(data.props || (data.props = {}))[prop] = data.model.value;
  var on = data.on || (data.on = {});
  if (isDef(on[event])) {
    on[event] = [data.model.callback].concat(on[event]);
  } else {
    on[event] = data.model.callback;
  }
}

/*  */

var SIMPLE_NORMALIZE = 1;
var ALWAYS_NORMALIZE = 2;

// wrapper function for providing a more flexible interface
// without getting yelled at by flow
function createElement (
  context,
  tag,
  data,
  children,
  normalizationType,
  alwaysNormalize
) {
  if (Array.isArray(data) || isPrimitive(data)) {
    normalizationType = children;
    children = data;
    data = undefined;
  }
  if (isTrue(alwaysNormalize)) {
    normalizationType = ALWAYS_NORMALIZE;
  }
  return _createElement(context, tag, data, children, normalizationType)
}

function _createElement (
  context,
  tag,
  data,
  children,
  normalizationType
) {
  if (isDef(data) && isDef((data).__ob__)) {
    "production" !== 'production' && warn(
      "Avoid using observed data object as vnode data: " + (JSON.stringify(data)) + "\n" +
      'Always create fresh vnode data objects in each render!',
      context
    );
    return createEmptyVNode()
  }
  // object syntax in v-bind
  if (isDef(data) && isDef(data.is)) {
    tag = data.is;
  }
  if (!tag) {
    // in case of component :is set to falsy value
    return createEmptyVNode()
  }
  // warn against non-primitive key
  if (false
  ) {
    warn(
      'Avoid using non-primitive value as key, ' +
      'use string/number value instead.',
      context
    );
  }
  // support single function children as default scoped slot
  if (Array.isArray(children) &&
    typeof children[0] === 'function'
  ) {
    data = data || {};
    data.scopedSlots = { default: children[0] };
    children.length = 0;
  }
  if (normalizationType === ALWAYS_NORMALIZE) {
    children = normalizeChildren(children);
  } else if (normalizationType === SIMPLE_NORMALIZE) {
    children = simpleNormalizeChildren(children);
  }
  var vnode, ns;
  if (typeof tag === 'string') {
    var Ctor;
    ns = (context.$vnode && context.$vnode.ns) || config.getTagNamespace(tag);
    if (config.isReservedTag(tag)) {
      // platform built-in elements
      vnode = new VNode(
        config.parsePlatformTagName(tag), data, children,
        undefined, undefined, context
      );
    } else if (isDef(Ctor = resolveAsset(context.$options, 'components', tag))) {
      // component
      vnode = createComponent(Ctor, data, context, children, tag);
    } else {
      // unknown or unlisted namespaced elements
      // check at runtime because it may get assigned a namespace when its
      // parent normalizes children
      vnode = new VNode(
        tag, data, children,
        undefined, undefined, context
      );
    }
  } else {
    // direct component options / constructor
    vnode = createComponent(tag, data, context, children);
  }
  if (isDef(vnode)) {
    if (ns) { applyNS(vnode, ns); }
    return vnode
  } else {
    return createEmptyVNode()
  }
}

function applyNS (vnode, ns, force) {
  vnode.ns = ns;
  if (vnode.tag === 'foreignObject') {
    // use default namespace inside foreignObject
    ns = undefined;
    force = true;
  }
  if (isDef(vnode.children)) {
    for (var i = 0, l = vnode.children.length; i < l; i++) {
      var child = vnode.children[i];
      if (isDef(child.tag) && (isUndef(child.ns) || isTrue(force))) {
        applyNS(child, ns, force);
      }
    }
  }
}

/*  */

function initRender (vm) {
  vm._vnode = null; // the root of the child tree
  vm._staticTrees = null; // v-once cached trees
  var options = vm.$options;
  var parentVnode = vm.$vnode = options._parentVnode; // the placeholder node in parent tree
  var renderContext = parentVnode && parentVnode.context;
  vm.$slots = resolveSlots(options._renderChildren, renderContext);
  vm.$scopedSlots = emptyObject;
  // bind the createElement fn to this instance
  // so that we get proper render context inside it.
  // args order: tag, data, children, normalizationType, alwaysNormalize
  // internal version is used by render functions compiled from templates
  vm._c = function (a, b, c, d) { return createElement(vm, a, b, c, d, false); };
  // normalization is always applied for the public version, used in
  // user-written render functions.
  vm.$createElement = function (a, b, c, d) { return createElement(vm, a, b, c, d, true); };

  // $attrs & $listeners are exposed for easier HOC creation.
  // they need to be reactive so that HOCs using them are always updated
  var parentData = parentVnode && parentVnode.data;

  /* istanbul ignore else */
  if (false) {
    defineReactive(vm, '$attrs', parentData && parentData.attrs || emptyObject, function () {
      !isUpdatingChildComponent && warn("$attrs is readonly.", vm);
    }, true);
    defineReactive(vm, '$listeners', options._parentListeners || emptyObject, function () {
      !isUpdatingChildComponent && warn("$listeners is readonly.", vm);
    }, true);
  } else {
    defineReactive(vm, '$attrs', parentData && parentData.attrs || emptyObject, null, true);
    defineReactive(vm, '$listeners', options._parentListeners || emptyObject, null, true);
  }
}

function renderMixin (Vue) {
  // install runtime convenience helpers
  installRenderHelpers(Vue.prototype);

  Vue.prototype.$nextTick = function (fn) {
    return nextTick(fn, this)
  };

  Vue.prototype._render = function () {
    var vm = this;
    var ref = vm.$options;
    var render = ref.render;
    var _parentVnode = ref._parentVnode;

    if (vm._isMounted) {
      // if the parent didn't update, the slot nodes will be the ones from
      // last render. They need to be cloned to ensure "freshness" for this render.
      for (var key in vm.$slots) {
        var slot = vm.$slots[key];
        // _rendered is a flag added by renderSlot, but may not be present
        // if the slot is passed from manually written render functions
        if (slot._rendered || (slot[0] && slot[0].elm)) {
          vm.$slots[key] = cloneVNodes(slot, true /* deep */);
        }
      }
    }

    vm.$scopedSlots = (_parentVnode && _parentVnode.data.scopedSlots) || emptyObject;

    // set parent vnode. this allows render functions to have access
    // to the data on the placeholder node.
    vm.$vnode = _parentVnode;
    // render self
    var vnode;
    try {
      vnode = render.call(vm._renderProxy, vm.$createElement);
    } catch (e) {
      handleError(e, vm, "render");
      // return error render result,
      // or previous vnode to prevent render error causing blank component
      /* istanbul ignore else */
      if (false) {
        if (vm.$options.renderError) {
          try {
            vnode = vm.$options.renderError.call(vm._renderProxy, vm.$createElement, e);
          } catch (e) {
            handleError(e, vm, "renderError");
            vnode = vm._vnode;
          }
        } else {
          vnode = vm._vnode;
        }
      } else {
        vnode = vm._vnode;
      }
    }
    // return empty vnode in case the render function errored out
    if (!(vnode instanceof VNode)) {
      if (false) {
        warn(
          'Multiple root nodes returned from render function. Render function ' +
          'should return a single root node.',
          vm
        );
      }
      vnode = createEmptyVNode();
    }
    // set parent
    vnode.parent = _parentVnode;
    return vnode
  };
}

/*  */

var uid$1 = 0;

function initMixin (Vue) {
  Vue.prototype._init = function (options) {
    var vm = this;
    // a uid
    vm._uid = uid$1++;

    var startTag, endTag;
    /* istanbul ignore if */
    if (false) {
      startTag = "vue-perf-start:" + (vm._uid);
      endTag = "vue-perf-end:" + (vm._uid);
      mark(startTag);
    }

    // a flag to avoid this being observed
    vm._isVue = true;
    // merge options
    if (options && options._isComponent) {
      // optimize internal component instantiation
      // since dynamic options merging is pretty slow, and none of the
      // internal component options needs special treatment.
      initInternalComponent(vm, options);
    } else {
      vm.$options = mergeOptions(
        resolveConstructorOptions(vm.constructor),
        options || {},
        vm
      );
    }
    /* istanbul ignore else */
    if (false) {
      initProxy(vm);
    } else {
      vm._renderProxy = vm;
    }
    // expose real self
    vm._self = vm;
    initLifecycle(vm);
    initEvents(vm);
    initRender(vm);
    callHook(vm, 'beforeCreate');
    initInjections(vm); // resolve injections before data/props
    initState(vm);
    initProvide(vm); // resolve provide after data/props
    callHook(vm, 'created');

    /* istanbul ignore if */
    if (false) {
      vm._name = formatComponentName(vm, false);
      mark(endTag);
      measure(("vue " + (vm._name) + " init"), startTag, endTag);
    }

    if (vm.$options.el) {
      vm.$mount(vm.$options.el);
    }
  };
}

function initInternalComponent (vm, options) {
  var opts = vm.$options = Object.create(vm.constructor.options);
  // doing this because it's faster than dynamic enumeration.
  opts.parent = options.parent;
  opts.propsData = options.propsData;
  opts._parentVnode = options._parentVnode;
  opts._parentListeners = options._parentListeners;
  opts._renderChildren = options._renderChildren;
  opts._componentTag = options._componentTag;
  opts._parentElm = options._parentElm;
  opts._refElm = options._refElm;
  if (options.render) {
    opts.render = options.render;
    opts.staticRenderFns = options.staticRenderFns;
  }
}

function resolveConstructorOptions (Ctor) {
  var options = Ctor.options;
  if (Ctor.super) {
    var superOptions = resolveConstructorOptions(Ctor.super);
    var cachedSuperOptions = Ctor.superOptions;
    if (superOptions !== cachedSuperOptions) {
      // super option changed,
      // need to resolve new options.
      Ctor.superOptions = superOptions;
      // check if there are any late-modified/attached options (#4976)
      var modifiedOptions = resolveModifiedOptions(Ctor);
      // update base extend options
      if (modifiedOptions) {
        extend(Ctor.extendOptions, modifiedOptions);
      }
      options = Ctor.options = mergeOptions(superOptions, Ctor.extendOptions);
      if (options.name) {
        options.components[options.name] = Ctor;
      }
    }
  }
  return options
}

function resolveModifiedOptions (Ctor) {
  var modified;
  var latest = Ctor.options;
  var extended = Ctor.extendOptions;
  var sealed = Ctor.sealedOptions;
  for (var key in latest) {
    if (latest[key] !== sealed[key]) {
      if (!modified) { modified = {}; }
      modified[key] = dedupe(latest[key], extended[key], sealed[key]);
    }
  }
  return modified
}

function dedupe (latest, extended, sealed) {
  // compare latest and sealed to ensure lifecycle hooks won't be duplicated
  // between merges
  if (Array.isArray(latest)) {
    var res = [];
    sealed = Array.isArray(sealed) ? sealed : [sealed];
    extended = Array.isArray(extended) ? extended : [extended];
    for (var i = 0; i < latest.length; i++) {
      // push original options and not sealed options to exclude duplicated options
      if (extended.indexOf(latest[i]) >= 0 || sealed.indexOf(latest[i]) < 0) {
        res.push(latest[i]);
      }
    }
    return res
  } else {
    return latest
  }
}

function Vue$3 (options) {
  if (false
  ) {
    warn('Vue is a constructor and should be called with the `new` keyword');
  }
  this._init(options);
}

initMixin(Vue$3);
stateMixin(Vue$3);
eventsMixin(Vue$3);
lifecycleMixin(Vue$3);
renderMixin(Vue$3);

/*  */

function initUse (Vue) {
  Vue.use = function (plugin) {
    var installedPlugins = (this._installedPlugins || (this._installedPlugins = []));
    if (installedPlugins.indexOf(plugin) > -1) {
      return this
    }

    // additional parameters
    var args = toArray(arguments, 1);
    args.unshift(this);
    if (typeof plugin.install === 'function') {
      plugin.install.apply(plugin, args);
    } else if (typeof plugin === 'function') {
      plugin.apply(null, args);
    }
    installedPlugins.push(plugin);
    return this
  };
}

/*  */

function initMixin$1 (Vue) {
  Vue.mixin = function (mixin) {
    this.options = mergeOptions(this.options, mixin);
    return this
  };
}

/*  */

function initExtend (Vue) {
  /**
   * Each instance constructor, including Vue, has a unique
   * cid. This enables us to create wrapped "child
   * constructors" for prototypal inheritance and cache them.
   */
  Vue.cid = 0;
  var cid = 1;

  /**
   * Class inheritance
   */
  Vue.extend = function (extendOptions) {
    extendOptions = extendOptions || {};
    var Super = this;
    var SuperId = Super.cid;
    var cachedCtors = extendOptions._Ctor || (extendOptions._Ctor = {});
    if (cachedCtors[SuperId]) {
      return cachedCtors[SuperId]
    }

    var name = extendOptions.name || Super.options.name;
    if (false) {
      if (!/^[a-zA-Z][\w-]*$/.test(name)) {
        warn(
          'Invalid component name: "' + name + '". Component names ' +
          'can only contain alphanumeric characters and the hyphen, ' +
          'and must start with a letter.'
        );
      }
    }

    var Sub = function VueComponent (options) {
      this._init(options);
    };
    Sub.prototype = Object.create(Super.prototype);
    Sub.prototype.constructor = Sub;
    Sub.cid = cid++;
    Sub.options = mergeOptions(
      Super.options,
      extendOptions
    );
    Sub['super'] = Super;

    // For props and computed properties, we define the proxy getters on
    // the Vue instances at extension time, on the extended prototype. This
    // avoids Object.defineProperty calls for each instance created.
    if (Sub.options.props) {
      initProps$1(Sub);
    }
    if (Sub.options.computed) {
      initComputed$1(Sub);
    }

    // allow further extension/mixin/plugin usage
    Sub.extend = Super.extend;
    Sub.mixin = Super.mixin;
    Sub.use = Super.use;

    // create asset registers, so extended classes
    // can have their private assets too.
    ASSET_TYPES.forEach(function (type) {
      Sub[type] = Super[type];
    });
    // enable recursive self-lookup
    if (name) {
      Sub.options.components[name] = Sub;
    }

    // keep a reference to the super options at extension time.
    // later at instantiation we can check if Super's options have
    // been updated.
    Sub.superOptions = Super.options;
    Sub.extendOptions = extendOptions;
    Sub.sealedOptions = extend({}, Sub.options);

    // cache constructor
    cachedCtors[SuperId] = Sub;
    return Sub
  };
}

function initProps$1 (Comp) {
  var props = Comp.options.props;
  for (var key in props) {
    proxy(Comp.prototype, "_props", key);
  }
}

function initComputed$1 (Comp) {
  var computed = Comp.options.computed;
  for (var key in computed) {
    defineComputed(Comp.prototype, key, computed[key]);
  }
}

/*  */

function initAssetRegisters (Vue) {
  /**
   * Create asset registration methods.
   */
  ASSET_TYPES.forEach(function (type) {
    Vue[type] = function (
      id,
      definition
    ) {
      if (!definition) {
        return this.options[type + 's'][id]
      } else {
        /* istanbul ignore if */
        if (false) {
          if (type === 'component' && config.isReservedTag(id)) {
            warn(
              'Do not use built-in or reserved HTML elements as component ' +
              'id: ' + id
            );
          }
        }
        if (type === 'component' && isPlainObject(definition)) {
          definition.name = definition.name || id;
          definition = this.options._base.extend(definition);
        }
        if (type === 'directive' && typeof definition === 'function') {
          definition = { bind: definition, update: definition };
        }
        this.options[type + 's'][id] = definition;
        return definition
      }
    };
  });
}

/*  */

function getComponentName (opts) {
  return opts && (opts.Ctor.options.name || opts.tag)
}

function matches (pattern, name) {
  if (Array.isArray(pattern)) {
    return pattern.indexOf(name) > -1
  } else if (typeof pattern === 'string') {
    return pattern.split(',').indexOf(name) > -1
  } else if (isRegExp(pattern)) {
    return pattern.test(name)
  }
  /* istanbul ignore next */
  return false
}

function pruneCache (keepAliveInstance, filter) {
  var cache = keepAliveInstance.cache;
  var keys = keepAliveInstance.keys;
  var _vnode = keepAliveInstance._vnode;
  for (var key in cache) {
    var cachedNode = cache[key];
    if (cachedNode) {
      var name = getComponentName(cachedNode.componentOptions);
      if (name && !filter(name)) {
        pruneCacheEntry(cache, key, keys, _vnode);
      }
    }
  }
}

function pruneCacheEntry (
  cache,
  key,
  keys,
  current
) {
  var cached$$1 = cache[key];
  if (cached$$1 && (!current || cached$$1.tag !== current.tag)) {
    cached$$1.componentInstance.$destroy();
  }
  cache[key] = null;
  remove(keys, key);
}

var patternTypes = [String, RegExp, Array];

var KeepAlive = {
  name: 'keep-alive',
  abstract: true,

  props: {
    include: patternTypes,
    exclude: patternTypes,
    max: [String, Number]
  },

  created: function created () {
    this.cache = Object.create(null);
    this.keys = [];
  },

  destroyed: function destroyed () {
    var this$1 = this;

    for (var key in this$1.cache) {
      pruneCacheEntry(this$1.cache, key, this$1.keys);
    }
  },

  watch: {
    include: function include (val) {
      pruneCache(this, function (name) { return matches(val, name); });
    },
    exclude: function exclude (val) {
      pruneCache(this, function (name) { return !matches(val, name); });
    }
  },

  render: function render () {
    var slot = this.$slots.default;
    var vnode = getFirstComponentChild(slot);
    var componentOptions = vnode && vnode.componentOptions;
    if (componentOptions) {
      // check pattern
      var name = getComponentName(componentOptions);
      var ref = this;
      var include = ref.include;
      var exclude = ref.exclude;
      if (
        // not included
        (include && (!name || !matches(include, name))) ||
        // excluded
        (exclude && name && matches(exclude, name))
      ) {
        return vnode
      }

      var ref$1 = this;
      var cache = ref$1.cache;
      var keys = ref$1.keys;
      var key = vnode.key == null
        // same constructor may get registered as different local components
        // so cid alone is not enough (#3269)
        ? componentOptions.Ctor.cid + (componentOptions.tag ? ("::" + (componentOptions.tag)) : '')
        : vnode.key;
      if (cache[key]) {
        vnode.componentInstance = cache[key].componentInstance;
        // make current key freshest
        remove(keys, key);
        keys.push(key);
      } else {
        cache[key] = vnode;
        keys.push(key);
        // prune oldest entry
        if (this.max && keys.length > parseInt(this.max)) {
          pruneCacheEntry(cache, keys[0], keys, this._vnode);
        }
      }

      vnode.data.keepAlive = true;
    }
    return vnode || (slot && slot[0])
  }
};

var builtInComponents = {
  KeepAlive: KeepAlive
};

/*  */

function initGlobalAPI (Vue) {
  // config
  var configDef = {};
  configDef.get = function () { return config; };
  if (false) {
    configDef.set = function () {
      warn(
        'Do not replace the Vue.config object, set individual fields instead.'
      );
    };
  }
  Object.defineProperty(Vue, 'config', configDef);

  // exposed util methods.
  // NOTE: these are not considered part of the public API - avoid relying on
  // them unless you are aware of the risk.
  Vue.util = {
    warn: warn,
    extend: extend,
    mergeOptions: mergeOptions,
    defineReactive: defineReactive
  };

  Vue.set = set;
  Vue.delete = del;
  Vue.nextTick = nextTick;

  Vue.options = Object.create(null);
  ASSET_TYPES.forEach(function (type) {
    Vue.options[type + 's'] = Object.create(null);
  });

  // this is used to identify the "base" constructor to extend all plain-object
  // components with in Weex's multi-instance scenarios.
  Vue.options._base = Vue;

  extend(Vue.options.components, builtInComponents);

  initUse(Vue);
  initMixin$1(Vue);
  initExtend(Vue);
  initAssetRegisters(Vue);
}

initGlobalAPI(Vue$3);

Object.defineProperty(Vue$3.prototype, '$isServer', {
  get: isServerRendering
});

Object.defineProperty(Vue$3.prototype, '$ssrContext', {
  get: function get () {
    /* istanbul ignore next */
    return this.$vnode && this.$vnode.ssrContext
  }
});

Vue$3.version = '2.5.9';

/*  */

// these are reserved for web because they are directly compiled away
// during template compilation
var isReservedAttr = makeMap('style,class');

// attributes that should be using props for binding
var acceptValue = makeMap('input,textarea,option,select,progress');
var mustUseProp = function (tag, type, attr) {
  return (
    (attr === 'value' && acceptValue(tag)) && type !== 'button' ||
    (attr === 'selected' && tag === 'option') ||
    (attr === 'checked' && tag === 'input') ||
    (attr === 'muted' && tag === 'video')
  )
};

var isEnumeratedAttr = makeMap('contenteditable,draggable,spellcheck');

var isBooleanAttr = makeMap(
  'allowfullscreen,async,autofocus,autoplay,checked,compact,controls,declare,' +
  'default,defaultchecked,defaultmuted,defaultselected,defer,disabled,' +
  'enabled,formnovalidate,hidden,indeterminate,inert,ismap,itemscope,loop,multiple,' +
  'muted,nohref,noresize,noshade,novalidate,nowrap,open,pauseonexit,readonly,' +
  'required,reversed,scoped,seamless,selected,sortable,translate,' +
  'truespeed,typemustmatch,visible'
);

var xlinkNS = 'http://www.w3.org/1999/xlink';

var isXlink = function (name) {
  return name.charAt(5) === ':' && name.slice(0, 5) === 'xlink'
};

var getXlinkProp = function (name) {
  return isXlink(name) ? name.slice(6, name.length) : ''
};

var isFalsyAttrValue = function (val) {
  return val == null || val === false
};

/*  */

function genClassForVnode (vnode) {
  var data = vnode.data;
  var parentNode = vnode;
  var childNode = vnode;
  while (isDef(childNode.componentInstance)) {
    childNode = childNode.componentInstance._vnode;
    if (childNode.data) {
      data = mergeClassData(childNode.data, data);
    }
  }
  while (isDef(parentNode = parentNode.parent)) {
    if (parentNode.data) {
      data = mergeClassData(data, parentNode.data);
    }
  }
  return renderClass(data.staticClass, data.class)
}

function mergeClassData (child, parent) {
  return {
    staticClass: concat(child.staticClass, parent.staticClass),
    class: isDef(child.class)
      ? [child.class, parent.class]
      : parent.class
  }
}

function renderClass (
  staticClass,
  dynamicClass
) {
  if (isDef(staticClass) || isDef(dynamicClass)) {
    return concat(staticClass, stringifyClass(dynamicClass))
  }
  /* istanbul ignore next */
  return ''
}

function concat (a, b) {
  return a ? b ? (a + ' ' + b) : a : (b || '')
}

function stringifyClass (value) {
  if (Array.isArray(value)) {
    return stringifyArray(value)
  }
  if (isObject(value)) {
    return stringifyObject(value)
  }
  if (typeof value === 'string') {
    return value
  }
  /* istanbul ignore next */
  return ''
}

function stringifyArray (value) {
  var res = '';
  var stringified;
  for (var i = 0, l = value.length; i < l; i++) {
    if (isDef(stringified = stringifyClass(value[i])) && stringified !== '') {
      if (res) { res += ' '; }
      res += stringified;
    }
  }
  return res
}

function stringifyObject (value) {
  var res = '';
  for (var key in value) {
    if (value[key]) {
      if (res) { res += ' '; }
      res += key;
    }
  }
  return res
}

/*  */

var namespaceMap = {
  svg: 'http://www.w3.org/2000/svg',
  math: 'http://www.w3.org/1998/Math/MathML'
};

var isHTMLTag = makeMap(
  'html,body,base,head,link,meta,style,title,' +
  'address,article,aside,footer,header,h1,h2,h3,h4,h5,h6,hgroup,nav,section,' +
  'div,dd,dl,dt,figcaption,figure,picture,hr,img,li,main,ol,p,pre,ul,' +
  'a,b,abbr,bdi,bdo,br,cite,code,data,dfn,em,i,kbd,mark,q,rp,rt,rtc,ruby,' +
  's,samp,small,span,strong,sub,sup,time,u,var,wbr,area,audio,map,track,video,' +
  'embed,object,param,source,canvas,script,noscript,del,ins,' +
  'caption,col,colgroup,table,thead,tbody,td,th,tr,' +
  'button,datalist,fieldset,form,input,label,legend,meter,optgroup,option,' +
  'output,progress,select,textarea,' +
  'details,dialog,menu,menuitem,summary,' +
  'content,element,shadow,template,blockquote,iframe,tfoot'
);

// this map is intentionally selective, only covering SVG elements that may
// contain child elements.
var isSVG = makeMap(
  'svg,animate,circle,clippath,cursor,defs,desc,ellipse,filter,font-face,' +
  'foreignObject,g,glyph,image,line,marker,mask,missing-glyph,path,pattern,' +
  'polygon,polyline,rect,switch,symbol,text,textpath,tspan,use,view',
  true
);

var isPreTag = function (tag) { return tag === 'pre'; };

var isReservedTag = function (tag) {
  return isHTMLTag(tag) || isSVG(tag)
};

function getTagNamespace (tag) {
  if (isSVG(tag)) {
    return 'svg'
  }
  // basic support for MathML
  // note it doesn't support other MathML elements being component roots
  if (tag === 'math') {
    return 'math'
  }
}

var unknownElementCache = Object.create(null);
function isUnknownElement (tag) {
  /* istanbul ignore if */
  if (!inBrowser) {
    return true
  }
  if (isReservedTag(tag)) {
    return false
  }
  tag = tag.toLowerCase();
  /* istanbul ignore if */
  if (unknownElementCache[tag] != null) {
    return unknownElementCache[tag]
  }
  var el = document.createElement(tag);
  if (tag.indexOf('-') > -1) {
    // http://stackoverflow.com/a/28210364/1070244
    return (unknownElementCache[tag] = (
      el.constructor === window.HTMLUnknownElement ||
      el.constructor === window.HTMLElement
    ))
  } else {
    return (unknownElementCache[tag] = /HTMLUnknownElement/.test(el.toString()))
  }
}

var isTextInputType = makeMap('text,number,password,search,email,tel,url');

/*  */

/**
 * Query an element selector if it's not an element already.
 */
function query (el) {
  if (typeof el === 'string') {
    var selected = document.querySelector(el);
    if (!selected) {
      "production" !== 'production' && warn(
        'Cannot find element: ' + el
      );
      return document.createElement('div')
    }
    return selected
  } else {
    return el
  }
}

/*  */

function createElement$1 (tagName, vnode) {
  var elm = document.createElement(tagName);
  if (tagName !== 'select') {
    return elm
  }
  // false or null will remove the attribute but undefined will not
  if (vnode.data && vnode.data.attrs && vnode.data.attrs.multiple !== undefined) {
    elm.setAttribute('multiple', 'multiple');
  }
  return elm
}

function createElementNS (namespace, tagName) {
  return document.createElementNS(namespaceMap[namespace], tagName)
}

function createTextNode (text) {
  return document.createTextNode(text)
}

function createComment (text) {
  return document.createComment(text)
}

function insertBefore (parentNode, newNode, referenceNode) {
  parentNode.insertBefore(newNode, referenceNode);
}

function removeChild (node, child) {
  node.removeChild(child);
}

function appendChild (node, child) {
  node.appendChild(child);
}

function parentNode (node) {
  return node.parentNode
}

function nextSibling (node) {
  return node.nextSibling
}

function tagName (node) {
  return node.tagName
}

function setTextContent (node, text) {
  node.textContent = text;
}

function setAttribute (node, key, val) {
  node.setAttribute(key, val);
}


var nodeOps = Object.freeze({
	createElement: createElement$1,
	createElementNS: createElementNS,
	createTextNode: createTextNode,
	createComment: createComment,
	insertBefore: insertBefore,
	removeChild: removeChild,
	appendChild: appendChild,
	parentNode: parentNode,
	nextSibling: nextSibling,
	tagName: tagName,
	setTextContent: setTextContent,
	setAttribute: setAttribute
});

/*  */

var ref = {
  create: function create (_, vnode) {
    registerRef(vnode);
  },
  update: function update (oldVnode, vnode) {
    if (oldVnode.data.ref !== vnode.data.ref) {
      registerRef(oldVnode, true);
      registerRef(vnode);
    }
  },
  destroy: function destroy (vnode) {
    registerRef(vnode, true);
  }
};

function registerRef (vnode, isRemoval) {
  var key = vnode.data.ref;
  if (!key) { return }

  var vm = vnode.context;
  var ref = vnode.componentInstance || vnode.elm;
  var refs = vm.$refs;
  if (isRemoval) {
    if (Array.isArray(refs[key])) {
      remove(refs[key], ref);
    } else if (refs[key] === ref) {
      refs[key] = undefined;
    }
  } else {
    if (vnode.data.refInFor) {
      if (!Array.isArray(refs[key])) {
        refs[key] = [ref];
      } else if (refs[key].indexOf(ref) < 0) {
        // $flow-disable-line
        refs[key].push(ref);
      }
    } else {
      refs[key] = ref;
    }
  }
}

/**
 * Virtual DOM patching algorithm based on Snabbdom by
 * Simon Friis Vindum (@paldepind)
 * Licensed under the MIT License
 * https://github.com/paldepind/snabbdom/blob/master/LICENSE
 *
 * modified by Evan You (@yyx990803)
 *
 * Not type-checking this because this file is perf-critical and the cost
 * of making flow understand it is not worth it.
 */

var emptyNode = new VNode('', {}, []);

var hooks = ['create', 'activate', 'update', 'remove', 'destroy'];

function sameVnode (a, b) {
  return (
    a.key === b.key && (
      (
        a.tag === b.tag &&
        a.isComment === b.isComment &&
        isDef(a.data) === isDef(b.data) &&
        sameInputType(a, b)
      ) || (
        isTrue(a.isAsyncPlaceholder) &&
        a.asyncFactory === b.asyncFactory &&
        isUndef(b.asyncFactory.error)
      )
    )
  )
}

function sameInputType (a, b) {
  if (a.tag !== 'input') { return true }
  var i;
  var typeA = isDef(i = a.data) && isDef(i = i.attrs) && i.type;
  var typeB = isDef(i = b.data) && isDef(i = i.attrs) && i.type;
  return typeA === typeB || isTextInputType(typeA) && isTextInputType(typeB)
}

function createKeyToOldIdx (children, beginIdx, endIdx) {
  var i, key;
  var map = {};
  for (i = beginIdx; i <= endIdx; ++i) {
    key = children[i].key;
    if (isDef(key)) { map[key] = i; }
  }
  return map
}

function createPatchFunction (backend) {
  var i, j;
  var cbs = {};

  var modules = backend.modules;
  var nodeOps = backend.nodeOps;

  for (i = 0; i < hooks.length; ++i) {
    cbs[hooks[i]] = [];
    for (j = 0; j < modules.length; ++j) {
      if (isDef(modules[j][hooks[i]])) {
        cbs[hooks[i]].push(modules[j][hooks[i]]);
      }
    }
  }

  function emptyNodeAt (elm) {
    return new VNode(nodeOps.tagName(elm).toLowerCase(), {}, [], undefined, elm)
  }

  function createRmCb (childElm, listeners) {
    function remove () {
      if (--remove.listeners === 0) {
        removeNode(childElm);
      }
    }
    remove.listeners = listeners;
    return remove
  }

  function removeNode (el) {
    var parent = nodeOps.parentNode(el);
    // element may have already been removed due to v-html / v-text
    if (isDef(parent)) {
      nodeOps.removeChild(parent, el);
    }
  }

  function isUnknownElement$$1 (vnode, inVPre) {
    return (
      !inVPre &&
      !vnode.ns &&
      !(
        config.ignoredElements.length &&
        config.ignoredElements.some(function (ignore) {
          return isRegExp(ignore)
            ? ignore.test(vnode.tag)
            : ignore === vnode.tag
        })
      ) &&
      config.isUnknownElement(vnode.tag)
    )
  }

  var creatingElmInVPre = 0;
  function createElm (vnode, insertedVnodeQueue, parentElm, refElm, nested) {
    vnode.isRootInsert = !nested; // for transition enter check
    if (createComponent(vnode, insertedVnodeQueue, parentElm, refElm)) {
      return
    }

    var data = vnode.data;
    var children = vnode.children;
    var tag = vnode.tag;
    if (isDef(tag)) {
      if (false) {
        if (data && data.pre) {
          creatingElmInVPre++;
        }
        if (isUnknownElement$$1(vnode, creatingElmInVPre)) {
          warn(
            'Unknown custom element: <' + tag + '> - did you ' +
            'register the component correctly? For recursive components, ' +
            'make sure to provide the "name" option.',
            vnode.context
          );
        }
      }
      vnode.elm = vnode.ns
        ? nodeOps.createElementNS(vnode.ns, tag)
        : nodeOps.createElement(tag, vnode);
      setScope(vnode);

      /* istanbul ignore if */
      {
        createChildren(vnode, children, insertedVnodeQueue);
        if (isDef(data)) {
          invokeCreateHooks(vnode, insertedVnodeQueue);
        }
        insert(parentElm, vnode.elm, refElm);
      }

      if (false) {
        creatingElmInVPre--;
      }
    } else if (isTrue(vnode.isComment)) {
      vnode.elm = nodeOps.createComment(vnode.text);
      insert(parentElm, vnode.elm, refElm);
    } else {
      vnode.elm = nodeOps.createTextNode(vnode.text);
      insert(parentElm, vnode.elm, refElm);
    }
  }

  function createComponent (vnode, insertedVnodeQueue, parentElm, refElm) {
    var i = vnode.data;
    if (isDef(i)) {
      var isReactivated = isDef(vnode.componentInstance) && i.keepAlive;
      if (isDef(i = i.hook) && isDef(i = i.init)) {
        i(vnode, false /* hydrating */, parentElm, refElm);
      }
      // after calling the init hook, if the vnode is a child component
      // it should've created a child instance and mounted it. the child
      // component also has set the placeholder vnode's elm.
      // in that case we can just return the element and be done.
      if (isDef(vnode.componentInstance)) {
        initComponent(vnode, insertedVnodeQueue);
        if (isTrue(isReactivated)) {
          reactivateComponent(vnode, insertedVnodeQueue, parentElm, refElm);
        }
        return true
      }
    }
  }

  function initComponent (vnode, insertedVnodeQueue) {
    if (isDef(vnode.data.pendingInsert)) {
      insertedVnodeQueue.push.apply(insertedVnodeQueue, vnode.data.pendingInsert);
      vnode.data.pendingInsert = null;
    }
    vnode.elm = vnode.componentInstance.$el;
    if (isPatchable(vnode)) {
      invokeCreateHooks(vnode, insertedVnodeQueue);
      setScope(vnode);
    } else {
      // empty component root.
      // skip all element-related modules except for ref (#3455)
      registerRef(vnode);
      // make sure to invoke the insert hook
      insertedVnodeQueue.push(vnode);
    }
  }

  function reactivateComponent (vnode, insertedVnodeQueue, parentElm, refElm) {
    var i;
    // hack for #4339: a reactivated component with inner transition
    // does not trigger because the inner node's created hooks are not called
    // again. It's not ideal to involve module-specific logic in here but
    // there doesn't seem to be a better way to do it.
    var innerNode = vnode;
    while (innerNode.componentInstance) {
      innerNode = innerNode.componentInstance._vnode;
      if (isDef(i = innerNode.data) && isDef(i = i.transition)) {
        for (i = 0; i < cbs.activate.length; ++i) {
          cbs.activate[i](emptyNode, innerNode);
        }
        insertedVnodeQueue.push(innerNode);
        break
      }
    }
    // unlike a newly created component,
    // a reactivated keep-alive component doesn't insert itself
    insert(parentElm, vnode.elm, refElm);
  }

  function insert (parent, elm, ref$$1) {
    if (isDef(parent)) {
      if (isDef(ref$$1)) {
        if (ref$$1.parentNode === parent) {
          nodeOps.insertBefore(parent, elm, ref$$1);
        }
      } else {
        nodeOps.appendChild(parent, elm);
      }
    }
  }

  function createChildren (vnode, children, insertedVnodeQueue) {
    if (Array.isArray(children)) {
      for (var i = 0; i < children.length; ++i) {
        createElm(children[i], insertedVnodeQueue, vnode.elm, null, true);
      }
    } else if (isPrimitive(vnode.text)) {
      nodeOps.appendChild(vnode.elm, nodeOps.createTextNode(vnode.text));
    }
  }

  function isPatchable (vnode) {
    while (vnode.componentInstance) {
      vnode = vnode.componentInstance._vnode;
    }
    return isDef(vnode.tag)
  }

  function invokeCreateHooks (vnode, insertedVnodeQueue) {
    for (var i$1 = 0; i$1 < cbs.create.length; ++i$1) {
      cbs.create[i$1](emptyNode, vnode);
    }
    i = vnode.data.hook; // Reuse variable
    if (isDef(i)) {
      if (isDef(i.create)) { i.create(emptyNode, vnode); }
      if (isDef(i.insert)) { insertedVnodeQueue.push(vnode); }
    }
  }

  // set scope id attribute for scoped CSS.
  // this is implemented as a special case to avoid the overhead
  // of going through the normal attribute patching process.
  function setScope (vnode) {
    var i;
    if (isDef(i = vnode.fnScopeId)) {
      nodeOps.setAttribute(vnode.elm, i, '');
    } else {
      var ancestor = vnode;
      while (ancestor) {
        if (isDef(i = ancestor.context) && isDef(i = i.$options._scopeId)) {
          nodeOps.setAttribute(vnode.elm, i, '');
        }
        ancestor = ancestor.parent;
      }
    }
    // for slot content they should also get the scopeId from the host instance.
    if (isDef(i = activeInstance) &&
      i !== vnode.context &&
      i !== vnode.fnContext &&
      isDef(i = i.$options._scopeId)
    ) {
      nodeOps.setAttribute(vnode.elm, i, '');
    }
  }

  function addVnodes (parentElm, refElm, vnodes, startIdx, endIdx, insertedVnodeQueue) {
    for (; startIdx <= endIdx; ++startIdx) {
      createElm(vnodes[startIdx], insertedVnodeQueue, parentElm, refElm);
    }
  }

  function invokeDestroyHook (vnode) {
    var i, j;
    var data = vnode.data;
    if (isDef(data)) {
      if (isDef(i = data.hook) && isDef(i = i.destroy)) { i(vnode); }
      for (i = 0; i < cbs.destroy.length; ++i) { cbs.destroy[i](vnode); }
    }
    if (isDef(i = vnode.children)) {
      for (j = 0; j < vnode.children.length; ++j) {
        invokeDestroyHook(vnode.children[j]);
      }
    }
  }

  function removeVnodes (parentElm, vnodes, startIdx, endIdx) {
    for (; startIdx <= endIdx; ++startIdx) {
      var ch = vnodes[startIdx];
      if (isDef(ch)) {
        if (isDef(ch.tag)) {
          removeAndInvokeRemoveHook(ch);
          invokeDestroyHook(ch);
        } else { // Text node
          removeNode(ch.elm);
        }
      }
    }
  }

  function removeAndInvokeRemoveHook (vnode, rm) {
    if (isDef(rm) || isDef(vnode.data)) {
      var i;
      var listeners = cbs.remove.length + 1;
      if (isDef(rm)) {
        // we have a recursively passed down rm callback
        // increase the listeners count
        rm.listeners += listeners;
      } else {
        // directly removing
        rm = createRmCb(vnode.elm, listeners);
      }
      // recursively invoke hooks on child component root node
      if (isDef(i = vnode.componentInstance) && isDef(i = i._vnode) && isDef(i.data)) {
        removeAndInvokeRemoveHook(i, rm);
      }
      for (i = 0; i < cbs.remove.length; ++i) {
        cbs.remove[i](vnode, rm);
      }
      if (isDef(i = vnode.data.hook) && isDef(i = i.remove)) {
        i(vnode, rm);
      } else {
        rm();
      }
    } else {
      removeNode(vnode.elm);
    }
  }

  function updateChildren (parentElm, oldCh, newCh, insertedVnodeQueue, removeOnly) {
    var oldStartIdx = 0;
    var newStartIdx = 0;
    var oldEndIdx = oldCh.length - 1;
    var oldStartVnode = oldCh[0];
    var oldEndVnode = oldCh[oldEndIdx];
    var newEndIdx = newCh.length - 1;
    var newStartVnode = newCh[0];
    var newEndVnode = newCh[newEndIdx];
    var oldKeyToIdx, idxInOld, vnodeToMove, refElm;

    // removeOnly is a special flag used only by <transition-group>
    // to ensure removed elements stay in correct relative positions
    // during leaving transitions
    var canMove = !removeOnly;

    while (oldStartIdx <= oldEndIdx && newStartIdx <= newEndIdx) {
      if (isUndef(oldStartVnode)) {
        oldStartVnode = oldCh[++oldStartIdx]; // Vnode has been moved left
      } else if (isUndef(oldEndVnode)) {
        oldEndVnode = oldCh[--oldEndIdx];
      } else if (sameVnode(oldStartVnode, newStartVnode)) {
        patchVnode(oldStartVnode, newStartVnode, insertedVnodeQueue);
        oldStartVnode = oldCh[++oldStartIdx];
        newStartVnode = newCh[++newStartIdx];
      } else if (sameVnode(oldEndVnode, newEndVnode)) {
        patchVnode(oldEndVnode, newEndVnode, insertedVnodeQueue);
        oldEndVnode = oldCh[--oldEndIdx];
        newEndVnode = newCh[--newEndIdx];
      } else if (sameVnode(oldStartVnode, newEndVnode)) { // Vnode moved right
        patchVnode(oldStartVnode, newEndVnode, insertedVnodeQueue);
        canMove && nodeOps.insertBefore(parentElm, oldStartVnode.elm, nodeOps.nextSibling(oldEndVnode.elm));
        oldStartVnode = oldCh[++oldStartIdx];
        newEndVnode = newCh[--newEndIdx];
      } else if (sameVnode(oldEndVnode, newStartVnode)) { // Vnode moved left
        patchVnode(oldEndVnode, newStartVnode, insertedVnodeQueue);
        canMove && nodeOps.insertBefore(parentElm, oldEndVnode.elm, oldStartVnode.elm);
        oldEndVnode = oldCh[--oldEndIdx];
        newStartVnode = newCh[++newStartIdx];
      } else {
        if (isUndef(oldKeyToIdx)) { oldKeyToIdx = createKeyToOldIdx(oldCh, oldStartIdx, oldEndIdx); }
        idxInOld = isDef(newStartVnode.key)
          ? oldKeyToIdx[newStartVnode.key]
          : findIdxInOld(newStartVnode, oldCh, oldStartIdx, oldEndIdx);
        if (isUndef(idxInOld)) { // New element
          createElm(newStartVnode, insertedVnodeQueue, parentElm, oldStartVnode.elm);
        } else {
          vnodeToMove = oldCh[idxInOld];
          /* istanbul ignore if */
          if (false) {
            warn(
              'It seems there are duplicate keys that is causing an update error. ' +
              'Make sure each v-for item has a unique key.'
            );
          }
          if (sameVnode(vnodeToMove, newStartVnode)) {
            patchVnode(vnodeToMove, newStartVnode, insertedVnodeQueue);
            oldCh[idxInOld] = undefined;
            canMove && nodeOps.insertBefore(parentElm, vnodeToMove.elm, oldStartVnode.elm);
          } else {
            // same key but different element. treat as new element
            createElm(newStartVnode, insertedVnodeQueue, parentElm, oldStartVnode.elm);
          }
        }
        newStartVnode = newCh[++newStartIdx];
      }
    }
    if (oldStartIdx > oldEndIdx) {
      refElm = isUndef(newCh[newEndIdx + 1]) ? null : newCh[newEndIdx + 1].elm;
      addVnodes(parentElm, refElm, newCh, newStartIdx, newEndIdx, insertedVnodeQueue);
    } else if (newStartIdx > newEndIdx) {
      removeVnodes(parentElm, oldCh, oldStartIdx, oldEndIdx);
    }
  }

  function findIdxInOld (node, oldCh, start, end) {
    for (var i = start; i < end; i++) {
      var c = oldCh[i];
      if (isDef(c) && sameVnode(node, c)) { return i }
    }
  }

  function patchVnode (oldVnode, vnode, insertedVnodeQueue, removeOnly) {
    if (oldVnode === vnode) {
      return
    }

    var elm = vnode.elm = oldVnode.elm;

    if (isTrue(oldVnode.isAsyncPlaceholder)) {
      if (isDef(vnode.asyncFactory.resolved)) {
        hydrate(oldVnode.elm, vnode, insertedVnodeQueue);
      } else {
        vnode.isAsyncPlaceholder = true;
      }
      return
    }

    // reuse element for static trees.
    // note we only do this if the vnode is cloned -
    // if the new node is not cloned it means the render functions have been
    // reset by the hot-reload-api and we need to do a proper re-render.
    if (isTrue(vnode.isStatic) &&
      isTrue(oldVnode.isStatic) &&
      vnode.key === oldVnode.key &&
      (isTrue(vnode.isCloned) || isTrue(vnode.isOnce))
    ) {
      vnode.componentInstance = oldVnode.componentInstance;
      return
    }

    var i;
    var data = vnode.data;
    if (isDef(data) && isDef(i = data.hook) && isDef(i = i.prepatch)) {
      i(oldVnode, vnode);
    }

    var oldCh = oldVnode.children;
    var ch = vnode.children;
    if (isDef(data) && isPatchable(vnode)) {
      for (i = 0; i < cbs.update.length; ++i) { cbs.update[i](oldVnode, vnode); }
      if (isDef(i = data.hook) && isDef(i = i.update)) { i(oldVnode, vnode); }
    }
    if (isUndef(vnode.text)) {
      if (isDef(oldCh) && isDef(ch)) {
        if (oldCh !== ch) { updateChildren(elm, oldCh, ch, insertedVnodeQueue, removeOnly); }
      } else if (isDef(ch)) {
        if (isDef(oldVnode.text)) { nodeOps.setTextContent(elm, ''); }
        addVnodes(elm, null, ch, 0, ch.length - 1, insertedVnodeQueue);
      } else if (isDef(oldCh)) {
        removeVnodes(elm, oldCh, 0, oldCh.length - 1);
      } else if (isDef(oldVnode.text)) {
        nodeOps.setTextContent(elm, '');
      }
    } else if (oldVnode.text !== vnode.text) {
      nodeOps.setTextContent(elm, vnode.text);
    }
    if (isDef(data)) {
      if (isDef(i = data.hook) && isDef(i = i.postpatch)) { i(oldVnode, vnode); }
    }
  }

  function invokeInsertHook (vnode, queue, initial) {
    // delay insert hooks for component root nodes, invoke them after the
    // element is really inserted
    if (isTrue(initial) && isDef(vnode.parent)) {
      vnode.parent.data.pendingInsert = queue;
    } else {
      for (var i = 0; i < queue.length; ++i) {
        queue[i].data.hook.insert(queue[i]);
      }
    }
  }

  var hydrationBailed = false;
  // list of modules that can skip create hook during hydration because they
  // are already rendered on the client or has no need for initialization
  // Note: style is excluded because it relies on initial clone for future
  // deep updates (#7063).
  var isRenderedModule = makeMap('attrs,class,staticClass,staticStyle,key');

  // Note: this is a browser-only function so we can assume elms are DOM nodes.
  function hydrate (elm, vnode, insertedVnodeQueue, inVPre) {
    var i;
    var tag = vnode.tag;
    var data = vnode.data;
    var children = vnode.children;
    inVPre = inVPre || (data && data.pre);
    vnode.elm = elm;

    if (isTrue(vnode.isComment) && isDef(vnode.asyncFactory)) {
      vnode.isAsyncPlaceholder = true;
      return true
    }
    // assert node match
    if (false) {
      if (!assertNodeMatch(elm, vnode, inVPre)) {
        return false
      }
    }
    if (isDef(data)) {
      if (isDef(i = data.hook) && isDef(i = i.init)) { i(vnode, true /* hydrating */); }
      if (isDef(i = vnode.componentInstance)) {
        // child component. it should have hydrated its own tree.
        initComponent(vnode, insertedVnodeQueue);
        return true
      }
    }
    if (isDef(tag)) {
      if (isDef(children)) {
        // empty element, allow client to pick up and populate children
        if (!elm.hasChildNodes()) {
          createChildren(vnode, children, insertedVnodeQueue);
        } else {
          // v-html and domProps: innerHTML
          if (isDef(i = data) && isDef(i = i.domProps) && isDef(i = i.innerHTML)) {
            if (i !== elm.innerHTML) {
              /* istanbul ignore if */
              if (false
              ) {
                hydrationBailed = true;
                console.warn('Parent: ', elm);
                console.warn('server innerHTML: ', i);
                console.warn('client innerHTML: ', elm.innerHTML);
              }
              return false
            }
          } else {
            // iterate and compare children lists
            var childrenMatch = true;
            var childNode = elm.firstChild;
            for (var i$1 = 0; i$1 < children.length; i$1++) {
              if (!childNode || !hydrate(childNode, children[i$1], insertedVnodeQueue, inVPre)) {
                childrenMatch = false;
                break
              }
              childNode = childNode.nextSibling;
            }
            // if childNode is not null, it means the actual childNodes list is
            // longer than the virtual children list.
            if (!childrenMatch || childNode) {
              /* istanbul ignore if */
              if (false
              ) {
                hydrationBailed = true;
                console.warn('Parent: ', elm);
                console.warn('Mismatching childNodes vs. VNodes: ', elm.childNodes, children);
              }
              return false
            }
          }
        }
      }
      if (isDef(data)) {
        var fullInvoke = false;
        for (var key in data) {
          if (!isRenderedModule(key)) {
            fullInvoke = true;
            invokeCreateHooks(vnode, insertedVnodeQueue);
            break
          }
        }
        if (!fullInvoke && data['class']) {
          // ensure collecting deps for deep class bindings for future updates
          traverse(data['class']);
        }
      }
    } else if (elm.data !== vnode.text) {
      elm.data = vnode.text;
    }
    return true
  }

  function assertNodeMatch (node, vnode, inVPre) {
    if (isDef(vnode.tag)) {
      return vnode.tag.indexOf('vue-component') === 0 || (
        !isUnknownElement$$1(vnode, inVPre) &&
        vnode.tag.toLowerCase() === (node.tagName && node.tagName.toLowerCase())
      )
    } else {
      return node.nodeType === (vnode.isComment ? 8 : 3)
    }
  }

  return function patch (oldVnode, vnode, hydrating, removeOnly, parentElm, refElm) {
    if (isUndef(vnode)) {
      if (isDef(oldVnode)) { invokeDestroyHook(oldVnode); }
      return
    }

    var isInitialPatch = false;
    var insertedVnodeQueue = [];

    if (isUndef(oldVnode)) {
      // empty mount (likely as component), create new root element
      isInitialPatch = true;
      createElm(vnode, insertedVnodeQueue, parentElm, refElm);
    } else {
      var isRealElement = isDef(oldVnode.nodeType);
      if (!isRealElement && sameVnode(oldVnode, vnode)) {
        // patch existing root node
        patchVnode(oldVnode, vnode, insertedVnodeQueue, removeOnly);
      } else {
        if (isRealElement) {
          // mounting to a real element
          // check if this is server-rendered content and if we can perform
          // a successful hydration.
          if (oldVnode.nodeType === 1 && oldVnode.hasAttribute(SSR_ATTR)) {
            oldVnode.removeAttribute(SSR_ATTR);
            hydrating = true;
          }
          if (isTrue(hydrating)) {
            if (hydrate(oldVnode, vnode, insertedVnodeQueue)) {
              invokeInsertHook(vnode, insertedVnodeQueue, true);
              return oldVnode
            } else if (false) {
              warn(
                'The client-side rendered virtual DOM tree is not matching ' +
                'server-rendered content. This is likely caused by incorrect ' +
                'HTML markup, for example nesting block-level elements inside ' +
                '<p>, or missing <tbody>. Bailing hydration and performing ' +
                'full client-side render.'
              );
            }
          }
          // either not server-rendered, or hydration failed.
          // create an empty node and replace it
          oldVnode = emptyNodeAt(oldVnode);
        }

        // replacing existing element
        var oldElm = oldVnode.elm;
        var parentElm$1 = nodeOps.parentNode(oldElm);

        // create new node
        createElm(
          vnode,
          insertedVnodeQueue,
          // extremely rare edge case: do not insert if old element is in a
          // leaving transition. Only happens when combining transition +
          // keep-alive + HOCs. (#4590)
          oldElm._leaveCb ? null : parentElm$1,
          nodeOps.nextSibling(oldElm)
        );

        // update parent placeholder node element, recursively
        if (isDef(vnode.parent)) {
          var ancestor = vnode.parent;
          var patchable = isPatchable(vnode);
          while (ancestor) {
            for (var i = 0; i < cbs.destroy.length; ++i) {
              cbs.destroy[i](ancestor);
            }
            ancestor.elm = vnode.elm;
            if (patchable) {
              for (var i$1 = 0; i$1 < cbs.create.length; ++i$1) {
                cbs.create[i$1](emptyNode, ancestor);
              }
              // #6513
              // invoke insert hooks that may have been merged by create hooks.
              // e.g. for directives that uses the "inserted" hook.
              var insert = ancestor.data.hook.insert;
              if (insert.merged) {
                // start at index 1 to avoid re-invoking component mounted hook
                for (var i$2 = 1; i$2 < insert.fns.length; i$2++) {
                  insert.fns[i$2]();
                }
              }
            } else {
              registerRef(ancestor);
            }
            ancestor = ancestor.parent;
          }
        }

        // destroy old node
        if (isDef(parentElm$1)) {
          removeVnodes(parentElm$1, [oldVnode], 0, 0);
        } else if (isDef(oldVnode.tag)) {
          invokeDestroyHook(oldVnode);
        }
      }
    }

    invokeInsertHook(vnode, insertedVnodeQueue, isInitialPatch);
    return vnode.elm
  }
}

/*  */

var directives = {
  create: updateDirectives,
  update: updateDirectives,
  destroy: function unbindDirectives (vnode) {
    updateDirectives(vnode, emptyNode);
  }
};

function updateDirectives (oldVnode, vnode) {
  if (oldVnode.data.directives || vnode.data.directives) {
    _update(oldVnode, vnode);
  }
}

function _update (oldVnode, vnode) {
  var isCreate = oldVnode === emptyNode;
  var isDestroy = vnode === emptyNode;
  var oldDirs = normalizeDirectives$1(oldVnode.data.directives, oldVnode.context);
  var newDirs = normalizeDirectives$1(vnode.data.directives, vnode.context);

  var dirsWithInsert = [];
  var dirsWithPostpatch = [];

  var key, oldDir, dir;
  for (key in newDirs) {
    oldDir = oldDirs[key];
    dir = newDirs[key];
    if (!oldDir) {
      // new directive, bind
      callHook$1(dir, 'bind', vnode, oldVnode);
      if (dir.def && dir.def.inserted) {
        dirsWithInsert.push(dir);
      }
    } else {
      // existing directive, update
      dir.oldValue = oldDir.value;
      callHook$1(dir, 'update', vnode, oldVnode);
      if (dir.def && dir.def.componentUpdated) {
        dirsWithPostpatch.push(dir);
      }
    }
  }

  if (dirsWithInsert.length) {
    var callInsert = function () {
      for (var i = 0; i < dirsWithInsert.length; i++) {
        callHook$1(dirsWithInsert[i], 'inserted', vnode, oldVnode);
      }
    };
    if (isCreate) {
      mergeVNodeHook(vnode, 'insert', callInsert);
    } else {
      callInsert();
    }
  }

  if (dirsWithPostpatch.length) {
    mergeVNodeHook(vnode, 'postpatch', function () {
      for (var i = 0; i < dirsWithPostpatch.length; i++) {
        callHook$1(dirsWithPostpatch[i], 'componentUpdated', vnode, oldVnode);
      }
    });
  }

  if (!isCreate) {
    for (key in oldDirs) {
      if (!newDirs[key]) {
        // no longer present, unbind
        callHook$1(oldDirs[key], 'unbind', oldVnode, oldVnode, isDestroy);
      }
    }
  }
}

var emptyModifiers = Object.create(null);

function normalizeDirectives$1 (
  dirs,
  vm
) {
  var res = Object.create(null);
  if (!dirs) {
    return res
  }
  var i, dir;
  for (i = 0; i < dirs.length; i++) {
    dir = dirs[i];
    if (!dir.modifiers) {
      dir.modifiers = emptyModifiers;
    }
    res[getRawDirName(dir)] = dir;
    dir.def = resolveAsset(vm.$options, 'directives', dir.name, true);
  }
  return res
}

function getRawDirName (dir) {
  return dir.rawName || ((dir.name) + "." + (Object.keys(dir.modifiers || {}).join('.')))
}

function callHook$1 (dir, hook, vnode, oldVnode, isDestroy) {
  var fn = dir.def && dir.def[hook];
  if (fn) {
    try {
      fn(vnode.elm, dir, vnode, oldVnode, isDestroy);
    } catch (e) {
      handleError(e, vnode.context, ("directive " + (dir.name) + " " + hook + " hook"));
    }
  }
}

var baseModules = [
  ref,
  directives
];

/*  */

function updateAttrs (oldVnode, vnode) {
  var opts = vnode.componentOptions;
  if (isDef(opts) && opts.Ctor.options.inheritAttrs === false) {
    return
  }
  if (isUndef(oldVnode.data.attrs) && isUndef(vnode.data.attrs)) {
    return
  }
  var key, cur, old;
  var elm = vnode.elm;
  var oldAttrs = oldVnode.data.attrs || {};
  var attrs = vnode.data.attrs || {};
  // clone observed objects, as the user probably wants to mutate it
  if (isDef(attrs.__ob__)) {
    attrs = vnode.data.attrs = extend({}, attrs);
  }

  for (key in attrs) {
    cur = attrs[key];
    old = oldAttrs[key];
    if (old !== cur) {
      setAttr(elm, key, cur);
    }
  }
  // #4391: in IE9, setting type can reset value for input[type=radio]
  // #6666: IE/Edge forces progress value down to 1 before setting a max
  /* istanbul ignore if */
  if ((isIE || isEdge) && attrs.value !== oldAttrs.value) {
    setAttr(elm, 'value', attrs.value);
  }
  for (key in oldAttrs) {
    if (isUndef(attrs[key])) {
      if (isXlink(key)) {
        elm.removeAttributeNS(xlinkNS, getXlinkProp(key));
      } else if (!isEnumeratedAttr(key)) {
        elm.removeAttribute(key);
      }
    }
  }
}

function setAttr (el, key, value) {
  if (isBooleanAttr(key)) {
    // set attribute for blank value
    // e.g. <option disabled>Select one</option>
    if (isFalsyAttrValue(value)) {
      el.removeAttribute(key);
    } else {
      // technically allowfullscreen is a boolean attribute for <iframe>,
      // but Flash expects a value of "true" when used on <embed> tag
      value = key === 'allowfullscreen' && el.tagName === 'EMBED'
        ? 'true'
        : key;
      el.setAttribute(key, value);
    }
  } else if (isEnumeratedAttr(key)) {
    el.setAttribute(key, isFalsyAttrValue(value) || value === 'false' ? 'false' : 'true');
  } else if (isXlink(key)) {
    if (isFalsyAttrValue(value)) {
      el.removeAttributeNS(xlinkNS, getXlinkProp(key));
    } else {
      el.setAttributeNS(xlinkNS, key, value);
    }
  } else {
    if (isFalsyAttrValue(value)) {
      el.removeAttribute(key);
    } else {
      // #7138: IE10 & 11 fires input event when setting placeholder on
      // <textarea>... block the first input event and remove the blocker
      // immediately.
      /* istanbul ignore if */
      if (
        isIE && !isIE9 &&
        el.tagName === 'TEXTAREA' &&
        key === 'placeholder' && !el.__ieph
      ) {
        var blocker = function (e) {
          e.stopImmediatePropagation();
          el.removeEventListener('input', blocker);
        };
        el.addEventListener('input', blocker);
        // $flow-disable-line
        el.__ieph = true; /* IE placeholder patched */
      }
      el.setAttribute(key, value);
    }
  }
}

var attrs = {
  create: updateAttrs,
  update: updateAttrs
};

/*  */

function updateClass (oldVnode, vnode) {
  var el = vnode.elm;
  var data = vnode.data;
  var oldData = oldVnode.data;
  if (
    isUndef(data.staticClass) &&
    isUndef(data.class) && (
      isUndef(oldData) || (
        isUndef(oldData.staticClass) &&
        isUndef(oldData.class)
      )
    )
  ) {
    return
  }

  var cls = genClassForVnode(vnode);

  // handle transition classes
  var transitionClass = el._transitionClasses;
  if (isDef(transitionClass)) {
    cls = concat(cls, stringifyClass(transitionClass));
  }

  // set the class
  if (cls !== el._prevClass) {
    el.setAttribute('class', cls);
    el._prevClass = cls;
  }
}

var klass = {
  create: updateClass,
  update: updateClass
};

/*  */

var validDivisionCharRE = /[\w).+\-_$\]]/;

function parseFilters (exp) {
  var inSingle = false;
  var inDouble = false;
  var inTemplateString = false;
  var inRegex = false;
  var curly = 0;
  var square = 0;
  var paren = 0;
  var lastFilterIndex = 0;
  var c, prev, i, expression, filters;

  for (i = 0; i < exp.length; i++) {
    prev = c;
    c = exp.charCodeAt(i);
    if (inSingle) {
      if (c === 0x27 && prev !== 0x5C) { inSingle = false; }
    } else if (inDouble) {
      if (c === 0x22 && prev !== 0x5C) { inDouble = false; }
    } else if (inTemplateString) {
      if (c === 0x60 && prev !== 0x5C) { inTemplateString = false; }
    } else if (inRegex) {
      if (c === 0x2f && prev !== 0x5C) { inRegex = false; }
    } else if (
      c === 0x7C && // pipe
      exp.charCodeAt(i + 1) !== 0x7C &&
      exp.charCodeAt(i - 1) !== 0x7C &&
      !curly && !square && !paren
    ) {
      if (expression === undefined) {
        // first filter, end of expression
        lastFilterIndex = i + 1;
        expression = exp.slice(0, i).trim();
      } else {
        pushFilter();
      }
    } else {
      switch (c) {
        case 0x22: inDouble = true; break         // "
        case 0x27: inSingle = true; break         // '
        case 0x60: inTemplateString = true; break // `
        case 0x28: paren++; break                 // (
        case 0x29: paren--; break                 // )
        case 0x5B: square++; break                // [
        case 0x5D: square--; break                // ]
        case 0x7B: curly++; break                 // {
        case 0x7D: curly--; break                 // }
      }
      if (c === 0x2f) { // /
        var j = i - 1;
        var p = (void 0);
        // find first non-whitespace prev char
        for (; j >= 0; j--) {
          p = exp.charAt(j);
          if (p !== ' ') { break }
        }
        if (!p || !validDivisionCharRE.test(p)) {
          inRegex = true;
        }
      }
    }
  }

  if (expression === undefined) {
    expression = exp.slice(0, i).trim();
  } else if (lastFilterIndex !== 0) {
    pushFilter();
  }

  function pushFilter () {
    (filters || (filters = [])).push(exp.slice(lastFilterIndex, i).trim());
    lastFilterIndex = i + 1;
  }

  if (filters) {
    for (i = 0; i < filters.length; i++) {
      expression = wrapFilter(expression, filters[i]);
    }
  }

  return expression
}

function wrapFilter (exp, filter) {
  var i = filter.indexOf('(');
  if (i < 0) {
    // _f: resolveFilter
    return ("_f(\"" + filter + "\")(" + exp + ")")
  } else {
    var name = filter.slice(0, i);
    var args = filter.slice(i + 1);
    return ("_f(\"" + name + "\")(" + exp + "," + args)
  }
}

/*  */

function baseWarn (msg) {
  console.error(("[Vue compiler]: " + msg));
}

function pluckModuleFunction (
  modules,
  key
) {
  return modules
    ? modules.map(function (m) { return m[key]; }).filter(function (_) { return _; })
    : []
}

function addProp (el, name, value) {
  (el.props || (el.props = [])).push({ name: name, value: value });
}

function addAttr (el, name, value) {
  (el.attrs || (el.attrs = [])).push({ name: name, value: value });
}

function addDirective (
  el,
  name,
  rawName,
  value,
  arg,
  modifiers
) {
  (el.directives || (el.directives = [])).push({ name: name, rawName: rawName, value: value, arg: arg, modifiers: modifiers });
}

function addHandler (
  el,
  name,
  value,
  modifiers,
  important,
  warn
) {
  modifiers = modifiers || emptyObject;
  // warn prevent and passive modifier
  /* istanbul ignore if */
  if (
    false
  ) {
    warn(
      'passive and prevent can\'t be used together. ' +
      'Passive handler can\'t prevent default event.'
    );
  }

  // check capture modifier
  if (modifiers.capture) {
    delete modifiers.capture;
    name = '!' + name; // mark the event as captured
  }
  if (modifiers.once) {
    delete modifiers.once;
    name = '~' + name; // mark the event as once
  }
  /* istanbul ignore if */
  if (modifiers.passive) {
    delete modifiers.passive;
    name = '&' + name; // mark the event as passive
  }

  // normalize click.right and click.middle since they don't actually fire
  // this is technically browser-specific, but at least for now browsers are
  // the only target envs that have right/middle clicks.
  if (name === 'click') {
    if (modifiers.right) {
      name = 'contextmenu';
      delete modifiers.right;
    } else if (modifiers.middle) {
      name = 'mouseup';
    }
  }

  var events;
  if (modifiers.native) {
    delete modifiers.native;
    events = el.nativeEvents || (el.nativeEvents = {});
  } else {
    events = el.events || (el.events = {});
  }

  var newHandler = { value: value };
  if (modifiers !== emptyObject) {
    newHandler.modifiers = modifiers;
  }

  var handlers = events[name];
  /* istanbul ignore if */
  if (Array.isArray(handlers)) {
    important ? handlers.unshift(newHandler) : handlers.push(newHandler);
  } else if (handlers) {
    events[name] = important ? [newHandler, handlers] : [handlers, newHandler];
  } else {
    events[name] = newHandler;
  }
}

function getBindingAttr (
  el,
  name,
  getStatic
) {
  var dynamicValue =
    getAndRemoveAttr(el, ':' + name) ||
    getAndRemoveAttr(el, 'v-bind:' + name);
  if (dynamicValue != null) {
    return parseFilters(dynamicValue)
  } else if (getStatic !== false) {
    var staticValue = getAndRemoveAttr(el, name);
    if (staticValue != null) {
      return JSON.stringify(staticValue)
    }
  }
}

// note: this only removes the attr from the Array (attrsList) so that it
// doesn't get processed by processAttrs.
// By default it does NOT remove it from the map (attrsMap) because the map is
// needed during codegen.
function getAndRemoveAttr (
  el,
  name,
  removeFromMap
) {
  var val;
  if ((val = el.attrsMap[name]) != null) {
    var list = el.attrsList;
    for (var i = 0, l = list.length; i < l; i++) {
      if (list[i].name === name) {
        list.splice(i, 1);
        break
      }
    }
  }
  if (removeFromMap) {
    delete el.attrsMap[name];
  }
  return val
}

/*  */

/**
 * Cross-platform code generation for component v-model
 */
function genComponentModel (
  el,
  value,
  modifiers
) {
  var ref = modifiers || {};
  var number = ref.number;
  var trim = ref.trim;

  var baseValueExpression = '$$v';
  var valueExpression = baseValueExpression;
  if (trim) {
    valueExpression =
      "(typeof " + baseValueExpression + " === 'string'" +
        "? " + baseValueExpression + ".trim()" +
        ": " + baseValueExpression + ")";
  }
  if (number) {
    valueExpression = "_n(" + valueExpression + ")";
  }
  var assignment = genAssignmentCode(value, valueExpression);

  el.model = {
    value: ("(" + value + ")"),
    expression: ("\"" + value + "\""),
    callback: ("function (" + baseValueExpression + ") {" + assignment + "}")
  };
}

/**
 * Cross-platform codegen helper for generating v-model value assignment code.
 */
function genAssignmentCode (
  value,
  assignment
) {
  var res = parseModel(value);
  if (res.key === null) {
    return (value + "=" + assignment)
  } else {
    return ("$set(" + (res.exp) + ", " + (res.key) + ", " + assignment + ")")
  }
}

/**
 * Parse a v-model expression into a base path and a final key segment.
 * Handles both dot-path and possible square brackets.
 *
 * Possible cases:
 *
 * - test
 * - test[key]
 * - test[test1[key]]
 * - test["a"][key]
 * - xxx.test[a[a].test1[key]]
 * - test.xxx.a["asa"][test1[key]]
 *
 */

var len;
var str;
var chr;
var index$1;
var expressionPos;
var expressionEndPos;



function parseModel (val) {
  len = val.length;

  if (val.indexOf('[') < 0 || val.lastIndexOf(']') < len - 1) {
    index$1 = val.lastIndexOf('.');
    if (index$1 > -1) {
      return {
        exp: val.slice(0, index$1),
        key: '"' + val.slice(index$1 + 1) + '"'
      }
    } else {
      return {
        exp: val,
        key: null
      }
    }
  }

  str = val;
  index$1 = expressionPos = expressionEndPos = 0;

  while (!eof()) {
    chr = next();
    /* istanbul ignore if */
    if (isStringStart(chr)) {
      parseString(chr);
    } else if (chr === 0x5B) {
      parseBracket(chr);
    }
  }

  return {
    exp: val.slice(0, expressionPos),
    key: val.slice(expressionPos + 1, expressionEndPos)
  }
}

function next () {
  return str.charCodeAt(++index$1)
}

function eof () {
  return index$1 >= len
}

function isStringStart (chr) {
  return chr === 0x22 || chr === 0x27
}

function parseBracket (chr) {
  var inBracket = 1;
  expressionPos = index$1;
  while (!eof()) {
    chr = next();
    if (isStringStart(chr)) {
      parseString(chr);
      continue
    }
    if (chr === 0x5B) { inBracket++; }
    if (chr === 0x5D) { inBracket--; }
    if (inBracket === 0) {
      expressionEndPos = index$1;
      break
    }
  }
}

function parseString (chr) {
  var stringQuote = chr;
  while (!eof()) {
    chr = next();
    if (chr === stringQuote) {
      break
    }
  }
}

/*  */

var warn$1;

// in some cases, the event used has to be determined at runtime
// so we used some reserved tokens during compile.
var RANGE_TOKEN = '__r';
var CHECKBOX_RADIO_TOKEN = '__c';

function model (
  el,
  dir,
  _warn
) {
  warn$1 = _warn;
  var value = dir.value;
  var modifiers = dir.modifiers;
  var tag = el.tag;
  var type = el.attrsMap.type;

  if (false) {
    // inputs with type="file" are read only and setting the input's
    // value will throw an error.
    if (tag === 'input' && type === 'file') {
      warn$1(
        "<" + (el.tag) + " v-model=\"" + value + "\" type=\"file\">:\n" +
        "File inputs are read only. Use a v-on:change listener instead."
      );
    }
  }

  if (el.component) {
    genComponentModel(el, value, modifiers);
    // component v-model doesn't need extra runtime
    return false
  } else if (tag === 'select') {
    genSelect(el, value, modifiers);
  } else if (tag === 'input' && type === 'checkbox') {
    genCheckboxModel(el, value, modifiers);
  } else if (tag === 'input' && type === 'radio') {
    genRadioModel(el, value, modifiers);
  } else if (tag === 'input' || tag === 'textarea') {
    genDefaultModel(el, value, modifiers);
  } else if (!config.isReservedTag(tag)) {
    genComponentModel(el, value, modifiers);
    // component v-model doesn't need extra runtime
    return false
  } else if (false) {
    warn$1(
      "<" + (el.tag) + " v-model=\"" + value + "\">: " +
      "v-model is not supported on this element type. " +
      'If you are working with contenteditable, it\'s recommended to ' +
      'wrap a library dedicated for that purpose inside a custom component.'
    );
  }

  // ensure runtime directive metadata
  return true
}

function genCheckboxModel (
  el,
  value,
  modifiers
) {
  var number = modifiers && modifiers.number;
  var valueBinding = getBindingAttr(el, 'value') || 'null';
  var trueValueBinding = getBindingAttr(el, 'true-value') || 'true';
  var falseValueBinding = getBindingAttr(el, 'false-value') || 'false';
  addProp(el, 'checked',
    "Array.isArray(" + value + ")" +
      "?_i(" + value + "," + valueBinding + ")>-1" + (
        trueValueBinding === 'true'
          ? (":(" + value + ")")
          : (":_q(" + value + "," + trueValueBinding + ")")
      )
  );
  addHandler(el, 'change',
    "var $$a=" + value + "," +
        '$$el=$event.target,' +
        "$$c=$$el.checked?(" + trueValueBinding + "):(" + falseValueBinding + ");" +
    'if(Array.isArray($$a)){' +
      "var $$v=" + (number ? '_n(' + valueBinding + ')' : valueBinding) + "," +
          '$$i=_i($$a,$$v);' +
      "if($$el.checked){$$i<0&&(" + value + "=$$a.concat([$$v]))}" +
      "else{$$i>-1&&(" + value + "=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}" +
    "}else{" + (genAssignmentCode(value, '$$c')) + "}",
    null, true
  );
}

function genRadioModel (
    el,
    value,
    modifiers
) {
  var number = modifiers && modifiers.number;
  var valueBinding = getBindingAttr(el, 'value') || 'null';
  valueBinding = number ? ("_n(" + valueBinding + ")") : valueBinding;
  addProp(el, 'checked', ("_q(" + value + "," + valueBinding + ")"));
  addHandler(el, 'change', genAssignmentCode(value, valueBinding), null, true);
}

function genSelect (
    el,
    value,
    modifiers
) {
  var number = modifiers && modifiers.number;
  var selectedVal = "Array.prototype.filter" +
    ".call($event.target.options,function(o){return o.selected})" +
    ".map(function(o){var val = \"_value\" in o ? o._value : o.value;" +
    "return " + (number ? '_n(val)' : 'val') + "})";

  var assignment = '$event.target.multiple ? $$selectedVal : $$selectedVal[0]';
  var code = "var $$selectedVal = " + selectedVal + ";";
  code = code + " " + (genAssignmentCode(value, assignment));
  addHandler(el, 'change', code, null, true);
}

function genDefaultModel (
  el,
  value,
  modifiers
) {
  var type = el.attrsMap.type;

  // warn if v-bind:value conflicts with v-model
  if (false) {
    var value$1 = el.attrsMap['v-bind:value'] || el.attrsMap[':value'];
    if (value$1) {
      var binding = el.attrsMap['v-bind:value'] ? 'v-bind:value' : ':value';
      warn$1(
        binding + "=\"" + value$1 + "\" conflicts with v-model on the same element " +
        'because the latter already expands to a value binding internally'
      );
    }
  }

  var ref = modifiers || {};
  var lazy = ref.lazy;
  var number = ref.number;
  var trim = ref.trim;
  var needCompositionGuard = !lazy && type !== 'range';
  var event = lazy
    ? 'change'
    : type === 'range'
      ? RANGE_TOKEN
      : 'input';

  var valueExpression = '$event.target.value';
  if (trim) {
    valueExpression = "$event.target.value.trim()";
  }
  if (number) {
    valueExpression = "_n(" + valueExpression + ")";
  }

  var code = genAssignmentCode(value, valueExpression);
  if (needCompositionGuard) {
    code = "if($event.target.composing)return;" + code;
  }

  addProp(el, 'value', ("(" + value + ")"));
  addHandler(el, event, code, null, true);
  if (trim || number) {
    addHandler(el, 'blur', '$forceUpdate()');
  }
}

/*  */

// normalize v-model event tokens that can only be determined at runtime.
// it's important to place the event as the first in the array because
// the whole point is ensuring the v-model callback gets called before
// user-attached handlers.
function normalizeEvents (on) {
  /* istanbul ignore if */
  if (isDef(on[RANGE_TOKEN])) {
    // IE input[type=range] only supports `change` event
    var event = isIE ? 'change' : 'input';
    on[event] = [].concat(on[RANGE_TOKEN], on[event] || []);
    delete on[RANGE_TOKEN];
  }
  // This was originally intended to fix #4521 but no longer necessary
  // after 2.5. Keeping it for backwards compat with generated code from < 2.4
  /* istanbul ignore if */
  if (isDef(on[CHECKBOX_RADIO_TOKEN])) {
    on.change = [].concat(on[CHECKBOX_RADIO_TOKEN], on.change || []);
    delete on[CHECKBOX_RADIO_TOKEN];
  }
}

var target$1;

function createOnceHandler (handler, event, capture) {
  var _target = target$1; // save current target element in closure
  return function onceHandler () {
    var res = handler.apply(null, arguments);
    if (res !== null) {
      remove$2(event, onceHandler, capture, _target);
    }
  }
}

function add$1 (
  event,
  handler,
  once$$1,
  capture,
  passive
) {
  handler = withMacroTask(handler);
  if (once$$1) { handler = createOnceHandler(handler, event, capture); }
  target$1.addEventListener(
    event,
    handler,
    supportsPassive
      ? { capture: capture, passive: passive }
      : capture
  );
}

function remove$2 (
  event,
  handler,
  capture,
  _target
) {
  (_target || target$1).removeEventListener(
    event,
    handler._withTask || handler,
    capture
  );
}

function updateDOMListeners (oldVnode, vnode) {
  if (isUndef(oldVnode.data.on) && isUndef(vnode.data.on)) {
    return
  }
  var on = vnode.data.on || {};
  var oldOn = oldVnode.data.on || {};
  target$1 = vnode.elm;
  normalizeEvents(on);
  updateListeners(on, oldOn, add$1, remove$2, vnode.context);
  target$1 = undefined;
}

var events = {
  create: updateDOMListeners,
  update: updateDOMListeners
};

/*  */

function updateDOMProps (oldVnode, vnode) {
  if (isUndef(oldVnode.data.domProps) && isUndef(vnode.data.domProps)) {
    return
  }
  var key, cur;
  var elm = vnode.elm;
  var oldProps = oldVnode.data.domProps || {};
  var props = vnode.data.domProps || {};
  // clone observed objects, as the user probably wants to mutate it
  if (isDef(props.__ob__)) {
    props = vnode.data.domProps = extend({}, props);
  }

  for (key in oldProps) {
    if (isUndef(props[key])) {
      elm[key] = '';
    }
  }
  for (key in props) {
    cur = props[key];
    // ignore children if the node has textContent or innerHTML,
    // as these will throw away existing DOM nodes and cause removal errors
    // on subsequent patches (#3360)
    if (key === 'textContent' || key === 'innerHTML') {
      if (vnode.children) { vnode.children.length = 0; }
      if (cur === oldProps[key]) { continue }
      // #6601 work around Chrome version <= 55 bug where single textNode
      // replaced by innerHTML/textContent retains its parentNode property
      if (elm.childNodes.length === 1) {
        elm.removeChild(elm.childNodes[0]);
      }
    }

    if (key === 'value') {
      // store value as _value as well since
      // non-string values will be stringified
      elm._value = cur;
      // avoid resetting cursor position when value is the same
      var strCur = isUndef(cur) ? '' : String(cur);
      if (shouldUpdateValue(elm, strCur)) {
        elm.value = strCur;
      }
    } else {
      elm[key] = cur;
    }
  }
}

// check platforms/web/util/attrs.js acceptValue


function shouldUpdateValue (elm, checkVal) {
  return (!elm.composing && (
    elm.tagName === 'OPTION' ||
    isDirty(elm, checkVal) ||
    isInputChanged(elm, checkVal)
  ))
}

function isDirty (elm, checkVal) {
  // return true when textbox (.number and .trim) loses focus and its value is
  // not equal to the updated value
  var notInFocus = true;
  // #6157
  // work around IE bug when accessing document.activeElement in an iframe
  try { notInFocus = document.activeElement !== elm; } catch (e) {}
  return notInFocus && elm.value !== checkVal
}

function isInputChanged (elm, newVal) {
  var value = elm.value;
  var modifiers = elm._vModifiers; // injected by v-model runtime
  if (isDef(modifiers) && modifiers.number) {
    return toNumber(value) !== toNumber(newVal)
  }
  if (isDef(modifiers) && modifiers.trim) {
    return value.trim() !== newVal.trim()
  }
  return value !== newVal
}

var domProps = {
  create: updateDOMProps,
  update: updateDOMProps
};

/*  */

var parseStyleText = cached(function (cssText) {
  var res = {};
  var listDelimiter = /;(?![^(]*\))/g;
  var propertyDelimiter = /:(.+)/;
  cssText.split(listDelimiter).forEach(function (item) {
    if (item) {
      var tmp = item.split(propertyDelimiter);
      tmp.length > 1 && (res[tmp[0].trim()] = tmp[1].trim());
    }
  });
  return res
});

// merge static and dynamic style data on the same vnode
function normalizeStyleData (data) {
  var style = normalizeStyleBinding(data.style);
  // static style is pre-processed into an object during compilation
  // and is always a fresh object, so it's safe to merge into it
  return data.staticStyle
    ? extend(data.staticStyle, style)
    : style
}

// normalize possible array / string values into Object
function normalizeStyleBinding (bindingStyle) {
  if (Array.isArray(bindingStyle)) {
    return toObject(bindingStyle)
  }
  if (typeof bindingStyle === 'string') {
    return parseStyleText(bindingStyle)
  }
  return bindingStyle
}

/**
 * parent component style should be after child's
 * so that parent component's style could override it
 */
function getStyle (vnode, checkChild) {
  var res = {};
  var styleData;

  if (checkChild) {
    var childNode = vnode;
    while (childNode.componentInstance) {
      childNode = childNode.componentInstance._vnode;
      if (childNode.data && (styleData = normalizeStyleData(childNode.data))) {
        extend(res, styleData);
      }
    }
  }

  if ((styleData = normalizeStyleData(vnode.data))) {
    extend(res, styleData);
  }

  var parentNode = vnode;
  while ((parentNode = parentNode.parent)) {
    if (parentNode.data && (styleData = normalizeStyleData(parentNode.data))) {
      extend(res, styleData);
    }
  }
  return res
}

/*  */

var cssVarRE = /^--/;
var importantRE = /\s*!important$/;
var setProp = function (el, name, val) {
  /* istanbul ignore if */
  if (cssVarRE.test(name)) {
    el.style.setProperty(name, val);
  } else if (importantRE.test(val)) {
    el.style.setProperty(name, val.replace(importantRE, ''), 'important');
  } else {
    var normalizedName = normalize(name);
    if (Array.isArray(val)) {
      // Support values array created by autoprefixer, e.g.
      // {display: ["-webkit-box", "-ms-flexbox", "flex"]}
      // Set them one by one, and the browser will only set those it can recognize
      for (var i = 0, len = val.length; i < len; i++) {
        el.style[normalizedName] = val[i];
      }
    } else {
      el.style[normalizedName] = val;
    }
  }
};

var vendorNames = ['Webkit', 'Moz', 'ms'];

var emptyStyle;
var normalize = cached(function (prop) {
  emptyStyle = emptyStyle || document.createElement('div').style;
  prop = camelize(prop);
  if (prop !== 'filter' && (prop in emptyStyle)) {
    return prop
  }
  var capName = prop.charAt(0).toUpperCase() + prop.slice(1);
  for (var i = 0; i < vendorNames.length; i++) {
    var name = vendorNames[i] + capName;
    if (name in emptyStyle) {
      return name
    }
  }
});

function updateStyle (oldVnode, vnode) {
  var data = vnode.data;
  var oldData = oldVnode.data;

  if (isUndef(data.staticStyle) && isUndef(data.style) &&
    isUndef(oldData.staticStyle) && isUndef(oldData.style)
  ) {
    return
  }

  var cur, name;
  var el = vnode.elm;
  var oldStaticStyle = oldData.staticStyle;
  var oldStyleBinding = oldData.normalizedStyle || oldData.style || {};

  // if static style exists, stylebinding already merged into it when doing normalizeStyleData
  var oldStyle = oldStaticStyle || oldStyleBinding;

  var style = normalizeStyleBinding(vnode.data.style) || {};

  // store normalized style under a different key for next diff
  // make sure to clone it if it's reactive, since the user likely wants
  // to mutate it.
  vnode.data.normalizedStyle = isDef(style.__ob__)
    ? extend({}, style)
    : style;

  var newStyle = getStyle(vnode, true);

  for (name in oldStyle) {
    if (isUndef(newStyle[name])) {
      setProp(el, name, '');
    }
  }
  for (name in newStyle) {
    cur = newStyle[name];
    if (cur !== oldStyle[name]) {
      // ie9 setting to null has no effect, must use empty string
      setProp(el, name, cur == null ? '' : cur);
    }
  }
}

var style = {
  create: updateStyle,
  update: updateStyle
};

/*  */

/**
 * Add class with compatibility for SVG since classList is not supported on
 * SVG elements in IE
 */
function addClass (el, cls) {
  /* istanbul ignore if */
  if (!cls || !(cls = cls.trim())) {
    return
  }

  /* istanbul ignore else */
  if (el.classList) {
    if (cls.indexOf(' ') > -1) {
      cls.split(/\s+/).forEach(function (c) { return el.classList.add(c); });
    } else {
      el.classList.add(cls);
    }
  } else {
    var cur = " " + (el.getAttribute('class') || '') + " ";
    if (cur.indexOf(' ' + cls + ' ') < 0) {
      el.setAttribute('class', (cur + cls).trim());
    }
  }
}

/**
 * Remove class with compatibility for SVG since classList is not supported on
 * SVG elements in IE
 */
function removeClass (el, cls) {
  /* istanbul ignore if */
  if (!cls || !(cls = cls.trim())) {
    return
  }

  /* istanbul ignore else */
  if (el.classList) {
    if (cls.indexOf(' ') > -1) {
      cls.split(/\s+/).forEach(function (c) { return el.classList.remove(c); });
    } else {
      el.classList.remove(cls);
    }
    if (!el.classList.length) {
      el.removeAttribute('class');
    }
  } else {
    var cur = " " + (el.getAttribute('class') || '') + " ";
    var tar = ' ' + cls + ' ';
    while (cur.indexOf(tar) >= 0) {
      cur = cur.replace(tar, ' ');
    }
    cur = cur.trim();
    if (cur) {
      el.setAttribute('class', cur);
    } else {
      el.removeAttribute('class');
    }
  }
}

/*  */

function resolveTransition (def) {
  if (!def) {
    return
  }
  /* istanbul ignore else */
  if (typeof def === 'object') {
    var res = {};
    if (def.css !== false) {
      extend(res, autoCssTransition(def.name || 'v'));
    }
    extend(res, def);
    return res
  } else if (typeof def === 'string') {
    return autoCssTransition(def)
  }
}

var autoCssTransition = cached(function (name) {
  return {
    enterClass: (name + "-enter"),
    enterToClass: (name + "-enter-to"),
    enterActiveClass: (name + "-enter-active"),
    leaveClass: (name + "-leave"),
    leaveToClass: (name + "-leave-to"),
    leaveActiveClass: (name + "-leave-active")
  }
});

var hasTransition = inBrowser && !isIE9;
var TRANSITION = 'transition';
var ANIMATION = 'animation';

// Transition property/event sniffing
var transitionProp = 'transition';
var transitionEndEvent = 'transitionend';
var animationProp = 'animation';
var animationEndEvent = 'animationend';
if (hasTransition) {
  /* istanbul ignore if */
  if (window.ontransitionend === undefined &&
    window.onwebkittransitionend !== undefined
  ) {
    transitionProp = 'WebkitTransition';
    transitionEndEvent = 'webkitTransitionEnd';
  }
  if (window.onanimationend === undefined &&
    window.onwebkitanimationend !== undefined
  ) {
    animationProp = 'WebkitAnimation';
    animationEndEvent = 'webkitAnimationEnd';
  }
}

// binding to window is necessary to make hot reload work in IE in strict mode
var raf = inBrowser
  ? window.requestAnimationFrame
    ? window.requestAnimationFrame.bind(window)
    : setTimeout
  : /* istanbul ignore next */ function (fn) { return fn(); };

function nextFrame (fn) {
  raf(function () {
    raf(fn);
  });
}

function addTransitionClass (el, cls) {
  var transitionClasses = el._transitionClasses || (el._transitionClasses = []);
  if (transitionClasses.indexOf(cls) < 0) {
    transitionClasses.push(cls);
    addClass(el, cls);
  }
}

function removeTransitionClass (el, cls) {
  if (el._transitionClasses) {
    remove(el._transitionClasses, cls);
  }
  removeClass(el, cls);
}

function whenTransitionEnds (
  el,
  expectedType,
  cb
) {
  var ref = getTransitionInfo(el, expectedType);
  var type = ref.type;
  var timeout = ref.timeout;
  var propCount = ref.propCount;
  if (!type) { return cb() }
  var event = type === TRANSITION ? transitionEndEvent : animationEndEvent;
  var ended = 0;
  var end = function () {
    el.removeEventListener(event, onEnd);
    cb();
  };
  var onEnd = function (e) {
    if (e.target === el) {
      if (++ended >= propCount) {
        end();
      }
    }
  };
  setTimeout(function () {
    if (ended < propCount) {
      end();
    }
  }, timeout + 1);
  el.addEventListener(event, onEnd);
}

var transformRE = /\b(transform|all)(,|$)/;

function getTransitionInfo (el, expectedType) {
  var styles = window.getComputedStyle(el);
  var transitionDelays = styles[transitionProp + 'Delay'].split(', ');
  var transitionDurations = styles[transitionProp + 'Duration'].split(', ');
  var transitionTimeout = getTimeout(transitionDelays, transitionDurations);
  var animationDelays = styles[animationProp + 'Delay'].split(', ');
  var animationDurations = styles[animationProp + 'Duration'].split(', ');
  var animationTimeout = getTimeout(animationDelays, animationDurations);

  var type;
  var timeout = 0;
  var propCount = 0;
  /* istanbul ignore if */
  if (expectedType === TRANSITION) {
    if (transitionTimeout > 0) {
      type = TRANSITION;
      timeout = transitionTimeout;
      propCount = transitionDurations.length;
    }
  } else if (expectedType === ANIMATION) {
    if (animationTimeout > 0) {
      type = ANIMATION;
      timeout = animationTimeout;
      propCount = animationDurations.length;
    }
  } else {
    timeout = Math.max(transitionTimeout, animationTimeout);
    type = timeout > 0
      ? transitionTimeout > animationTimeout
        ? TRANSITION
        : ANIMATION
      : null;
    propCount = type
      ? type === TRANSITION
        ? transitionDurations.length
        : animationDurations.length
      : 0;
  }
  var hasTransform =
    type === TRANSITION &&
    transformRE.test(styles[transitionProp + 'Property']);
  return {
    type: type,
    timeout: timeout,
    propCount: propCount,
    hasTransform: hasTransform
  }
}

function getTimeout (delays, durations) {
  /* istanbul ignore next */
  while (delays.length < durations.length) {
    delays = delays.concat(delays);
  }

  return Math.max.apply(null, durations.map(function (d, i) {
    return toMs(d) + toMs(delays[i])
  }))
}

function toMs (s) {
  return Number(s.slice(0, -1)) * 1000
}

/*  */

function enter (vnode, toggleDisplay) {
  var el = vnode.elm;

  // call leave callback now
  if (isDef(el._leaveCb)) {
    el._leaveCb.cancelled = true;
    el._leaveCb();
  }

  var data = resolveTransition(vnode.data.transition);
  if (isUndef(data)) {
    return
  }

  /* istanbul ignore if */
  if (isDef(el._enterCb) || el.nodeType !== 1) {
    return
  }

  var css = data.css;
  var type = data.type;
  var enterClass = data.enterClass;
  var enterToClass = data.enterToClass;
  var enterActiveClass = data.enterActiveClass;
  var appearClass = data.appearClass;
  var appearToClass = data.appearToClass;
  var appearActiveClass = data.appearActiveClass;
  var beforeEnter = data.beforeEnter;
  var enter = data.enter;
  var afterEnter = data.afterEnter;
  var enterCancelled = data.enterCancelled;
  var beforeAppear = data.beforeAppear;
  var appear = data.appear;
  var afterAppear = data.afterAppear;
  var appearCancelled = data.appearCancelled;
  var duration = data.duration;

  // activeInstance will always be the <transition> component managing this
  // transition. One edge case to check is when the <transition> is placed
  // as the root node of a child component. In that case we need to check
  // <transition>'s parent for appear check.
  var context = activeInstance;
  var transitionNode = activeInstance.$vnode;
  while (transitionNode && transitionNode.parent) {
    transitionNode = transitionNode.parent;
    context = transitionNode.context;
  }

  var isAppear = !context._isMounted || !vnode.isRootInsert;

  if (isAppear && !appear && appear !== '') {
    return
  }

  var startClass = isAppear && appearClass
    ? appearClass
    : enterClass;
  var activeClass = isAppear && appearActiveClass
    ? appearActiveClass
    : enterActiveClass;
  var toClass = isAppear && appearToClass
    ? appearToClass
    : enterToClass;

  var beforeEnterHook = isAppear
    ? (beforeAppear || beforeEnter)
    : beforeEnter;
  var enterHook = isAppear
    ? (typeof appear === 'function' ? appear : enter)
    : enter;
  var afterEnterHook = isAppear
    ? (afterAppear || afterEnter)
    : afterEnter;
  var enterCancelledHook = isAppear
    ? (appearCancelled || enterCancelled)
    : enterCancelled;

  var explicitEnterDuration = toNumber(
    isObject(duration)
      ? duration.enter
      : duration
  );

  if (false) {
    checkDuration(explicitEnterDuration, 'enter', vnode);
  }

  var expectsCSS = css !== false && !isIE9;
  var userWantsControl = getHookArgumentsLength(enterHook);

  var cb = el._enterCb = once(function () {
    if (expectsCSS) {
      removeTransitionClass(el, toClass);
      removeTransitionClass(el, activeClass);
    }
    if (cb.cancelled) {
      if (expectsCSS) {
        removeTransitionClass(el, startClass);
      }
      enterCancelledHook && enterCancelledHook(el);
    } else {
      afterEnterHook && afterEnterHook(el);
    }
    el._enterCb = null;
  });

  if (!vnode.data.show) {
    // remove pending leave element on enter by injecting an insert hook
    mergeVNodeHook(vnode, 'insert', function () {
      var parent = el.parentNode;
      var pendingNode = parent && parent._pending && parent._pending[vnode.key];
      if (pendingNode &&
        pendingNode.tag === vnode.tag &&
        pendingNode.elm._leaveCb
      ) {
        pendingNode.elm._leaveCb();
      }
      enterHook && enterHook(el, cb);
    });
  }

  // start enter transition
  beforeEnterHook && beforeEnterHook(el);
  if (expectsCSS) {
    addTransitionClass(el, startClass);
    addTransitionClass(el, activeClass);
    nextFrame(function () {
      addTransitionClass(el, toClass);
      removeTransitionClass(el, startClass);
      if (!cb.cancelled && !userWantsControl) {
        if (isValidDuration(explicitEnterDuration)) {
          setTimeout(cb, explicitEnterDuration);
        } else {
          whenTransitionEnds(el, type, cb);
        }
      }
    });
  }

  if (vnode.data.show) {
    toggleDisplay && toggleDisplay();
    enterHook && enterHook(el, cb);
  }

  if (!expectsCSS && !userWantsControl) {
    cb();
  }
}

function leave (vnode, rm) {
  var el = vnode.elm;

  // call enter callback now
  if (isDef(el._enterCb)) {
    el._enterCb.cancelled = true;
    el._enterCb();
  }

  var data = resolveTransition(vnode.data.transition);
  if (isUndef(data) || el.nodeType !== 1) {
    return rm()
  }

  /* istanbul ignore if */
  if (isDef(el._leaveCb)) {
    return
  }

  var css = data.css;
  var type = data.type;
  var leaveClass = data.leaveClass;
  var leaveToClass = data.leaveToClass;
  var leaveActiveClass = data.leaveActiveClass;
  var beforeLeave = data.beforeLeave;
  var leave = data.leave;
  var afterLeave = data.afterLeave;
  var leaveCancelled = data.leaveCancelled;
  var delayLeave = data.delayLeave;
  var duration = data.duration;

  var expectsCSS = css !== false && !isIE9;
  var userWantsControl = getHookArgumentsLength(leave);

  var explicitLeaveDuration = toNumber(
    isObject(duration)
      ? duration.leave
      : duration
  );

  if (false) {
    checkDuration(explicitLeaveDuration, 'leave', vnode);
  }

  var cb = el._leaveCb = once(function () {
    if (el.parentNode && el.parentNode._pending) {
      el.parentNode._pending[vnode.key] = null;
    }
    if (expectsCSS) {
      removeTransitionClass(el, leaveToClass);
      removeTransitionClass(el, leaveActiveClass);
    }
    if (cb.cancelled) {
      if (expectsCSS) {
        removeTransitionClass(el, leaveClass);
      }
      leaveCancelled && leaveCancelled(el);
    } else {
      rm();
      afterLeave && afterLeave(el);
    }
    el._leaveCb = null;
  });

  if (delayLeave) {
    delayLeave(performLeave);
  } else {
    performLeave();
  }

  function performLeave () {
    // the delayed leave may have already been cancelled
    if (cb.cancelled) {
      return
    }
    // record leaving element
    if (!vnode.data.show) {
      (el.parentNode._pending || (el.parentNode._pending = {}))[(vnode.key)] = vnode;
    }
    beforeLeave && beforeLeave(el);
    if (expectsCSS) {
      addTransitionClass(el, leaveClass);
      addTransitionClass(el, leaveActiveClass);
      nextFrame(function () {
        addTransitionClass(el, leaveToClass);
        removeTransitionClass(el, leaveClass);
        if (!cb.cancelled && !userWantsControl) {
          if (isValidDuration(explicitLeaveDuration)) {
            setTimeout(cb, explicitLeaveDuration);
          } else {
            whenTransitionEnds(el, type, cb);
          }
        }
      });
    }
    leave && leave(el, cb);
    if (!expectsCSS && !userWantsControl) {
      cb();
    }
  }
}

// only used in dev mode
function checkDuration (val, name, vnode) {
  if (typeof val !== 'number') {
    warn(
      "<transition> explicit " + name + " duration is not a valid number - " +
      "got " + (JSON.stringify(val)) + ".",
      vnode.context
    );
  } else if (isNaN(val)) {
    warn(
      "<transition> explicit " + name + " duration is NaN - " +
      'the duration expression might be incorrect.',
      vnode.context
    );
  }
}

function isValidDuration (val) {
  return typeof val === 'number' && !isNaN(val)
}

/**
 * Normalize a transition hook's argument length. The hook may be:
 * - a merged hook (invoker) with the original in .fns
 * - a wrapped component method (check ._length)
 * - a plain function (.length)
 */
function getHookArgumentsLength (fn) {
  if (isUndef(fn)) {
    return false
  }
  var invokerFns = fn.fns;
  if (isDef(invokerFns)) {
    // invoker
    return getHookArgumentsLength(
      Array.isArray(invokerFns)
        ? invokerFns[0]
        : invokerFns
    )
  } else {
    return (fn._length || fn.length) > 1
  }
}

function _enter (_, vnode) {
  if (vnode.data.show !== true) {
    enter(vnode);
  }
}

var transition = inBrowser ? {
  create: _enter,
  activate: _enter,
  remove: function remove$$1 (vnode, rm) {
    /* istanbul ignore else */
    if (vnode.data.show !== true) {
      leave(vnode, rm);
    } else {
      rm();
    }
  }
} : {};

var platformModules = [
  attrs,
  klass,
  events,
  domProps,
  style,
  transition
];

/*  */

// the directive module should be applied last, after all
// built-in modules have been applied.
var modules = platformModules.concat(baseModules);

var patch = createPatchFunction({ nodeOps: nodeOps, modules: modules });

/**
 * Not type checking this file because flow doesn't like attaching
 * properties to Elements.
 */

/* istanbul ignore if */
if (isIE9) {
  // http://www.matts411.com/post/internet-explorer-9-oninput/
  document.addEventListener('selectionchange', function () {
    var el = document.activeElement;
    if (el && el.vmodel) {
      trigger(el, 'input');
    }
  });
}

var directive = {
  inserted: function inserted (el, binding, vnode, oldVnode) {
    if (vnode.tag === 'select') {
      // #6903
      if (oldVnode.elm && !oldVnode.elm._vOptions) {
        mergeVNodeHook(vnode, 'postpatch', function () {
          directive.componentUpdated(el, binding, vnode);
        });
      } else {
        setSelected(el, binding, vnode.context);
      }
      el._vOptions = [].map.call(el.options, getValue);
    } else if (vnode.tag === 'textarea' || isTextInputType(el.type)) {
      el._vModifiers = binding.modifiers;
      if (!binding.modifiers.lazy) {
        // Safari < 10.2 & UIWebView doesn't fire compositionend when
        // switching focus before confirming composition choice
        // this also fixes the issue where some browsers e.g. iOS Chrome
        // fires "change" instead of "input" on autocomplete.
        el.addEventListener('change', onCompositionEnd);
        if (!isAndroid) {
          el.addEventListener('compositionstart', onCompositionStart);
          el.addEventListener('compositionend', onCompositionEnd);
        }
        /* istanbul ignore if */
        if (isIE9) {
          el.vmodel = true;
        }
      }
    }
  },

  componentUpdated: function componentUpdated (el, binding, vnode) {
    if (vnode.tag === 'select') {
      setSelected(el, binding, vnode.context);
      // in case the options rendered by v-for have changed,
      // it's possible that the value is out-of-sync with the rendered options.
      // detect such cases and filter out values that no longer has a matching
      // option in the DOM.
      var prevOptions = el._vOptions;
      var curOptions = el._vOptions = [].map.call(el.options, getValue);
      if (curOptions.some(function (o, i) { return !looseEqual(o, prevOptions[i]); })) {
        // trigger change event if
        // no matching option found for at least one value
        var needReset = el.multiple
          ? binding.value.some(function (v) { return hasNoMatchingOption(v, curOptions); })
          : binding.value !== binding.oldValue && hasNoMatchingOption(binding.value, curOptions);
        if (needReset) {
          trigger(el, 'change');
        }
      }
    }
  }
};

function setSelected (el, binding, vm) {
  actuallySetSelected(el, binding, vm);
  /* istanbul ignore if */
  if (isIE || isEdge) {
    setTimeout(function () {
      actuallySetSelected(el, binding, vm);
    }, 0);
  }
}

function actuallySetSelected (el, binding, vm) {
  var value = binding.value;
  var isMultiple = el.multiple;
  if (isMultiple && !Array.isArray(value)) {
    "production" !== 'production' && warn(
      "<select multiple v-model=\"" + (binding.expression) + "\"> " +
      "expects an Array value for its binding, but got " + (Object.prototype.toString.call(value).slice(8, -1)),
      vm
    );
    return
  }
  var selected, option;
  for (var i = 0, l = el.options.length; i < l; i++) {
    option = el.options[i];
    if (isMultiple) {
      selected = looseIndexOf(value, getValue(option)) > -1;
      if (option.selected !== selected) {
        option.selected = selected;
      }
    } else {
      if (looseEqual(getValue(option), value)) {
        if (el.selectedIndex !== i) {
          el.selectedIndex = i;
        }
        return
      }
    }
  }
  if (!isMultiple) {
    el.selectedIndex = -1;
  }
}

function hasNoMatchingOption (value, options) {
  return options.every(function (o) { return !looseEqual(o, value); })
}

function getValue (option) {
  return '_value' in option
    ? option._value
    : option.value
}

function onCompositionStart (e) {
  e.target.composing = true;
}

function onCompositionEnd (e) {
  // prevent triggering an input event for no reason
  if (!e.target.composing) { return }
  e.target.composing = false;
  trigger(e.target, 'input');
}

function trigger (el, type) {
  var e = document.createEvent('HTMLEvents');
  e.initEvent(type, true, true);
  el.dispatchEvent(e);
}

/*  */

// recursively search for possible transition defined inside the component root
function locateNode (vnode) {
  return vnode.componentInstance && (!vnode.data || !vnode.data.transition)
    ? locateNode(vnode.componentInstance._vnode)
    : vnode
}

var show = {
  bind: function bind (el, ref, vnode) {
    var value = ref.value;

    vnode = locateNode(vnode);
    var transition$$1 = vnode.data && vnode.data.transition;
    var originalDisplay = el.__vOriginalDisplay =
      el.style.display === 'none' ? '' : el.style.display;
    if (value && transition$$1) {
      vnode.data.show = true;
      enter(vnode, function () {
        el.style.display = originalDisplay;
      });
    } else {
      el.style.display = value ? originalDisplay : 'none';
    }
  },

  update: function update (el, ref, vnode) {
    var value = ref.value;
    var oldValue = ref.oldValue;

    /* istanbul ignore if */
    if (value === oldValue) { return }
    vnode = locateNode(vnode);
    var transition$$1 = vnode.data && vnode.data.transition;
    if (transition$$1) {
      vnode.data.show = true;
      if (value) {
        enter(vnode, function () {
          el.style.display = el.__vOriginalDisplay;
        });
      } else {
        leave(vnode, function () {
          el.style.display = 'none';
        });
      }
    } else {
      el.style.display = value ? el.__vOriginalDisplay : 'none';
    }
  },

  unbind: function unbind (
    el,
    binding,
    vnode,
    oldVnode,
    isDestroy
  ) {
    if (!isDestroy) {
      el.style.display = el.__vOriginalDisplay;
    }
  }
};

var platformDirectives = {
  model: directive,
  show: show
};

/*  */

// Provides transition support for a single element/component.
// supports transition mode (out-in / in-out)

var transitionProps = {
  name: String,
  appear: Boolean,
  css: Boolean,
  mode: String,
  type: String,
  enterClass: String,
  leaveClass: String,
  enterToClass: String,
  leaveToClass: String,
  enterActiveClass: String,
  leaveActiveClass: String,
  appearClass: String,
  appearActiveClass: String,
  appearToClass: String,
  duration: [Number, String, Object]
};

// in case the child is also an abstract component, e.g. <keep-alive>
// we want to recursively retrieve the real component to be rendered
function getRealChild (vnode) {
  var compOptions = vnode && vnode.componentOptions;
  if (compOptions && compOptions.Ctor.options.abstract) {
    return getRealChild(getFirstComponentChild(compOptions.children))
  } else {
    return vnode
  }
}

function extractTransitionData (comp) {
  var data = {};
  var options = comp.$options;
  // props
  for (var key in options.propsData) {
    data[key] = comp[key];
  }
  // events.
  // extract listeners and pass them directly to the transition methods
  var listeners = options._parentListeners;
  for (var key$1 in listeners) {
    data[camelize(key$1)] = listeners[key$1];
  }
  return data
}

function placeholder (h, rawChild) {
  if (/\d-keep-alive$/.test(rawChild.tag)) {
    return h('keep-alive', {
      props: rawChild.componentOptions.propsData
    })
  }
}

function hasParentTransition (vnode) {
  while ((vnode = vnode.parent)) {
    if (vnode.data.transition) {
      return true
    }
  }
}

function isSameChild (child, oldChild) {
  return oldChild.key === child.key && oldChild.tag === child.tag
}

var Transition = {
  name: 'transition',
  props: transitionProps,
  abstract: true,

  render: function render (h) {
    var this$1 = this;

    var children = this.$slots.default;
    if (!children) {
      return
    }

    // filter out text nodes (possible whitespaces)
    children = children.filter(function (c) { return c.tag || isAsyncPlaceholder(c); });
    /* istanbul ignore if */
    if (!children.length) {
      return
    }

    // warn multiple elements
    if (false) {
      warn(
        '<transition> can only be used on a single element. Use ' +
        '<transition-group> for lists.',
        this.$parent
      );
    }

    var mode = this.mode;

    // warn invalid mode
    if (false
    ) {
      warn(
        'invalid <transition> mode: ' + mode,
        this.$parent
      );
    }

    var rawChild = children[0];

    // if this is a component root node and the component's
    // parent container node also has transition, skip.
    if (hasParentTransition(this.$vnode)) {
      return rawChild
    }

    // apply transition data to child
    // use getRealChild() to ignore abstract components e.g. keep-alive
    var child = getRealChild(rawChild);
    /* istanbul ignore if */
    if (!child) {
      return rawChild
    }

    if (this._leaving) {
      return placeholder(h, rawChild)
    }

    // ensure a key that is unique to the vnode type and to this transition
    // component instance. This key will be used to remove pending leaving nodes
    // during entering.
    var id = "__transition-" + (this._uid) + "-";
    child.key = child.key == null
      ? child.isComment
        ? id + 'comment'
        : id + child.tag
      : isPrimitive(child.key)
        ? (String(child.key).indexOf(id) === 0 ? child.key : id + child.key)
        : child.key;

    var data = (child.data || (child.data = {})).transition = extractTransitionData(this);
    var oldRawChild = this._vnode;
    var oldChild = getRealChild(oldRawChild);

    // mark v-show
    // so that the transition module can hand over the control to the directive
    if (child.data.directives && child.data.directives.some(function (d) { return d.name === 'show'; })) {
      child.data.show = true;
    }

    if (
      oldChild &&
      oldChild.data &&
      !isSameChild(child, oldChild) &&
      !isAsyncPlaceholder(oldChild) &&
      // #6687 component root is a comment node
      !(oldChild.componentInstance && oldChild.componentInstance._vnode.isComment)
    ) {
      // replace old child transition data with fresh one
      // important for dynamic transitions!
      var oldData = oldChild.data.transition = extend({}, data);
      // handle transition mode
      if (mode === 'out-in') {
        // return placeholder node and queue update when leave finishes
        this._leaving = true;
        mergeVNodeHook(oldData, 'afterLeave', function () {
          this$1._leaving = false;
          this$1.$forceUpdate();
        });
        return placeholder(h, rawChild)
      } else if (mode === 'in-out') {
        if (isAsyncPlaceholder(child)) {
          return oldRawChild
        }
        var delayedLeave;
        var performLeave = function () { delayedLeave(); };
        mergeVNodeHook(data, 'afterEnter', performLeave);
        mergeVNodeHook(data, 'enterCancelled', performLeave);
        mergeVNodeHook(oldData, 'delayLeave', function (leave) { delayedLeave = leave; });
      }
    }

    return rawChild
  }
};

/*  */

// Provides transition support for list items.
// supports move transitions using the FLIP technique.

// Because the vdom's children update algorithm is "unstable" - i.e.
// it doesn't guarantee the relative positioning of removed elements,
// we force transition-group to update its children into two passes:
// in the first pass, we remove all nodes that need to be removed,
// triggering their leaving transition; in the second pass, we insert/move
// into the final desired state. This way in the second pass removed
// nodes will remain where they should be.

var props = extend({
  tag: String,
  moveClass: String
}, transitionProps);

delete props.mode;

var TransitionGroup = {
  props: props,

  render: function render (h) {
    var tag = this.tag || this.$vnode.data.tag || 'span';
    var map = Object.create(null);
    var prevChildren = this.prevChildren = this.children;
    var rawChildren = this.$slots.default || [];
    var children = this.children = [];
    var transitionData = extractTransitionData(this);

    for (var i = 0; i < rawChildren.length; i++) {
      var c = rawChildren[i];
      if (c.tag) {
        if (c.key != null && String(c.key).indexOf('__vlist') !== 0) {
          children.push(c);
          map[c.key] = c
          ;(c.data || (c.data = {})).transition = transitionData;
        } else if (false) {
          var opts = c.componentOptions;
          var name = opts ? (opts.Ctor.options.name || opts.tag || '') : c.tag;
          warn(("<transition-group> children must be keyed: <" + name + ">"));
        }
      }
    }

    if (prevChildren) {
      var kept = [];
      var removed = [];
      for (var i$1 = 0; i$1 < prevChildren.length; i$1++) {
        var c$1 = prevChildren[i$1];
        c$1.data.transition = transitionData;
        c$1.data.pos = c$1.elm.getBoundingClientRect();
        if (map[c$1.key]) {
          kept.push(c$1);
        } else {
          removed.push(c$1);
        }
      }
      this.kept = h(tag, null, kept);
      this.removed = removed;
    }

    return h(tag, null, children)
  },

  beforeUpdate: function beforeUpdate () {
    // force removing pass
    this.__patch__(
      this._vnode,
      this.kept,
      false, // hydrating
      true // removeOnly (!important, avoids unnecessary moves)
    );
    this._vnode = this.kept;
  },

  updated: function updated () {
    var children = this.prevChildren;
    var moveClass = this.moveClass || ((this.name || 'v') + '-move');
    if (!children.length || !this.hasMove(children[0].elm, moveClass)) {
      return
    }

    // we divide the work into three loops to avoid mixing DOM reads and writes
    // in each iteration - which helps prevent layout thrashing.
    children.forEach(callPendingCbs);
    children.forEach(recordPosition);
    children.forEach(applyTranslation);

    // force reflow to put everything in position
    // assign to this to avoid being removed in tree-shaking
    // $flow-disable-line
    this._reflow = document.body.offsetHeight;

    children.forEach(function (c) {
      if (c.data.moved) {
        var el = c.elm;
        var s = el.style;
        addTransitionClass(el, moveClass);
        s.transform = s.WebkitTransform = s.transitionDuration = '';
        el.addEventListener(transitionEndEvent, el._moveCb = function cb (e) {
          if (!e || /transform$/.test(e.propertyName)) {
            el.removeEventListener(transitionEndEvent, cb);
            el._moveCb = null;
            removeTransitionClass(el, moveClass);
          }
        });
      }
    });
  },

  methods: {
    hasMove: function hasMove (el, moveClass) {
      /* istanbul ignore if */
      if (!hasTransition) {
        return false
      }
      /* istanbul ignore if */
      if (this._hasMove) {
        return this._hasMove
      }
      // Detect whether an element with the move class applied has
      // CSS transitions. Since the element may be inside an entering
      // transition at this very moment, we make a clone of it and remove
      // all other transition classes applied to ensure only the move class
      // is applied.
      var clone = el.cloneNode();
      if (el._transitionClasses) {
        el._transitionClasses.forEach(function (cls) { removeClass(clone, cls); });
      }
      addClass(clone, moveClass);
      clone.style.display = 'none';
      this.$el.appendChild(clone);
      var info = getTransitionInfo(clone);
      this.$el.removeChild(clone);
      return (this._hasMove = info.hasTransform)
    }
  }
};

function callPendingCbs (c) {
  /* istanbul ignore if */
  if (c.elm._moveCb) {
    c.elm._moveCb();
  }
  /* istanbul ignore if */
  if (c.elm._enterCb) {
    c.elm._enterCb();
  }
}

function recordPosition (c) {
  c.data.newPos = c.elm.getBoundingClientRect();
}

function applyTranslation (c) {
  var oldPos = c.data.pos;
  var newPos = c.data.newPos;
  var dx = oldPos.left - newPos.left;
  var dy = oldPos.top - newPos.top;
  if (dx || dy) {
    c.data.moved = true;
    var s = c.elm.style;
    s.transform = s.WebkitTransform = "translate(" + dx + "px," + dy + "px)";
    s.transitionDuration = '0s';
  }
}

var platformComponents = {
  Transition: Transition,
  TransitionGroup: TransitionGroup
};

/*  */

// install platform specific utils
Vue$3.config.mustUseProp = mustUseProp;
Vue$3.config.isReservedTag = isReservedTag;
Vue$3.config.isReservedAttr = isReservedAttr;
Vue$3.config.getTagNamespace = getTagNamespace;
Vue$3.config.isUnknownElement = isUnknownElement;

// install platform runtime directives & components
extend(Vue$3.options.directives, platformDirectives);
extend(Vue$3.options.components, platformComponents);

// install platform patch function
Vue$3.prototype.__patch__ = inBrowser ? patch : noop;

// public mount method
Vue$3.prototype.$mount = function (
  el,
  hydrating
) {
  el = el && inBrowser ? query(el) : undefined;
  return mountComponent(this, el, hydrating)
};

// devtools global hook
/* istanbul ignore next */
Vue$3.nextTick(function () {
  if (config.devtools) {
    if (devtools) {
      devtools.emit('init', Vue$3);
    } else if (false) {
      console[console.info ? 'info' : 'log'](
        'Download the Vue Devtools extension for a better development experience:\n' +
        'https://github.com/vuejs/vue-devtools'
      );
    }
  }
  if (false
  ) {
    console[console.info ? 'info' : 'log'](
      "You are running Vue in development mode.\n" +
      "Make sure to turn on production mode when deploying for production.\n" +
      "See more tips at https://vuejs.org/guide/deployment.html"
    );
  }
}, 0);

/*  */

var defaultTagRE = /\{\{((?:.|\n)+?)\}\}/g;
var regexEscapeRE = /[-.*+?^${}()|[\]\/\\]/g;

var buildRegex = cached(function (delimiters) {
  var open = delimiters[0].replace(regexEscapeRE, '\\$&');
  var close = delimiters[1].replace(regexEscapeRE, '\\$&');
  return new RegExp(open + '((?:.|\\n)+?)' + close, 'g')
});

function parseText (
  text,
  delimiters
) {
  var tagRE = delimiters ? buildRegex(delimiters) : defaultTagRE;
  if (!tagRE.test(text)) {
    return
  }
  var tokens = [];
  var lastIndex = tagRE.lastIndex = 0;
  var match, index;
  while ((match = tagRE.exec(text))) {
    index = match.index;
    // push text token
    if (index > lastIndex) {
      tokens.push(JSON.stringify(text.slice(lastIndex, index)));
    }
    // tag token
    var exp = parseFilters(match[1].trim());
    tokens.push(("_s(" + exp + ")"));
    lastIndex = index + match[0].length;
  }
  if (lastIndex < text.length) {
    tokens.push(JSON.stringify(text.slice(lastIndex)));
  }
  return tokens.join('+')
}

/*  */

function transformNode (el, options) {
  var warn = options.warn || baseWarn;
  var staticClass = getAndRemoveAttr(el, 'class');
  if (false) {
    var expression = parseText(staticClass, options.delimiters);
    if (expression) {
      warn(
        "class=\"" + staticClass + "\": " +
        'Interpolation inside attributes has been removed. ' +
        'Use v-bind or the colon shorthand instead. For example, ' +
        'instead of <div class="{{ val }}">, use <div :class="val">.'
      );
    }
  }
  if (staticClass) {
    el.staticClass = JSON.stringify(staticClass);
  }
  var classBinding = getBindingAttr(el, 'class', false /* getStatic */);
  if (classBinding) {
    el.classBinding = classBinding;
  }
}

function genData (el) {
  var data = '';
  if (el.staticClass) {
    data += "staticClass:" + (el.staticClass) + ",";
  }
  if (el.classBinding) {
    data += "class:" + (el.classBinding) + ",";
  }
  return data
}

var klass$1 = {
  staticKeys: ['staticClass'],
  transformNode: transformNode,
  genData: genData
};

/*  */

function transformNode$1 (el, options) {
  var warn = options.warn || baseWarn;
  var staticStyle = getAndRemoveAttr(el, 'style');
  if (staticStyle) {
    /* istanbul ignore if */
    if (false) {
      var expression = parseText(staticStyle, options.delimiters);
      if (expression) {
        warn(
          "style=\"" + staticStyle + "\": " +
          'Interpolation inside attributes has been removed. ' +
          'Use v-bind or the colon shorthand instead. For example, ' +
          'instead of <div style="{{ val }}">, use <div :style="val">.'
        );
      }
    }
    el.staticStyle = JSON.stringify(parseStyleText(staticStyle));
  }

  var styleBinding = getBindingAttr(el, 'style', false /* getStatic */);
  if (styleBinding) {
    el.styleBinding = styleBinding;
  }
}

function genData$1 (el) {
  var data = '';
  if (el.staticStyle) {
    data += "staticStyle:" + (el.staticStyle) + ",";
  }
  if (el.styleBinding) {
    data += "style:(" + (el.styleBinding) + "),";
  }
  return data
}

var style$1 = {
  staticKeys: ['staticStyle'],
  transformNode: transformNode$1,
  genData: genData$1
};

/*  */

var decoder;

var he = {
  decode: function decode (html) {
    decoder = decoder || document.createElement('div');
    decoder.innerHTML = html;
    return decoder.textContent
  }
};

/*  */

var isUnaryTag = makeMap(
  'area,base,br,col,embed,frame,hr,img,input,isindex,keygen,' +
  'link,meta,param,source,track,wbr'
);

// Elements that you can, intentionally, leave open
// (and which close themselves)
var canBeLeftOpenTag = makeMap(
  'colgroup,dd,dt,li,options,p,td,tfoot,th,thead,tr,source'
);

// HTML5 tags https://html.spec.whatwg.org/multipage/indices.html#elements-3
// Phrasing Content https://html.spec.whatwg.org/multipage/dom.html#phrasing-content
var isNonPhrasingTag = makeMap(
  'address,article,aside,base,blockquote,body,caption,col,colgroup,dd,' +
  'details,dialog,div,dl,dt,fieldset,figcaption,figure,footer,form,' +
  'h1,h2,h3,h4,h5,h6,head,header,hgroup,hr,html,legend,li,menuitem,meta,' +
  'optgroup,option,param,rp,rt,source,style,summary,tbody,td,tfoot,th,thead,' +
  'title,tr,track'
);

/**
 * Not type-checking this file because it's mostly vendor code.
 */

/*!
 * HTML Parser By John Resig (ejohn.org)
 * Modified by Juriy "kangax" Zaytsev
 * Original code by Erik Arvidsson, Mozilla Public License
 * http://erik.eae.net/simplehtmlparser/simplehtmlparser.js
 */

// Regular Expressions for parsing tags and attributes
var attribute = /^\s*([^\s"'<>\/=]+)(?:\s*(=)\s*(?:"([^"]*)"+|'([^']*)'+|([^\s"'=<>`]+)))?/;
// could use https://www.w3.org/TR/1999/REC-xml-names-19990114/#NT-QName
// but for Vue templates we can enforce a simple charset
var ncname = '[a-zA-Z_][\\w\\-\\.]*';
var qnameCapture = "((?:" + ncname + "\\:)?" + ncname + ")";
var startTagOpen = new RegExp(("^<" + qnameCapture));
var startTagClose = /^\s*(\/?)>/;
var endTag = new RegExp(("^<\\/" + qnameCapture + "[^>]*>"));
var doctype = /^<!DOCTYPE [^>]+>/i;
var comment = /^<!--/;
var conditionalComment = /^<!\[/;

var IS_REGEX_CAPTURING_BROKEN = false;
'x'.replace(/x(.)?/g, function (m, g) {
  IS_REGEX_CAPTURING_BROKEN = g === '';
});

// Special Elements (can contain anything)
var isPlainTextElement = makeMap('script,style,textarea', true);
var reCache = {};

var decodingMap = {
  '&lt;': '<',
  '&gt;': '>',
  '&quot;': '"',
  '&amp;': '&',
  '&#10;': '\n',
  '&#9;': '\t'
};
var encodedAttr = /&(?:lt|gt|quot|amp);/g;
var encodedAttrWithNewLines = /&(?:lt|gt|quot|amp|#10|#9);/g;

// #5992
var isIgnoreNewlineTag = makeMap('pre,textarea', true);
var shouldIgnoreFirstNewline = function (tag, html) { return tag && isIgnoreNewlineTag(tag) && html[0] === '\n'; };

function decodeAttr (value, shouldDecodeNewlines) {
  var re = shouldDecodeNewlines ? encodedAttrWithNewLines : encodedAttr;
  return value.replace(re, function (match) { return decodingMap[match]; })
}

function parseHTML (html, options) {
  var stack = [];
  var expectHTML = options.expectHTML;
  var isUnaryTag$$1 = options.isUnaryTag || no;
  var canBeLeftOpenTag$$1 = options.canBeLeftOpenTag || no;
  var index = 0;
  var last, lastTag;
  while (html) {
    last = html;
    // Make sure we're not in a plaintext content element like script/style
    if (!lastTag || !isPlainTextElement(lastTag)) {
      var textEnd = html.indexOf('<');
      if (textEnd === 0) {
        // Comment:
        if (comment.test(html)) {
          var commentEnd = html.indexOf('-->');

          if (commentEnd >= 0) {
            if (options.shouldKeepComment) {
              options.comment(html.substring(4, commentEnd));
            }
            advance(commentEnd + 3);
            continue
          }
        }

        // http://en.wikipedia.org/wiki/Conditional_comment#Downlevel-revealed_conditional_comment
        if (conditionalComment.test(html)) {
          var conditionalEnd = html.indexOf(']>');

          if (conditionalEnd >= 0) {
            advance(conditionalEnd + 2);
            continue
          }
        }

        // Doctype:
        var doctypeMatch = html.match(doctype);
        if (doctypeMatch) {
          advance(doctypeMatch[0].length);
          continue
        }

        // End tag:
        var endTagMatch = html.match(endTag);
        if (endTagMatch) {
          var curIndex = index;
          advance(endTagMatch[0].length);
          parseEndTag(endTagMatch[1], curIndex, index);
          continue
        }

        // Start tag:
        var startTagMatch = parseStartTag();
        if (startTagMatch) {
          handleStartTag(startTagMatch);
          if (shouldIgnoreFirstNewline(lastTag, html)) {
            advance(1);
          }
          continue
        }
      }

      var text = (void 0), rest = (void 0), next = (void 0);
      if (textEnd >= 0) {
        rest = html.slice(textEnd);
        while (
          !endTag.test(rest) &&
          !startTagOpen.test(rest) &&
          !comment.test(rest) &&
          !conditionalComment.test(rest)
        ) {
          // < in plain text, be forgiving and treat it as text
          next = rest.indexOf('<', 1);
          if (next < 0) { break }
          textEnd += next;
          rest = html.slice(textEnd);
        }
        text = html.substring(0, textEnd);
        advance(textEnd);
      }

      if (textEnd < 0) {
        text = html;
        html = '';
      }

      if (options.chars && text) {
        options.chars(text);
      }
    } else {
      var endTagLength = 0;
      var stackedTag = lastTag.toLowerCase();
      var reStackedTag = reCache[stackedTag] || (reCache[stackedTag] = new RegExp('([\\s\\S]*?)(</' + stackedTag + '[^>]*>)', 'i'));
      var rest$1 = html.replace(reStackedTag, function (all, text, endTag) {
        endTagLength = endTag.length;
        if (!isPlainTextElement(stackedTag) && stackedTag !== 'noscript') {
          text = text
            .replace(/<!--([\s\S]*?)-->/g, '$1')
            .replace(/<!\[CDATA\[([\s\S]*?)]]>/g, '$1');
        }
        if (shouldIgnoreFirstNewline(stackedTag, text)) {
          text = text.slice(1);
        }
        if (options.chars) {
          options.chars(text);
        }
        return ''
      });
      index += html.length - rest$1.length;
      html = rest$1;
      parseEndTag(stackedTag, index - endTagLength, index);
    }

    if (html === last) {
      options.chars && options.chars(html);
      if (false) {
        options.warn(("Mal-formatted tag at end of template: \"" + html + "\""));
      }
      break
    }
  }

  // Clean up any remaining tags
  parseEndTag();

  function advance (n) {
    index += n;
    html = html.substring(n);
  }

  function parseStartTag () {
    var start = html.match(startTagOpen);
    if (start) {
      var match = {
        tagName: start[1],
        attrs: [],
        start: index
      };
      advance(start[0].length);
      var end, attr;
      while (!(end = html.match(startTagClose)) && (attr = html.match(attribute))) {
        advance(attr[0].length);
        match.attrs.push(attr);
      }
      if (end) {
        match.unarySlash = end[1];
        advance(end[0].length);
        match.end = index;
        return match
      }
    }
  }

  function handleStartTag (match) {
    var tagName = match.tagName;
    var unarySlash = match.unarySlash;

    if (expectHTML) {
      if (lastTag === 'p' && isNonPhrasingTag(tagName)) {
        parseEndTag(lastTag);
      }
      if (canBeLeftOpenTag$$1(tagName) && lastTag === tagName) {
        parseEndTag(tagName);
      }
    }

    var unary = isUnaryTag$$1(tagName) || !!unarySlash;

    var l = match.attrs.length;
    var attrs = new Array(l);
    for (var i = 0; i < l; i++) {
      var args = match.attrs[i];
      // hackish work around FF bug https://bugzilla.mozilla.org/show_bug.cgi?id=369778
      if (IS_REGEX_CAPTURING_BROKEN && args[0].indexOf('""') === -1) {
        if (args[3] === '') { delete args[3]; }
        if (args[4] === '') { delete args[4]; }
        if (args[5] === '') { delete args[5]; }
      }
      var value = args[3] || args[4] || args[5] || '';
      var shouldDecodeNewlines = tagName === 'a' && args[1] === 'href'
        ? options.shouldDecodeNewlinesForHref
        : options.shouldDecodeNewlines;
      attrs[i] = {
        name: args[1],
        value: decodeAttr(value, shouldDecodeNewlines)
      };
    }

    if (!unary) {
      stack.push({ tag: tagName, lowerCasedTag: tagName.toLowerCase(), attrs: attrs });
      lastTag = tagName;
    }

    if (options.start) {
      options.start(tagName, attrs, unary, match.start, match.end);
    }
  }

  function parseEndTag (tagName, start, end) {
    var pos, lowerCasedTagName;
    if (start == null) { start = index; }
    if (end == null) { end = index; }

    if (tagName) {
      lowerCasedTagName = tagName.toLowerCase();
    }

    // Find the closest opened tag of the same type
    if (tagName) {
      for (pos = stack.length - 1; pos >= 0; pos--) {
        if (stack[pos].lowerCasedTag === lowerCasedTagName) {
          break
        }
      }
    } else {
      // If no tag name is provided, clean shop
      pos = 0;
    }

    if (pos >= 0) {
      // Close all the open elements, up the stack
      for (var i = stack.length - 1; i >= pos; i--) {
        if (false
        ) {
          options.warn(
            ("tag <" + (stack[i].tag) + "> has no matching end tag.")
          );
        }
        if (options.end) {
          options.end(stack[i].tag, start, end);
        }
      }

      // Remove the open elements from the stack
      stack.length = pos;
      lastTag = pos && stack[pos - 1].tag;
    } else if (lowerCasedTagName === 'br') {
      if (options.start) {
        options.start(tagName, [], true, start, end);
      }
    } else if (lowerCasedTagName === 'p') {
      if (options.start) {
        options.start(tagName, [], false, start, end);
      }
      if (options.end) {
        options.end(tagName, start, end);
      }
    }
  }
}

/*  */

var onRE = /^@|^v-on:/;
var dirRE = /^v-|^@|^:/;
var forAliasRE = /(.*?)\s+(?:in|of)\s+(.*)/;
var forIteratorRE = /\((\{[^}]*\}|[^,{]*),([^,]*)(?:,([^,]*))?\)/;
var stripParensRE = /^\(|\)$/g;

var argRE = /:(.*)$/;
var bindRE = /^:|^v-bind:/;
var modifierRE = /\.[^.]+/g;

var decodeHTMLCached = cached(he.decode);

// configurable state
var warn$2;
var delimiters;
var transforms;
var preTransforms;
var postTransforms;
var platformIsPreTag;
var platformMustUseProp;
var platformGetTagNamespace;



function createASTElement (
  tag,
  attrs,
  parent
) {
  return {
    type: 1,
    tag: tag,
    attrsList: attrs,
    attrsMap: makeAttrsMap(attrs),
    parent: parent,
    children: []
  }
}

/**
 * Convert HTML string to AST.
 */
function parse (
  template,
  options
) {
  warn$2 = options.warn || baseWarn;

  platformIsPreTag = options.isPreTag || no;
  platformMustUseProp = options.mustUseProp || no;
  platformGetTagNamespace = options.getTagNamespace || no;

  transforms = pluckModuleFunction(options.modules, 'transformNode');
  preTransforms = pluckModuleFunction(options.modules, 'preTransformNode');
  postTransforms = pluckModuleFunction(options.modules, 'postTransformNode');

  delimiters = options.delimiters;

  var stack = [];
  var preserveWhitespace = options.preserveWhitespace !== false;
  var root;
  var currentParent;
  var inVPre = false;
  var inPre = false;
  var warned = false;

  function warnOnce (msg) {
    if (!warned) {
      warned = true;
      warn$2(msg);
    }
  }

  function endPre (element) {
    // check pre state
    if (element.pre) {
      inVPre = false;
    }
    if (platformIsPreTag(element.tag)) {
      inPre = false;
    }
  }

  parseHTML(template, {
    warn: warn$2,
    expectHTML: options.expectHTML,
    isUnaryTag: options.isUnaryTag,
    canBeLeftOpenTag: options.canBeLeftOpenTag,
    shouldDecodeNewlines: options.shouldDecodeNewlines,
    shouldDecodeNewlinesForHref: options.shouldDecodeNewlinesForHref,
    shouldKeepComment: options.comments,
    start: function start (tag, attrs, unary) {
      // check namespace.
      // inherit parent ns if there is one
      var ns = (currentParent && currentParent.ns) || platformGetTagNamespace(tag);

      // handle IE svg bug
      /* istanbul ignore if */
      if (isIE && ns === 'svg') {
        attrs = guardIESVGBug(attrs);
      }

      var element = createASTElement(tag, attrs, currentParent);
      if (ns) {
        element.ns = ns;
      }

      if (isForbiddenTag(element) && !isServerRendering()) {
        element.forbidden = true;
        "production" !== 'production' && warn$2(
          'Templates should only be responsible for mapping the state to the ' +
          'UI. Avoid placing tags with side-effects in your templates, such as ' +
          "<" + tag + ">" + ', as they will not be parsed.'
        );
      }

      // apply pre-transforms
      for (var i = 0; i < preTransforms.length; i++) {
        element = preTransforms[i](element, options) || element;
      }

      if (!inVPre) {
        processPre(element);
        if (element.pre) {
          inVPre = true;
        }
      }
      if (platformIsPreTag(element.tag)) {
        inPre = true;
      }
      if (inVPre) {
        processRawAttrs(element);
      } else if (!element.processed) {
        // structural directives
        processFor(element);
        processIf(element);
        processOnce(element);
        // element-scope stuff
        processElement(element, options);
      }

      function checkRootConstraints (el) {
        if (false) {
          if (el.tag === 'slot' || el.tag === 'template') {
            warnOnce(
              "Cannot use <" + (el.tag) + "> as component root element because it may " +
              'contain multiple nodes.'
            );
          }
          if (el.attrsMap.hasOwnProperty('v-for')) {
            warnOnce(
              'Cannot use v-for on stateful component root element because ' +
              'it renders multiple elements.'
            );
          }
        }
      }

      // tree management
      if (!root) {
        root = element;
        checkRootConstraints(root);
      } else if (!stack.length) {
        // allow root elements with v-if, v-else-if and v-else
        if (root.if && (element.elseif || element.else)) {
          checkRootConstraints(element);
          addIfCondition(root, {
            exp: element.elseif,
            block: element
          });
        } else if (false) {
          warnOnce(
            "Component template should contain exactly one root element. " +
            "If you are using v-if on multiple elements, " +
            "use v-else-if to chain them instead."
          );
        }
      }
      if (currentParent && !element.forbidden) {
        if (element.elseif || element.else) {
          processIfConditions(element, currentParent);
        } else if (element.slotScope) { // scoped slot
          currentParent.plain = false;
          var name = element.slotTarget || '"default"';(currentParent.scopedSlots || (currentParent.scopedSlots = {}))[name] = element;
        } else {
          currentParent.children.push(element);
          element.parent = currentParent;
        }
      }
      if (!unary) {
        currentParent = element;
        stack.push(element);
      } else {
        endPre(element);
      }
      // apply post-transforms
      for (var i$1 = 0; i$1 < postTransforms.length; i$1++) {
        postTransforms[i$1](element, options);
      }
    },

    end: function end () {
      // remove trailing whitespace
      var element = stack[stack.length - 1];
      var lastNode = element.children[element.children.length - 1];
      if (lastNode && lastNode.type === 3 && lastNode.text === ' ' && !inPre) {
        element.children.pop();
      }
      // pop stack
      stack.length -= 1;
      currentParent = stack[stack.length - 1];
      endPre(element);
    },

    chars: function chars (text) {
      if (!currentParent) {
        if (false) {
          if (text === template) {
            warnOnce(
              'Component template requires a root element, rather than just text.'
            );
          } else if ((text = text.trim())) {
            warnOnce(
              ("text \"" + text + "\" outside root element will be ignored.")
            );
          }
        }
        return
      }
      // IE textarea placeholder bug
      /* istanbul ignore if */
      if (isIE &&
        currentParent.tag === 'textarea' &&
        currentParent.attrsMap.placeholder === text
      ) {
        return
      }
      var children = currentParent.children;
      text = inPre || text.trim()
        ? isTextTag(currentParent) ? text : decodeHTMLCached(text)
        // only preserve whitespace if its not right after a starting tag
        : preserveWhitespace && children.length ? ' ' : '';
      if (text) {
        var expression;
        if (!inVPre && text !== ' ' && (expression = parseText(text, delimiters))) {
          children.push({
            type: 2,
            expression: expression,
            text: text
          });
        } else if (text !== ' ' || !children.length || children[children.length - 1].text !== ' ') {
          children.push({
            type: 3,
            text: text
          });
        }
      }
    },
    comment: function comment (text) {
      currentParent.children.push({
        type: 3,
        text: text,
        isComment: true
      });
    }
  });
  return root
}

function processPre (el) {
  if (getAndRemoveAttr(el, 'v-pre') != null) {
    el.pre = true;
  }
}

function processRawAttrs (el) {
  var l = el.attrsList.length;
  if (l) {
    var attrs = el.attrs = new Array(l);
    for (var i = 0; i < l; i++) {
      attrs[i] = {
        name: el.attrsList[i].name,
        value: JSON.stringify(el.attrsList[i].value)
      };
    }
  } else if (!el.pre) {
    // non root node in pre blocks with no attributes
    el.plain = true;
  }
}

function processElement (element, options) {
  processKey(element);

  // determine whether this is a plain element after
  // removing structural attributes
  element.plain = !element.key && !element.attrsList.length;

  processRef(element);
  processSlot(element);
  processComponent(element);
  for (var i = 0; i < transforms.length; i++) {
    element = transforms[i](element, options) || element;
  }
  processAttrs(element);
}

function processKey (el) {
  var exp = getBindingAttr(el, 'key');
  if (exp) {
    if (false) {
      warn$2("<template> cannot be keyed. Place the key on real elements instead.");
    }
    el.key = exp;
  }
}

function processRef (el) {
  var ref = getBindingAttr(el, 'ref');
  if (ref) {
    el.ref = ref;
    el.refInFor = checkInFor(el);
  }
}

function processFor (el) {
  var exp;
  if ((exp = getAndRemoveAttr(el, 'v-for'))) {
    var inMatch = exp.match(forAliasRE);
    if (!inMatch) {
      "production" !== 'production' && warn$2(
        ("Invalid v-for expression: " + exp)
      );
      return
    }
    el.for = inMatch[2].trim();
    var alias = inMatch[1].trim();
    var iteratorMatch = alias.match(forIteratorRE);
    if (iteratorMatch) {
      el.alias = iteratorMatch[1].trim();
      el.iterator1 = iteratorMatch[2].trim();
      if (iteratorMatch[3]) {
        el.iterator2 = iteratorMatch[3].trim();
      }
    } else {
      el.alias = alias.replace(stripParensRE, '');
    }
  }
}

function processIf (el) {
  var exp = getAndRemoveAttr(el, 'v-if');
  if (exp) {
    el.if = exp;
    addIfCondition(el, {
      exp: exp,
      block: el
    });
  } else {
    if (getAndRemoveAttr(el, 'v-else') != null) {
      el.else = true;
    }
    var elseif = getAndRemoveAttr(el, 'v-else-if');
    if (elseif) {
      el.elseif = elseif;
    }
  }
}

function processIfConditions (el, parent) {
  var prev = findPrevElement(parent.children);
  if (prev && prev.if) {
    addIfCondition(prev, {
      exp: el.elseif,
      block: el
    });
  } else if (false) {
    warn$2(
      "v-" + (el.elseif ? ('else-if="' + el.elseif + '"') : 'else') + " " +
      "used on element <" + (el.tag) + "> without corresponding v-if."
    );
  }
}

function findPrevElement (children) {
  var i = children.length;
  while (i--) {
    if (children[i].type === 1) {
      return children[i]
    } else {
      if (false) {
        warn$2(
          "text \"" + (children[i].text.trim()) + "\" between v-if and v-else(-if) " +
          "will be ignored."
        );
      }
      children.pop();
    }
  }
}

function addIfCondition (el, condition) {
  if (!el.ifConditions) {
    el.ifConditions = [];
  }
  el.ifConditions.push(condition);
}

function processOnce (el) {
  var once$$1 = getAndRemoveAttr(el, 'v-once');
  if (once$$1 != null) {
    el.once = true;
  }
}

function processSlot (el) {
  if (el.tag === 'slot') {
    el.slotName = getBindingAttr(el, 'name');
    if (false) {
      warn$2(
        "`key` does not work on <slot> because slots are abstract outlets " +
        "and can possibly expand into multiple elements. " +
        "Use the key on a wrapping element instead."
      );
    }
  } else {
    var slotScope;
    if (el.tag === 'template') {
      slotScope = getAndRemoveAttr(el, 'scope');
      /* istanbul ignore if */
      if (false) {
        warn$2(
          "the \"scope\" attribute for scoped slots have been deprecated and " +
          "replaced by \"slot-scope\" since 2.5. The new \"slot-scope\" attribute " +
          "can also be used on plain elements in addition to <template> to " +
          "denote scoped slots.",
          true
        );
      }
      el.slotScope = slotScope || getAndRemoveAttr(el, 'slot-scope');
    } else if ((slotScope = getAndRemoveAttr(el, 'slot-scope'))) {
      /* istanbul ignore if */
      if (false) {
        warn$2(
          "Ambiguous combined usage of slot-scope and v-for on <" + (el.tag) + "> " +
          "(v-for takes higher priority). Use a wrapper <template> for the " +
          "scoped slot to make it clearer.",
          true
        );
      }
      el.slotScope = slotScope;
    }
    var slotTarget = getBindingAttr(el, 'slot');
    if (slotTarget) {
      el.slotTarget = slotTarget === '""' ? '"default"' : slotTarget;
      // preserve slot as an attribute for native shadow DOM compat
      // only for non-scoped slots.
      if (el.tag !== 'template' && !el.slotScope) {
        addAttr(el, 'slot', slotTarget);
      }
    }
  }
}

function processComponent (el) {
  var binding;
  if ((binding = getBindingAttr(el, 'is'))) {
    el.component = binding;
  }
  if (getAndRemoveAttr(el, 'inline-template') != null) {
    el.inlineTemplate = true;
  }
}

function processAttrs (el) {
  var list = el.attrsList;
  var i, l, name, rawName, value, modifiers, isProp;
  for (i = 0, l = list.length; i < l; i++) {
    name = rawName = list[i].name;
    value = list[i].value;
    if (dirRE.test(name)) {
      // mark element as dynamic
      el.hasBindings = true;
      // modifiers
      modifiers = parseModifiers(name);
      if (modifiers) {
        name = name.replace(modifierRE, '');
      }
      if (bindRE.test(name)) { // v-bind
        name = name.replace(bindRE, '');
        value = parseFilters(value);
        isProp = false;
        if (modifiers) {
          if (modifiers.prop) {
            isProp = true;
            name = camelize(name);
            if (name === 'innerHtml') { name = 'innerHTML'; }
          }
          if (modifiers.camel) {
            name = camelize(name);
          }
          if (modifiers.sync) {
            addHandler(
              el,
              ("update:" + (camelize(name))),
              genAssignmentCode(value, "$event")
            );
          }
        }
        if (isProp || (
          !el.component && platformMustUseProp(el.tag, el.attrsMap.type, name)
        )) {
          addProp(el, name, value);
        } else {
          addAttr(el, name, value);
        }
      } else if (onRE.test(name)) { // v-on
        name = name.replace(onRE, '');
        addHandler(el, name, value, modifiers, false, warn$2);
      } else { // normal directives
        name = name.replace(dirRE, '');
        // parse arg
        var argMatch = name.match(argRE);
        var arg = argMatch && argMatch[1];
        if (arg) {
          name = name.slice(0, -(arg.length + 1));
        }
        addDirective(el, name, rawName, value, arg, modifiers);
        if (false) {
          checkForAliasModel(el, value);
        }
      }
    } else {
      // literal attribute
      if (false) {
        var expression = parseText(value, delimiters);
        if (expression) {
          warn$2(
            name + "=\"" + value + "\": " +
            'Interpolation inside attributes has been removed. ' +
            'Use v-bind or the colon shorthand instead. For example, ' +
            'instead of <div id="{{ val }}">, use <div :id="val">.'
          );
        }
      }
      addAttr(el, name, JSON.stringify(value));
      // #6887 firefox doesn't update muted state if set via attribute
      // even immediately after element creation
      if (!el.component &&
          name === 'muted' &&
          platformMustUseProp(el.tag, el.attrsMap.type, name)) {
        addProp(el, name, 'true');
      }
    }
  }
}

function checkInFor (el) {
  var parent = el;
  while (parent) {
    if (parent.for !== undefined) {
      return true
    }
    parent = parent.parent;
  }
  return false
}

function parseModifiers (name) {
  var match = name.match(modifierRE);
  if (match) {
    var ret = {};
    match.forEach(function (m) { ret[m.slice(1)] = true; });
    return ret
  }
}

function makeAttrsMap (attrs) {
  var map = {};
  for (var i = 0, l = attrs.length; i < l; i++) {
    if (
      false
    ) {
      warn$2('duplicate attribute: ' + attrs[i].name);
    }
    map[attrs[i].name] = attrs[i].value;
  }
  return map
}

// for script (e.g. type="x/template") or style, do not decode content
function isTextTag (el) {
  return el.tag === 'script' || el.tag === 'style'
}

function isForbiddenTag (el) {
  return (
    el.tag === 'style' ||
    (el.tag === 'script' && (
      !el.attrsMap.type ||
      el.attrsMap.type === 'text/javascript'
    ))
  )
}

var ieNSBug = /^xmlns:NS\d+/;
var ieNSPrefix = /^NS\d+:/;

/* istanbul ignore next */
function guardIESVGBug (attrs) {
  var res = [];
  for (var i = 0; i < attrs.length; i++) {
    var attr = attrs[i];
    if (!ieNSBug.test(attr.name)) {
      attr.name = attr.name.replace(ieNSPrefix, '');
      res.push(attr);
    }
  }
  return res
}

function checkForAliasModel (el, value) {
  var _el = el;
  while (_el) {
    if (_el.for && _el.alias === value) {
      warn$2(
        "<" + (el.tag) + " v-model=\"" + value + "\">: " +
        "You are binding v-model directly to a v-for iteration alias. " +
        "This will not be able to modify the v-for source array because " +
        "writing to the alias is like modifying a function local variable. " +
        "Consider using an array of objects and use v-model on an object property instead."
      );
    }
    _el = _el.parent;
  }
}

/*  */

/**
 * Expand input[v-model] with dyanmic type bindings into v-if-else chains
 * Turn this:
 *   <input v-model="data[type]" :type="type">
 * into this:
 *   <input v-if="type === 'checkbox'" type="checkbox" v-model="data[type]">
 *   <input v-else-if="type === 'radio'" type="radio" v-model="data[type]">
 *   <input v-else :type="type" v-model="data[type]">
 */

function preTransformNode (el, options) {
  if (el.tag === 'input') {
    var map = el.attrsMap;
    if (map['v-model'] && (map['v-bind:type'] || map[':type'])) {
      var typeBinding = getBindingAttr(el, 'type');
      var ifCondition = getAndRemoveAttr(el, 'v-if', true);
      var ifConditionExtra = ifCondition ? ("&&(" + ifCondition + ")") : "";
      var hasElse = getAndRemoveAttr(el, 'v-else', true) != null;
      var elseIfCondition = getAndRemoveAttr(el, 'v-else-if', true);
      // 1. checkbox
      var branch0 = cloneASTElement(el);
      // process for on the main node
      processFor(branch0);
      addRawAttr(branch0, 'type', 'checkbox');
      processElement(branch0, options);
      branch0.processed = true; // prevent it from double-processed
      branch0.if = "(" + typeBinding + ")==='checkbox'" + ifConditionExtra;
      addIfCondition(branch0, {
        exp: branch0.if,
        block: branch0
      });
      // 2. add radio else-if condition
      var branch1 = cloneASTElement(el);
      getAndRemoveAttr(branch1, 'v-for', true);
      addRawAttr(branch1, 'type', 'radio');
      processElement(branch1, options);
      addIfCondition(branch0, {
        exp: "(" + typeBinding + ")==='radio'" + ifConditionExtra,
        block: branch1
      });
      // 3. other
      var branch2 = cloneASTElement(el);
      getAndRemoveAttr(branch2, 'v-for', true);
      addRawAttr(branch2, ':type', typeBinding);
      processElement(branch2, options);
      addIfCondition(branch0, {
        exp: ifCondition,
        block: branch2
      });

      if (hasElse) {
        branch0.else = true;
      } else if (elseIfCondition) {
        branch0.elseif = elseIfCondition;
      }

      return branch0
    }
  }
}

function cloneASTElement (el) {
  return createASTElement(el.tag, el.attrsList.slice(), el.parent)
}

function addRawAttr (el, name, value) {
  el.attrsMap[name] = value;
  el.attrsList.push({ name: name, value: value });
}

var model$2 = {
  preTransformNode: preTransformNode
};

var modules$1 = [
  klass$1,
  style$1,
  model$2
];

/*  */

function text (el, dir) {
  if (dir.value) {
    addProp(el, 'textContent', ("_s(" + (dir.value) + ")"));
  }
}

/*  */

function html (el, dir) {
  if (dir.value) {
    addProp(el, 'innerHTML', ("_s(" + (dir.value) + ")"));
  }
}

var directives$1 = {
  model: model,
  text: text,
  html: html
};

/*  */

var baseOptions = {
  expectHTML: true,
  modules: modules$1,
  directives: directives$1,
  isPreTag: isPreTag,
  isUnaryTag: isUnaryTag,
  mustUseProp: mustUseProp,
  canBeLeftOpenTag: canBeLeftOpenTag,
  isReservedTag: isReservedTag,
  getTagNamespace: getTagNamespace,
  staticKeys: genStaticKeys(modules$1)
};

/*  */

var isStaticKey;
var isPlatformReservedTag;

var genStaticKeysCached = cached(genStaticKeys$1);

/**
 * Goal of the optimizer: walk the generated template AST tree
 * and detect sub-trees that are purely static, i.e. parts of
 * the DOM that never needs to change.
 *
 * Once we detect these sub-trees, we can:
 *
 * 1. Hoist them into constants, so that we no longer need to
 *    create fresh nodes for them on each re-render;
 * 2. Completely skip them in the patching process.
 */
function optimize (root, options) {
  if (!root) { return }
  isStaticKey = genStaticKeysCached(options.staticKeys || '');
  isPlatformReservedTag = options.isReservedTag || no;
  // first pass: mark all non-static nodes.
  markStatic$1(root);
  // second pass: mark static roots.
  markStaticRoots(root, false);
}

function genStaticKeys$1 (keys) {
  return makeMap(
    'type,tag,attrsList,attrsMap,plain,parent,children,attrs' +
    (keys ? ',' + keys : '')
  )
}

function markStatic$1 (node) {
  node.static = isStatic(node);
  if (node.type === 1) {
    // do not make component slot content static. this avoids
    // 1. components not able to mutate slot nodes
    // 2. static slot content fails for hot-reloading
    if (
      !isPlatformReservedTag(node.tag) &&
      node.tag !== 'slot' &&
      node.attrsMap['inline-template'] == null
    ) {
      return
    }
    for (var i = 0, l = node.children.length; i < l; i++) {
      var child = node.children[i];
      markStatic$1(child);
      if (!child.static) {
        node.static = false;
      }
    }
    if (node.ifConditions) {
      for (var i$1 = 1, l$1 = node.ifConditions.length; i$1 < l$1; i$1++) {
        var block = node.ifConditions[i$1].block;
        markStatic$1(block);
        if (!block.static) {
          node.static = false;
        }
      }
    }
  }
}

function markStaticRoots (node, isInFor) {
  if (node.type === 1) {
    if (node.static || node.once) {
      node.staticInFor = isInFor;
    }
    // For a node to qualify as a static root, it should have children that
    // are not just static text. Otherwise the cost of hoisting out will
    // outweigh the benefits and it's better off to just always render it fresh.
    if (node.static && node.children.length && !(
      node.children.length === 1 &&
      node.children[0].type === 3
    )) {
      node.staticRoot = true;
      return
    } else {
      node.staticRoot = false;
    }
    if (node.children) {
      for (var i = 0, l = node.children.length; i < l; i++) {
        markStaticRoots(node.children[i], isInFor || !!node.for);
      }
    }
    if (node.ifConditions) {
      for (var i$1 = 1, l$1 = node.ifConditions.length; i$1 < l$1; i$1++) {
        markStaticRoots(node.ifConditions[i$1].block, isInFor);
      }
    }
  }
}

function isStatic (node) {
  if (node.type === 2) { // expression
    return false
  }
  if (node.type === 3) { // text
    return true
  }
  return !!(node.pre || (
    !node.hasBindings && // no dynamic bindings
    !node.if && !node.for && // not v-if or v-for or v-else
    !isBuiltInTag(node.tag) && // not a built-in
    isPlatformReservedTag(node.tag) && // not a component
    !isDirectChildOfTemplateFor(node) &&
    Object.keys(node).every(isStaticKey)
  ))
}

function isDirectChildOfTemplateFor (node) {
  while (node.parent) {
    node = node.parent;
    if (node.tag !== 'template') {
      return false
    }
    if (node.for) {
      return true
    }
  }
  return false
}

/*  */

var fnExpRE = /^\s*([\w$_]+|\([^)]*?\))\s*=>|^function\s*\(/;
var simplePathRE = /^\s*[A-Za-z_$][\w$]*(?:\.[A-Za-z_$][\w$]*|\['.*?']|\[".*?"]|\[\d+]|\[[A-Za-z_$][\w$]*])*\s*$/;

// keyCode aliases
var keyCodes = {
  esc: 27,
  tab: 9,
  enter: 13,
  space: 32,
  up: 38,
  left: 37,
  right: 39,
  down: 40,
  'delete': [8, 46]
};

// #4868: modifiers that prevent the execution of the listener
// need to explicitly return null so that we can determine whether to remove
// the listener for .once
var genGuard = function (condition) { return ("if(" + condition + ")return null;"); };

var modifierCode = {
  stop: '$event.stopPropagation();',
  prevent: '$event.preventDefault();',
  self: genGuard("$event.target !== $event.currentTarget"),
  ctrl: genGuard("!$event.ctrlKey"),
  shift: genGuard("!$event.shiftKey"),
  alt: genGuard("!$event.altKey"),
  meta: genGuard("!$event.metaKey"),
  left: genGuard("'button' in $event && $event.button !== 0"),
  middle: genGuard("'button' in $event && $event.button !== 1"),
  right: genGuard("'button' in $event && $event.button !== 2")
};

function genHandlers (
  events,
  isNative,
  warn
) {
  var res = isNative ? 'nativeOn:{' : 'on:{';
  for (var name in events) {
    res += "\"" + name + "\":" + (genHandler(name, events[name])) + ",";
  }
  return res.slice(0, -1) + '}'
}

function genHandler (
  name,
  handler
) {
  if (!handler) {
    return 'function(){}'
  }

  if (Array.isArray(handler)) {
    return ("[" + (handler.map(function (handler) { return genHandler(name, handler); }).join(',')) + "]")
  }

  var isMethodPath = simplePathRE.test(handler.value);
  var isFunctionExpression = fnExpRE.test(handler.value);

  if (!handler.modifiers) {
    return isMethodPath || isFunctionExpression
      ? handler.value
      : ("function($event){" + (handler.value) + "}") // inline statement
  } else {
    var code = '';
    var genModifierCode = '';
    var keys = [];
    for (var key in handler.modifiers) {
      if (modifierCode[key]) {
        genModifierCode += modifierCode[key];
        // left/right
        if (keyCodes[key]) {
          keys.push(key);
        }
      } else if (key === 'exact') {
        var modifiers = (handler.modifiers);
        genModifierCode += genGuard(
          ['ctrl', 'shift', 'alt', 'meta']
            .filter(function (keyModifier) { return !modifiers[keyModifier]; })
            .map(function (keyModifier) { return ("$event." + keyModifier + "Key"); })
            .join('||')
        );
      } else {
        keys.push(key);
      }
    }
    if (keys.length) {
      code += genKeyFilter(keys);
    }
    // Make sure modifiers like prevent and stop get executed after key filtering
    if (genModifierCode) {
      code += genModifierCode;
    }
    var handlerCode = isMethodPath
      ? handler.value + '($event)'
      : isFunctionExpression
        ? ("(" + (handler.value) + ")($event)")
        : handler.value;
    return ("function($event){" + code + handlerCode + "}")
  }
}

function genKeyFilter (keys) {
  return ("if(!('button' in $event)&&" + (keys.map(genFilterCode).join('&&')) + ")return null;")
}

function genFilterCode (key) {
  var keyVal = parseInt(key, 10);
  if (keyVal) {
    return ("$event.keyCode!==" + keyVal)
  }
  var code = keyCodes[key];
  return (
    "_k($event.keyCode," +
    (JSON.stringify(key)) + "," +
    (JSON.stringify(code)) + "," +
    "$event.key)"
  )
}

/*  */

function on (el, dir) {
  if (false) {
    warn("v-on without argument does not support modifiers.");
  }
  el.wrapListeners = function (code) { return ("_g(" + code + "," + (dir.value) + ")"); };
}

/*  */

function bind$1 (el, dir) {
  el.wrapData = function (code) {
    return ("_b(" + code + ",'" + (el.tag) + "'," + (dir.value) + "," + (dir.modifiers && dir.modifiers.prop ? 'true' : 'false') + (dir.modifiers && dir.modifiers.sync ? ',true' : '') + ")")
  };
}

/*  */

var baseDirectives = {
  on: on,
  bind: bind$1,
  cloak: noop
};

/*  */

var CodegenState = function CodegenState (options) {
  this.options = options;
  this.warn = options.warn || baseWarn;
  this.transforms = pluckModuleFunction(options.modules, 'transformCode');
  this.dataGenFns = pluckModuleFunction(options.modules, 'genData');
  this.directives = extend(extend({}, baseDirectives), options.directives);
  var isReservedTag = options.isReservedTag || no;
  this.maybeComponent = function (el) { return !isReservedTag(el.tag); };
  this.onceId = 0;
  this.staticRenderFns = [];
};



function generate (
  ast,
  options
) {
  var state = new CodegenState(options);
  var code = ast ? genElement(ast, state) : '_c("div")';
  return {
    render: ("with(this){return " + code + "}"),
    staticRenderFns: state.staticRenderFns
  }
}

function genElement (el, state) {
  if (el.staticRoot && !el.staticProcessed) {
    return genStatic(el, state)
  } else if (el.once && !el.onceProcessed) {
    return genOnce(el, state)
  } else if (el.for && !el.forProcessed) {
    return genFor(el, state)
  } else if (el.if && !el.ifProcessed) {
    return genIf(el, state)
  } else if (el.tag === 'template' && !el.slotTarget) {
    return genChildren(el, state) || 'void 0'
  } else if (el.tag === 'slot') {
    return genSlot(el, state)
  } else {
    // component or element
    var code;
    if (el.component) {
      code = genComponent(el.component, el, state);
    } else {
      var data = el.plain ? undefined : genData$2(el, state);

      var children = el.inlineTemplate ? null : genChildren(el, state, true);
      code = "_c('" + (el.tag) + "'" + (data ? ("," + data) : '') + (children ? ("," + children) : '') + ")";
    }
    // module transforms
    for (var i = 0; i < state.transforms.length; i++) {
      code = state.transforms[i](el, code);
    }
    return code
  }
}

// hoist static sub-trees out
function genStatic (el, state, once$$1) {
  el.staticProcessed = true;
  state.staticRenderFns.push(("with(this){return " + (genElement(el, state)) + "}"));
  return ("_m(" + (state.staticRenderFns.length - 1) + "," + (el.staticInFor ? 'true' : 'false') + "," + (once$$1 ? 'true' : 'false') + ")")
}

// v-once
function genOnce (el, state) {
  el.onceProcessed = true;
  if (el.if && !el.ifProcessed) {
    return genIf(el, state)
  } else if (el.staticInFor) {
    var key = '';
    var parent = el.parent;
    while (parent) {
      if (parent.for) {
        key = parent.key;
        break
      }
      parent = parent.parent;
    }
    if (!key) {
      "production" !== 'production' && state.warn(
        "v-once can only be used inside v-for that is keyed. "
      );
      return genElement(el, state)
    }
    return ("_o(" + (genElement(el, state)) + "," + (state.onceId++) + "," + key + ")")
  } else {
    return genStatic(el, state, true)
  }
}

function genIf (
  el,
  state,
  altGen,
  altEmpty
) {
  el.ifProcessed = true; // avoid recursion
  return genIfConditions(el.ifConditions.slice(), state, altGen, altEmpty)
}

function genIfConditions (
  conditions,
  state,
  altGen,
  altEmpty
) {
  if (!conditions.length) {
    return altEmpty || '_e()'
  }

  var condition = conditions.shift();
  if (condition.exp) {
    return ("(" + (condition.exp) + ")?" + (genTernaryExp(condition.block)) + ":" + (genIfConditions(conditions, state, altGen, altEmpty)))
  } else {
    return ("" + (genTernaryExp(condition.block)))
  }

  // v-if with v-once should generate code like (a)?_m(0):_m(1)
  function genTernaryExp (el) {
    return altGen
      ? altGen(el, state)
      : el.once
        ? genOnce(el, state)
        : genElement(el, state)
  }
}

function genFor (
  el,
  state,
  altGen,
  altHelper
) {
  var exp = el.for;
  var alias = el.alias;
  var iterator1 = el.iterator1 ? ("," + (el.iterator1)) : '';
  var iterator2 = el.iterator2 ? ("," + (el.iterator2)) : '';

  if (false
  ) {
    state.warn(
      "<" + (el.tag) + " v-for=\"" + alias + " in " + exp + "\">: component lists rendered with " +
      "v-for should have explicit keys. " +
      "See https://vuejs.org/guide/list.html#key for more info.",
      true /* tip */
    );
  }

  el.forProcessed = true; // avoid recursion
  return (altHelper || '_l') + "((" + exp + ")," +
    "function(" + alias + iterator1 + iterator2 + "){" +
      "return " + ((altGen || genElement)(el, state)) +
    '})'
}

function genData$2 (el, state) {
  var data = '{';

  // directives first.
  // directives may mutate the el's other properties before they are generated.
  var dirs = genDirectives(el, state);
  if (dirs) { data += dirs + ','; }

  // key
  if (el.key) {
    data += "key:" + (el.key) + ",";
  }
  // ref
  if (el.ref) {
    data += "ref:" + (el.ref) + ",";
  }
  if (el.refInFor) {
    data += "refInFor:true,";
  }
  // pre
  if (el.pre) {
    data += "pre:true,";
  }
  // record original tag name for components using "is" attribute
  if (el.component) {
    data += "tag:\"" + (el.tag) + "\",";
  }
  // module data generation functions
  for (var i = 0; i < state.dataGenFns.length; i++) {
    data += state.dataGenFns[i](el);
  }
  // attributes
  if (el.attrs) {
    data += "attrs:{" + (genProps(el.attrs)) + "},";
  }
  // DOM props
  if (el.props) {
    data += "domProps:{" + (genProps(el.props)) + "},";
  }
  // event handlers
  if (el.events) {
    data += (genHandlers(el.events, false, state.warn)) + ",";
  }
  if (el.nativeEvents) {
    data += (genHandlers(el.nativeEvents, true, state.warn)) + ",";
  }
  // slot target
  // only for non-scoped slots
  if (el.slotTarget && !el.slotScope) {
    data += "slot:" + (el.slotTarget) + ",";
  }
  // scoped slots
  if (el.scopedSlots) {
    data += (genScopedSlots(el.scopedSlots, state)) + ",";
  }
  // component v-model
  if (el.model) {
    data += "model:{value:" + (el.model.value) + ",callback:" + (el.model.callback) + ",expression:" + (el.model.expression) + "},";
  }
  // inline-template
  if (el.inlineTemplate) {
    var inlineTemplate = genInlineTemplate(el, state);
    if (inlineTemplate) {
      data += inlineTemplate + ",";
    }
  }
  data = data.replace(/,$/, '') + '}';
  // v-bind data wrap
  if (el.wrapData) {
    data = el.wrapData(data);
  }
  // v-on data wrap
  if (el.wrapListeners) {
    data = el.wrapListeners(data);
  }
  return data
}

function genDirectives (el, state) {
  var dirs = el.directives;
  if (!dirs) { return }
  var res = 'directives:[';
  var hasRuntime = false;
  var i, l, dir, needRuntime;
  for (i = 0, l = dirs.length; i < l; i++) {
    dir = dirs[i];
    needRuntime = true;
    var gen = state.directives[dir.name];
    if (gen) {
      // compile-time directive that manipulates AST.
      // returns true if it also needs a runtime counterpart.
      needRuntime = !!gen(el, dir, state.warn);
    }
    if (needRuntime) {
      hasRuntime = true;
      res += "{name:\"" + (dir.name) + "\",rawName:\"" + (dir.rawName) + "\"" + (dir.value ? (",value:(" + (dir.value) + "),expression:" + (JSON.stringify(dir.value))) : '') + (dir.arg ? (",arg:\"" + (dir.arg) + "\"") : '') + (dir.modifiers ? (",modifiers:" + (JSON.stringify(dir.modifiers))) : '') + "},";
    }
  }
  if (hasRuntime) {
    return res.slice(0, -1) + ']'
  }
}

function genInlineTemplate (el, state) {
  var ast = el.children[0];
  if (false) {
    state.warn('Inline-template components must have exactly one child element.');
  }
  if (ast.type === 1) {
    var inlineRenderFns = generate(ast, state.options);
    return ("inlineTemplate:{render:function(){" + (inlineRenderFns.render) + "},staticRenderFns:[" + (inlineRenderFns.staticRenderFns.map(function (code) { return ("function(){" + code + "}"); }).join(',')) + "]}")
  }
}

function genScopedSlots (
  slots,
  state
) {
  return ("scopedSlots:_u([" + (Object.keys(slots).map(function (key) {
      return genScopedSlot(key, slots[key], state)
    }).join(',')) + "])")
}

function genScopedSlot (
  key,
  el,
  state
) {
  if (el.for && !el.forProcessed) {
    return genForScopedSlot(key, el, state)
  }
  var fn = "function(" + (String(el.slotScope)) + "){" +
    "return " + (el.tag === 'template'
      ? el.if
        ? ((el.if) + "?" + (genChildren(el, state) || 'undefined') + ":undefined")
        : genChildren(el, state) || 'undefined'
      : genElement(el, state)) + "}";
  return ("{key:" + key + ",fn:" + fn + "}")
}

function genForScopedSlot (
  key,
  el,
  state
) {
  var exp = el.for;
  var alias = el.alias;
  var iterator1 = el.iterator1 ? ("," + (el.iterator1)) : '';
  var iterator2 = el.iterator2 ? ("," + (el.iterator2)) : '';
  el.forProcessed = true; // avoid recursion
  return "_l((" + exp + ")," +
    "function(" + alias + iterator1 + iterator2 + "){" +
      "return " + (genScopedSlot(key, el, state)) +
    '})'
}

function genChildren (
  el,
  state,
  checkSkip,
  altGenElement,
  altGenNode
) {
  var children = el.children;
  if (children.length) {
    var el$1 = children[0];
    // optimize single v-for
    if (children.length === 1 &&
      el$1.for &&
      el$1.tag !== 'template' &&
      el$1.tag !== 'slot'
    ) {
      return (altGenElement || genElement)(el$1, state)
    }
    var normalizationType = checkSkip
      ? getNormalizationType(children, state.maybeComponent)
      : 0;
    var gen = altGenNode || genNode;
    return ("[" + (children.map(function (c) { return gen(c, state); }).join(',')) + "]" + (normalizationType ? ("," + normalizationType) : ''))
  }
}

// determine the normalization needed for the children array.
// 0: no normalization needed
// 1: simple normalization needed (possible 1-level deep nested array)
// 2: full normalization needed
function getNormalizationType (
  children,
  maybeComponent
) {
  var res = 0;
  for (var i = 0; i < children.length; i++) {
    var el = children[i];
    if (el.type !== 1) {
      continue
    }
    if (needsNormalization(el) ||
        (el.ifConditions && el.ifConditions.some(function (c) { return needsNormalization(c.block); }))) {
      res = 2;
      break
    }
    if (maybeComponent(el) ||
        (el.ifConditions && el.ifConditions.some(function (c) { return maybeComponent(c.block); }))) {
      res = 1;
    }
  }
  return res
}

function needsNormalization (el) {
  return el.for !== undefined || el.tag === 'template' || el.tag === 'slot'
}

function genNode (node, state) {
  if (node.type === 1) {
    return genElement(node, state)
  } if (node.type === 3 && node.isComment) {
    return genComment(node)
  } else {
    return genText(node)
  }
}

function genText (text) {
  return ("_v(" + (text.type === 2
    ? text.expression // no need for () because already wrapped in _s()
    : transformSpecialNewlines(JSON.stringify(text.text))) + ")")
}

function genComment (comment) {
  return ("_e(" + (JSON.stringify(comment.text)) + ")")
}

function genSlot (el, state) {
  var slotName = el.slotName || '"default"';
  var children = genChildren(el, state);
  var res = "_t(" + slotName + (children ? ("," + children) : '');
  var attrs = el.attrs && ("{" + (el.attrs.map(function (a) { return ((camelize(a.name)) + ":" + (a.value)); }).join(',')) + "}");
  var bind$$1 = el.attrsMap['v-bind'];
  if ((attrs || bind$$1) && !children) {
    res += ",null";
  }
  if (attrs) {
    res += "," + attrs;
  }
  if (bind$$1) {
    res += (attrs ? '' : ',null') + "," + bind$$1;
  }
  return res + ')'
}

// componentName is el.component, take it as argument to shun flow's pessimistic refinement
function genComponent (
  componentName,
  el,
  state
) {
  var children = el.inlineTemplate ? null : genChildren(el, state, true);
  return ("_c(" + componentName + "," + (genData$2(el, state)) + (children ? ("," + children) : '') + ")")
}

function genProps (props) {
  var res = '';
  for (var i = 0; i < props.length; i++) {
    var prop = props[i];
    res += "\"" + (prop.name) + "\":" + (transformSpecialNewlines(prop.value)) + ",";
  }
  return res.slice(0, -1)
}

// #3895, #4268
function transformSpecialNewlines (text) {
  return text
    .replace(/\u2028/g, '\\u2028')
    .replace(/\u2029/g, '\\u2029')
}

/*  */

// these keywords should not appear inside expressions, but operators like
// typeof, instanceof and in are allowed
var prohibitedKeywordRE = new RegExp('\\b' + (
  'do,if,for,let,new,try,var,case,else,with,await,break,catch,class,const,' +
  'super,throw,while,yield,delete,export,import,return,switch,default,' +
  'extends,finally,continue,debugger,function,arguments'
).split(',').join('\\b|\\b') + '\\b');

// these unary operators should not be used as property/method names
var unaryOperatorsRE = new RegExp('\\b' + (
  'delete,typeof,void'
).split(',').join('\\s*\\([^\\)]*\\)|\\b') + '\\s*\\([^\\)]*\\)');

// strip strings in expressions
var stripStringRE = /'(?:[^'\\]|\\.)*'|"(?:[^"\\]|\\.)*"|`(?:[^`\\]|\\.)*\$\{|\}(?:[^`\\]|\\.)*`|`(?:[^`\\]|\\.)*`/g;

// detect problematic expressions in a template
function detectErrors (ast) {
  var errors = [];
  if (ast) {
    checkNode(ast, errors);
  }
  return errors
}

function checkNode (node, errors) {
  if (node.type === 1) {
    for (var name in node.attrsMap) {
      if (dirRE.test(name)) {
        var value = node.attrsMap[name];
        if (value) {
          if (name === 'v-for') {
            checkFor(node, ("v-for=\"" + value + "\""), errors);
          } else if (onRE.test(name)) {
            checkEvent(value, (name + "=\"" + value + "\""), errors);
          } else {
            checkExpression(value, (name + "=\"" + value + "\""), errors);
          }
        }
      }
    }
    if (node.children) {
      for (var i = 0; i < node.children.length; i++) {
        checkNode(node.children[i], errors);
      }
    }
  } else if (node.type === 2) {
    checkExpression(node.expression, node.text, errors);
  }
}

function checkEvent (exp, text, errors) {
  var stipped = exp.replace(stripStringRE, '');
  var keywordMatch = stipped.match(unaryOperatorsRE);
  if (keywordMatch && stipped.charAt(keywordMatch.index - 1) !== '$') {
    errors.push(
      "avoid using JavaScript unary operator as property name: " +
      "\"" + (keywordMatch[0]) + "\" in expression " + (text.trim())
    );
  }
  checkExpression(exp, text, errors);
}

function checkFor (node, text, errors) {
  checkExpression(node.for || '', text, errors);
  checkIdentifier(node.alias, 'v-for alias', text, errors);
  checkIdentifier(node.iterator1, 'v-for iterator', text, errors);
  checkIdentifier(node.iterator2, 'v-for iterator', text, errors);
}

function checkIdentifier (
  ident,
  type,
  text,
  errors
) {
  if (typeof ident === 'string') {
    try {
      new Function(("var " + ident + "=_"));
    } catch (e) {
      errors.push(("invalid " + type + " \"" + ident + "\" in expression: " + (text.trim())));
    }
  }
}

function checkExpression (exp, text, errors) {
  try {
    new Function(("return " + exp));
  } catch (e) {
    var keywordMatch = exp.replace(stripStringRE, '').match(prohibitedKeywordRE);
    if (keywordMatch) {
      errors.push(
        "avoid using JavaScript keyword as property name: " +
        "\"" + (keywordMatch[0]) + "\"\n  Raw expression: " + (text.trim())
      );
    } else {
      errors.push(
        "invalid expression: " + (e.message) + " in\n\n" +
        "    " + exp + "\n\n" +
        "  Raw expression: " + (text.trim()) + "\n"
      );
    }
  }
}

/*  */

function createFunction (code, errors) {
  try {
    return new Function(code)
  } catch (err) {
    errors.push({ err: err, code: code });
    return noop
  }
}

function createCompileToFunctionFn (compile) {
  var cache = Object.create(null);

  return function compileToFunctions (
    template,
    options,
    vm
  ) {
    options = extend({}, options);
    var warn$$1 = options.warn || warn;
    delete options.warn;

    /* istanbul ignore if */
    if (false) {
      // detect possible CSP restriction
      try {
        new Function('return 1');
      } catch (e) {
        if (e.toString().match(/unsafe-eval|CSP/)) {
          warn$$1(
            'It seems you are using the standalone build of Vue.js in an ' +
            'environment with Content Security Policy that prohibits unsafe-eval. ' +
            'The template compiler cannot work in this environment. Consider ' +
            'relaxing the policy to allow unsafe-eval or pre-compiling your ' +
            'templates into render functions.'
          );
        }
      }
    }

    // check cache
    var key = options.delimiters
      ? String(options.delimiters) + template
      : template;
    if (cache[key]) {
      return cache[key]
    }

    // compile
    var compiled = compile(template, options);

    // check compilation errors/tips
    if (false) {
      if (compiled.errors && compiled.errors.length) {
        warn$$1(
          "Error compiling template:\n\n" + template + "\n\n" +
          compiled.errors.map(function (e) { return ("- " + e); }).join('\n') + '\n',
          vm
        );
      }
      if (compiled.tips && compiled.tips.length) {
        compiled.tips.forEach(function (msg) { return tip(msg, vm); });
      }
    }

    // turn code into functions
    var res = {};
    var fnGenErrors = [];
    res.render = createFunction(compiled.render, fnGenErrors);
    res.staticRenderFns = compiled.staticRenderFns.map(function (code) {
      return createFunction(code, fnGenErrors)
    });

    // check function generation errors.
    // this should only happen if there is a bug in the compiler itself.
    // mostly for codegen development use
    /* istanbul ignore if */
    if (false) {
      if ((!compiled.errors || !compiled.errors.length) && fnGenErrors.length) {
        warn$$1(
          "Failed to generate render function:\n\n" +
          fnGenErrors.map(function (ref) {
            var err = ref.err;
            var code = ref.code;

            return ((err.toString()) + " in\n\n" + code + "\n");
        }).join('\n'),
          vm
        );
      }
    }

    return (cache[key] = res)
  }
}

/*  */

function createCompilerCreator (baseCompile) {
  return function createCompiler (baseOptions) {
    function compile (
      template,
      options
    ) {
      var finalOptions = Object.create(baseOptions);
      var errors = [];
      var tips = [];
      finalOptions.warn = function (msg, tip) {
        (tip ? tips : errors).push(msg);
      };

      if (options) {
        // merge custom modules
        if (options.modules) {
          finalOptions.modules =
            (baseOptions.modules || []).concat(options.modules);
        }
        // merge custom directives
        if (options.directives) {
          finalOptions.directives = extend(
            Object.create(baseOptions.directives),
            options.directives
          );
        }
        // copy other options
        for (var key in options) {
          if (key !== 'modules' && key !== 'directives') {
            finalOptions[key] = options[key];
          }
        }
      }

      var compiled = baseCompile(template, finalOptions);
      if (false) {
        errors.push.apply(errors, detectErrors(compiled.ast));
      }
      compiled.errors = errors;
      compiled.tips = tips;
      return compiled
    }

    return {
      compile: compile,
      compileToFunctions: createCompileToFunctionFn(compile)
    }
  }
}

/*  */

// `createCompilerCreator` allows creating compilers that use alternative
// parser/optimizer/codegen, e.g the SSR optimizing compiler.
// Here we just export a default compiler using the default parts.
var createCompiler = createCompilerCreator(function baseCompile (
  template,
  options
) {
  var ast = parse(template.trim(), options);
  optimize(ast, options);
  var code = generate(ast, options);
  return {
    ast: ast,
    render: code.render,
    staticRenderFns: code.staticRenderFns
  }
});

/*  */

var ref$1 = createCompiler(baseOptions);
var compileToFunctions = ref$1.compileToFunctions;

/*  */

// check whether current browser encodes a char inside attribute values
var div;
function getShouldDecode (href) {
  div = div || document.createElement('div');
  div.innerHTML = href ? "<a href=\"\n\"/>" : "<div a=\"\n\"/>";
  return div.innerHTML.indexOf('&#10;') > 0
}

// #3663: IE encodes newlines inside attribute values while other browsers don't
var shouldDecodeNewlines = inBrowser ? getShouldDecode(false) : false;
// #6828: chrome encodes content in a[href]
var shouldDecodeNewlinesForHref = inBrowser ? getShouldDecode(true) : false;

/*  */

var idToTemplate = cached(function (id) {
  var el = query(id);
  return el && el.innerHTML
});

var mount = Vue$3.prototype.$mount;
Vue$3.prototype.$mount = function (
  el,
  hydrating
) {
  el = el && query(el);

  /* istanbul ignore if */
  if (el === document.body || el === document.documentElement) {
    "production" !== 'production' && warn(
      "Do not mount Vue to <html> or <body> - mount to normal elements instead."
    );
    return this
  }

  var options = this.$options;
  // resolve template/el and convert to render function
  if (!options.render) {
    var template = options.template;
    if (template) {
      if (typeof template === 'string') {
        if (template.charAt(0) === '#') {
          template = idToTemplate(template);
          /* istanbul ignore if */
          if (false) {
            warn(
              ("Template element not found or is empty: " + (options.template)),
              this
            );
          }
        }
      } else if (template.nodeType) {
        template = template.innerHTML;
      } else {
        if (false) {
          warn('invalid template option:' + template, this);
        }
        return this
      }
    } else if (el) {
      template = getOuterHTML(el);
    }
    if (template) {
      /* istanbul ignore if */
      if (false) {
        mark('compile');
      }

      var ref = compileToFunctions(template, {
        shouldDecodeNewlines: shouldDecodeNewlines,
        shouldDecodeNewlinesForHref: shouldDecodeNewlinesForHref,
        delimiters: options.delimiters,
        comments: options.comments
      }, this);
      var render = ref.render;
      var staticRenderFns = ref.staticRenderFns;
      options.render = render;
      options.staticRenderFns = staticRenderFns;

      /* istanbul ignore if */
      if (false) {
        mark('compile end');
        measure(("vue " + (this._name) + " compile"), 'compile', 'compile end');
      }
    }
  }
  return mount.call(this, el, hydrating)
};

/**
 * Get outerHTML of elements, taking care
 * of SVG elements in IE as well.
 */
function getOuterHTML (el) {
  if (el.outerHTML) {
    return el.outerHTML
  } else {
    var container = document.createElement('div');
    container.appendChild(el.cloneNode(true));
    return container.innerHTML
  }
}

Vue$3.compile = compileToFunctions;

/* harmony default export */ __webpack_exports__["default"] = (Vue$3);

/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("DuR2"), __webpack_require__("162o").setImmediate))

/***/ }),

/***/ "77Pl":
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__("EqjI");
module.exports = function (it) {
  if (!isObject(it)) throw TypeError(it + ' is not an object!');
  return it;
};


/***/ }),

/***/ "7GwW":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__("cGG2");
var settle = __webpack_require__("21It");
var buildURL = __webpack_require__("DQCr");
var parseHeaders = __webpack_require__("oJlt");
var isURLSameOrigin = __webpack_require__("GHBc");
var createError = __webpack_require__("FtD3");
var btoa = (typeof window !== 'undefined' && window.btoa && window.btoa.bind(window)) || __webpack_require__("thJu");

module.exports = function xhrAdapter(config) {
  return new Promise(function dispatchXhrRequest(resolve, reject) {
    var requestData = config.data;
    var requestHeaders = config.headers;

    if (utils.isFormData(requestData)) {
      delete requestHeaders['Content-Type']; // Let the browser set it
    }

    var request = new XMLHttpRequest();
    var loadEvent = 'onreadystatechange';
    var xDomain = false;

    // For IE 8/9 CORS support
    // Only supports POST and GET calls and doesn't returns the response headers.
    // DON'T do this for testing b/c XMLHttpRequest is mocked, not XDomainRequest.
    if ("production" !== 'test' &&
        typeof window !== 'undefined' &&
        window.XDomainRequest && !('withCredentials' in request) &&
        !isURLSameOrigin(config.url)) {
      request = new window.XDomainRequest();
      loadEvent = 'onload';
      xDomain = true;
      request.onprogress = function handleProgress() {};
      request.ontimeout = function handleTimeout() {};
    }

    // HTTP basic authentication
    if (config.auth) {
      var username = config.auth.username || '';
      var password = config.auth.password || '';
      requestHeaders.Authorization = 'Basic ' + btoa(username + ':' + password);
    }

    request.open(config.method.toUpperCase(), buildURL(config.url, config.params, config.paramsSerializer), true);

    // Set the request timeout in MS
    request.timeout = config.timeout;

    // Listen for ready state
    request[loadEvent] = function handleLoad() {
      if (!request || (request.readyState !== 4 && !xDomain)) {
        return;
      }

      // The request errored out and we didn't get a response, this will be
      // handled by onerror instead
      // With one exception: request that using file: protocol, most browsers
      // will return status as 0 even though it's a successful request
      if (request.status === 0 && !(request.responseURL && request.responseURL.indexOf('file:') === 0)) {
        return;
      }

      // Prepare the response
      var responseHeaders = 'getAllResponseHeaders' in request ? parseHeaders(request.getAllResponseHeaders()) : null;
      var responseData = !config.responseType || config.responseType === 'text' ? request.responseText : request.response;
      var response = {
        data: responseData,
        // IE sends 1223 instead of 204 (https://github.com/axios/axios/issues/201)
        status: request.status === 1223 ? 204 : request.status,
        statusText: request.status === 1223 ? 'No Content' : request.statusText,
        headers: responseHeaders,
        config: config,
        request: request
      };

      settle(resolve, reject, response);

      // Clean up request
      request = null;
    };

    // Handle low level network errors
    request.onerror = function handleError() {
      // Real errors are hidden from us by the browser
      // onerror should only fire if it's a network error
      reject(createError('Network Error', config, null, request));

      // Clean up request
      request = null;
    };

    // Handle timeout
    request.ontimeout = function handleTimeout() {
      reject(createError('timeout of ' + config.timeout + 'ms exceeded', config, 'ECONNABORTED',
        request));

      // Clean up request
      request = null;
    };

    // Add xsrf header
    // This is only done if running in a standard browser environment.
    // Specifically not if we're in a web worker, or react-native.
    if (utils.isStandardBrowserEnv()) {
      var cookies = __webpack_require__("p1b6");

      // Add xsrf header
      var xsrfValue = (config.withCredentials || isURLSameOrigin(config.url)) && config.xsrfCookieName ?
          cookies.read(config.xsrfCookieName) :
          undefined;

      if (xsrfValue) {
        requestHeaders[config.xsrfHeaderName] = xsrfValue;
      }
    }

    // Add headers to the request
    if ('setRequestHeader' in request) {
      utils.forEach(requestHeaders, function setRequestHeader(val, key) {
        if (typeof requestData === 'undefined' && key.toLowerCase() === 'content-type') {
          // Remove Content-Type if data is undefined
          delete requestHeaders[key];
        } else {
          // Otherwise add header to the request
          request.setRequestHeader(key, val);
        }
      });
    }

    // Add withCredentials to request if needed
    if (config.withCredentials) {
      request.withCredentials = true;
    }

    // Add responseType to request if needed
    if (config.responseType) {
      try {
        request.responseType = config.responseType;
      } catch (e) {
        // Expected DOMException thrown by browsers not compatible XMLHttpRequest Level 2.
        // But, this can be suppressed for 'json' type as it can be parsed by default 'transformResponse' function.
        if (config.responseType !== 'json') {
          throw e;
        }
      }
    }

    // Handle progress if needed
    if (typeof config.onDownloadProgress === 'function') {
      request.addEventListener('progress', config.onDownloadProgress);
    }

    // Not all browsers support upload events
    if (typeof config.onUploadProgress === 'function' && request.upload) {
      request.upload.addEventListener('progress', config.onUploadProgress);
    }

    if (config.cancelToken) {
      // Handle cancellation
      config.cancelToken.promise.then(function onCanceled(cancel) {
        if (!request) {
          return;
        }

        request.abort();
        reject(cancel);
        // Clean up request
        request = null;
      });
    }

    if (requestData === undefined) {
      requestData = null;
    }

    // Send the request
    request.send(requestData);
  });
};


/***/ }),

/***/ "7HnR":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _utils = __webpack_require__("Nvt7");

var _utils2 = _interopRequireDefault(_utils);

var _eventBus = __webpack_require__("Us91");

var _eventBus2 = _interopRequireDefault(_eventBus);

var _extends = __webpack_require__("KkIu");

var _extends2 = _interopRequireDefault(_extends);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var touchEvents = {
  start: _utils2.default.support.touch ? 'touchstart' : 'mousedown',
  move: _utils2.default.support.touch ? 'touchmove' : 'mousemove',
  end: _utils2.default.support.touch ? 'touchend' : 'mouseup'
}; // 借鉴
// https://github.com/szimek/signature_pad

var isTouchEvent = false;
var isTouch = false;
var Signature = function Signature(el, options) {
  this.wrapper = typeof el === 'string' ? document.querySelector(el) : el;
  var defaults = {
    lineWidth: 3,
    penColor: '#000',
    backgroundColor: '#FFF',
    placeholder: '请在白色区域内 横向签名',
    onInit: _utils2.default.noop,
    onBegin: _utils2.default.noop,
    onUpdate: _utils2.default.noop,
    onEnd: _utils2.default.noop
  };
  this.options = defaults;
  (0, _extends2.default)(this.options, options);
  this.unique = this.options.unique || _utils2.default.getUnique();
  this.touches = {};
  this.clearPlaceholder = false;
  this.isPainted = false;
  this._init();
};
Signature.prototype = {
  _init: function _init() {
    var self = this;
    self._createCanvas();
    self.setPlaceholder();
    self.observer = _eventBus2.default.create(self.unique);
    self._addEvent();
    self.observer.emit('onInit');
  },
  _createCanvas: function _createCanvas() {
    var self = this;
    var _wrapper = self.wrapper;
    var _canvas = document.createElement('canvas');
    var _ctx = _canvas.getContext('2d');
    _wrapper.appendChild(_canvas);
    self._canvas = _canvas;
    self._ctx = _ctx;
    self._setCanvas();
  },
  _setCanvas: function _setCanvas() {
    var self = this;
    var _wrapper = self.wrapper;
    var _canvas = self._canvas;
    var _ctx = self._ctx;
    var _options = self.options;
    _canvas.width = _wrapper.clientWidth;
    _canvas.height = _wrapper.clientHeight;
    _ctx.lineWidth = _options.lineWidth;
    _ctx.strokeStyle = _options.penColor;
    _ctx.fillStyle = self.options.backgroundColor;
    _ctx.fillRect(0, 0, _canvas.width, _canvas.height);
    self.rect = _canvas.getBoundingClientRect();
  },
  _addEvent: function _addEvent() {
    var self = this;
    self._canvas['addEventListener'](touchEvents.start, this, false);
    self._canvas['addEventListener'](touchEvents.move, this, false);
    self._canvas['addEventListener'](touchEvents.end, this, false);
    window['addEventListener']('resize', this, false);
    for (var item in self.options) {
      if (item.indexOf('on') === 0) {
        if (self.options[item] instanceof Function) {
          (function (item, _self) {
            _self.observer.on(item, function () {
              _self.options[item].apply(_self, Array.prototype.slice.call(arguments));
            });
          })(item, self);
        }
      }
    }
  },
  _onTouchStart: function _onTouchStart(e) {
    var self = this;
    if (e.originalEvent) e = e.originalEvent;
    isTouchEvent = e.type === 'touchstart';
    var touch = isTouchEvent ? e.touches[0] : e;
    isTouch = true;
    self.clearPlaceholder || self.clear();
    self.clearPlaceholder = true;
    self._strokeBegin(touch);
    self.isPainted = true;
    e.preventDefault();
  },
  _onTouchMove: function _onTouchMove(e) {
    var self = this;
    if (e.originalEvent) e = e.originalEvent;
    if (!isTouch && e.type === 'mousemove') {
      e.preventDefault();
      return;
    }
    var touch = isTouchEvent ? e.touches[0] : e;
    self._strokeUpdate(touch);
    e.preventDefault();
  },
  _onTouchEnd: function _onTouchEnd(e) {
    var self = this;
    if (e.originalEvent) e = e.originalEvent;
    var touch = isTouchEvent ? e.touches[0] : e;
    self._strokeEnd(touch);
    isTouch = false;
    e.preventDefault();
  },
  _onResize: function _onResize(e) {
    var self = this;
    self._setCanvas();
    self.reset();
  },
  _strokeBegin: function _strokeBegin(touch) {
    var self = this;
    self.touches.startX = touch.clientX;
    self.touches.startY = touch.clientY;
    self._strokeUpdate(touch);
    self.observer.emit('onBegin', touch);
  },
  _strokeUpdate: function _strokeUpdate(touch) {
    var self = this;
    var _touches = self.touches;
    _touches.currentX = touch.clientX;
    _touches.currentY = touch.clientY;
    var start = self._createPoint(_touches.startX, _touches.startY);
    var end = self._createPoint(_touches.currentX, _touches.currentY);
    self._drawLine(start, end);
    _touches.startX = touch.clientX;
    _touches.startY = touch.clientY;
    self.observer.emit('onUpdate', touch);
  },
  _strokeEnd: function _strokeEnd(touch) {
    var self = this;
    self.observer.emit('onEnd', touch);
  },
  _createPoint: function _createPoint(x, y) {
    var self = this;
    var _offset = self.rect;
    return {
      x: x - _offset.left,
      y: y - _offset.top
    };
  },
  _drawLine: function _drawLine(start, end) {
    var self = this;
    var _ctx = self._ctx;
    _ctx.beginPath();
    _ctx.moveTo(start.x, start.y);
    _ctx.lineTo(end.x, end.y);
    _ctx.closePath();
    _ctx.stroke();
  },
  handleEvent: function handleEvent(e) {
    var self = this;
    switch (e.type) {
      case 'touchstart':
        self._onTouchStart(e);
        break;
      case 'touchmove':
        self._onTouchMove(e);
        break;
      case 'touchend':
        self._onTouchEnd(e);
        break;
      case 'mousedown':
        self._onTouchStart(e);
        break;
      case 'mousemove':
        self._onTouchMove(e);
        break;
      case 'mouseup':
        self._onTouchEnd(e);
        break;
      case 'resize':
        this._onResize(e);
        break;
    }
  },
  setPlaceholder: function setPlaceholder(placeholder) {
    var self = this;
    var _ctx = self._ctx;
    var _canvas = self._canvas;
    _ctx.font = '300 15px PingFang SC';
    _ctx.textAlign = 'center';
    _ctx.textBaseline = 'middle';
    _ctx.fillStyle = '#ccc';
    placeholder = placeholder || self.options.placeholder;
    _ctx.fillText(self.options.placeholder, _canvas.width / 2, _canvas.height / 2);
  },
  clear: function clear() {
    var self = this;
    var _canvas = self._canvas;
    var _ctx = self._ctx;
    _ctx.fillStyle = self.options.backgroundColor;
    _ctx.clearRect(0, 0, _canvas.width, _canvas.height);
    _ctx.fillRect(0, 0, _canvas.width, _canvas.height);
  },
  reset: function reset() {
    var self = this;
    self.clear();
    self.clearPlaceholder = false;
    self.isPainted = false;
    self.setPlaceholder();
  },
  toImage: function toImage(type, quality) {
    var self = this;
    if (!self.isPainted) {
      return;
    }
    type = type || 'image/png';
    quality = quality || 0.92;
    return self._canvas.toDataURL(type, quality);
  }
};

exports.default = Signature;
module.exports = exports['default'];

/***/ }),

/***/ "7KvD":
/***/ (function(module, exports) {

// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
var global = module.exports = typeof window != 'undefined' && window.Math == Math
  ? window : typeof self != 'undefined' && self.Math == Math ? self
  // eslint-disable-next-line no-new-func
  : Function('return this')();
if (typeof __g == 'number') __g = global; // eslint-disable-line no-undef


/***/ }),

/***/ "7UMu":
/***/ (function(module, exports, __webpack_require__) {

// 7.2.2 IsArray(argument)
var cof = __webpack_require__("R9M2");
module.exports = Array.isArray || function isArray(arg) {
  return cof(arg) == 'Array';
};


/***/ }),

/***/ "880/":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__("hJx8");


/***/ }),

/***/ "8HOu":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "8hRR":
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__("B0bq"), __esModule: true };

/***/ }),

/***/ "8ueD":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

__webpack_require__("mZY2");

var _utils = __webpack_require__("Nvt7");

var _utils2 = _interopRequireDefault(_utils);

var _eventBus = __webpack_require__("Us91");

var _eventBus2 = _interopRequireDefault(_eventBus);

var _transition = __webpack_require__("ebYN");

var _transition2 = _interopRequireDefault(_transition);

var _extends = __webpack_require__("KkIu");

var _extends2 = _interopRequireDefault(_extends);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// touch事件
var touchEvents = {
  start: _utils2.default.support.touch ? 'touchstart' : 'mousedown',
  move: _utils2.default.support.touch ? 'touchmove' : 'mousemove',
  end: _utils2.default.support.touch ? 'touchend' : 'mouseup'
};

var Swiper = function Swiper(el, options) {
  this.wrapper = typeof el === 'string' ? document.querySelector(el) : el;
  this.scroller = this.wrapper.querySelector('.bx-swiper-scroller');
  var defaults = {
    // 轮播组件的宽度,默认设备宽度
    width: null,
    // 轮播组件的高度, default、min、auto、数值
    height: null,
    // 轮播间隔事件
    speed: 5000,
    // 是否循环轮播
    loop: true,
    // 是否自动轮播
    autoplay: true,
    // 轮播动画时间
    transitionSpeed: 300,
    // 是否展示指示器/分页器
    pagination: true,
    // 页数大于当前值时,才展示分页器
    paginationLimit: 1,
    // 覆盖默认指示器/分页器样式
    paginationClass: null,
    // 指示器/分页器距离底部的距离
    paginationBottom: 9,
    // 滑动角度小于该值,才能正常滑动
    angle: 45,
    // 滑动结束后,时间小于{duration}毫秒并且距离大于{distance},即判定为滑动到上一个/下一个
    duration: 300,
    distance: 30,
    // 放大倍数, 根据viewport动态设置scale的值, 基本为1
    scale: null,
    // 是否开启回弹
    bounce: true,
    // 轮播相关事件
    onInit: _utils2.default.noop,
    onTouchStart: _utils2.default.noop,
    onTouchMove: _utils2.default.noop,
    onTouchEnd: _utils2.default.noop,
    onSlide: _utils2.default.noop,
    onSlidePrev: _utils2.default.noop,
    onSlideNext: _utils2.default.noop,
    onTransitionEnd: _utils2.default.noop
  };
  this.options = defaults;
  (0, _extends2.default)(this.options, options);
  this.options.$parent = this;
  this.computedWidth = this.options.width;
  this.total = 0;
  this.loopTotal = 0;
  this.currentIndex = 0;
  this.timer = null;
  this.isTouchStart = false;
  this.isTouchEnd = false;
  this.direction = null;
  this.distance = 0;
  this.offset = {
    x: 0, // 横向滑动距离
    y: 0 // 纵向滑动距离
  };
  this.touches = {
    startX: 0, // touch前一个点
    startY: 0, // touch前一个点
    currentX: 0, // touch后一个点
    currentY: 0, // touch后一个点
    distanceX: 0, // 两个touch之间的距离
    distanceY: 0 // 两个touch之间的距离
  };
  this.unique = this.options.unique || _utils2.default.getUnique();
  this.init();
};
var startTime = 0;
var endTime = 0;
var duration = 0;
var isTouchEvent = false;
var isTouch = false;
var isSliding;
Swiper.prototype = {
  init: function init() {
    var self = this;
    self.setWidth();
    self.setHeight();
    self.setIndex();
    self.setScale();
    self.total = self.getTotal();
    if (self.options.pagination && self.total > self.options.paginationLimit) {
      self.initPagination();
    }
    self.total <= 1 && (self.options.loop = false);
    self.options.loop && self.createLoop();
    self.options.autoplay && self.startInterval(self.options.speed);
    self.observer = _eventBus2.default.create(self.unique);
    self._addEvent();
    self.observer.emit('onInit');
  },
  // 设置容器宽度
  setWidth: function setWidth() {
    var self = this;
    var _width = 0;

    if (self.options.width) {
      self.wrapper.style.width = _utils2.default.isPercentage(self.options.width) ? self.options.width : self.options.width + 'px';
    }
    _width = self.wrapper.clientWidth;
    self.computedWidth = _width;
  },
  // 设置容器高度
  setHeight: function setHeight() {
    var self = this;
    if (self.options.height) {
      if (_utils2.default.isPercentage(self.options.height)) {
        self.wrapper.style['height'] = self.computedWidth * _utils2.default.percentageToNumber(self.options.height) + 'px';
      } else {
        self.wrapper.style['height'] = self.options.height + 'px';
      }
    } else {
      self.wrapper.style['height'] = '100%';
    }
  },
  // 设置元素放大倍数
  setScale: function setScale() {
    var self = this;
    if (!self.options.scale) {
      self.options.scale = _utils2.default.getScale();
    }
  },
  // autopaly为true,开启轮播定时器
  startInterval: function startInterval(speed) {
    var self = this;
    self.timer = window.setInterval(function () {
      if (self.isTouchStart) {
        if (self.isTouchEnd) {
          self.isTouchStart = false;
          self.isTouchEnd = false;
        }
        return false;
      }
      self.next();
    }, speed);
  },
  // 获取当前轮播个数
  getTotal: function getTotal() {
    var self = this;
    var items = self.wrapper.querySelectorAll('.bx-swiper-slide');
    return items.length;
  },
  // 设置轮播项index
  setIndex: function setIndex() {
    var self = this;
    var items = self.wrapper.querySelectorAll('.bx-swiper-slide');
    for (var index = 0; index < items.length; index++) {
      items[index].setAttribute('data-slide-index', index);
    }
  },
  // 获取当前轮播项index
  getIndex: function getIndex() {
    var self = this;
    var items = self.wrapper.querySelectorAll('.bx-swiper-slide');
    var currentIndex = 0;
    for (var index = 0; index < items.length; index++) {
      if (_utils2.default.hasClass(items[index], 'bx-swiper-slide--active')) {
        currentIndex = items[index].getAttribute('data-slide-index');
      }
    }
    return currentIndex;
  },
  // 滚动到指定的x轴/y轴位置, time为动画时间
  slideTo: function slideTo(x, y, time) {
    var self = this;
    _transition2.default.setProperty(self.scroller, _transition2.default.prefixStyle('transform'));
    time !== 0 && (time = self.options.transitionSpeed);
    _transition2.default.setDuration(self.scroller, time);
    self._translate(x, y);
  },
  // 滚动到指定的index
  slideToIndex: function slideToIndex(index, type) {
    var self = this;
    if (self.options.loop) {
      if (type === 'prev') {
        if (index === self.total - 1) {
          self.slideTo(0, 0);
        } else {
          self.slideTo(-1 * (index + 1) * self.computedWidth, 0);
        }
      } else {
        if (index === 0) {
          self.slideTo(-1 * (self.loopTotal - 1) * self.computedWidth, 0);
        } else {
          self.slideTo(-1 * (index + 1) * self.computedWidth, 0);
        }
      }
    } else {
      self.slideTo(-1 * index * self.computedWidth, 0);
    }

    self.setItemActive();
    self.options.pagination && self.setPaginationActive();
    self.observer.emit('onSlide');
  },
  // 更新index位置
  updateIndex: function updateIndex() {
    var self = this;
    if (self.options.loop) {
      self.slideTo(-1 * (self.currentIndex + 1) * self.computedWidth, 0, 0);
    } else {
      self.slideTo(-1 * self.currentIndex * self.computedWidth, 0, 0);
    }
  },
  // 设置当前index的轮播项为活动状态
  setItemActive: function setItemActive() {
    var self = this;
    var items = self.wrapper.querySelectorAll('.bx-swiper-slide');
    for (var index = 0; index < items.length; index++) {
      if (items[index].getAttribute('data-slide-index') === self.currentIndex) {
        !_utils2.default.hasClass(items[index], 'bx-swiper-slide--active') && _utils2.default.addClass(items[index], 'bx-swiper-slide--active');
      } else {
        _utils2.default.hasClass(items[index], 'bx-swiper-slide--active') && _utils2.default.removeClass(items[index], 'bx-swiper-slide--active');
      }
    }
  },
  // 初始化指示器/分页器
  initPagination: function initPagination() {
    var self = this;
    var div = document.createElement('div');
    div.className = self.options.paginationClass ? 'bx-swiper-paginations ' + self.options.paginationClass : 'bx-swiper-paginations';
    var html = '';
    for (var i = 0; i < self.total; i++) {
      html += '<div class="bx-swiper-pagination' + (i === 0 ? ' bx-swiper-pagination--active' : '') + '"></div>';
    }
    div.innerHTML = html;
    // 使用该方案, 分页器会模糊
    // div.style.bottom = (self.options.paginationBottom * self.options.scale) + 'px';
    // self.options.scale != 1 && Utils.setScale(div, self.options.scale);
    div.style.bottom = self.options.paginationBottom / self.options.scale + 'px';
    self.options.scale !== 1 && (div.style.zoom = self.options.scale);
    self.wrapper.appendChild(div);
  },
  // 设置当前index的指示器/分页器为活动状态
  setPaginationActive: function setPaginationActive() {
    var self = this;
    var items = self.wrapper.querySelectorAll('.bx-swiper-pagination');
    for (var index = 0; index < items.length; index++) {
      if (index === self.currentIndex) {
        !_utils2.default.hasClass(items[index], 'bx-swiper-pagination--active') && _utils2.default.addClass(items[index], 'bx-swiper-pagination--active');
        !_utils2.default.hasClass(items[index], 'bx-swiper-pagination--translation') && _utils2.default.addClass(items[index], 'bx-swiper-pagination--translation');
      } else {
        _utils2.default.hasClass(items[index], 'bx-swiper-pagination--active') && _utils2.default.removeClass(items[index], 'bx-swiper-pagination--active');
        _utils2.default.hasClass(items[index], 'bx-swiper-pagination--translation') && _utils2.default.removeClass(items[index], 'bx-swiper-pagination--translation');
      }
    }
  },
  // 滑动到上一个
  prev: function prev() {
    var self = this;
    self.currentIndex--;
    if (self.currentIndex < 0) {
      self.currentIndex = self.total - 1;
    }
    self.slideToIndex(self.currentIndex, 'prev');
    self.observer.emit('onSlidePrev');
  },
  // 滑动到下一个
  next: function next() {
    var self = this;
    self.currentIndex++;
    if (self.currentIndex >= self.total) {
      self.currentIndex = 0;
    }
    self.slideToIndex(self.currentIndex, 'next');
    self.observer.emit('onSlideNext');
  },
  // 初始化循环滚动
  createLoop: function createLoop() {
    var self = this;
    var items = self.wrapper.querySelectorAll('.bx-swiper-slide');
    var firstNode = items[0].cloneNode(true);
    _utils2.default.removeClass(firstNode, 'bx-swiper-slide--active');
    var lastNode = items[items.length - 1].cloneNode(true);
    self.scroller.insertBefore(lastNode, items[0]);
    self.scroller.appendChild(firstNode);
    self.loopTotal = self.getTotal();
    // 定位到第一个slideitem
    self._translate(-1 * self.computedWidth, 0);
  },
  // 处理循环滚动位置
  handleLoop: function handleLoop() {
    var self = this;
    if (self.offset.x === 0) {
      self.slideTo(-1 * self.total * self.computedWidth, 0, 0);
    }
    if (self.offset.x === -1 * (self.loopTotal - 1) * self.computedWidth) {
      self.slideTo(-1 * self.computedWidth, 0, 0);
    }
  },
  // 统一事件处理中心
  handleEvent: function handleEvent(e) {
    switch (e.type) {
      case 'touchstart':
        this._onTouchStart(e);
        break;
      case 'touchmove':
        this._onTouchMove(e);
        break;
      case 'touchend':
        this._onTouchEnd(e);
        break;
      case 'mousedown':
        this._onTouchStart(e);
        break;
      case 'mousemove':
        this._onTouchMove(e);
        break;
      case 'mouseup':
        this._onTouchEnd(e);
        break;
      case 'transitionend':
        this._transitionEnd(e);
        break;
      case 'webkitTransitionEnd':
        this._transitionEnd(e);
        break;
      case 'resize':
        this._onResize(e);
        break;
    }
  },
  // 判断是否需要回弹
  setBounce: function setBounce() {
    var self = this;
    if (!self.options.loop) {
      if (self.currentIndex === 0 && self.direction === 'right') {
        return true;
      }
      if (self.currentIndex === self.total - 1 && self.direction === 'left') {
        return true;
      }
    }
    return false;
  },
  // 添加事件
  _addEvent: function _addEvent() {
    var self = this;
    this.wrapper['addEventListener'](touchEvents.start, this, false);
    this.wrapper['addEventListener'](touchEvents.move, this, false);
    this.wrapper['addEventListener'](touchEvents.end, this, false);
    if (_utils2.default.support.touch && !_utils2.default.env.isIos && !_utils2.default.env.isAndroid) {
      this.wrapper['addEventListener']('mousedown', this, false);
      this.wrapper['addEventListener']('mousemove', this, false);
      this.wrapper['addEventListener']('mouseup', this, false);
    }
    this.scroller['addEventListener']('transitionend', this, false);
    this.scroller['addEventListener']('webkitTransitionEnd', this, false);
    window['addEventListener']('resize', this, false);
    for (var item in self.options) {
      if (item.indexOf('on') === 0) {
        if (self.options[item] instanceof Function) {
          (function (item, _self) {
            _self.observer.on(item, function () {
              _self.options[item].apply(_self, Array.prototype.slice.call(arguments));
            });
          })(item, self);
        }
      }
    }
  },
  _onTouchStart: function _onTouchStart(e) {
    var self = this;
    // 兼容jq自己封装的originalEvent,指向原始的事件对象
    if (e.originalEvent) e = e.originalEvent;
    // 大于一个touch点,不做处理
    if (e.touches && e.touches.length > 1) {
      e.preventDefault();
      return;
    }
    isTouchEvent = e.type === 'touchstart';
    isTouch = true;
    isSliding = undefined;
    self.touches.startX = isTouchEvent ? e.touches[0].pageX : e.pageX;
    self.touches.startY = isTouchEvent ? e.touches[0].pageY : e.pageY;
    startTime = _utils2.default.now();
    self.distance = 0;
    self.isTouchStart = true;
    _transition2.default.setDuration(self.scroller, 0);
    self.observer.emit('onTouchStart');
  },
  _onTouchMove: function _onTouchMove(e) {
    var self = this;
    if (e.originalEvent) e = e.originalEvent;
    if (!isTouch && e.type === 'mousemove') {
      e.preventDefault();
      return;
    }
    self.options.loop && self.handleLoop();
    if (e.touches && e.touches.length > 1) {
      e.preventDefault();
      return;
    }
    self.touches.currentX = e.type === 'touchmove' ? e.touches[0].pageX : e.pageX;
    self.touches.currentY = e.type === 'touchmove' ? e.touches[0].pageY : e.pageY;
    var touchAngle = Math.atan2(Math.abs(self.touches.currentY - self.touches.startY), Math.abs(self.touches.currentX - self.touches.startX)) * 180 / Math.PI;
    if (typeof isSliding === 'undefined') {
      isSliding = touchAngle <= self.options.angle;
    }
    if (!isSliding) {
      return;
    }
    self.touches.distanceX = self.touches.currentX - self.touches.startX;
    self.touches.distanceY = self.touches.currentY - self.touches.startY;
    self.touches.distanceX > 0 ? self.direction = 'right' : self.direction = 'left';
    self.options.bounce && (self.bounce = self.setBounce());
    self.bounce && (self.touches.distanceX = self.touches.distanceX / 2);
    self.offset.x += self.touches.distanceX;
    self.distance += self.touches.distanceX;
    self._translate(self.offset.x, 0);
    self.touches.startX = self.touches.currentX;
    self.touches.startY = self.touches.currentY;
    e.preventDefault();
    self.observer.emit('onTouchMove');
  },
  _onTouchEnd: function _onTouchEnd(e) {
    var self = this;
    endTime = _utils2.default.now();
    duration = endTime - startTime;
    if (!self.bounce && (duration <= self.options.duration && Math.abs(self.distance) > self.options.distance || Math.abs(self.distance) > self.computedWidth / 2)) {
      self.distance > 0 ? self.prev() : self.next();
    } else {
      self.slideTo(self.offset.x - self.distance, 0);
    }
    isTouch = false;
    self.isTouchEnd = true;
    self.observer.emit('onTouchEnd');
  },
  _onResize: function _onResize(e) {
    var self = this;
    self.setWidth();
    self.setHeight();
    self.updateIndex();
  },
  // transition动画结束后回调
  _transitionEnd: function _transitionEnd(e) {
    var self = this;
    self.options.loop && self.handleLoop();
    self.observer.emit('onTransitionEnd');
  },
  // 页面滑动到指定位置
  _translate: function _translate(x, y) {
    var self = this;
    if (!self.options.bounce) {
      if (x > 0) {
        x = 0;
      }
      var total = self.options.loop ? self.loopTotal : self.total;
      var totalDistance = (total - 1) * self.computedWidth;
      if (Math.abs(x) > totalDistance) {
        x = -1 * totalDistance;
      }
    }
    self.offset.x = x;
    _transition2.default.setTransform(self.scroller, x, y);
  }
};
exports.default = {
  create: function create(el, options) {
    return new Swiper(el, options);
  }
};
module.exports = exports['default'];

/***/ }),

/***/ "9bCY":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/views/ui/List.vue
var List = __webpack_require__("gCjl");
var List_default = /*#__PURE__*/__webpack_require__.n(List);

// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2a3b9981","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/ui/List.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0,false,false)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"demo-list"},[_c('div',{staticClass:"demo-list-group"},[_c('h3',{staticClass:"demo-title"},[_vm._v("列表项")]),_vm._v(" "),_c('div',{staticClass:"bx-list"},[_c('div',{staticClass:"bx-list-item"},[_vm._v("列表项1")]),_vm._v(" "),_c('div',{staticClass:"bx-list-item"},[_vm._v("列表项2")]),_vm._v(" "),_c('div',{staticClass:"bx-list-item"},[_c('div',{staticClass:"bx-list-item-title"},[_vm._v("\n          列表1\n        ")]),_vm._v(" "),_c('div',{staticClass:"bx-list-item-extra"},[_vm._v("说明文字")])]),_vm._v(" "),_c('div',{staticClass:"bx-list-item"},[_c('div',{staticClass:"bx-list-item-title"},[_vm._v("\n          列表1\n        ")]),_vm._v(" "),_c('div',{staticClass:"bx-list-item-extra"},[_vm._v("说明文字")])]),_vm._v(" "),_c('div',{staticClass:"bx-list-item"},[_c('div',{staticClass:"bx-list-item-title"},[_vm._v("\n          列表1\n        ")]),_vm._v(" "),_c('div',{staticClass:"bx-list-item-link"},[_c('i',{staticClass:"bx-icon bx-icon-arrows-right"})])]),_vm._v(" "),_c('div',{staticClass:"bx-list-item"},[_c('div',{staticClass:"bx-list-item-title"},[_vm._v("\n          列表1\n        ")]),_vm._v(" "),_c('div',{staticClass:"bx-list-item-extra"},[_c('span',[_vm._v("说明文字")])]),_vm._v(" "),_c('div',{staticClass:"bx-list-item-link"},[_c('i',{staticClass:"bx-icon bx-icon-arrows-right"})])]),_vm._v(" "),_c('div',{staticClass:"bx-list-item"},[_c('div',{staticClass:"bx-list-item-icon"},[_c('img',{attrs:{"src":"http://img.winbaoxian.com/autoUpload/learning/avatar_default_79148af363.png"}})]),_vm._v(" "),_c('div',{staticClass:"bx-list-item-title"},[_vm._v("列表1")]),_vm._v(" "),_c('div',{staticClass:"bx-list-item-extra"},[_vm._v("说明文字")])]),_vm._v(" "),_c('div',{staticClass:"bx-list-item"},[_c('div',{staticClass:"bx-list-item-icon"},[_c('i',{staticClass:"bx-icon bx-icon-image"})]),_vm._v(" "),_c('div',{staticClass:"bx-list-item-title"},[_vm._v("列表1")]),_vm._v(" "),_c('div',{staticClass:"bx-list-item-extra"},[_vm._v("说明文字")]),_vm._v(" "),_c('div',{staticClass:"bx-list-item-link"},[_c('i',{staticClass:"bx-icon bx-icon-arrows-right"})])])])]),_vm._v(" "),_c('div',{staticClass:"demo-list-group"},[_c('h3',{staticClass:"demo-title"},[_vm._v("左右文字组合列表")]),_vm._v(" "),_c('div',{staticClass:"bx-panel"},[_c('div',{staticClass:"bx-panel-header"},[_c('div',{staticClass:"bx-panel-title"},[_vm._v("个人信息")]),_vm._v(" "),_c('div',{staticClass:"bx-panel-extra"},[_vm._v("更多")]),_vm._v(" "),_c('div',{staticClass:"bx-panel-link"},[_c('i',{staticClass:"bx-icon bx-icon-arrows-right"})])]),_vm._v(" "),_c('div',{staticClass:"bx-panel-body"},[_c('ul',{staticClass:"bx-list"},[_c('li',{staticClass:"bx-list-item"},[_c('div',{staticClass:"bx-list-item-title"},[_vm._v("姓名")]),_vm._v(" "),_c('div',{staticClass:"bx-list-item-value"},[_vm._v("邱国荣")]),_vm._v(" "),_c('div',{staticClass:"bx-list-item-link"},[_c('i',{staticClass:"bx-icon bx-icon-arrows-right"})])]),_vm._v(" "),_c('li',{staticClass:"bx-list-item"},[_c('div',{staticClass:"bx-list-item-title"},[_vm._v("性别")]),_vm._v(" "),_c('div',{staticClass:"bx-list-item-value"},[_vm._v("男")]),_vm._v(" "),_c('div',{staticClass:"bx-list-item-link"},[_c('i',{staticClass:"bx-icon bx-icon-arrows-right"})])]),_vm._v(" "),_c('li',{staticClass:"bx-list-item"},[_c('div',{staticClass:"bx-list-item-title"},[_vm._v("邮箱")]),_vm._v(" "),_c('div',{staticClass:"bx-list-item-value"},[_vm._v("qgr@winbaoxian.com")]),_vm._v(" "),_c('div',{staticClass:"bx-list-item-link"},[_c('i',{staticClass:"bx-icon bx-icon-arrows-right"})])])])])])]),_vm._v(" "),_c('div',{staticClass:"demo-list-group"},[_c('h3',{staticClass:"demo-title"},[_vm._v("图文组合列表")]),_vm._v(" "),_c('div',{staticClass:"bx-panel"},[_c('div',{staticClass:"bx-panel-header"},[_c('div',{staticClass:"bx-panel-title"},[_vm._v("图文组合")]),_vm._v(" "),_c('div',{staticClass:"bx-panel-extra"},[_vm._v("更多")]),_vm._v(" "),_c('div',{staticClass:"bx-panel-link"},[_c('i',{staticClass:"bx-icon bx-icon-arrows-right"})])]),_vm._v(" "),_c('div',{staticClass:"bx-panel-body"},[_c('ul',{staticClass:"bx-list"},[_c('li',{staticClass:"bx-list-item"},[_c('div',{staticClass:"bx-list-item-inner"},[_c('div',{staticClass:"bx-list-item-title"},[_vm._v("标题")]),_vm._v(" "),_c('div',{staticClass:"bx-list-item-subtitle"},[_vm._v("列表副文案列表副文案列表副文案列表副文案")])])]),_vm._v(" "),_c('li',{staticClass:"bx-list-item"},[_c('div',{staticClass:"bx-list-item-inner"},[_c('div',{staticClass:"bx-list-item-title bx-text-ellipsis"},[_vm._v("标题标题标题标题标题标题标题标题标题标题标题标题标题标题标题标题")]),_vm._v(" "),_c('div',{staticClass:"bx-list-item-subtitle bx-text-ellipsis-two"},[_vm._v("列表副文案列表副文案列表副文案列表副文案列表副文案列表副文案列表副文案列表副文案列表副文案列表副文案列表副文案列表副文案列表副文案列表副文案列表副文案列表副文案列表副文案列表副文案列表副文案列表副文案列表副文案列表副文案列表副文案列表副文案列表副文案列表副文案列表副文案列表副文案")])])]),_vm._v(" "),_c('li',{staticClass:"bx-list-item"},[_c('div',{staticClass:"bx-list-item-inner"},[_c('div',{staticClass:"bx-list-item-title bx-flex"},[_c('p',{staticClass:"bx-flex-item bx-text-ellipsis"},[_vm._v("标题限制11个字标题限制11个字标题限制11个字")]),_vm._v(" "),_c('p',{staticClass:"demo-list-item-time"},[_vm._v("2017-02-08 12:11:53")])]),_vm._v(" "),_c('div',{staticClass:"bx-list-item-subtitle"},[_vm._v("张某某")])])]),_vm._v(" "),_c('li',{staticClass:"bx-list-item"},[_c('div',{staticClass:"bx-list-item-image"},[_c('img',{attrs:{"src":"http://img.winbaoxian.com/autoUpload/learning/avatar_default_79148af363.png"}})]),_vm._v(" "),_c('div',{staticClass:"bx-list-item-inner"},[_c('div',{staticClass:"bx-list-item-title bx-text-ellipsis-one"},[_vm._v("标题标题标题标题标题标题标题标题标题标题标题标题标题标题标题标题标题标题标题标题标题标题标题标题标题标题标题标题标题标题标题标题")]),_vm._v(" "),_c('div',{staticClass:"bx-list-item-subtitle bx-text-ellipsis-three"},[_vm._v("副标题副标题副标题副标题副标题副标题副标题副标题副标题副标题副标题副标题副标题副标题副标题副标题副标题副标题副标题副标题副标题副标题副标题副标题")])])])])]),_vm._v(" "),_c('div',{staticClass:"bx-panel-footer bx-text-align-center bx-color-minor"},[_c('span',[_vm._v("查看更多")]),_vm._v(" "),_c('span',[_c('i',{staticClass:"bx-icon bx-icon-arrows-down"})])])])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var ui_List = (esExports);
// CONCATENATED MODULE: ./src/views/ui/List.vue
function injectStyle (ssrContext) {
  __webpack_require__("c90P")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  List_default.a,
  ui_List,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var views_ui_List = __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "AI4d":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/views/Audio.vue
var Audio = __webpack_require__("xew0");
var Audio_default = /*#__PURE__*/__webpack_require__.n(Audio);

// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-65eb2441","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/Audio.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',_vm._l((_vm.audioArr),function(audio){return _c('div',{staticClass:"list-item"},[_c('audio',{staticClass:"audioplayer",attrs:{"src":audio.url,"preload":"metadata","controls":"controls"}})])}))}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var views_Audio = (esExports);
// CONCATENATED MODULE: ./src/views/Audio.vue
function injectStyle (ssrContext) {
  __webpack_require__("/YgI")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-65eb2441"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  Audio_default.a,
  views_Audio,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var src_views_Audio = __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "AV57":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
/* eslint-disable */
// 来源
// https://github.com/Tencent/weui.js/blob/master/src/uploader/image.js
var ImageHelper = {
  // 检查图片是否有被压扁，如果有，返回比率
  // ref to http://stackoverflow.com/questions/11929099/html5-canvas-drawimage-ratio-bug-ios
  detectVerticalSquash: function detectVerticalSquash(img) {
    // 拍照在IOS7或以下的机型会出现照片被压扁的bug
    var data;
    var ih = img.naturalHeight;
    var canvas = document.createElement('canvas');
    canvas.width = 1;
    canvas.height = ih;
    var ctx = canvas.getContext('2d');
    ctx.drawImage(img, 0, 0);
    try {
      data = ctx.getImageData(0, 0, 1, ih).data;
    } catch (err) {
      console.log('Cannot check verticalSquash: CORS?');
      return 1;
    }
    var sy = 0;
    var ey = ih;
    var py = ih;
    while (py > sy) {
      var alpha = data[(py - 1) * 4 + 3];
      if (alpha === 0) {
        ey = py;
      } else {
        sy = py;
      }
      py = ey + sy >> 1; // py = parseInt((ey + sy) / 2)
    }
    var ratio = py / ih;
    return ratio === 0 ? 1 : ratio;
  },
  // dataURI to blob
  // ref to https://gist.github.com/fupslot/5015897
  dataURItoBuffer: function dataURItoBuffer(dataURI) {
    var byteString = atob(dataURI.split(',')[1]);
    var buffer = new ArrayBuffer(byteString.length);
    var view = new Uint8Array(buffer);
    for (var i = 0; i < byteString.length; i++) {
      view[i] = byteString.charCodeAt(i);
    }
    return buffer;
  },
  dataURItoBlob: function dataURItoBlob(dataURI) {
    var mimeString = dataURI.split(',')[0].split(':')[1].split(';')[0];
    var buffer = this.dataURItoBuffer(dataURI);
    return new Blob([buffer], { type: mimeString });
  },
  // 获取图片的orientation
  // ref to http://stackoverflow.com/questions/7584794/accessing-jpeg-exif-rotation-data-in-javascript-on-the-client-side
  getOrientation: function getOrientation(buffer) {
    var view = new DataView(buffer);
    if (view.getUint16(0, false) != 0xFFD8) return -2;
    var length = view.byteLength,
        offset = 2;
    while (offset < length) {
      var marker = view.getUint16(offset, false);
      offset += 2;
      if (marker == 0xFFE1) {
        if (view.getUint32(offset += 2, false) != 0x45786966) return -1;
        var little = view.getUint16(offset += 6, false) == 0x4949;
        offset += view.getUint32(offset + 4, little);
        var tags = view.getUint16(offset, little);
        offset += 2;
        for (var i = 0; i < tags; i++) {
          if (view.getUint16(offset + i * 12, little) == 0x0112) return view.getUint16(offset + i * 12 + 8, little);
        }
      } else if ((marker & 0xFF00) != 0xFF00) break;else offset += view.getUint16(offset, false);
    }
    return -1;
  },
  // 修正拍照时图片的方向
  // ref to https://stackoverflow.com/questions/19463126/how-to-draw-photo-with-correct-orientation-in-canvas-after-capture-photo-by-usin
  orientationHelper: function orientationHelper(canvas, ctx, orientation) {
    var w = canvas.width;
    var h = canvas.height;
    if (orientation > 4) {
      canvas.width = h;
      canvas.height = w;
    }
    switch (orientation) {
      case 2:
        ctx.translate(w, 0);
        ctx.scale(-1, 1);
        break;
      case 3:
        ctx.translate(w, h);
        ctx.rotate(Math.PI);
        break;
      case 4:
        ctx.translate(0, h);
        ctx.scale(1, -1);
        break;
      case 5:
        ctx.rotate(0.5 * Math.PI);
        ctx.scale(1, -1);
        break;
      case 6:
        ctx.rotate(0.5 * Math.PI);
        ctx.translate(0, -h);
        break;
      case 7:
        ctx.rotate(0.5 * Math.PI);
        ctx.translate(w, -h);
        ctx.scale(-1, 1);
        break;
      case 8:
        ctx.rotate(-0.5 * Math.PI);
        ctx.translate(-w, 0);
        break;
    }
  }
};
exports.default = ImageHelper;
module.exports = exports['default'];

/***/ }),

/***/ "AXd+":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "B0bq":
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__("fWfb");
module.exports = __webpack_require__("FeBl").Object.getOwnPropertySymbols;


/***/ }),

/***/ "B7pF":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

exports.default = {
  data: function data() {
    return {
      current: 0,
      horizontal: [{
        title: '方案一',
        doing: true,
        done: false
      }, {
        title: '方案二',
        doing: false,
        done: false
      }, {
        title: '方案三',
        doing: false,
        done: false
      }, {
        title: '方案四',
        doing: false,
        done: false
      }, {
        title: '已完成',
        doing: false,
        done: false
      }],
      vertical: [{
        title: '方案一',
        content: '这里是说明文案这里是说明文案这里是说明文案这里是说明文案这里是说明文案这里是说明文案这里是说明文案这里是说明文案这里是说明文案这里是说明文案这里是说明文案这里是说明文案',
        doing: true,
        done: false
      }, {
        title: '方案二',
        content: '这里是说明文案这里是说明文案这里是说明文案这里是说明文案文案文案文案文案文案文案文案限两行',
        doing: false,
        done: false
      }, {
        title: '方案三',
        doing: false,
        done: false
      }, {
        title: '方案四',
        content: '这里是说明文案这里是说明文案这里是说明文案这里是说明文案文案文案文案文案文案文案文案限两行',
        doing: false,
        done: false
      }, {
        title: '已完成',
        doing: false,
        done: false
      }]
    };
  },

  created: function created() {
    var self = this;
    var i = 0;
    window.setInterval(function () {
      for (i = 0; i < self.horizontal.length; i++) {
        self.horizontal[i].doing = false;
        self.horizontal[i].done = false;
        self.vertical[i].doing = false;
        self.vertical[i].done = false;
      }
      self.horizontal[self.current].doing = true;
      self.vertical[self.current].doing = true;
      for (i = 0; i < self.current; i++) {
        self.horizontal[i].done = true;
        self.vertical[i].done = true;
      }

      self.current = self.current + 1;
      if (self.current >= 5) {
        self.current = 0;
      }
    }, 800);
  }
};
module.exports = exports['default'];

/***/ }),

/***/ "BqSl":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "CVwJ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/views/Signature.vue
var Signature = __webpack_require__("j9++");
var Signature_default = /*#__PURE__*/__webpack_require__.n(Signature);

// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5f45aa04","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/Signature.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"demo-signature"},[(_vm.show)?_c('div',{staticClass:"demo-popup"},[_c('div',[_vm._v("\n      请签上你的大名\n      "),_c('a',{on:{"click":_vm.hidePopup}},[_vm._v("隐藏")])]),_vm._v(" "),_c('div',{staticClass:"bx-signature"}),_vm._v(" "),_c('div',[_c('a',{on:{"click":_vm.createImage}},[_vm._v("点我预览")]),_vm._v(" "),_c('a',{on:{"click":_vm.clearCanvas}},[_vm._v("我要重置")])]),_vm._v(" "),_c('div',{staticClass:"demo-signature-preview"},[(_vm.base64)?_c('img',{attrs:{"src":_vm.base64}}):_vm._e()])]):_vm._e(),_vm._v(" "),(!_vm.show)?_c('div',{staticClass:"demo-btn",on:{"click":_vm.showPopup}},[_vm._v("我要签名")]):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var views_Signature = (esExports);
// CONCATENATED MODULE: ./src/views/Signature.vue
function injectStyle (ssrContext) {
  __webpack_require__("wCRF")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-5f45aa04"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  Signature_default.a,
  views_Signature,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var src_views_Signature = __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "Cn5t":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var ua = window.navigator.userAgent;
var vers;
var env = {};
var regexp = {
  // eslint-disable-next-line
  ios: /OS ([\d_\.]+) like Mac OS X/,
  // eslint-disable-next-line
  android: /Android[\s\/]([\d\.]+)/
};
if (ua.match(regexp.ios)) {
  vers = ua.match(regexp.ios);
  env.os = {
    name: 'IOS',
    isIOS: !0,
    version: vers[1].split('_').join('.')
  };
} else if (ua.match(regexp.android)) {
  // eslint-disable-next-line
  vers = ua.match(regexp.android);
  env.os = {
    name: 'Android',
    isAndroid: !0,
    version: vers[1]
  };
} else {
  env.os = { name: 'unknown', version: '0.0.0' };
}

var loading = {
  html: '',
  css3: false,
  svg: false,
  canvas: false,
  normal: false,
  version: env.os.version,
  // 元素缩放比
  scale: 1,
  timer: null,
  _normalHtml: function _normalHtml() {
    this.html += '<div class="loading-circle">';
    this.html += '<div class="loading-half-circle"></div>';
    this.html += '</div>';
  },
  _css3Html: function _css3Html() {
    this.html += '<div class="loading-circle rotation-self">';
    this.html += '<div class="loading-half-circle rotation-clip"></div>';
    this.html += '</div>';
  },
  // css3对android 4.3及以下进行降级处理
  _css3CompatibleHtml: function _css3CompatibleHtml() {
    this.html += '<div class="loading-circle circle-clip-auto">';
    this.html += '<div class="loading-half-circle rotation-self-360"></div>';
    this.html += '</div>';
  },
  _svgHtml: function _svgHtml() {
    this.html += '<svg class="loading-svg" width="80" height="80" xmlns="http://www.w3.org/2000/svg">';
    this.html += '<circle cx="40" cy="40" r="30" stroke="#FFF" fill="none" stroke-width="3" stroke-linecap="round">';
    this.html += '<animate attributeName="stroke-dashoffset" dur="1.6s" repeatCount="indefinite" from="427" to="45"></animate>';
    this.html += '<animate attributeName="stroke-dasharray" dur="1.6s" repeatCount="indefinite" values="121 70;1 190;121 70"></animate>';
    this.html += '</circle>';
    this.html += '</svg>';
  },
  _canvasHtml: function _canvasHtml() {
    this.html += '<canvas id="loading-canvas" class="loading-canvas" width="80" height="80"></canvas>';
  },
  _normalInit: function _normalInit() {
    // 进度条长度阀值
    var threshold = 0;
    // 定时器间隔时间
    var during = 20;
    // 每个during转动角度
    var angle = 8;
    // 进度条转动720度为一个周期,周期分为3个间隔
    // 第一个间隔,进度条长度增加
    // 第二个间隔,进度条长度不变
    // 第三个间隔,进度条长度减少
    var section = 720 / 3 / angle;

    var counter = 0;
    var rotateSelf = 0;
    var rotateHalf = 0;
    this.timer = window.setInterval(function () {
      counter++;
      if (counter <= section) {
        threshold += during;
        rotateHalf = threshold / (during * section) * 180;
      }
      if (counter >= section && counter <= section * 2) {
        rotateHalf = 180;
      }
      if (counter >= section * 2 && counter <= section * 3) {
        threshold -= during;
        rotateHalf = 180 - threshold / (during * section) * 180 + 180;
      }
      if (counter === section * 3) {
        threshold = 0;
        counter = 0;
        rotateHalf = 0;
      }
      rotateSelf = counter / (3 * section) * 540;

      document.getElementsByClassName('loading-circle')[0].style.transform = 'rotate(' + rotateSelf + 'deg)';
      document.getElementsByClassName('loading-circle')[0].style.WebkitTransform = 'rotate(' + rotateSelf + 'deg)';
      document.getElementsByClassName('loading-half-circle')[0].style.transform = 'rotate(' + rotateHalf + 'deg)';
      document.getElementsByClassName('loading-half-circle')[0].style.WebkitTransform = 'rotate(' + rotateHalf + 'deg)';
    }, during);
  },
  _canvasInit: function _canvasInit() {
    // 初始化canvas

    var canvas = document.getElementById('loading-canvas');
    var ctx = canvas.getContext('2d');

    var x = canvas.width / 2;
    var y = canvas.height / 2;

    // 解决IOS retina屏下绘制图像模糊
    var devicePixelRatio = window.devicePixelRatio || 1;
    var backingStoreRatio = ctx.webkitBackingStorePixelRatio || ctx.mozBackingStorePixelRatio || ctx.msBackingStorePixelRatio || ctx.oBackingStorePixelRatio || ctx.backingStorePixelRatio || 1;
    var ratio = devicePixelRatio / backingStoreRatio;
    if (devicePixelRatio !== backingStoreRatio) {
      var oldWidth = canvas.width;
      var oldHeight = canvas.height;
      canvas.width = oldWidth * ratio;
      canvas.height = oldHeight * ratio;
      canvas.style.width = oldWidth + 'px';
      canvas.style.height = oldHeight + 'px';
      ctx.scale(ratio, ratio);
    }
    // 解决IOS retina屏下绘制图像模糊

    // 进度条长度阀值
    var threshold = 0;
    // 定时器间隔时间
    var during = 15;
    // 每个during转动角度
    var angle = 6;
    // 进度条转动720度为一个周期,周期分为3个间隔
    // 第一个间隔,进度条长度增加
    // 第二个间隔,进度条长度不变
    // 第三个间隔,进度条长度减少
    var section = 720 / 3 / angle;
    var counter = 0;

    this.timer = window.setInterval(function () {
      counter++;
      // 第一个间隔,进度条长度增加
      if (counter <= section) {
        threshold += during;
      }
      // 第三个间隔,进度条长度减少
      if (counter >= section * 2 && counter <= section * 3) {
        threshold -= during;
      }
      // 一个周期结束,重置
      if (counter === section * 3) {
        threshold = 0;
        counter = 0;
      }
      rotate();
      drawArc();
    }, during);
    // 画布旋转angle角度
    function rotate() {
      ctx.translate(x, y); // 将绘图原点移到画布中点
      ctx.rotate(Math.PI / 180 * angle); // 旋转角度
      ctx.translate(-x, -y); // 将画布原点移动
    }

    // 在画布上画进度条
    function drawArc() {
      ctx.clearRect(0, 0, canvas.width, canvas.height);
      ctx.lineWidth = 3;
      ctx.strokeStyle = '#FFF';
      ctx.beginPath();
      ctx.arc(40, 40, 30, 1.5 * Math.PI, (threshold / (during * section) + 1.5) * Math.PI);
      ctx.stroke();
      ctx.closePath();
    }
  },
  // 在版本号ver及ver以下,如ver=4.4.4,则表示包含4.4.4及以下
  underVersion: function underVersion(ver) {
    if (this.compareVersion(this.version, ver) === '=') {
      return true;
    }
    if (this.compareVersion(this.version, ver) === '<') {
      return true;
    }
    return false;
  },
  // 获取viewport content中的参数
  getViewPortParam: function getViewPortParam(name) {
    var viewport = document.querySelector('meta[name=viewport]');
    if (!viewport) {
      return null;
    }
    var content = viewport.getAttribute('content');
    if (!content) {
      return null;
    }
    // eslint-disable-next-line
    name = name.replace(/[\[]/, '\\[').replace(/[\]]/, '\\]');
    var regex = new RegExp('(^|,)' + name + '=([^,]*)(,|$)', 'i');
    var results = regex.exec(content);

    return results === null ? null : decodeURIComponent(results[2].replace(/\+/g, ' '));
  },
  // 根据viewport设置放大倍数,默认为1
  setScale: function setScale() {
    var initialScale = this.getViewPortParam('initial-scale') || 0;
    var maximumScale = this.getViewPortParam('maximum-scale') || 0;
    var minimumScale = this.getViewPortParam('minimum-scale') || 0;
    var scale = initialScale;
    if (maximumScale !== 0 && maximumScale <= initialScale) {
      scale = maximumScale;
    }
    if (minimumScale !== 0 && minimumScale >= initialScale) {
      scale = minimumScale;
    }
    this.scale = 1.0 / scale;
  },
  // 比较两个版本号
  compareVersion: function compareVersion(curr, target) {
    if (curr === target) {
      return '=';
    }
    var currArr = curr.split('.');
    var targetArr = target.split('.');
    var len = currArr.length >= targetArr.length ? currArr.length : targetArr.length;

    for (var i = 0; i < len; i++) {
      if (!currArr[i]) {
        currArr[i] = 0;
      }
      if (!targetArr[i]) {
        targetArr[i] = 0;
      }

      if (currArr[i] > targetArr[i]) {
        return '>';
      } else if (currArr[i] < targetArr[i]) {
        return '<';
      }
    }

    return '=';
  },
  // 显示loading,共有4中实现方式 1、css3   2、js timer 3、svg  4、canvas
  show: function show(options) {
    this.html = '';
    options = options || {};
    this.css3 = options.css3 || false;
    this.svg = options.svg || false;
    this.canvas = options.canvas || false;
    this.normal = options.normal || false;

    this.setScale();

    // 如果dom已存在,则不再重复添加
    var logoLoading = document.getElementsByClassName('logo-loading');
    if (logoLoading.length > 0) {
      console.log('dom已存在');
      return;
    }

    // 创建loading dom
    var div = document.createElement('div');
    div.className = 'logo-loading';
    if (env.os.isIOS) {
      // scale放大缩小会造成失真
      // div.style.transform = 'scale(' + this.scale + ')';
      // div.style.WebkitTransform = 'scale(' + this.scale + ')';
      div.style.zoom = this.scale;
    }
    if (this.css3) {
      this._css3Html();
    } else if (this.normal) {
      this._normalHtml();
    } else if (this.svg) {
      this._svgHtml();
    } else if (this.canvas) {
      this._canvasHtml();
    } else {
      if (env.os.isIOS) {
        this._canvasHtml();
      } else if (env.os.isAndroid && this.underVersion('4.3.0')) {
        this._css3CompatibleHtml();
      } else {
        this._css3Html();
      }
    }
    this.html += '<div class="logo-icon">';
    this.html += '<p></p> <p></p> <p></p> <p></p> <p></p> <p></p> <p></p>';
    this.html += '</div>';
    div.innerHTML = this.html;
    document.body.appendChild(div);
    var canvas = document.getElementById('loading-canvas');
    if (canvas) {
      this._canvasInit();
    }
    if (this.normal) {
      this._normalInit();
    }
  },
  // 隐藏loading
  hide: function hide() {
    var logoLoading = document.getElementsByClassName('logo-loading');
    if (logoLoading.length > 0) {
      var _element = logoLoading[0];
      _element.parentNode.removeChild(_element);
      if (this.timer) {
        clearInterval(this.timer);
        this.timer = null;
      }
    }
  }
};
exports.default = loading;
module.exports = exports['default'];

/***/ }),

/***/ "D2L2":
/***/ (function(module, exports) {

var hasOwnProperty = {}.hasOwnProperty;
module.exports = function (it, key) {
  return hasOwnProperty.call(it, key);
};


/***/ }),

/***/ "DL+9":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _uploader = __webpack_require__("i36v");

var _uploader2 = _interopRequireDefault(_uploader);

var _loading = __webpack_require__("Y6T+");

var _loading2 = _interopRequireDefault(_loading);

var _api = __webpack_require__("VsUZ");

var _api2 = _interopRequireDefault(_api);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var FILEDIR = 'tinsurance_refund'; //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

exports.default = {
  data: function data() {
    return {
      imageOSS: null,
      imageServer: null,
      base64: null,
      imageBase64: null
    };
  },

  methods: {
    getSuffix: function getSuffix(filename) {
      var pos = filename.lastIndexOf('.');
      var suffix = '';
      if (pos !== -1) {
        suffix = filename.substring(pos);
      }
      return suffix;
    },
    uploadBase64: function uploadBase64() {
      var self = this;
      if (!self.base64) {
        console.log('请输入base64内容');
        return false;
      }
      // eslint-disable-next-line
      var uploader = new _uploader2.default(null, {
        url: window.location.origin + '/oss/upload',
        data: {
          success_action_status: 200
        },
        autoUpload: false,
        base64: self.base64,
        onBefore: function onBefore(file) {
          _api2.default.getAuthInfo(FILEDIR).then(function (response) {
            var data = response.data.data;
            // 正式情况使用
            // uploader.options.url = data.host;
            uploader.options.data.signature = data.signature;
            uploader.options.data.policy = data.policy;
            uploader.options.data.OSSAccessKeyId = data.accessid;
            uploader.options.data.key = data.dir + data.fileName + '.png';
            uploader.upload();
          });
        },
        onSuccess: function onSuccess() {
          self.imageBase64 = 'http://media.winbaoxian.com/' + this.options.data.key;
        },
        onError: function onError(xhr, status, message) {
          console.log(xhr, status, message);
        }
      });
    }
  },
  mounted: function mounted() {
    var self = this;
    self.$nextTick(function () {
      // eslint-disable-next-line
      var uploaderOSS = new _uploader2.default('.bx-uploader-oss', {
        url: window.location.origin + '/oss/upload',
        autoUpload: false,
        data: {
          success_action_status: 200
        },
        compress: {
          type: 'image/jpeg',
          width: 1000,
          height: 1000
        },
        onBefore: function onBefore(file) {
          _loading2.default.show();
          _api2.default.getAuthInfo(FILEDIR).then(function (response) {
            var data = response.data.data;
            // 正式情况使用
            // uploaderOSS.options.url = data.host;
            uploaderOSS.options.data.signature = data.signature;
            uploaderOSS.options.data.policy = data.policy;
            uploaderOSS.options.data.OSSAccessKeyId = data.accessid;
            uploaderOSS.options.data.key = data.dir + data.fileName + self.getSuffix(file.name);
            uploaderOSS.upload();
          });
        },
        onSuccess: function onSuccess() {
          self.imageOSS = 'http://media.winbaoxian.com/' + this.options.data.key;
        },
        onError: function onError(xhr, status, message) {
          console.log(xhr, status, message);
        },
        onComplete: function onComplete() {
          _loading2.default.hide();
          console.log('complete');
        },
        onProgress: function onProgress(percent) {
          console.log(percent);
        }
      });
      // eslint-disable-next-line
      var uploaderServer = new _uploader2.default('.bx-uploader-server', {
        url: window.location.origin + '/management/learningContent/uploadImage',
        compress: {
          type: 'image/jpeg',
          width: 1000,
          height: 1000
        },
        xhrFields: {
          'withCredentials': true
        },
        onBefore: function onBefore() {
          _loading2.default.show();
        },
        onSuccess: function onSuccess(response) {
          if (response.success) {
            self.imageServer = response.data.url;
          }
        },
        onError: function onError(xhr, status, message) {
          console.log(xhr, status, message);
        },
        onComplete: function onComplete() {
          _loading2.default.hide();
          console.log('complete');
        }
      });
    });
  }
};
module.exports = exports['default'];

/***/ }),

/***/ "DQCr":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__("cGG2");

function encode(val) {
  return encodeURIComponent(val).
    replace(/%40/gi, '@').
    replace(/%3A/gi, ':').
    replace(/%24/g, '$').
    replace(/%2C/gi, ',').
    replace(/%20/g, '+').
    replace(/%5B/gi, '[').
    replace(/%5D/gi, ']');
}

/**
 * Build a URL by appending params to the end
 *
 * @param {string} url The base of the url (e.g., http://www.google.com)
 * @param {object} [params] The params to be appended
 * @returns {string} The formatted url
 */
module.exports = function buildURL(url, params, paramsSerializer) {
  /*eslint no-param-reassign:0*/
  if (!params) {
    return url;
  }

  var serializedParams;
  if (paramsSerializer) {
    serializedParams = paramsSerializer(params);
  } else if (utils.isURLSearchParams(params)) {
    serializedParams = params.toString();
  } else {
    var parts = [];

    utils.forEach(params, function serialize(val, key) {
      if (val === null || typeof val === 'undefined') {
        return;
      }

      if (utils.isArray(val)) {
        key = key + '[]';
      }

      if (!utils.isArray(val)) {
        val = [val];
      }

      utils.forEach(val, function parseValue(v) {
        if (utils.isDate(v)) {
          v = v.toISOString();
        } else if (utils.isObject(v)) {
          v = JSON.stringify(v);
        }
        parts.push(encode(key) + '=' + encode(v));
      });
    });

    serializedParams = parts.join('&');
  }

  if (serializedParams) {
    url += (url.indexOf('?') === -1 ? '?' : '&') + serializedParams;
  }

  return url;
};


/***/ }),

/***/ "DV5c":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/views/ui/Modal.vue
var Modal = __webpack_require__("TqSx");
var Modal_default = /*#__PURE__*/__webpack_require__.n(Modal);

// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-fcb732cc","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/ui/Modal.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"demo-modal"},[_c('div',{staticClass:"demo-modal-group"},[_c('div',{staticClass:"demo-title"},[_vm._v("Toast")]),_vm._v(" "),_c('div',{staticClass:"bx-panel"},[_c('div',{staticClass:"bx-panel-body"},[_c('div',{staticClass:"bx-list"},[_c('div',{staticClass:"bx-list-item",on:{"click":function($event){_vm.toast('最长文案不超过28个字符')}}},[_c('div',{staticClass:"bx-list-item-title"},[_vm._v("轻提示")]),_vm._v(" "),_vm._m(0,false,false)]),_vm._v(" "),_c('div',{staticClass:"bx-list-item",on:{"click":function($event){_vm.toast('成功提示','success')}}},[_c('div',{staticClass:"bx-list-item-title"},[_vm._v("成功提示")]),_vm._v(" "),_vm._m(1,false,false)]),_vm._v(" "),_c('div',{staticClass:"bx-list-item",on:{"click":function($event){_vm.toast('失败提示','error')}}},[_c('div',{staticClass:"bx-list-item-title"},[_vm._v("失败提示")]),_vm._v(" "),_vm._m(2,false,false)]),_vm._v(" "),_c('div',{staticClass:"bx-list-item",on:{"click":function($event){_vm.toast('警示提示','warn')}}},[_c('div',{staticClass:"bx-list-item-title"},[_vm._v("警示提示")]),_vm._v(" "),_vm._m(3,false,false)])])])])]),_vm._v(" "),_c('div',{staticClass:"demo-modal-group"},[_c('div',{staticClass:"demo-title"},[_vm._v("Modal")]),_vm._v(" "),_c('div',{staticClass:"bx-panel"},[_c('div',{staticClass:"bx-panel-body"},[_c('div',{staticClass:"bx-list"},[_c('div',{staticClass:"bx-list-item",on:{"click":function($event){_vm.modal()}}},[_c('div',{staticClass:"bx-list-item-title"},[_vm._v("通用Modal")]),_vm._v(" "),_vm._m(4,false,false)])])])])]),_vm._v(" "),_c('div',{staticClass:"demo-modal-group"},[_c('div',{staticClass:"demo-title"},[_vm._v("Alert")]),_vm._v(" "),_c('div',{staticClass:"bx-panel"},[_c('div',{staticClass:"bx-panel-body"},[_c('div',{staticClass:"bx-list"},[_c('div',{staticClass:"bx-list-item",on:{"click":function($event){_vm.alert('普通Alert')}}},[_c('div',{staticClass:"bx-list-item-title"},[_vm._v("普通Alert")]),_vm._v(" "),_vm._m(5,false,false)]),_vm._v(" "),_c('div',{staticClass:"bx-list-item",on:{"click":function($event){_vm.alert('带标题Alert','标题')}}},[_c('div',{staticClass:"bx-list-item-title"},[_vm._v("带标题Alert")]),_vm._v(" "),_vm._m(6,false,false)]),_vm._v(" "),_c('div',{staticClass:"bx-list-item",on:{"click":function($event){_vm.alert('<div style=\'color:red\'>自定义内容</div>')}}},[_c('div',{staticClass:"bx-list-item-title"},[_vm._v("自定义内容Alert")]),_vm._v(" "),_vm._m(7,false,false)])])])])]),_vm._v(" "),_c('div',{staticClass:"demo-modal-group"},[_c('div',{staticClass:"demo-title"},[_vm._v("Dialog")]),_vm._v(" "),_c('div',{staticClass:"bx-panel"},[_c('div',{staticClass:"bx-panel-body"},[_c('div',{staticClass:"bx-list"},[_c('div',{staticClass:"bx-list-item",on:{"click":function($event){_vm.dialog('普通Dialog')}}},[_c('div',{staticClass:"bx-list-item-title"},[_vm._v("普通Dialog")]),_vm._v(" "),_vm._m(8,false,false)]),_vm._v(" "),_c('div',{staticClass:"bx-list-item",on:{"click":function($event){_vm.dialog('带标题Dialog','标题')}}},[_c('div',{staticClass:"bx-list-item-title"},[_vm._v("带标题Dialog")]),_vm._v(" "),_vm._m(9,false,false)]),_vm._v(" "),_c('div',{staticClass:"bx-list-item",on:{"click":function($event){_vm.dialog('<div style=\'color:red\'>自定义内容</div>')}}},[_c('div',{staticClass:"bx-list-item-title"},[_vm._v("自定义内容Dialog")]),_vm._v(" "),_vm._m(10,false,false)])])])])]),_vm._v(" "),_c('div',{staticClass:"demo-modal-group"},[_c('div',{staticClass:"demo-title"},[_vm._v("Picker")]),_vm._v(" "),_c('div',{staticClass:"bx-panel"},[_c('div',{staticClass:"bx-panel-body"},[_c('div',{staticClass:"bx-list"},[_c('div',{staticClass:"bx-list-item",on:{"click":function($event){_vm.picker()}}},[_c('div',{staticClass:"bx-list-item-title"},[_vm._v("通用Picker(仅有布局,未有动效)")]),_vm._v(" "),_vm._m(11,false,false)])])])])]),_vm._v(" "),(_vm.alertVisible)?_c('div',{staticClass:"bx-alert"},[_c('div',{staticClass:"bx-modal-overlay"}),_vm._v(" "),_c('div',{staticClass:"bx-modal"},[(_vm.alertTitle)?_c('div',{staticClass:"bx-modal-header"},[_c('div',{staticClass:"bx-modal-title"},[_vm._v(_vm._s(_vm.alertTitle))])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"bx-modal-body"},[_c('div',{staticClass:"bx-modal-inner"},[_c('div',{staticClass:"bx-modal-content",domProps:{"innerHTML":_vm._s(_vm.alertMsg)}})])]),_vm._v(" "),_c('div',{staticClass:"bx-modal-footer"},[_c('div',{staticClass:"bx-modal-buttons"},[_c('a',{staticClass:"bx-modal-btn bx-modal-link",on:{"click":function($event){_vm.closeModal()}}},[_vm._v("知道了")])])])])]):_vm._e(),_vm._v(" "),(_vm.dialogVisible)?_c('div',{staticClass:"bx-dialog"},[_c('div',{staticClass:"bx-modal-overlay"}),_vm._v(" "),_c('div',{staticClass:"bx-modal"},[(_vm.dialogTitle)?_c('div',{staticClass:"bx-modal-header"},[_c('div',{staticClass:"bx-modal-title"},[_vm._v(_vm._s(_vm.dialogTitle))])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"bx-modal-body"},[_c('div',{staticClass:"bx-modal-inner"},[_c('div',{staticClass:"bx-modal-content",domProps:{"innerHTML":_vm._s(_vm.dialogMsg)}})])]),_vm._v(" "),_c('div',{staticClass:"bx-modal-footer"},[_c('div',{staticClass:"bx-modal-buttons"},[_c('a',{staticClass:"bx-modal-btn",on:{"click":function($event){_vm.closeModal()}}},[_vm._v("取消")]),_vm._v(" "),_c('a',{staticClass:"bx-modal-btn bx-modal-link",on:{"click":function($event){_vm.closeModal()}}},[_vm._v("确定")])])])])]):_vm._e(),_vm._v(" "),(_vm.modalVisible)?_c('div',{staticClass:"bx-modal-panel"},[_c('div',{staticClass:"bx-modal-overlay"}),_vm._v(" "),_c('div',{staticClass:"bx-modal"},[_c('div',{staticClass:"bx-modal-header"},[_c('div',{staticClass:"bx-modal-close",on:{"click":function($event){_vm.closeModal()}}},[_c('i',{staticClass:"bx-icon"})]),_vm._v(" "),_c('div',{staticClass:"bx-modal-title"},[_vm._v("温馨提示")])]),_vm._v(" "),_vm._m(12,false,false),_vm._v(" "),_c('div',{staticClass:"bx-modal-footer"},[_c('div',{staticClass:"bx-modal-buttons"},[_c('a',{staticClass:"bx-modal-btn",on:{"click":function($event){_vm.closeModal()}}},[_vm._v("取消")]),_vm._v(" "),_c('a',{staticClass:"bx-modal-btn bx-modal-link",on:{"click":function($event){_vm.closeModal()}}},[_vm._v("确定")])])])])]):_vm._e(),_vm._v(" "),(_vm.toastVisible)?_c('div',{staticClass:"bx-toast",class:_vm.toastType},[(_vm.toastType)?_c('i',{staticClass:"bx-icon"}):_vm._e(),_vm._v(_vm._s(_vm.toastMsg)+"\n  ")]):_vm._e(),_vm._v(" "),(_vm.pickerVisible)?_c('div',{staticClass:"bx-picker-panel"},[_c('div',{staticClass:"bx-picker-overlay",on:{"click":function($event){_vm.closeModal()}}}),_vm._v(" "),_c('div',{staticClass:"bx-picker"},[_c('div',{staticClass:"bx-picker-header"},[_c('a',{staticClass:"bx-picker-action bx-picker-close",on:{"click":function($event){_vm.closeModal()}}},[_vm._v("关闭")]),_vm._v(" "),_c('a',{staticClass:"bx-picker-action bx-picker-confirm",on:{"click":function($event){_vm.closeModal()}}},[_vm._v("确定")])]),_vm._v(" "),_vm._m(13,false,false)])]):_vm._e()])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"bx-list-item-link"},[_c('i',{staticClass:"bx-icon"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"bx-list-item-link"},[_c('i',{staticClass:"bx-icon"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"bx-list-item-link"},[_c('i',{staticClass:"bx-icon"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"bx-list-item-link"},[_c('i',{staticClass:"bx-icon"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"bx-list-item-link"},[_c('i',{staticClass:"bx-icon"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"bx-list-item-link"},[_c('i',{staticClass:"bx-icon"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"bx-list-item-link"},[_c('i',{staticClass:"bx-icon"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"bx-list-item-link"},[_c('i',{staticClass:"bx-icon"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"bx-list-item-link"},[_c('i',{staticClass:"bx-icon"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"bx-list-item-link"},[_c('i',{staticClass:"bx-icon"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"bx-list-item-link"},[_c('i',{staticClass:"bx-icon"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"bx-list-item-link"},[_c('i',{staticClass:"bx-icon"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"bx-modal-body"},[_c('div',{staticClass:"bx-modal-inner"},[_c('div',{staticClass:"bx-modal-title"},[_vm._v("标题")]),_vm._v(" "),_c('div',{staticClass:"bx-modal-content"},[_vm._v("补充说明正文")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"bx-picker-body"},[_c('div',{staticClass:"bx-picker-group"},[_c('div',{staticClass:"bx-picker-group-mask"}),_vm._v(" "),_c('div',{staticClass:"bx-picker-indicator"}),_vm._v(" "),_c('div',{staticClass:"bx-picker-content"},[_c('div',{staticClass:"bx-picker-item"},[_vm._v("浙江省")]),_vm._v(" "),_c('div',{staticClass:"bx-picker-item"},[_vm._v("福建省")]),_vm._v(" "),_c('div',{staticClass:"bx-picker-item"},[_vm._v("江苏省")]),_vm._v(" "),_c('div',{staticClass:"bx-picker-item"},[_vm._v("广东省")]),_vm._v(" "),_c('div',{staticClass:"bx-picker-item"},[_vm._v("山东省")]),_vm._v(" "),_c('div',{staticClass:"bx-picker-item"},[_vm._v("安徽省")]),_vm._v(" "),_c('div',{staticClass:"bx-picker-item"},[_vm._v("陕西省")]),_vm._v(" "),_c('div',{staticClass:"bx-picker-item"},[_vm._v("河南省")]),_vm._v(" "),_c('div',{staticClass:"bx-picker-item"},[_vm._v("河北省")])])]),_vm._v(" "),_c('div',{staticClass:"bx-picker-group"},[_c('div',{staticClass:"bx-picker-group-mask"}),_vm._v(" "),_c('div',{staticClass:"bx-picker-indicator"}),_vm._v(" "),_c('div',{staticClass:"bx-picker-content"},[_c('div',{staticClass:"bx-picker-item"},[_vm._v("杭州市")]),_vm._v(" "),_c('div',{staticClass:"bx-picker-item"},[_vm._v("绍兴市")]),_vm._v(" "),_c('div',{staticClass:"bx-picker-item"},[_vm._v("温州市")]),_vm._v(" "),_c('div',{staticClass:"bx-picker-item"},[_vm._v("宁波市")]),_vm._v(" "),_c('div',{staticClass:"bx-picker-item"},[_vm._v("丽水市")]),_vm._v(" "),_c('div',{staticClass:"bx-picker-item"},[_vm._v("温岭市")]),_vm._v(" "),_c('div',{staticClass:"bx-picker-item"},[_vm._v("嘉兴市")])])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var ui_Modal = (esExports);
// CONCATENATED MODULE: ./src/views/ui/Modal.vue
function injectStyle (ssrContext) {
  __webpack_require__("oyy5")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  Modal_default.a,
  ui_Modal,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var views_ui_Modal = __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "DuR2":
/***/ (function(module, exports) {

var g;

// This works in non-strict mode
g = (function() {
	return this;
})();

try {
	// This works if eval is allowed (see CSP)
	g = g || Function("return this")() || (1,eval)("this");
} catch(e) {
	// This works if the window reference is available
	if(typeof window === "object")
		g = window;
}

// g can still be undefined, but nothing to do about it...
// We return undefined, instead of nothing here, so it's
// easier to handle this case. if(!global) { ...}

module.exports = g;


/***/ }),

/***/ "EIYJ":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "EqjI":
/***/ (function(module, exports) {

module.exports = function (it) {
  return typeof it === 'object' ? it !== null : typeof it === 'function';
};


/***/ }),

/***/ "FeBl":
/***/ (function(module, exports) {

var core = module.exports = { version: '2.5.1' };
if (typeof __e == 'number') __e = core; // eslint-disable-line no-undef


/***/ }),

/***/ "FtD3":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var enhanceError = __webpack_require__("t8qj");

/**
 * Create an Error with the specified message, config, error code, request and response.
 *
 * @param {string} message The error message.
 * @param {Object} config The config.
 * @param {string} [code] The error code (for example, 'ECONNABORTED').
 * @param {Object} [request] The request.
 * @param {Object} [response] The response.
 * @returns {Error} The created error.
 */
module.exports = function createError(message, config, code, request, response) {
  var error = new Error(message);
  return enhanceError(error, config, code, request, response);
};


/***/ }),

/***/ "GHBc":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__("cGG2");

module.exports = (
  utils.isStandardBrowserEnv() ?

  // Standard browser envs have full support of the APIs needed to test
  // whether the request URL is of the same origin as current location.
  (function standardBrowserEnv() {
    var msie = /(msie|trident)/i.test(navigator.userAgent);
    var urlParsingNode = document.createElement('a');
    var originURL;

    /**
    * Parse a URL to discover it's components
    *
    * @param {String} url The URL to be parsed
    * @returns {Object}
    */
    function resolveURL(url) {
      var href = url;

      if (msie) {
        // IE needs attribute set twice to normalize properties
        urlParsingNode.setAttribute('href', href);
        href = urlParsingNode.href;
      }

      urlParsingNode.setAttribute('href', href);

      // urlParsingNode provides the UrlUtils interface - http://url.spec.whatwg.org/#urlutils
      return {
        href: urlParsingNode.href,
        protocol: urlParsingNode.protocol ? urlParsingNode.protocol.replace(/:$/, '') : '',
        host: urlParsingNode.host,
        search: urlParsingNode.search ? urlParsingNode.search.replace(/^\?/, '') : '',
        hash: urlParsingNode.hash ? urlParsingNode.hash.replace(/^#/, '') : '',
        hostname: urlParsingNode.hostname,
        port: urlParsingNode.port,
        pathname: (urlParsingNode.pathname.charAt(0) === '/') ?
                  urlParsingNode.pathname :
                  '/' + urlParsingNode.pathname
      };
    }

    originURL = resolveURL(window.location.href);

    /**
    * Determine if a URL shares the same origin as the current location
    *
    * @param {String} requestURL The URL to test
    * @returns {boolean} True if URL shares the same origin, otherwise false
    */
    return function isURLSameOrigin(requestURL) {
      var parsed = (utils.isString(requestURL)) ? resolveURL(requestURL) : requestURL;
      return (parsed.protocol === originURL.protocol &&
            parsed.host === originURL.host);
    };
  })() :

  // Non standard browser envs (web workers, react-native) lack needed support.
  (function nonStandardBrowserEnv() {
    return function isURLSameOrigin() {
      return true;
    };
  })()
);


/***/ }),

/***/ "HJES":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Ibhu":
/***/ (function(module, exports, __webpack_require__) {

var has = __webpack_require__("D2L2");
var toIObject = __webpack_require__("TcQ7");
var arrayIndexOf = __webpack_require__("vFc/")(false);
var IE_PROTO = __webpack_require__("ax3d")('IE_PROTO');

module.exports = function (object, names) {
  var O = toIObject(object);
  var i = 0;
  var result = [];
  var key;
  for (key in O) if (key != IE_PROTO) has(O, key) && result.push(key);
  // Don't enum bug & hidden keys
  while (names.length > i) if (has(O, key = names[i++])) {
    ~arrayIndexOf(result, key) || result.push(key);
  }
  return result;
};


/***/ }),

/***/ "JP+z":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function bind(fn, thisArg) {
  return function wrap() {
    var args = new Array(arguments.length);
    for (var i = 0; i < args.length; i++) {
      args[i] = arguments[i];
    }
    return fn.apply(thisArg, args);
  };
};


/***/ }),

/***/ "JxQx":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

__webpack_require__("YWdn");

var _utils = __webpack_require__("Nvt7");

var _utils2 = _interopRequireDefault(_utils);

var _eventBus = __webpack_require__("Us91");

var _eventBus2 = _interopRequireDefault(_eventBus);

var _extends = __webpack_require__("KkIu");

var _extends2 = _interopRequireDefault(_extends);

var _messageboxSms = __webpack_require__("phXb");

var _messageboxSms2 = _interopRequireDefault(_messageboxSms);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MessageBox = function MessageBox(html, options) {
  var defaults = {
    title: null,
    message: null,
    buttons: []
  };
  this.options = defaults;
  (0, _extends2.default)(this.options, options);
  this.unique = this.options.unique || _utils2.default.getUnique();
  this.html = html;
  this._init();
};
MessageBox.prototype = {
  _init: function _init() {
    var self = this;
    self.observer = _eventBus2.default.create(self.unique);
    self._appendBody(self.html);
    self._addEvent();
  },
  _createElement: function _createElement(html) {
    var div = document.createElement('div');
    div.innerHTML = html;
    return div;
  },
  _appendBody: function _appendBody(html) {
    var self = this;
    self.$el = self._createElement(html);
    document.body.appendChild(self.$el);
  },
  _addEvent: function _addEvent() {
    var self = this;
    var buttons = self.options.buttons;
    var $dom = null;
    for (var i = 0; i < buttons.length; i++) {
      $dom = self.$el.querySelector(buttons[i].el);
      if ($dom) {
        (function (index, _self) {
          $dom.addEventListener('click', function () {
            buttons[index].callback && buttons[index].callback.apply(_self, Array.prototype.slice.call(arguments));
            buttons[index].close && self.close();
          }, false);
        })(i, self);
      }
    }
    for (var item in self.options) {
      if (item.indexOf('on') === 0) {
        if (self.options[item] instanceof Function) {
          (function (item, _self) {
            _self.observer.on(item, function () {
              _self.options[item].apply(_self, Array.prototype.slice.call(arguments));
            });
          })(item, self);
        }
      }
    }
  },
  close: function close() {
    var self = this;
    document.body.removeChild(self.$el);
  }
};

MessageBox.SMS = function (options) {
  var defaults = {
    title: '短信验证码',
    placeholder: '请输入短信验证码',
    maxLength: 6,
    counter: 10,
    onSend: _utils2.default.noop,
    onInput: _utils2.default.noop,
    onCancel: _utils2.default.noop,
    onSubmit: _utils2.default.noop
  };
  var config = {};
  config = (0, _extends2.default)(defaults, options);
  config.buttons = [];
  config.buttons.push({
    el: '.js-btn-sms',
    callback: function callback() {
      this.observer.emit('onSend');
      startTimer(this.$el);
    }
  });
  config.buttons.push({
    el: '.js-btn-cancel',
    close: true,
    callback: function callback() {
      this.observer.emit('onCancel');
    }
  });
  config.buttons.push({
    el: '.js-btn-submit',
    callback: function callback() {
      this.observer.emit('onSubmit');
    }
  });
  var instance = new MessageBox(_messageboxSms2.default, config);
  var $input = instance.$el.querySelector('.bx-sms-input');
  instance.$el.querySelector('.bx-modal-title').innerText = config.title;
  $input.setAttribute('placeholder', config.placeholder);
  $input.setAttribute('maxlength', config.maxLength);
  instance.$el.querySelector('.bx-sms-count').innerText = config.counter;
  $input.addEventListener('input', function () {
    var value = instance.$el.querySelector('.bx-sms-input').value;
    instance.observer.emit('onInput', value);
    if (value === '') {
      _utils2.default.removeClass($input, 'bx-sms-input--error');
    }
  });
  instance.setWrong = function () {
    _utils2.default.addClass($input, 'bx-sms-input--error');
  };
  return instance;
};

var startTimer = function startTimer(el) {
  var $btnSMS = el.querySelector('.js-btn-sms');
  var $btnSMSDisable = el.querySelector('.bx-sms-btn--disable');
  var $smsCount = el.querySelector('.bx-sms-count');
  $btnSMS.style.display = 'none';
  $btnSMSDisable.style.display = 'block';
  var counter = $smsCount.innerText;
  var originalCounter = counter;
  counter = parseInt(counter);
  var timer = window.setInterval(function () {
    counter--;
    $smsCount.innerText = counter;
    if (counter === 0) {
      window.clearInterval(timer);
      timer = null;
      $smsCount.innerText = originalCounter;
      $btnSMS.innerText = '重新获取';
      $btnSMS.style.display = 'block';
      $btnSMSDisable.style.display = 'none';
    }
  }, 1000);
};

exports.default = MessageBox;
module.exports = exports['default'];

/***/ }),

/***/ "KCLY":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(process) {

var utils = __webpack_require__("cGG2");
var normalizeHeaderName = __webpack_require__("5VQ+");

var DEFAULT_CONTENT_TYPE = {
  'Content-Type': 'application/x-www-form-urlencoded'
};

function setContentTypeIfUnset(headers, value) {
  if (!utils.isUndefined(headers) && utils.isUndefined(headers['Content-Type'])) {
    headers['Content-Type'] = value;
  }
}

function getDefaultAdapter() {
  var adapter;
  if (typeof XMLHttpRequest !== 'undefined') {
    // For browsers use XHR adapter
    adapter = __webpack_require__("7GwW");
  } else if (typeof process !== 'undefined') {
    // For node use HTTP adapter
    adapter = __webpack_require__("7GwW");
  }
  return adapter;
}

var defaults = {
  adapter: getDefaultAdapter(),

  transformRequest: [function transformRequest(data, headers) {
    normalizeHeaderName(headers, 'Content-Type');
    if (utils.isFormData(data) ||
      utils.isArrayBuffer(data) ||
      utils.isBuffer(data) ||
      utils.isStream(data) ||
      utils.isFile(data) ||
      utils.isBlob(data)
    ) {
      return data;
    }
    if (utils.isArrayBufferView(data)) {
      return data.buffer;
    }
    if (utils.isURLSearchParams(data)) {
      setContentTypeIfUnset(headers, 'application/x-www-form-urlencoded;charset=utf-8');
      return data.toString();
    }
    if (utils.isObject(data)) {
      setContentTypeIfUnset(headers, 'application/json;charset=utf-8');
      return JSON.stringify(data);
    }
    return data;
  }],

  transformResponse: [function transformResponse(data) {
    /*eslint no-param-reassign:0*/
    if (typeof data === 'string') {
      try {
        data = JSON.parse(data);
      } catch (e) { /* Ignore */ }
    }
    return data;
  }],

  timeout: 0,

  xsrfCookieName: 'XSRF-TOKEN',
  xsrfHeaderName: 'X-XSRF-TOKEN',

  maxContentLength: -1,

  validateStatus: function validateStatus(status) {
    return status >= 200 && status < 300;
  }
};

defaults.headers = {
  common: {
    'Accept': 'application/json, text/plain, */*'
  }
};

utils.forEach(['delete', 'get', 'head'], function forEachMethodNoData(method) {
  defaults.headers[method] = {};
});

utils.forEach(['post', 'put', 'patch'], function forEachMethodWithData(method) {
  defaults.headers[method] = utils.merge(DEFAULT_CONTENT_TYPE);
});

module.exports = defaults;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("W2nU")))

/***/ }),

/***/ "Kh4W":
/***/ (function(module, exports, __webpack_require__) {

exports.f = __webpack_require__("dSzd");


/***/ }),

/***/ "KkIu":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// 来源 object-assign
// https://github.com/sindresorhus/object-assign/edit/master/index.js



Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getOwnPropertySymbols = __webpack_require__("8hRR");

var _getOwnPropertySymbols2 = _interopRequireDefault(_getOwnPropertySymbols);

exports.default = function (target, source) {
  var from;
  var to = toObject(target);
  var symbols;

  for (var s = 1; s < arguments.length; s++) {
    from = Object(arguments[s]);

    for (var key in from) {
      if (hasOwnProperty.call(from, key)) {
        to[key] = from[key];
      }
    }

    if (getOwnPropertySymbols) {
      symbols = getOwnPropertySymbols(from);
      for (var i = 0; i < symbols.length; i++) {
        if (propIsEnumerable.call(from, symbols[i])) {
          to[symbols[i]] = from[symbols[i]];
        }
      }
    }
  }

  return to;
};

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var getOwnPropertySymbols = _getOwnPropertySymbols2.default;
var hasOwnProperty = Object.prototype.hasOwnProperty;
var propIsEnumerable = Object.prototype.propertyIsEnumerable;

function toObject(val) {
  if (val === null || val === undefined) {
    throw new TypeError('Object.assign cannot be called with null or undefined');
  }
  return Object(val);
}

;
module.exports = exports['default'];

/***/ }),

/***/ "L4cK":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _utils = __webpack_require__("Nvt7");

var _utils2 = _interopRequireDefault(_utils);

var _eventBus = __webpack_require__("Us91");

var _eventBus2 = _interopRequireDefault(_eventBus);

var _extends = __webpack_require__("KkIu");

var _extends2 = _interopRequireDefault(_extends);

var _requestAnimationFrame = __webpack_require__("YBGw");

var _requestAnimationFrame2 = _interopRequireDefault(_requestAnimationFrame);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ACTIONS = {
  START: 'START',
  SPIN_ROTATE: 'SPIN_ROTATE',
  SPIN_ZOOMOUT: 'SPIN_ZOOMOUT',
  ARC_ZOOMIN: 'ARC_ZOOMIN',
  TICK_DRAW: 'TICK_DRAW',
  END: 'END'
};

var Point = function Point(x, y) {
  this.x = x;
  this.y = y;
};

var Loading = function Loading(el, options) {
  this.wrapper = typeof el === 'string' ? document.querySelector(el) : el;
  var defaults = {
    background: '#FFF',
    spin: {
      lines: 8,
      speed: 1000,
      zoomSpeed: 1500
    },
    arc: {
      zoomSpeed: 1000
    },
    tick: {
      AToB: 4,
      BToC: 8
    },
    onSuccess: _utils2.default.noop
  };
  this.options = defaults;
  (0, _extends2.default)(this.options, options);
  this.unique = this.options.unique || _utils2.default.getUnique();
  this.ACTIONS = ACTIONS;
  this.action = ACTIONS.START;
  this.requestId = null;
  this._init();
};

Loading.prototype = {
  _init: function _init() {
    var self = this;
    self._createCanvas();
    self.observer = _eventBus2.default.create(self.unique);
    self._addEvent();
  },
  _createCanvas: function _createCanvas() {
    var self = this;
    var _wrapper = self.wrapper;
    var _canvas = document.createElement('canvas');
    var _ctx = _canvas.getContext('2d');
    _wrapper.appendChild(_canvas);
    var _width = _wrapper.clientWidth;
    var _height = _wrapper.clientHeight;
    self._setCanvasWH(_canvas, _ctx, _width, _height);
    _ctx.fillStyle = self.options.background;
    _ctx.fillRect(0, 0, _canvas.width, _canvas.height);
    self._canvas = _canvas;
    self._ctx = _ctx;
    self.width = _width;
    self.height = _height;
    self._setConfig();
    self.path = self._createTickPath(self.radius);
  },
  // 设置canvas的宽高
  _setCanvasWH: function _setCanvasWH(canvas, ctx, width, height) {
    var self = this;
    var ratio = self._calculatePixelRatio(ctx);
    if (ratio !== 1) {
      canvas.width = width * ratio;
      canvas.height = height * ratio;
      canvas.style.width = width + 'px';
      canvas.style.height = height + 'px';
      ctx.scale(ratio, ratio);
    } else {
      canvas.width = width;
      canvas.height = height;
    }
  },
  _setConfig: function _setConfig() {
    var self = this;
    self.action = ACTIONS.START;
    self.currentSpin = 0;
    self.currentSpinZoom = 1;
    self.currentArcZoom = 0;
    self.currentPath = 1;
    self.currentTickPoint = 10;
    self.options.spin.width || (self.options.spin.width = self.width / 15);
    self.options.tick.width || (self.options.tick.width = self.width / 15);
    var radius = self.width / 2.5;
    self.radius = radius;
    // 打钩的三个关键点
    self.A = new Point(-1 * radius / 2, radius / 20);
    self.B = new Point(-1 * radius / 20, radius / 2);
    self.C = new Point(radius / 2, -1 * radius / 3);
  },
  // 解决retina屏下绘制图像模糊
  _calculatePixelRatio: function _calculatePixelRatio(ctx) {
    var devicePixelRatio = window.devicePixelRatio || 1;
    var backingStoreRatio = ctx.webkitBackingStorePixelRatio || ctx.mozBackingStorePixelRatio || ctx.msBackingStorePixelRatio || ctx.oBackingStorePixelRatio || ctx.backingStorePixelRatio || 1;
    return devicePixelRatio / backingStoreRatio;
  },
  _addEvent: function _addEvent() {
    var self = this;
    window['addEventListener']('resize', this, false);
    for (var item in self.options) {
      if (item.indexOf('on') === 0) {
        if (self.options[item] instanceof Function) {
          (function (item, _self) {
            _self.observer.on(item, function () {
              _self.options[item].apply(_self, Array.prototype.slice.call(arguments));
            });
          })(item, self);
        }
      }
    }
  },
  _onResize: function _onResize(e) {
    console.log('resize');
  },
  _createTickPath: function _createTickPath(radius) {
    var self = this;
    var path = [];
    var A = self.A;
    var B = self.B;
    var C = self.C;
    var AToB = self.options.tick.AToB;
    var ABK = (B.y - A.y) / (B.x - A.x);
    var ABXLength = Math.abs(B.x - A.x);
    var BToC = self.options.tick.BToC;
    var BCK = (C.y - B.y) / (C.x - B.x);
    var BCXLength = Math.abs(C.x - B.x);
    path.push(A);
    var i = 0;
    var x = 0;
    var y = 0;
    for (i = 0; i < AToB; i++) {
      x = A.x + (i + 1) * ABXLength / (AToB + 1);
      y = A.y + ABK * (i + 1) * ABXLength / (AToB + 1);
      path.push(new Point(x, y));
    }
    path.push(B);
    for (i = 0; i < BToC; i++) {
      x = B.x + (i + 1) * BCXLength / (BToC + 1);
      y = B.y + BCK * (i + 1) * BCXLength / (BToC + 1);
      path.push(new Point(x, y));
    }
    path.push(C);
    return path;
  },
  _drawLine: function _drawLine(start, end) {
    var self = this;
    var _ctx = self._ctx;
    _ctx.beginPath();
    _ctx.moveTo(start.x, start.y);
    _ctx.lineTo(end.x, end.y);
    _ctx.lineCap = 'round';
    _ctx.lineJoin = 'round';
    _ctx.lineWidth = self.options.tick.width;
    _ctx.strokeStyle = '#FFF';
    _ctx.closePath();
    _ctx.stroke();
  },
  _drawSpin: function _drawSpin() {
    var self = this;
    var _ctx = self._ctx;
    var width = self.width;
    var height = self.height;
    var rotation = 360 / self.options.spin.lines;
    _ctx.save();
    _ctx.clearRect(0, 0, width, height);
    _ctx.translate(width / 2, height / 2);
    var opacity = 1;
    var i = 0;
    for (i = 0; i < self.currentSpin; i++) {
      _ctx.beginPath();
      _ctx.rotate(-1 * rotation * Math.PI / 180);
      _ctx.moveTo(0, -1 * width / 6);
      _ctx.lineTo(0, -1 * width / 3);
      _ctx.lineCap = 'round';
      _ctx.lineWidth = self.options.spin.width;
      if (self.currentSpin - i < 1) {
        opacity = self.currentSpin - i;
      }
      _ctx.strokeStyle = 'rgba(80, 140, 238,' + opacity + ')';
      _ctx.stroke();
    }
    _ctx.restore();
    if (self.currentSpin < self.options.spin.lines) {
      self.currentSpin = parseFloat(self.currentSpin) + 100 / self.options.spin.speed;
    } else {
      self.currentSpin = 0;
    }
    // 防止小数精度问题产生的bug
    self.currentSpin = self.currentSpin.toFixed(3);
  },
  _drawSpinZoom: function _drawSpinZoom(callback) {
    var self = this;
    var _ctx = self._ctx;
    var width = self.width;
    var height = self.height;
    _ctx.save();
    _ctx.clearRect(0, 0, width, height);
    _ctx.translate(width / 2, height / 2);
    _ctx.scale(self.currentSpinZoom, self.currentSpinZoom);
    if (self.currentSpinZoom > 0) {
      self.currentSpinZoom -= 100 / self.options.spin.zoomSpeed;
    } else {
      self.currentSpinZoom = 0;
      callback && callback();
    }
    for (var i = 0; i < self.options.spin.lines; i++) {
      _ctx.beginPath();
      _ctx.rotate(Math.PI * 2 / self.options.spin.lines);
      _ctx.moveTo(width / 6, 0);
      _ctx.lineTo(width / 3, 0);
      _ctx.lineCap = 'round';
      _ctx.lineWidth = self.options.spin.width;
      _ctx.strokeStyle = 'rgba(80, 140, 238, 1)';
      _ctx.stroke();
    }
    _ctx.restore();
  },
  _drawArc: function _drawArc(callback) {
    var self = this;
    var _ctx = self._ctx;
    var width = self.width;
    var height = self.height;
    _ctx.save();
    _ctx.clearRect(0, 0, width, height);
    _ctx.translate(width / 2, height / 2);
    _ctx.scale(self.currentArcZoom, self.currentArcZoom);
    if (self.currentArcZoom < 1) {
      self.currentArcZoom += 100 / self.options.arc.zoomSpeed;
    } else {
      self.currentArcZoom = 1;
    }
    _ctx.arc(0, 0, width / 2.5, 0, 2 * Math.PI, false);
    _ctx.fillStyle = '#508cee';
    _ctx.fill();
    _ctx.restore();
    callback && callback();
  },
  _drawPoint: function _drawPoint(callback) {
    var self = this;
    var _ctx = self._ctx;
    var width = self.width;
    var height = self.height;
    _ctx.save();
    _ctx.translate(width / 2, height / 2);
    var A = new Point(self.A.x, self.A.y - self.currentTickPoint);
    var B = new Point(A.x + 1, A.y + 1);
    self._drawLine(A, B);
    _ctx.restore();
    if (self.currentTickPoint > 0) {
      self.currentTickPoint -= 1.5;
    } else {
      callback && callback();
    }
  },
  _drawTick: function _drawTick(callback) {
    var self = this;
    var _ctx = self._ctx;
    var width = self.width;
    var height = self.height;
    _ctx.save();
    _ctx.translate(width / 2, height / 2);
    var path = self.path;
    if (self.currentPath < path.length) {
      for (var i = 0; i < self.currentPath; i++) {
        self._drawLine(path[i], path[i + 1]);
      }
      self.currentPath++;
    }
    _ctx.restore();
    if (self.currentPath >= path.length) {
      callback && callback();
    }
  },
  _starAnimation: function _starAnimation() {
    var self = this;
    switch (self.action) {
      case ACTIONS.START:
        self.setAction(ACTIONS.SPIN_ROTATE);
        break;
      case ACTIONS.SPIN_ROTATE:
        self._drawSpin();
        break;
      case ACTIONS.SPIN_ZOOMOUT:
        self._drawSpinZoom(function () {
          self.setAction(ACTIONS.ARC_ZOOMIN);
        });
        break;
      case ACTIONS.ARC_ZOOMIN:
        self._drawArc(function () {
          if (self.currentArcZoom > 0.5) {
            self._drawPoint(function () {
              self.setAction(ACTIONS.TICK_DRAW);
            });
          }
        });
        break;
      case ACTIONS.TICK_DRAW:
        self._drawTick(function () {
          self.setAction(ACTIONS.END);
        });
        break;
      case ACTIONS.END:
        self.observer.emit('onSuccess');
        self._stopAnimation();
        break;
    }
    self.requestId && _requestAnimationFrame2.default.requestAnimationFrame(function () {
      self._starAnimation();
    });
  },
  _stopAnimation: function _stopAnimation() {
    var self = this;
    _requestAnimationFrame2.default.cancelAnimationFrame(self.requestId);
    self.requestId = null;
  },
  handleEvent: function handleEvent(e) {
    switch (e.type) {
      case 'resize':
        this._onResize(e);
        break;
    }
  },
  setAction: function setAction(actName) {
    var self = this;
    self.action = actName;
  },
  clear: function clear() {
    var self = this;
    var _canvas = self._canvas;
    var _ctx = self._ctx;
    _ctx.fillStyle = self.options.backgroundColor;
    _ctx.clearRect(0, 0, _canvas.width, _canvas.height);
    _ctx.fillRect(0, 0, _canvas.width, _canvas.height);
  },
  start: function start() {
    var self = this;
    self._setConfig();
    self.requestId = _requestAnimationFrame2.default.requestAnimationFrame(function () {
      self._starAnimation();
    });
  },
  stop: function stop() {
    var self = this;
    self._stopAnimation();
  },
  success: function success() {
    var self = this;
    self.setAction(ACTIONS.SPIN_ZOOMOUT);
  }
};

exports.default = Loading;
module.exports = exports['default'];

/***/ }),

/***/ "LKZe":
/***/ (function(module, exports, __webpack_require__) {

var pIE = __webpack_require__("NpIQ");
var createDesc = __webpack_require__("X8DO");
var toIObject = __webpack_require__("TcQ7");
var toPrimitive = __webpack_require__("MmMw");
var has = __webpack_require__("D2L2");
var IE8_DOM_DEFINE = __webpack_require__("SfB7");
var gOPD = Object.getOwnPropertyDescriptor;

exports.f = __webpack_require__("+E39") ? gOPD : function getOwnPropertyDescriptor(O, P) {
  O = toIObject(O);
  P = toPrimitive(P, true);
  if (IE8_DOM_DEFINE) try {
    return gOPD(O, P);
  } catch (e) { /* empty */ }
  if (has(O, P)) return createDesc(!pIE.f.call(O, P), O[P]);
};


/***/ }),

/***/ "LVVn":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/views/ui/Home.vue
var Home = __webpack_require__("tcli");
var Home_default = /*#__PURE__*/__webpack_require__.n(Home);

// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1f622d53","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/ui/Home.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('router-view')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var ui_Home = (esExports);
// CONCATENATED MODULE: ./src/views/ui/Home.vue
function injectStyle (ssrContext) {
  __webpack_require__("ZC1W")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  Home_default.a,
  ui_Home,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var views_ui_Home = __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "M93x":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/App.vue
var App = __webpack_require__("xJD8");
var App_default = /*#__PURE__*/__webpack_require__.n(App);

// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5a5e8d54","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('router-view')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var selectortype_template_index_0_src_App = (esExports);
// CONCATENATED MODULE: ./src/App.vue
function injectStyle (ssrContext) {
  __webpack_require__("BqSl")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  App_default.a,
  selectortype_template_index_0_src_App,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var src_App = __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "MPII":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/views/ui/Search.vue
var Search = __webpack_require__("g2Sx");
var Search_default = /*#__PURE__*/__webpack_require__.n(Search);

// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-40d2bf80","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/ui/Search.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"demo-search"},[_c('div',{staticClass:"demo-panel-title"},[_vm._v("标准内容")]),_vm._v(" "),_c('div',{staticClass:"demo-search-group"},[_c('h3',{staticClass:"demo-title"},[_vm._v("搜索栏")]),_vm._v(" "),_c('div',{staticClass:"bx-search"},[_c('div',{staticClass:"bx-search-form"},[_c('i',{staticClass:"bx-search-icon bx-icon bx-icon-search"}),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.key),expression:"key"}],staticClass:"bx-search-input",attrs:{"type":"text","placeholder":"搜索提示语"},domProps:{"value":(_vm.key)},on:{"focus":_vm.focus,"input":[function($event){if($event.target.composing){ return; }_vm.key=$event.target.value},_vm.input]}}),_vm._v(" "),(_vm.showDelete)?_c('a',{staticClass:"bx-search-clear bx-icon bx-icon-close-circle-surface",on:{"click":_vm.clear}}):_vm._e()]),_vm._v(" "),(_vm.showCancel)?_c('div',{staticClass:"bx-search-btn",on:{"click":_vm.cancel}},[_vm._v("取消")]):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"demo-panel-title"},[_vm._v("效果调试")]),_vm._v(" "),_vm._m(0,false,false),_vm._v(" "),_vm._m(1,false,false),_vm._v(" "),_vm._m(2,false,false),_vm._v(" "),_vm._m(3,false,false),_vm._v(" "),_vm._m(4,false,false)])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"demo-search-group"},[_c('h3',{staticClass:"demo-title"},[_vm._v("搜索栏12px-16px")]),_vm._v(" "),_c('div',{staticClass:"bx-search"},[_c('input',{staticClass:"bx-input-test",attrs:{"type":"text","placeholder":"搜索提示语"}})])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"demo-search-group"},[_c('h3',{staticClass:"demo-title"},[_vm._v("搜索栏13px-17px")]),_vm._v(" "),_c('div',{staticClass:"bx-search"},[_c('input',{staticClass:"bx-input-test-13",attrs:{"type":"text","placeholder":"搜索提示语"}})])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"demo-search-group"},[_c('h3',{staticClass:"demo-title"},[_vm._v("搜索栏14px-20px")]),_vm._v(" "),_c('div',{staticClass:"bx-search"},[_c('input',{staticClass:"bx-input-test-14",attrs:{"type":"text","placeholder":"搜索提示语"}})])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"demo-search-group"},[_c('h3',{staticClass:"demo-title"},[_vm._v("搜索栏15px-21px")]),_vm._v(" "),_c('div',{staticClass:"bx-search"},[_c('input',{staticClass:"bx-input-test-15",attrs:{"type":"text","placeholder":"搜索提示语"}})])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"demo-search-group"},[_c('h3',{staticClass:"demo-title"},[_vm._v("搜索栏16px-22px")]),_vm._v(" "),_c('div',{staticClass:"bx-search"},[_c('input',{staticClass:"bx-input-test-16",attrs:{"type":"text","placeholder":"搜索提示语"}})])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var ui_Search = (esExports);
// CONCATENATED MODULE: ./src/views/ui/Search.vue
function injectStyle (ssrContext) {
  __webpack_require__("Ww8N")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  Search_default.a,
  ui_Search,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var views_ui_Search = __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "MQ77":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

exports.default = {};
module.exports = exports["default"];

/***/ }),

/***/ "MU5D":
/***/ (function(module, exports, __webpack_require__) {

// fallback for non-array-like ES3 and non-enumerable old V8 strings
var cof = __webpack_require__("R9M2");
// eslint-disable-next-line no-prototype-builtins
module.exports = Object('z').propertyIsEnumerable(0) ? Object : function (it) {
  return cof(it) == 'String' ? it.split('') : Object(it);
};


/***/ }),

/***/ "MmMw":
/***/ (function(module, exports, __webpack_require__) {

// 7.1.1 ToPrimitive(input [, PreferredType])
var isObject = __webpack_require__("EqjI");
// instead of the ES6 spec version, we didn't implement @@toPrimitive case
// and the second argument - flag - preferred type is a string
module.exports = function (it, S) {
  if (!isObject(it)) return it;
  var fn, val;
  if (S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
  if (typeof (fn = it.valueOf) == 'function' && !isObject(val = fn.call(it))) return val;
  if (!S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
  throw TypeError("Can't convert object to primitive value");
};


/***/ }),

/***/ "NHnr":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _vue = __webpack_require__("7+uW");

var _vue2 = _interopRequireDefault(_vue);

var _App = __webpack_require__("M93x");

var _App2 = _interopRequireDefault(_App);

var _router = __webpack_require__("YaEn");

var _router2 = _interopRequireDefault(_router);

__webpack_require__("zqqR");

__webpack_require__("zGTM");

var _qrcode = __webpack_require__("Y36A");

var _qrcode2 = _interopRequireDefault(_qrcode);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_vue2.default.config.productionTip = false;

/* eslint-disable no-new */
new _vue2.default({
  el: '#app',
  router: _router2.default,
  template: '<App/>',
  created: function created() {
    // eslint-disable-next-line
    if (false) {
      _qrcode2.default.log(window.location.href);
    }
  },
  components: { App: _App2.default }
});

/***/ }),

/***/ "Nlks":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/views/Tab.vue
var Tab = __webpack_require__("YGIn");
var Tab_default = /*#__PURE__*/__webpack_require__.n(Tab);

// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4b5eab6c","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/Tab.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_vm._m(0,false,false),_vm._v(" "),_vm._m(1,false,false),_vm._v(" "),_vm._m(2,false,false),_vm._v(" "),_vm._m(3,false,false),_vm._v(" "),_c('div',{staticClass:"demo-tab-panel"},[_c('div',{staticClass:"demo-title"},[_vm._v("异步获取数据")]),_vm._v(" "),_c('div',{staticClass:"bx-tab-container bx-tab-six"},[_vm._m(4,false,false),_vm._v(" "),_c('div',{staticClass:"bx-tab-contents"},[_c('div',{staticClass:"bx-tab-scroller"},[_vm._m(5,false,false),_vm._v(" "),_c('div',{staticClass:"bx-tab-content"},[_c('p',[_vm._v(_vm._s(_vm.product.name))]),_vm._v(" "),_c('p',[_vm._v(_vm._s(_vm.product.name))]),_vm._v(" "),_c('p',[_vm._v(_vm._s(_vm.product.name))]),_vm._v(" "),_c('p',[_vm._v(_vm._s(_vm.product.name))]),_vm._v(" "),_c('p',[_vm._v(_vm._s(_vm.product.name))]),_vm._v(" "),_c('p',[_vm._v(_vm._s(_vm.product.name))])]),_vm._v(" "),_c('div',{staticClass:"bx-tab-content"},[_c('p',[_vm._v(_vm._s(_vm.desc.name))]),_vm._v(" "),_c('p',[_vm._v(_vm._s(_vm.desc.name))]),_vm._v(" "),_c('p',[_vm._v(_vm._s(_vm.desc.name))]),_vm._v(" "),_c('p',[_vm._v(_vm._s(_vm.desc.name))]),_vm._v(" "),_c('p',[_vm._v(_vm._s(_vm.desc.name))]),_vm._v(" "),_c('p',[_vm._v(_vm._s(_vm.desc.name))]),_vm._v(" "),_c('p',[_vm._v(_vm._s(_vm.desc.name))])]),_vm._v(" "),_c('div',{staticClass:"bx-tab-content"},[_c('p',[_vm._v(_vm._s(_vm.person.name))]),_vm._v(" "),_c('p',[_vm._v(_vm._s(_vm.person.name))]),_vm._v(" "),_c('p',[_vm._v(_vm._s(_vm.person.name))]),_vm._v(" "),_c('p',[_vm._v(_vm._s(_vm.person.name))]),_vm._v(" "),_c('p',[_vm._v(_vm._s(_vm.person.name))]),_vm._v(" "),_c('p',[_vm._v(_vm._s(_vm.person.age))]),_vm._v(" "),_c('p',[_vm._v(_vm._s(_vm.person.age))]),_vm._v(" "),_c('p',[_vm._v(_vm._s(_vm.person.age))]),_vm._v(" "),_c('p',[_vm._v(_vm._s(_vm.person.age))]),_vm._v(" "),_c('p',[_vm._v(_vm._s(_vm.person.age))]),_vm._v(" "),_c('p',[_vm._v(_vm._s(_vm.person.age))])])])])])]),_vm._v(" "),_c('div',{staticClass:"demo-tab-panel"},[_c('div',{staticClass:"demo-title"},[_vm._v("单个内容,异步获取数据变更内容")]),_vm._v(" "),_c('div',{staticClass:"bx-tab-container bx-tab-single"},[_vm._m(6,false,false),_vm._v(" "),_c('div',{staticClass:"bx-tab-contents"},[_c('div',{staticClass:"bx-tab-scroller"},[_c('div',{staticClass:"bx-tab-content"},_vm._l((_vm.list),function(item){return _c('div',[_vm._v(_vm._s(item.name))])}))])])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"demo-tab-panel"},[_c('div',{staticClass:"demo-title"},[_vm._v("两项")]),_vm._v(" "),_c('div',{staticClass:"bx-tab-container bx-tab-two"},[_c('div',{staticClass:"bx-tab"},[_c('div',{staticClass:"bx-tab-wrap"},[_c('div',{staticClass:"bx-tab-item"},[_c('div',{staticClass:"bx-tab-text"},[_vm._v("分类一")])]),_vm._v(" "),_c('div',{staticClass:"bx-tab-item"},[_c('div',{staticClass:"bx-tab-text"},[_vm._v("分类二")])])]),_vm._v(" "),_c('div',{staticClass:"bx-tab-line"})]),_vm._v(" "),_c('div',{staticClass:"bx-tab-contents"},[_c('div',{staticClass:"bx-tab-scroller"},[_c('div',{staticClass:"bx-tab-content"},[_c('p',[_vm._v("分类一内容")]),_vm._v(" "),_c('p',[_vm._v("分类一内容")]),_vm._v(" "),_c('p',[_vm._v("分类一内容")])]),_vm._v(" "),_c('div',{staticClass:"bx-tab-content"},[_c('p',[_vm._v("分类二内容")]),_vm._v(" "),_c('p',[_vm._v("分类二内容")]),_vm._v(" "),_c('p',[_vm._v("分类二内容")])])])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"demo-tab-panel"},[_c('div',{staticClass:"demo-title"},[_vm._v("三项(内容高度不一致)")]),_vm._v(" "),_c('div',{staticClass:"bx-tab-container bx-tab-three"},[_c('div',{staticClass:"bx-tab"},[_c('div',{staticClass:"bx-tab-wrap"},[_c('div',{staticClass:"bx-tab-item"},[_c('div',{staticClass:"bx-tab-text"},[_vm._v("分类一")])]),_vm._v(" "),_c('div',{staticClass:"bx-tab-item"},[_c('div',{staticClass:"bx-tab-text"},[_vm._v("分类二")])]),_vm._v(" "),_c('div',{staticClass:"bx-tab-item"},[_c('div',{staticClass:"bx-tab-text"},[_vm._v("分类三")])])]),_vm._v(" "),_c('div',{staticClass:"bx-tab-line"})]),_vm._v(" "),_c('div',{staticClass:"bx-tab-contents"},[_c('div',{staticClass:"bx-tab-scroller"},[_c('div',{staticClass:"bx-tab-content"},[_c('p',[_vm._v("分类一内容")]),_vm._v(" "),_c('p',[_vm._v("分类一内容")]),_vm._v(" "),_c('p',[_vm._v("分类一内容")])]),_vm._v(" "),_c('div',{staticClass:"bx-tab-content"},[_c('p',[_vm._v("分类二内容")]),_vm._v(" "),_c('p',[_vm._v("分类二内容")]),_vm._v(" "),_c('p',[_vm._v("分类二内容")])]),_vm._v(" "),_c('div',{staticClass:"bx-tab-content"},[_c('p',[_vm._v("分类三内容")]),_vm._v(" "),_c('p',[_vm._v("分类三内容")]),_vm._v(" "),_c('p',[_vm._v("分类三内容")]),_vm._v(" "),_c('p',[_vm._v("分类三内容")]),_vm._v(" "),_c('p',[_vm._v("分类三内容")]),_vm._v(" "),_c('p',[_vm._v("分类三内容")]),_vm._v(" "),_c('p',[_vm._v("分类三内容")]),_vm._v(" "),_c('p',[_vm._v("分类三内容")]),_vm._v(" "),_c('p',[_vm._v("分类三内容")]),_vm._v(" "),_c('p',[_vm._v("分类三内容")])])])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"demo-tab-panel"},[_c('div',{staticClass:"demo-title"},[_vm._v("四项")]),_vm._v(" "),_c('div',{staticClass:"bx-tab-container bx-tab-four"},[_c('div',{staticClass:"bx-tab"},[_c('div',{staticClass:"bx-tab-wrap"},[_c('div',{staticClass:"bx-tab-item"},[_c('div',{staticClass:"bx-tab-text"},[_vm._v("分类一")])]),_vm._v(" "),_c('div',{staticClass:"bx-tab-item"},[_c('div',{staticClass:"bx-tab-text"},[_vm._v("分类二")])]),_vm._v(" "),_c('div',{staticClass:"bx-tab-item"},[_c('div',{staticClass:"bx-tab-text"},[_vm._v("分类三")])]),_vm._v(" "),_c('div',{staticClass:"bx-tab-item"},[_c('div',{staticClass:"bx-tab-text"},[_vm._v("分类四")])])]),_vm._v(" "),_c('div',{staticClass:"bx-tab-line"})]),_vm._v(" "),_c('div',{staticClass:"bx-tab-contents"},[_c('div',{staticClass:"bx-tab-scroller"},[_c('div',{staticClass:"bx-tab-content"},[_c('p',[_vm._v("分类一内容")]),_vm._v(" "),_c('p',[_vm._v("分类一内容")]),_vm._v(" "),_c('p',[_vm._v("分类一内容")]),_vm._v(" "),_c('p',[_vm._v("分类一内容")]),_vm._v(" "),_c('p',[_vm._v("分类一内容")]),_vm._v(" "),_c('p',[_vm._v("分类一内容")]),_vm._v(" "),_c('p',[_vm._v("分类一内容")]),_vm._v(" "),_c('p',[_vm._v("分类一内容")]),_vm._v(" "),_c('p',[_vm._v("分类一内容")])]),_vm._v(" "),_c('div',{staticClass:"bx-tab-content"},[_c('p',[_vm._v("分类二内容")]),_vm._v(" "),_c('p',[_vm._v("分类二内容")]),_vm._v(" "),_c('p',[_vm._v("分类二内容")]),_vm._v(" "),_c('p',[_vm._v("分类二内容")]),_vm._v(" "),_c('p',[_vm._v("分类二内容")]),_vm._v(" "),_c('p',[_vm._v("分类二内容")]),_vm._v(" "),_c('p',[_vm._v("分类二内容")]),_vm._v(" "),_c('p',[_vm._v("分类二内容")]),_vm._v(" "),_c('p',[_vm._v("分类二内容")]),_vm._v(" "),_c('p',[_vm._v("分类二内容")])]),_vm._v(" "),_c('div',{staticClass:"bx-tab-content"},[_c('p',[_vm._v("分类三内容")]),_vm._v(" "),_c('p',[_vm._v("分类三内容")]),_vm._v(" "),_c('p',[_vm._v("分类三内容")]),_vm._v(" "),_c('p',[_vm._v("分类三内容")]),_vm._v(" "),_c('p',[_vm._v("分类三内容")]),_vm._v(" "),_c('p',[_vm._v("分类三内容")]),_vm._v(" "),_c('p',[_vm._v("分类三内容")]),_vm._v(" "),_c('p',[_vm._v("分类三内容")]),_vm._v(" "),_c('p',[_vm._v("分类三内容")]),_vm._v(" "),_c('p',[_vm._v("分类三内容")]),_vm._v(" "),_c('p',[_vm._v("分类三内容")]),_vm._v(" "),_c('p',[_vm._v("分类三内容")]),_vm._v(" "),_c('p',[_vm._v("分类三内容")]),_vm._v(" "),_c('p',[_vm._v("分类三内容")]),_vm._v(" "),_c('p',[_vm._v("分类三内容")]),_vm._v(" "),_c('p',[_vm._v("分类三内容")]),_vm._v(" "),_c('p',[_vm._v("分类三内容")]),_vm._v(" "),_c('p',[_vm._v("分类三内容")]),_vm._v(" "),_c('p',[_vm._v("分类三内容")]),_vm._v(" "),_c('p',[_vm._v("分类三内容")]),_vm._v(" "),_c('p',[_vm._v("分类三内容")]),_vm._v(" "),_c('p',[_vm._v("分类三内容")]),_vm._v(" "),_c('p',[_vm._v("分类三内容")]),_vm._v(" "),_c('p',[_vm._v("分类三内容")]),_vm._v(" "),_c('p',[_vm._v("分类三内容")]),_vm._v(" "),_c('p',[_vm._v("分类三内容")]),_vm._v(" "),_c('p',[_vm._v("分类三内容")]),_vm._v(" "),_c('p',[_vm._v("分类三内容")]),_vm._v(" "),_c('p',[_vm._v("分类三内容")]),_vm._v(" "),_c('p',[_vm._v("分类三内容")]),_vm._v(" "),_c('p',[_vm._v("分类三内容")]),_vm._v(" "),_c('p',[_vm._v("分类三内容")]),_vm._v(" "),_c('p',[_vm._v("分类三内容")]),_vm._v(" "),_c('p',[_vm._v("分类三内容")]),_vm._v(" "),_c('p',[_vm._v("分类三内容")]),_vm._v(" "),_c('p',[_vm._v("分类三内容")])]),_vm._v(" "),_c('div',{staticClass:"bx-tab-content"},[_c('p',[_vm._v("分类四内容")]),_vm._v(" "),_c('p',[_vm._v("分类四内容")]),_vm._v(" "),_c('p',[_vm._v("分类四内容")])])])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"demo-tab-panel"},[_c('div',{staticClass:"demo-title"},[_vm._v("五项(禁止滑动,取消页面滑动切换)")]),_vm._v(" "),_c('div',{staticClass:"bx-tab-container bx-tab-five"},[_c('div',{staticClass:"bx-tab"},[_c('div',{staticClass:"bx-tab-wrap"},[_c('div',{staticClass:"bx-tab-item"},[_c('div',{staticClass:"bx-tab-text"},[_vm._v("降级处理")])]),_vm._v(" "),_c('div',{staticClass:"bx-tab-item"},[_c('div',{staticClass:"bx-tab-text"},[_vm._v("关闭滑动")])]),_vm._v(" "),_c('div',{staticClass:"bx-tab-item"},[_c('div',{staticClass:"bx-tab-text"},[_vm._v("防止低端")])]),_vm._v(" "),_c('div',{staticClass:"bx-tab-item"},[_c('div',{staticClass:"bx-tab-text"},[_vm._v("手机切换")])]),_vm._v(" "),_c('div',{staticClass:"bx-tab-item"},[_c('div',{staticClass:"bx-tab-text"},[_vm._v("延迟卡顿")])])]),_vm._v(" "),_c('div',{staticClass:"bx-tab-line"})]),_vm._v(" "),_c('div',{staticClass:"bx-tab-contents"},[_c('div',{staticClass:"bx-tab-scroller",staticStyle:{"padding":"15px 15px"}},[_c('div',{staticClass:"bx-tab-content"},[_c('p',[_vm._v("分类一内容")]),_vm._v(" "),_c('p',[_vm._v("分类一内容")]),_vm._v(" "),_c('p',[_vm._v("分类一内容")])]),_vm._v(" "),_c('div',{staticClass:"bx-tab-content"},[_c('p',[_vm._v("分类二内容")]),_vm._v(" "),_c('p',[_vm._v("分类二内容")]),_vm._v(" "),_c('p',[_vm._v("分类二内容")])]),_vm._v(" "),_c('div',{staticClass:"bx-tab-content"},[_c('p',[_vm._v("分类三内容")]),_vm._v(" "),_c('p',[_vm._v("分类三内容")]),_vm._v(" "),_c('p',[_vm._v("分类三内容")])]),_vm._v(" "),_c('div',{staticClass:"bx-tab-content"},[_c('p',[_vm._v("分类四内容")]),_vm._v(" "),_c('p',[_vm._v("分类四内容")]),_vm._v(" "),_c('p',[_vm._v("分类四内容")])]),_vm._v(" "),_c('div',{staticClass:"bx-tab-content"},[_c('p',[_vm._v("分类五内容")]),_vm._v(" "),_c('p',[_vm._v("分类五内容")]),_vm._v(" "),_c('p',[_vm._v("分类五内容")])])])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"bx-tab"},[_c('div',{staticClass:"bx-tab-wrap"},[_c('div',{staticClass:"bx-tab-item"},[_c('div',{staticClass:"bx-tab-text"},[_vm._v("固定内容")])]),_vm._v(" "),_c('div',{staticClass:"bx-tab-item"},[_c('div',{staticClass:"bx-tab-text"},[_vm._v("异步获取")])]),_vm._v(" "),_c('div',{staticClass:"bx-tab-item"},[_c('div',{staticClass:"bx-tab-text"},[_vm._v("异步获取")])]),_vm._v(" "),_c('div',{staticClass:"bx-tab-item"},[_c('div',{staticClass:"bx-tab-text"},[_vm._v("异步获取")])])]),_vm._v(" "),_c('div',{staticClass:"bx-tab-line"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"bx-tab-content"},[_c('p',[_vm._v("固定内容")]),_vm._v(" "),_c('p',[_vm._v("固定内容")]),_vm._v(" "),_c('p',[_vm._v("固定内容")]),_vm._v(" "),_c('p',[_vm._v("固定内容")]),_vm._v(" "),_c('p',[_vm._v("固定内容")]),_vm._v(" "),_c('p',[_vm._v("固定内容")]),_vm._v(" "),_c('p',[_vm._v("固定内容")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"bx-tab"},[_c('div',{staticClass:"bx-tab-wrap"},[_c('div',{staticClass:"bx-tab-item"},[_c('div',{staticClass:"bx-tab-text"},[_vm._v("异步获取")])]),_vm._v(" "),_c('div',{staticClass:"bx-tab-item"},[_c('div',{staticClass:"bx-tab-text"},[_vm._v("异步获取")])]),_vm._v(" "),_c('div',{staticClass:"bx-tab-item"},[_c('div',{staticClass:"bx-tab-text"},[_vm._v("异步获取")])])]),_vm._v(" "),_c('div',{staticClass:"bx-tab-line"})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var views_Tab = (esExports);
// CONCATENATED MODULE: ./src/views/Tab.vue
function injectStyle (ssrContext) {
  __webpack_require__("iTU9")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-4b5eab6c"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  Tab_default.a,
  views_Tab,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var src_views_Tab = __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "NpIQ":
/***/ (function(module, exports) {

exports.f = {}.propertyIsEnumerable;


/***/ }),

/***/ "Nvt7":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var utils = {
  support: {
    touch: function () {
      // eslint-disable-next-line
      return !!('ontouchstart' in window || window.DocumentTouch && document instanceof DocumentTouch);
    }()
  },
  env: {
    isWechat: /MicroMessenger/i.test(navigator.userAgent),
    isWeiyi: /WeiYi/i.test(navigator.userAgent),
    isIos: /(iPhone|iPad|iPod)/.test(navigator.userAgent),
    isAndroid: /Android/.test(navigator.userAgent)
  },
  now: function now() {
    return new Date().getTime();
  },
  getRandom: function getRandom(min, max) {
    var range = max - min;
    var rand = Math.random();
    return min + Math.round(rand * range);
  },
  getUnique: function getUnique() {
    var unique = '';
    unique = this.now() + '_' + this.getRandom(0, 10000);
    return unique;
  },
  hasClass: function hasClass(obj, cls) {
    return obj.className.match(new RegExp(cls));
  },
  addClass: function addClass(obj, cls) {
    if (!this.hasClass(obj, cls)) obj.className += ' ' + cls;
  },
  removeClass: function removeClass(obj, cls) {
    if (this.hasClass(obj, cls)) {
      var reg = new RegExp('(\\s|^)' + cls);
      obj.className = obj.className.replace(reg, '');
    }
  },
  noop: function noop() {},
  // 创建debug DOM
  createDebug: function createDebug() {
    var div = document.createElement('div');
    div.id = 'debug';
    div.style.position = 'fixed';
    div.style.top = '0px';
    div.style.left = '0px';
    div.style.right = '0px';
    div.style.zIndex = '9999';
    div.style.backgroundColor = 'rgba(0,0,0,0.8)';
    div.style.color = '#FFF';
    div.style.wordBreak = 'break-all';
    div.style.wordWrap = 'break-word';
    div.style.overflowY = 'scroll';
    div.style.fontSize = '10px';
    document.body.appendChild(div);
  },
  // 向debug DOM添加元素
  appendDebug: function appendDebug(element, text, color) {
    var debug = document.getElementById('debug');
    var item = document.createElement(element);
    color = color || '#FFF';
    item.style.color = color;
    item.innerText = text;
    console.log(text);
    debug.appendChild(item);
  },
  // 是否是百分比数值
  isPercentage: function isPercentage(value) {
    value = value + '';
    if (value.indexOf('%') !== -1) {
      return true;
    }
    return false;
  },
  // 百分比转小数
  percentageToNumber: function percentageToNumber(value) {
    value = value + '';
    if (value.indexOf('%') !== -1) {
      value = parseFloat(value.replace('%', '')).toFixed(2);
      return (value / 100).toFixed(2);
    }
    return value;
  },
  // 获取viewport content中的参数
  getViewPortParam: function getViewPortParam(name) {
    var viewport = document.querySelector('meta[name=viewport]');
    if (!viewport) {
      return null;
    }
    var content = viewport.getAttribute('content');
    if (!content) {
      return null;
    }
    // eslint-disable-next-line
    name = name.replace(/[\[]/, '\\[').replace(/[\]]/, '\\]');
    var regex = new RegExp('(^|,)' + name + '=([^,]*)(,|$)', 'i');
    var results = regex.exec(content);
    return results === null ? null : decodeURIComponent(results[2].replace(/\+/g, ' '));
  },
  // 根据viewport设置放大倍数,默认为1
  getScale: function getScale() {
    var initialScale = this.getViewPortParam('initial-scale') || 0;
    var maximumScale = this.getViewPortParam('maximum-scale') || 0;
    var minimumScale = this.getViewPortParam('minimum-scale') || 0;
    var scale = initialScale;
    if (maximumScale !== 0 && maximumScale <= initialScale) {
      scale = maximumScale;
    }
    if (minimumScale !== 0 && minimumScale >= initialScale) {
      scale = minimumScale;
    }
    return scale === 0 ? 1 : 1.0 / scale;
  }
};
exports.default = utils;
module.exports = exports['default'];

/***/ }),

/***/ "O4g8":
/***/ (function(module, exports) {

module.exports = true;


/***/ }),

/***/ "ON07":
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__("EqjI");
var document = __webpack_require__("7KvD").document;
// typeof document.createElement is 'object' in old IE
var is = isObject(document) && isObject(document.createElement);
module.exports = function (it) {
  return is ? document.createElement(it) : {};
};


/***/ }),

/***/ "OWXg":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "PGcd":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/views/Loading.vue
var Loading = __webpack_require__("gepI");
var Loading_default = /*#__PURE__*/__webpack_require__.n(Loading);

// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-9eece072","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/Loading.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"demo-tab-panel"},[_c('div',{staticClass:"demo-title"},[_vm._v("Loading")]),_vm._v(" "),_c('div',{staticClass:"demo-content"},[_c('div',{staticClass:"bx-btn bx-btn--sm",on:{"click":function($event){_vm.showLoading()}}},[_vm._v("Loading Show")]),_vm._v(" "),_c('div',{staticClass:"bx-btn bx-btn--sm",on:{"click":function($event){_vm.hideLoading()}}},[_vm._v("Loading Hide")])])]),_vm._v(" "),_c('div',{staticClass:"demo-tab-panel"},[_c('div',{staticClass:"demo-title"},[_vm._v("Loading To Success By Canvas")]),_vm._v(" "),_c('div',{staticClass:"demo-content"},[_c('div',{staticClass:"loading-success",staticStyle:{"width":"100px","height":"100px","margin":"15px auto"}}),_vm._v(" "),_c('div',{staticClass:"bx-btn bx-btn--sm",on:{"click":function($event){_vm.loadingReset()}}},[_vm._v("Reset Loading")]),_vm._v(" "),_c('div',{staticClass:"bx-btn bx-btn--sm",on:{"click":function($event){_vm.loadingPause()}}},[_vm._v("Pause Loading")]),_vm._v(" "),_c('div',{staticClass:"bx-btn bx-btn--sm",on:{"click":function($event){_vm.loadingToSuccess()}}},[_vm._v("Loading To Success")])])]),_vm._v(" "),_c('div',{staticClass:"demo-tab-panel"},[_c('div',{staticClass:"demo-title"},[_vm._v("Loading To Success By SVG")]),_vm._v(" "),_c('div',{staticClass:"demo-content"},[_c('svg',{staticClass:"loading-success-svg",attrs:{"xmlns":"http://www.w3.org/2000/svg","version":"1.1"}},[_c('circle',{staticClass:"loading-success-circle",attrs:{"cx":"40","cy":"40","r":"30"}}),_vm._v(" "),_c('polyline',{staticClass:"loading-success-line",attrs:{"points":"20,40 35,55 60 30"}})])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var views_Loading = (esExports);
// CONCATENATED MODULE: ./src/views/Loading.vue
function injectStyle (ssrContext) {
  __webpack_require__("hNRi")
  __webpack_require__("iIDT")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-9eece072"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  Loading_default.a,
  views_Loading,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var src_views_Loading = __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "PJ7N":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

exports.default = {};
module.exports = exports["default"];

/***/ }),

/***/ "QRG4":
/***/ (function(module, exports, __webpack_require__) {

// 7.1.15 ToLength
var toInteger = __webpack_require__("UuGF");
var min = Math.min;
module.exports = function (it) {
  return it > 0 ? min(toInteger(it), 0x1fffffffffffff) : 0; // pow(2, 53) - 1 == 9007199254740991
};


/***/ }),

/***/ "R9M2":
/***/ (function(module, exports) {

var toString = {}.toString;

module.exports = function (it) {
  return toString.call(it).slice(8, -1);
};


/***/ }),

/***/ "RPLV":
/***/ (function(module, exports, __webpack_require__) {

var document = __webpack_require__("7KvD").document;
module.exports = document && document.documentElement;


/***/ }),

/***/ "Re3r":
/***/ (function(module, exports) {

/*!
 * Determine if an object is a Buffer
 *
 * @author   Feross Aboukhadijeh <https://feross.org>
 * @license  MIT
 */

// The _isBuffer check is for Safari 5-7 support, because it's missing
// Object.prototype.constructor. Remove this eventually
module.exports = function (obj) {
  return obj != null && (isBuffer(obj) || isSlowBuffer(obj) || !!obj._isBuffer)
}

function isBuffer (obj) {
  return !!obj.constructor && typeof obj.constructor.isBuffer === 'function' && obj.constructor.isBuffer(obj)
}

// For Node v0.10 support. Remove this eventually.
function isSlowBuffer (obj) {
  return typeof obj.readFloatLE === 'function' && typeof obj.slice === 'function' && isBuffer(obj.slice(0, 0))
}


/***/ }),

/***/ "Rrel":
/***/ (function(module, exports, __webpack_require__) {

// fallback for IE11 buggy Object.getOwnPropertyNames with iframe and window
var toIObject = __webpack_require__("TcQ7");
var gOPN = __webpack_require__("n0T6").f;
var toString = {}.toString;

var windowNames = typeof window == 'object' && window && Object.getOwnPropertyNames
  ? Object.getOwnPropertyNames(window) : [];

var getWindowNames = function (it) {
  try {
    return gOPN(it);
  } catch (e) {
    return windowNames.slice();
  }
};

module.exports.f = function getOwnPropertyNames(it) {
  return windowNames && toString.call(it) == '[object Window]' ? getWindowNames(it) : gOPN(toIObject(it));
};


/***/ }),

/***/ "S82l":
/***/ (function(module, exports) {

module.exports = function (exec) {
  try {
    return !!exec();
  } catch (e) {
    return true;
  }
};


/***/ }),

/***/ "SEiN":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/views/ui/Button.vue
var Button = __webpack_require__("PJ7N");
var Button_default = /*#__PURE__*/__webpack_require__.n(Button);

// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-40b6e439","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/ui/Button.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0,false,false)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"demo-content"},[_c('div',{staticClass:"bx-btn"},[_vm._v("常用按钮 默认按钮")]),_vm._v(" "),_c('div',{staticClass:"bx-btn bx-btn--primary"},[_vm._v("常用按钮 主按钮")]),_vm._v(" "),_c('div',{staticClass:"bx-btn bx-btn--disabled"},[_vm._v("常用按钮 不可操作")]),_vm._v(" "),_c('div',{staticClass:"bx-btn bx-btn--primary bx-btn--plain"},[_vm._v("小按钮 主按钮")]),_vm._v(" "),_c('div',{staticClass:"bx-btn bx-btn--plain"},[_vm._v("小按钮 次按钮")]),_vm._v(" "),_c('div',{staticClass:"bx-btn bx-btn--primary bx-btn--inline"},[_vm._v("primary inline")]),_vm._v(" "),_c('div',{staticClass:"bx-btn bx-btn--disabled bx-btn--inline"},[_vm._v("disabled inline")]),_vm._v(" "),_c('div',{staticClass:"bx-btn bx-btn--primary bx-btn--plain bx-btn--inline"},[_vm._v("plain inline")]),_vm._v(" "),_c('div',{staticClass:"bx-btn bx-btn--plain bx-btn--inline"},[_vm._v("plain inline")]),_vm._v(" "),_c('button',{staticClass:"bx-btn bx-btn--primary"},[_vm._v("button按钮")]),_vm._v(" "),_c('input',{staticClass:"bx-btn bx-btn--primary",attrs:{"type":"text","disabled":"","value":"input按钮"}}),_vm._v(" "),_c('a',{staticClass:"bx-btn bx-btn--primary"},[_vm._v("a标签按钮")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var ui_Button = (esExports);
// CONCATENATED MODULE: ./src/views/ui/Button.vue
function injectStyle (ssrContext) {
  __webpack_require__("EIYJ")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-40b6e439"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  Button_default.a,
  ui_Button,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var views_ui_Button = __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "SfB7":
/***/ (function(module, exports, __webpack_require__) {

module.exports = !__webpack_require__("+E39") && !__webpack_require__("S82l")(function () {
  return Object.defineProperty(__webpack_require__("ON07")('div'), 'a', { get: function () { return 7; } }).a != 7;
});


/***/ }),

/***/ "TNV1":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__("cGG2");

/**
 * Transform the data for a request or a response
 *
 * @param {Object|String} data The data to be transformed
 * @param {Array} headers The headers for the request or response
 * @param {Array|Function} fns A single function or Array of functions
 * @returns {*} The resulting transformed data
 */
module.exports = function transformData(data, headers, fns) {
  /*eslint no-param-reassign:0*/
  utils.forEach(fns, function transform(fn) {
    data = fn(data, headers);
  });

  return data;
};


/***/ }),

/***/ "TcQ7":
/***/ (function(module, exports, __webpack_require__) {

// to indexed object, toObject with fallback for non-array-like ES3 strings
var IObject = __webpack_require__("MU5D");
var defined = __webpack_require__("52gC");
module.exports = function (it) {
  return IObject(defined(it));
};


/***/ }),

/***/ "TqSx":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

exports.default = {
  data: function data() {
    return {
      toastMsg: '',
      toastVisible: false,
      toastType: null,
      alertVisible: false,
      alertMsg: '',
      alertTitle: '',
      dialogVisible: false,
      dialogMsg: '',
      dialogTitle: '',
      modalVisible: false,
      pickerVisible: false
    };
  },

  methods: {
    toast: function toast(msg, type) {
      var self = this;
      self.toastMsg = msg;
      self.toastVisible = true;
      type && (self.toastType = 'bx-toast--' + type);
      window.setTimeout(function () {
        self.toastMsg = '';
        self.toastVisible = false;
        self.toastType = null;
      }, 2000);
    },
    alert: function alert(msg, title) {
      var self = this;
      self.alertMsg = msg;
      self.alertVisible = true;
      self.alertTitle = title;
    },
    dialog: function dialog(msg, title) {
      var self = this;
      self.dialogMsg = msg;
      self.dialogVisible = true;
      self.dialogTitle = title;
    },
    modal: function modal() {
      var self = this;
      self.modalVisible = true;
    },
    picker: function picker() {
      var self = this;
      self.pickerVisible = true;
    },
    closeModal: function closeModal() {
      var self = this;
      self.alertVisible && (self.alertVisible = false);
      self.dialogVisible && (self.dialogVisible = false);
      self.modalVisible && (self.modalVisible = false);
      self.pickerVisible && (self.pickerVisible = false);
    }
  }
};
module.exports = exports['default'];

/***/ }),

/***/ "U+De":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/views/Uploader.vue
var Uploader = __webpack_require__("DL+9");
var Uploader_default = /*#__PURE__*/__webpack_require__.n(Uploader);

// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-b0aae7e2","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/Uploader.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_vm._m(0,false,false),_vm._v(" "),_c('div',{staticClass:"bx-uploader bx-uploader-oss"},[_c('input',{staticClass:"bx-input-file",attrs:{"type":"file"}}),_vm._v(" "),_c('div',{staticClass:"bx-preview"},[(_vm.imageOSS)?_c('img',{attrs:{"src":_vm.imageOSS}}):_vm._e()]),_vm._v(" "),(!_vm.imageOSS)?_c('div',{staticClass:"bx-upload"},[_c('img',{staticClass:"upload-background",attrs:{"src":"//media.winbaoxian.com/autoUpload/common/idCard_9e638c5329de848.png"}}),_vm._v(" "),_c('img',{staticClass:"upload-btn",attrs:{"src":"//media.winbaoxian.com/autoUpload/common/btn-upload_46483e95444d6cc.png"}})]):_vm._e()]),_vm._v(" "),_vm._m(1,false,false),_vm._v(" "),_c('div',{staticClass:"bx-uploader bx-uploader-server"},[_c('input',{staticClass:"bx-input-file",attrs:{"type":"file"}}),_vm._v(" "),_c('div',{staticClass:"bx-preview"},[(_vm.imageServer)?_c('img',{attrs:{"src":_vm.imageServer}}):_vm._e()]),_vm._v(" "),(!_vm.imageServer)?_c('div',{staticClass:"bx-upload"},[_c('img',{staticClass:"upload-background",attrs:{"src":"//media.winbaoxian.com/autoUpload/common/idCard_9e638c5329de848.png"}}),_vm._v(" "),_c('img',{staticClass:"upload-btn",attrs:{"src":"//media.winbaoxian.com/autoUpload/common/btn-upload_46483e95444d6cc.png"}})]):_vm._e()]),_vm._v(" "),_vm._m(2,false,false),_vm._v(" "),_c('div',{staticClass:"bx-uploader bx-uploader-base64"},[_c('div',[_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.base64),expression:"base64"}],staticClass:"bx-uploader-textarea",attrs:{"rows":"5","placeholder":"请输入base64格式内容"},domProps:{"value":(_vm.base64)},on:{"input":function($event){if($event.target.composing){ return; }_vm.base64=$event.target.value}}}),_vm._v(" "),_c('a',{staticClass:"bx-btn bx-btn--sm",on:{"click":_vm.uploadBase64}},[_vm._v("Base64转图片URL")])]),_vm._v(" "),_c('div',{staticClass:"bx-preview"},[(_vm.imageBase64)?_c('img',{attrs:{"src":_vm.imageBase64}}):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"demo-title"})])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"demo-title"},[_vm._v("\n    OSS直传\n    "),_c('span',{staticClass:"demo-subtitle"},[_vm._v("(OSS Server对域名有限制,请使用代理或者修改hosts)")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"demo-title"},[_vm._v("\n    服务端上传\n    "),_c('span',{staticClass:"demo-subtitle"},[_vm._v("(没有可使用的接口演示)")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"demo-title"},[_vm._v("\n    Base64文件上传\n    "),_c('span',{staticClass:"demo-subtitle"},[_vm._v("(OSS直传)")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var views_Uploader = (esExports);
// CONCATENATED MODULE: ./src/views/Uploader.vue
function injectStyle (ssrContext) {
  __webpack_require__("mqfF")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-b0aae7e2"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  Uploader_default.a,
  views_Uploader,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var src_views_Uploader = __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "UOlw":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

exports.default = {
  data: function data() {
    return {};
  },

  methods: {}
};
module.exports = exports["default"];

/***/ }),

/***/ "Us91":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
// 事件总线
var EventBus = function EventBus(unique) {
  this.unique = unique || new Date().getTime();
  this.topics = {};
};
EventBus.prototype.on = function (topic, func) {
  var cbs = this.topics[this.unique + topic];
  cbs ? cbs.push(func) : this.topics[this.unique + topic] = [];
  if (!cbs) {
    this.topics[this.unique + topic].push(func);
  }
};
EventBus.prototype.emit = function (topic) {
  var cbs = this.topics[this.unique + topic];
  var args = Array.prototype.slice.call(arguments, 1);
  if (cbs) {
    for (var i = 0; i < cbs.length; i++) {
      cbs[i].apply(this, args);
    }
  }
};
EventBus.prototype.off = function (topic) {
  var cbs = this.topics[this.unique + topic];
  if (cbs) {
    var i = cbs.length;
    while (i--) {
      cbs.splice(i, 1);
    }
  }
};

exports.default = {
  eventBuses: [],
  create: function create(unique) {
    for (var i = 0; i < this.eventBuses.length; i++) {
      if (this.eventBuses[i].unique === unique) {
        return this.eventBuses[i];
      }
    }
    var eventBus = new EventBus(unique);
    this.eventBuses.push(eventBus);
    return eventBus;
  }
};
module.exports = exports["default"];

/***/ }),

/***/ "UuGF":
/***/ (function(module, exports) {

// 7.1.4 ToInteger
var ceil = Math.ceil;
var floor = Math.floor;
module.exports = function (it) {
  return isNaN(it = +it) ? 0 : (it > 0 ? floor : ceil)(it);
};


/***/ }),

/***/ "VU/8":
/***/ (function(module, exports) {

/* globals __VUE_SSR_CONTEXT__ */

// IMPORTANT: Do NOT use ES2015 features in this file.
// This module is a runtime utility for cleaner component module output and will
// be included in the final webpack user bundle.

module.exports = function normalizeComponent (
  rawScriptExports,
  compiledTemplate,
  functionalTemplate,
  injectStyles,
  scopeId,
  moduleIdentifier /* server only */
) {
  var esModule
  var scriptExports = rawScriptExports = rawScriptExports || {}

  // ES6 modules interop
  var type = typeof rawScriptExports.default
  if (type === 'object' || type === 'function') {
    esModule = rawScriptExports
    scriptExports = rawScriptExports.default
  }

  // Vue.extend constructor export interop
  var options = typeof scriptExports === 'function'
    ? scriptExports.options
    : scriptExports

  // render functions
  if (compiledTemplate) {
    options.render = compiledTemplate.render
    options.staticRenderFns = compiledTemplate.staticRenderFns
    options._compiled = true
  }

  // functional template
  if (functionalTemplate) {
    options.functional = true
  }

  // scopedId
  if (scopeId) {
    options._scopeId = scopeId
  }

  var hook
  if (moduleIdentifier) { // server build
    hook = function (context) {
      // 2.3 injection
      context =
        context || // cached call
        (this.$vnode && this.$vnode.ssrContext) || // stateful
        (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
      // 2.2 with runInNewContext: true
      if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
        context = __VUE_SSR_CONTEXT__
      }
      // inject component styles
      if (injectStyles) {
        injectStyles.call(this, context)
      }
      // register component module identifier for async chunk inferrence
      if (context && context._registeredComponents) {
        context._registeredComponents.add(moduleIdentifier)
      }
    }
    // used by ssr in case component is cached and beforeCreate
    // never gets called
    options._ssrRegister = hook
  } else if (injectStyles) {
    hook = injectStyles
  }

  if (hook) {
    var functional = options.functional
    var existing = functional
      ? options.render
      : options.beforeCreate

    if (!functional) {
      // inject component registration as beforeCreate hook
      options.beforeCreate = existing
        ? [].concat(existing, hook)
        : [hook]
    } else {
      // for template-only hot-reload because in that case the render fn doesn't
      // go through the normalizer
      options._injectStyles = hook
      // register for functioal component in vue file
      options.render = function renderWithStyleInjection (h, context) {
        hook.call(context)
        return existing(h, context)
      }
    }
  }

  return {
    esModule: esModule,
    exports: scriptExports,
    options: options
  }
}


/***/ }),

/***/ "VsUZ":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _axios = __webpack_require__("mtWM");

var _axios2 = _interopRequireDefault(_axios);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var api = {
  // 获取OSS直传授权信息
  getAuthInfo: function getAuthInfo(fileDir) {
    return (0, _axios2.default)({
      url: '',
      method: 'get',
      params: {}
    });
  }
};

exports.default = api;
module.exports = exports['default'];

/***/ }),

/***/ "W2nU":
/***/ (function(module, exports) {

// shim for using process in browser
var process = module.exports = {};

// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.

var cachedSetTimeout;
var cachedClearTimeout;

function defaultSetTimout() {
    throw new Error('setTimeout has not been defined');
}
function defaultClearTimeout () {
    throw new Error('clearTimeout has not been defined');
}
(function () {
    try {
        if (typeof setTimeout === 'function') {
            cachedSetTimeout = setTimeout;
        } else {
            cachedSetTimeout = defaultSetTimout;
        }
    } catch (e) {
        cachedSetTimeout = defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === 'function') {
            cachedClearTimeout = clearTimeout;
        } else {
            cachedClearTimeout = defaultClearTimeout;
        }
    } catch (e) {
        cachedClearTimeout = defaultClearTimeout;
    }
} ())
function runTimeout(fun) {
    if (cachedSetTimeout === setTimeout) {
        //normal enviroments in sane situations
        return setTimeout(fun, 0);
    }
    // if setTimeout wasn't available but was latter defined
    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
        cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedSetTimeout(fun, 0);
    } catch(e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return cachedSetTimeout.call(null, fun, 0);
        } catch(e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return cachedSetTimeout.call(this, fun, 0);
        }
    }


}
function runClearTimeout(marker) {
    if (cachedClearTimeout === clearTimeout) {
        //normal enviroments in sane situations
        return clearTimeout(marker);
    }
    // if clearTimeout wasn't available but was latter defined
    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
        cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedClearTimeout(marker);
    } catch (e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return cachedClearTimeout.call(null, marker);
        } catch (e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return cachedClearTimeout.call(this, marker);
        }
    }



}
var queue = [];
var draining = false;
var currentQueue;
var queueIndex = -1;

function cleanUpNextTick() {
    if (!draining || !currentQueue) {
        return;
    }
    draining = false;
    if (currentQueue.length) {
        queue = currentQueue.concat(queue);
    } else {
        queueIndex = -1;
    }
    if (queue.length) {
        drainQueue();
    }
}

function drainQueue() {
    if (draining) {
        return;
    }
    var timeout = runTimeout(cleanUpNextTick);
    draining = true;

    var len = queue.length;
    while(len) {
        currentQueue = queue;
        queue = [];
        while (++queueIndex < len) {
            if (currentQueue) {
                currentQueue[queueIndex].run();
            }
        }
        queueIndex = -1;
        len = queue.length;
    }
    currentQueue = null;
    draining = false;
    runClearTimeout(timeout);
}

process.nextTick = function (fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) {
        for (var i = 1; i < arguments.length; i++) {
            args[i - 1] = arguments[i];
        }
    }
    queue.push(new Item(fun, args));
    if (queue.length === 1 && !draining) {
        runTimeout(drainQueue);
    }
};

// v8 likes predictible objects
function Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
Item.prototype.run = function () {
    this.fun.apply(null, this.array);
};
process.title = 'browser';
process.browser = true;
process.env = {};
process.argv = [];
process.version = ''; // empty string to avoid regexp issues
process.versions = {};

function noop() {}

process.on = noop;
process.addListener = noop;
process.once = noop;
process.off = noop;
process.removeListener = noop;
process.removeAllListeners = noop;
process.emit = noop;
process.prependListener = noop;
process.prependOnceListener = noop;

process.listeners = function (name) { return [] }

process.binding = function (name) {
    throw new Error('process.binding is not supported');
};

process.cwd = function () { return '/' };
process.chdir = function (dir) {
    throw new Error('process.chdir is not supported');
};
process.umask = function() { return 0; };


/***/ }),

/***/ "WHXa":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Ww8N":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "X2Oc":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* eslint-disable */


Object.defineProperty(exports, "__esModule", {
  value: true
});
var Utils = {};
Utils.setCookie = function (name, value, days) {
  var Days = days ? days : 30;
  var exp = new Date();
  exp.setTime(exp.getTime() + Days * 24 * 60 * 60 * 1000);
  document.cookie = name + "=" + escape(value) + ";path=/;expires=" + exp.toGMTString();
};
Utils.getCooke = function (name) {
  var arr,
      reg = new RegExp("(^| )" + name + "=([^;]*)(;|$)");
  if (arr = document.cookie.match(reg)) return unescape(arr[2]);else return null;
};

exports.default = Utils;
module.exports = exports["default"];

/***/ }),

/***/ "X8DO":
/***/ (function(module, exports) {

module.exports = function (bitmap, value) {
  return {
    enumerable: !(bitmap & 1),
    configurable: !(bitmap & 2),
    writable: !(bitmap & 4),
    value: value
  };
};


/***/ }),

/***/ "XXfZ":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Xc4G":
/***/ (function(module, exports, __webpack_require__) {

// all enumerable object keys, includes symbols
var getKeys = __webpack_require__("lktj");
var gOPS = __webpack_require__("1kS7");
var pIE = __webpack_require__("NpIQ");
module.exports = function (it) {
  var result = getKeys(it);
  var getSymbols = gOPS.f;
  if (getSymbols) {
    var symbols = getSymbols(it);
    var isEnum = pIE.f;
    var i = 0;
    var key;
    while (symbols.length > i) if (isEnum.call(it, key = symbols[i++])) result.push(key);
  } return result;
};


/***/ }),

/***/ "XmWM":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var defaults = __webpack_require__("KCLY");
var utils = __webpack_require__("cGG2");
var InterceptorManager = __webpack_require__("fuGk");
var dispatchRequest = __webpack_require__("xLtR");

/**
 * Create a new instance of Axios
 *
 * @param {Object} instanceConfig The default config for the instance
 */
function Axios(instanceConfig) {
  this.defaults = instanceConfig;
  this.interceptors = {
    request: new InterceptorManager(),
    response: new InterceptorManager()
  };
}

/**
 * Dispatch a request
 *
 * @param {Object} config The config specific for this request (merged with this.defaults)
 */
Axios.prototype.request = function request(config) {
  /*eslint no-param-reassign:0*/
  // Allow for axios('example/url'[, config]) a la fetch API
  if (typeof config === 'string') {
    config = utils.merge({
      url: arguments[0]
    }, arguments[1]);
  }

  config = utils.merge(defaults, this.defaults, { method: 'get' }, config);
  config.method = config.method.toLowerCase();

  // Hook up interceptors middleware
  var chain = [dispatchRequest, undefined];
  var promise = Promise.resolve(config);

  this.interceptors.request.forEach(function unshiftRequestInterceptors(interceptor) {
    chain.unshift(interceptor.fulfilled, interceptor.rejected);
  });

  this.interceptors.response.forEach(function pushResponseInterceptors(interceptor) {
    chain.push(interceptor.fulfilled, interceptor.rejected);
  });

  while (chain.length) {
    promise = promise.then(chain.shift(), chain.shift());
  }

  return promise;
};

// Provide aliases for supported request methods
utils.forEach(['delete', 'get', 'head', 'options'], function forEachMethodNoData(method) {
  /*eslint func-names:0*/
  Axios.prototype[method] = function(url, config) {
    return this.request(utils.merge(config || {}, {
      method: method,
      url: url
    }));
  };
});

utils.forEach(['post', 'put', 'patch'], function forEachMethodWithData(method) {
  /*eslint func-names:0*/
  Axios.prototype[method] = function(url, data, config) {
    return this.request(utils.merge(config || {}, {
      method: method,
      url: url,
      data: data
    }));
  };
});

module.exports = Axios;


/***/ }),

/***/ "Y36A":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
/* eslint-disable */
/**
 * 扩展自 https://github.com/davidshimjs/qrcodejs
 */
var QRCode;
//---------------------------------------------------------------------
// QRCode for JavaScript
//
// Copyright (c) 2009 Kazuhiko Arase
//
// URL: http://www.d-project.com/
//
// Licensed under the MIT license:
//   http://www.opensource.org/licenses/mit-license.php
//
// The word "QR Code" is registered trademark of
// DENSO WAVE INCORPORATED
//   http://www.denso-wave.com/qrcode/faqpatent-e.html
//
//---------------------------------------------------------------------
function QR8bitByte(data) {
  this.mode = QRMode.MODE_8BIT_BYTE;
  this.data = data;
  this.parsedData = [];

  // Added to support UTF-8 Characters
  for (var i = 0, l = this.data.length; i < l; i++) {
    var byteArray = [];
    var code = this.data.charCodeAt(i);

    if (code > 0x10000) {
      byteArray[0] = 0xF0 | (code & 0x1C0000) >>> 18;
      byteArray[1] = 0x80 | (code & 0x3F000) >>> 12;
      byteArray[2] = 0x80 | (code & 0xFC0) >>> 6;
      byteArray[3] = 0x80 | code & 0x3F;
    } else if (code > 0x800) {
      byteArray[0] = 0xE0 | (code & 0xF000) >>> 12;
      byteArray[1] = 0x80 | (code & 0xFC0) >>> 6;
      byteArray[2] = 0x80 | code & 0x3F;
    } else if (code > 0x80) {
      byteArray[0] = 0xC0 | (code & 0x7C0) >>> 6;
      byteArray[1] = 0x80 | code & 0x3F;
    } else {
      byteArray[0] = code;
    }

    this.parsedData.push(byteArray);
  }

  this.parsedData = Array.prototype.concat.apply([], this.parsedData);

  if (this.parsedData.length != this.data.length) {
    this.parsedData.unshift(191);
    this.parsedData.unshift(187);
    this.parsedData.unshift(239);
  }
}

QR8bitByte.prototype = {
  getLength: function getLength(buffer) {
    return this.parsedData.length;
  },
  write: function write(buffer) {
    for (var i = 0, l = this.parsedData.length; i < l; i++) {
      buffer.put(this.parsedData[i], 8);
    }
  }
};

function QRCodeModel(typeNumber, errorCorrectLevel) {
  this.typeNumber = typeNumber;
  this.errorCorrectLevel = errorCorrectLevel;
  this.modules = null;
  this.moduleCount = 0;
  this.dataCache = null;
  this.dataList = [];
}

QRCodeModel.prototype = {
  addData: function addData(data) {
    var newData = new QR8bitByte(data);
    this.dataList.push(newData);
    this.dataCache = null;
  }, isDark: function isDark(row, col) {
    if (row < 0 || this.moduleCount <= row || col < 0 || this.moduleCount <= col) {
      throw new Error(row + "," + col);
    }
    return this.modules[row][col];
  }, getModuleCount: function getModuleCount() {
    return this.moduleCount;
  }, make: function make() {
    this.makeImpl(false, this.getBestMaskPattern());
  }, makeImpl: function makeImpl(test, maskPattern) {
    this.moduleCount = this.typeNumber * 4 + 17;
    this.modules = new Array(this.moduleCount);
    for (var row = 0; row < this.moduleCount; row++) {
      this.modules[row] = new Array(this.moduleCount);
      for (var col = 0; col < this.moduleCount; col++) {
        this.modules[row][col] = null;
      }
    }
    this.setupPositionProbePattern(0, 0);
    this.setupPositionProbePattern(this.moduleCount - 7, 0);
    this.setupPositionProbePattern(0, this.moduleCount - 7);
    this.setupPositionAdjustPattern();
    this.setupTimingPattern();
    this.setupTypeInfo(test, maskPattern);
    if (this.typeNumber >= 7) {
      this.setupTypeNumber(test);
    }
    if (this.dataCache == null) {
      this.dataCache = QRCodeModel.createData(this.typeNumber, this.errorCorrectLevel, this.dataList);
    }
    this.mapData(this.dataCache, maskPattern);
  }, setupPositionProbePattern: function setupPositionProbePattern(row, col) {
    for (var r = -1; r <= 7; r++) {
      if (row + r <= -1 || this.moduleCount <= row + r) continue;
      for (var c = -1; c <= 7; c++) {
        if (col + c <= -1 || this.moduleCount <= col + c) continue;
        if (0 <= r && r <= 6 && (c == 0 || c == 6) || 0 <= c && c <= 6 && (r == 0 || r == 6) || 2 <= r && r <= 4 && 2 <= c && c <= 4) {
          this.modules[row + r][col + c] = true;
        } else {
          this.modules[row + r][col + c] = false;
        }
      }
    }
  }, getBestMaskPattern: function getBestMaskPattern() {
    var minLostPoint = 0;
    var pattern = 0;
    for (var i = 0; i < 8; i++) {
      this.makeImpl(true, i);
      var lostPoint = QRUtil.getLostPoint(this);
      if (i == 0 || minLostPoint > lostPoint) {
        minLostPoint = lostPoint;
        pattern = i;
      }
    }
    return pattern;
  }, createMovieClip: function createMovieClip(target_mc, instance_name, depth) {
    var qr_mc = target_mc.createEmptyMovieClip(instance_name, depth);
    var cs = 1;
    this.make();
    for (var row = 0; row < this.modules.length; row++) {
      var y = row * cs;
      for (var col = 0; col < this.modules[row].length; col++) {
        var x = col * cs;
        var dark = this.modules[row][col];
        if (dark) {
          qr_mc.beginFill(0, 100);
          qr_mc.moveTo(x, y);
          qr_mc.lineTo(x + cs, y);
          qr_mc.lineTo(x + cs, y + cs);
          qr_mc.lineTo(x, y + cs);
          qr_mc.endFill();
        }
      }
    }
    return qr_mc;
  }, setupTimingPattern: function setupTimingPattern() {
    for (var r = 8; r < this.moduleCount - 8; r++) {
      if (this.modules[r][6] != null) {
        continue;
      }
      this.modules[r][6] = r % 2 == 0;
    }
    for (var c = 8; c < this.moduleCount - 8; c++) {
      if (this.modules[6][c] != null) {
        continue;
      }
      this.modules[6][c] = c % 2 == 0;
    }
  }, setupPositionAdjustPattern: function setupPositionAdjustPattern() {
    var pos = QRUtil.getPatternPosition(this.typeNumber);
    for (var i = 0; i < pos.length; i++) {
      for (var j = 0; j < pos.length; j++) {
        var row = pos[i];
        var col = pos[j];
        if (this.modules[row][col] != null) {
          continue;
        }
        for (var r = -2; r <= 2; r++) {
          for (var c = -2; c <= 2; c++) {
            if (r == -2 || r == 2 || c == -2 || c == 2 || r == 0 && c == 0) {
              this.modules[row + r][col + c] = true;
            } else {
              this.modules[row + r][col + c] = false;
            }
          }
        }
      }
    }
  }, setupTypeNumber: function setupTypeNumber(test) {
    var bits = QRUtil.getBCHTypeNumber(this.typeNumber);
    for (var i = 0; i < 18; i++) {
      var mod = !test && (bits >> i & 1) == 1;
      this.modules[Math.floor(i / 3)][i % 3 + this.moduleCount - 8 - 3] = mod;
    }
    for (var i = 0; i < 18; i++) {
      var mod = !test && (bits >> i & 1) == 1;
      this.modules[i % 3 + this.moduleCount - 8 - 3][Math.floor(i / 3)] = mod;
    }
  }, setupTypeInfo: function setupTypeInfo(test, maskPattern) {
    var data = this.errorCorrectLevel << 3 | maskPattern;
    var bits = QRUtil.getBCHTypeInfo(data);
    for (var i = 0; i < 15; i++) {
      var mod = !test && (bits >> i & 1) == 1;
      if (i < 6) {
        this.modules[i][8] = mod;
      } else if (i < 8) {
        this.modules[i + 1][8] = mod;
      } else {
        this.modules[this.moduleCount - 15 + i][8] = mod;
      }
    }
    for (var i = 0; i < 15; i++) {
      var mod = !test && (bits >> i & 1) == 1;
      if (i < 8) {
        this.modules[8][this.moduleCount - i - 1] = mod;
      } else if (i < 9) {
        this.modules[8][15 - i - 1 + 1] = mod;
      } else {
        this.modules[8][15 - i - 1] = mod;
      }
    }
    this.modules[this.moduleCount - 8][8] = !test;
  }, mapData: function mapData(data, maskPattern) {
    var inc = -1;
    var row = this.moduleCount - 1;
    var bitIndex = 7;
    var byteIndex = 0;
    for (var col = this.moduleCount - 1; col > 0; col -= 2) {
      if (col == 6) col--;
      while (true) {
        for (var c = 0; c < 2; c++) {
          if (this.modules[row][col - c] == null) {
            var dark = false;
            if (byteIndex < data.length) {
              dark = (data[byteIndex] >>> bitIndex & 1) == 1;
            }
            var mask = QRUtil.getMask(maskPattern, row, col - c);
            if (mask) {
              dark = !dark;
            }
            this.modules[row][col - c] = dark;
            bitIndex--;
            if (bitIndex == -1) {
              byteIndex++;
              bitIndex = 7;
            }
          }
        }
        row += inc;
        if (row < 0 || this.moduleCount <= row) {
          row -= inc;
          inc = -inc;
          break;
        }
      }
    }
  }
};
QRCodeModel.PAD0 = 0xEC;
QRCodeModel.PAD1 = 0x11;
QRCodeModel.createData = function (typeNumber, errorCorrectLevel, dataList) {
  var rsBlocks = QRRSBlock.getRSBlocks(typeNumber, errorCorrectLevel);
  var buffer = new QRBitBuffer();
  for (var i = 0; i < dataList.length; i++) {
    var data = dataList[i];
    buffer.put(data.mode, 4);
    buffer.put(data.getLength(), QRUtil.getLengthInBits(data.mode, typeNumber));
    data.write(buffer);
  }
  var totalDataCount = 0;
  for (var i = 0; i < rsBlocks.length; i++) {
    totalDataCount += rsBlocks[i].dataCount;
  }
  if (buffer.getLengthInBits() > totalDataCount * 8) {
    throw new Error("code length overflow. (" + buffer.getLengthInBits() + ">" + totalDataCount * 8 + ")");
  }
  if (buffer.getLengthInBits() + 4 <= totalDataCount * 8) {
    buffer.put(0, 4);
  }
  while (buffer.getLengthInBits() % 8 != 0) {
    buffer.putBit(false);
  }
  while (true) {
    if (buffer.getLengthInBits() >= totalDataCount * 8) {
      break;
    }
    buffer.put(QRCodeModel.PAD0, 8);
    if (buffer.getLengthInBits() >= totalDataCount * 8) {
      break;
    }
    buffer.put(QRCodeModel.PAD1, 8);
  }
  return QRCodeModel.createBytes(buffer, rsBlocks);
};
QRCodeModel.createBytes = function (buffer, rsBlocks) {
  var offset = 0;
  var maxDcCount = 0;
  var maxEcCount = 0;
  var dcdata = new Array(rsBlocks.length);
  var ecdata = new Array(rsBlocks.length);
  for (var r = 0; r < rsBlocks.length; r++) {
    var dcCount = rsBlocks[r].dataCount;
    var ecCount = rsBlocks[r].totalCount - dcCount;
    maxDcCount = Math.max(maxDcCount, dcCount);
    maxEcCount = Math.max(maxEcCount, ecCount);
    dcdata[r] = new Array(dcCount);
    for (var i = 0; i < dcdata[r].length; i++) {
      dcdata[r][i] = 0xff & buffer.buffer[i + offset];
    }
    offset += dcCount;
    var rsPoly = QRUtil.getErrorCorrectPolynomial(ecCount);
    var rawPoly = new QRPolynomial(dcdata[r], rsPoly.getLength() - 1);
    var modPoly = rawPoly.mod(rsPoly);
    ecdata[r] = new Array(rsPoly.getLength() - 1);
    for (var i = 0; i < ecdata[r].length; i++) {
      var modIndex = i + modPoly.getLength() - ecdata[r].length;
      ecdata[r][i] = modIndex >= 0 ? modPoly.get(modIndex) : 0;
    }
  }
  var totalCodeCount = 0;
  for (var i = 0; i < rsBlocks.length; i++) {
    totalCodeCount += rsBlocks[i].totalCount;
  }
  var data = new Array(totalCodeCount);
  var index = 0;
  for (var i = 0; i < maxDcCount; i++) {
    for (var r = 0; r < rsBlocks.length; r++) {
      if (i < dcdata[r].length) {
        data[index++] = dcdata[r][i];
      }
    }
  }
  for (var i = 0; i < maxEcCount; i++) {
    for (var r = 0; r < rsBlocks.length; r++) {
      if (i < ecdata[r].length) {
        data[index++] = ecdata[r][i];
      }
    }
  }
  return data;
};
var QRMode = { MODE_NUMBER: 1 << 0, MODE_ALPHA_NUM: 1 << 1, MODE_8BIT_BYTE: 1 << 2, MODE_KANJI: 1 << 3 };
var QRErrorCorrectLevel = { L: 1, M: 0, Q: 3, H: 2 };
var QRMaskPattern = {
  PATTERN000: 0,
  PATTERN001: 1,
  PATTERN010: 2,
  PATTERN011: 3,
  PATTERN100: 4,
  PATTERN101: 5,
  PATTERN110: 6,
  PATTERN111: 7
};
var QRUtil = {
  PATTERN_POSITION_TABLE: [[], [6, 18], [6, 22], [6, 26], [6, 30], [6, 34], [6, 22, 38], [6, 24, 42], [6, 26, 46], [6, 28, 50], [6, 30, 54], [6, 32, 58], [6, 34, 62], [6, 26, 46, 66], [6, 26, 48, 70], [6, 26, 50, 74], [6, 30, 54, 78], [6, 30, 56, 82], [6, 30, 58, 86], [6, 34, 62, 90], [6, 28, 50, 72, 94], [6, 26, 50, 74, 98], [6, 30, 54, 78, 102], [6, 28, 54, 80, 106], [6, 32, 58, 84, 110], [6, 30, 58, 86, 114], [6, 34, 62, 90, 118], [6, 26, 50, 74, 98, 122], [6, 30, 54, 78, 102, 126], [6, 26, 52, 78, 104, 130], [6, 30, 56, 82, 108, 134], [6, 34, 60, 86, 112, 138], [6, 30, 58, 86, 114, 142], [6, 34, 62, 90, 118, 146], [6, 30, 54, 78, 102, 126, 150], [6, 24, 50, 76, 102, 128, 154], [6, 28, 54, 80, 106, 132, 158], [6, 32, 58, 84, 110, 136, 162], [6, 26, 54, 82, 110, 138, 166], [6, 30, 58, 86, 114, 142, 170]],
  G15: 1 << 10 | 1 << 8 | 1 << 5 | 1 << 4 | 1 << 2 | 1 << 1 | 1 << 0,
  G18: 1 << 12 | 1 << 11 | 1 << 10 | 1 << 9 | 1 << 8 | 1 << 5 | 1 << 2 | 1 << 0,
  G15_MASK: 1 << 14 | 1 << 12 | 1 << 10 | 1 << 4 | 1 << 1,
  getBCHTypeInfo: function getBCHTypeInfo(data) {
    var d = data << 10;
    while (QRUtil.getBCHDigit(d) - QRUtil.getBCHDigit(QRUtil.G15) >= 0) {
      d ^= QRUtil.G15 << QRUtil.getBCHDigit(d) - QRUtil.getBCHDigit(QRUtil.G15);
    }
    return (data << 10 | d) ^ QRUtil.G15_MASK;
  },
  getBCHTypeNumber: function getBCHTypeNumber(data) {
    var d = data << 12;
    while (QRUtil.getBCHDigit(d) - QRUtil.getBCHDigit(QRUtil.G18) >= 0) {
      d ^= QRUtil.G18 << QRUtil.getBCHDigit(d) - QRUtil.getBCHDigit(QRUtil.G18);
    }
    return data << 12 | d;
  },
  getBCHDigit: function getBCHDigit(data) {
    var digit = 0;
    while (data != 0) {
      digit++;
      data >>>= 1;
    }
    return digit;
  },
  getPatternPosition: function getPatternPosition(typeNumber) {
    return QRUtil.PATTERN_POSITION_TABLE[typeNumber - 1];
  },
  getMask: function getMask(maskPattern, i, j) {
    switch (maskPattern) {
      case QRMaskPattern.PATTERN000:
        return (i + j) % 2 == 0;
      case QRMaskPattern.PATTERN001:
        return i % 2 == 0;
      case QRMaskPattern.PATTERN010:
        return j % 3 == 0;
      case QRMaskPattern.PATTERN011:
        return (i + j) % 3 == 0;
      case QRMaskPattern.PATTERN100:
        return (Math.floor(i / 2) + Math.floor(j / 3)) % 2 == 0;
      case QRMaskPattern.PATTERN101:
        return i * j % 2 + i * j % 3 == 0;
      case QRMaskPattern.PATTERN110:
        return (i * j % 2 + i * j % 3) % 2 == 0;
      case QRMaskPattern.PATTERN111:
        return (i * j % 3 + (i + j) % 2) % 2 == 0;
      default:
        throw new Error("bad maskPattern:" + maskPattern);
    }
  },
  getErrorCorrectPolynomial: function getErrorCorrectPolynomial(errorCorrectLength) {
    var a = new QRPolynomial([1], 0);
    for (var i = 0; i < errorCorrectLength; i++) {
      a = a.multiply(new QRPolynomial([1, QRMath.gexp(i)], 0));
    }
    return a;
  },
  getLengthInBits: function getLengthInBits(mode, type) {
    if (1 <= type && type < 10) {
      switch (mode) {
        case QRMode.MODE_NUMBER:
          return 10;
        case QRMode.MODE_ALPHA_NUM:
          return 9;
        case QRMode.MODE_8BIT_BYTE:
          return 8;
        case QRMode.MODE_KANJI:
          return 8;
        default:
          throw new Error("mode:" + mode);
      }
    } else if (type < 27) {
      switch (mode) {
        case QRMode.MODE_NUMBER:
          return 12;
        case QRMode.MODE_ALPHA_NUM:
          return 11;
        case QRMode.MODE_8BIT_BYTE:
          return 16;
        case QRMode.MODE_KANJI:
          return 10;
        default:
          throw new Error("mode:" + mode);
      }
    } else if (type < 41) {
      switch (mode) {
        case QRMode.MODE_NUMBER:
          return 14;
        case QRMode.MODE_ALPHA_NUM:
          return 13;
        case QRMode.MODE_8BIT_BYTE:
          return 16;
        case QRMode.MODE_KANJI:
          return 12;
        default:
          throw new Error("mode:" + mode);
      }
    } else {
      throw new Error("type:" + type);
    }
  },
  getLostPoint: function getLostPoint(qrCode) {
    var moduleCount = qrCode.getModuleCount();
    var lostPoint = 0;
    for (var row = 0; row < moduleCount; row++) {
      for (var col = 0; col < moduleCount; col++) {
        var sameCount = 0;
        var dark = qrCode.isDark(row, col);
        for (var r = -1; r <= 1; r++) {
          if (row + r < 0 || moduleCount <= row + r) {
            continue;
          }
          for (var c = -1; c <= 1; c++) {
            if (col + c < 0 || moduleCount <= col + c) {
              continue;
            }
            if (r == 0 && c == 0) {
              continue;
            }
            if (dark == qrCode.isDark(row + r, col + c)) {
              sameCount++;
            }
          }
        }
        if (sameCount > 5) {
          lostPoint += 3 + sameCount - 5;
        }
      }
    }
    for (var row = 0; row < moduleCount - 1; row++) {
      for (var col = 0; col < moduleCount - 1; col++) {
        var count = 0;
        if (qrCode.isDark(row, col)) count++;
        if (qrCode.isDark(row + 1, col)) count++;
        if (qrCode.isDark(row, col + 1)) count++;
        if (qrCode.isDark(row + 1, col + 1)) count++;
        if (count == 0 || count == 4) {
          lostPoint += 3;
        }
      }
    }
    for (var row = 0; row < moduleCount; row++) {
      for (var col = 0; col < moduleCount - 6; col++) {
        if (qrCode.isDark(row, col) && !qrCode.isDark(row, col + 1) && qrCode.isDark(row, col + 2) && qrCode.isDark(row, col + 3) && qrCode.isDark(row, col + 4) && !qrCode.isDark(row, col + 5) && qrCode.isDark(row, col + 6)) {
          lostPoint += 40;
        }
      }
    }
    for (var col = 0; col < moduleCount; col++) {
      for (var row = 0; row < moduleCount - 6; row++) {
        if (qrCode.isDark(row, col) && !qrCode.isDark(row + 1, col) && qrCode.isDark(row + 2, col) && qrCode.isDark(row + 3, col) && qrCode.isDark(row + 4, col) && !qrCode.isDark(row + 5, col) && qrCode.isDark(row + 6, col)) {
          lostPoint += 40;
        }
      }
    }
    var darkCount = 0;
    for (var col = 0; col < moduleCount; col++) {
      for (var row = 0; row < moduleCount; row++) {
        if (qrCode.isDark(row, col)) {
          darkCount++;
        }
      }
    }
    var ratio = Math.abs(100 * darkCount / moduleCount / moduleCount - 50) / 5;
    lostPoint += ratio * 10;
    return lostPoint;
  }
};
var QRMath = {
  glog: function glog(n) {
    if (n < 1) {
      throw new Error("glog(" + n + ")");
    }
    return QRMath.LOG_TABLE[n];
  }, gexp: function gexp(n) {
    while (n < 0) {
      n += 255;
    }
    while (n >= 256) {
      n -= 255;
    }
    return QRMath.EXP_TABLE[n];
  }, EXP_TABLE: new Array(256), LOG_TABLE: new Array(256)
};
for (var i = 0; i < 8; i++) {
  QRMath.EXP_TABLE[i] = 1 << i;
}
for (var i = 8; i < 256; i++) {
  QRMath.EXP_TABLE[i] = QRMath.EXP_TABLE[i - 4] ^ QRMath.EXP_TABLE[i - 5] ^ QRMath.EXP_TABLE[i - 6] ^ QRMath.EXP_TABLE[i - 8];
}
for (var i = 0; i < 255; i++) {
  QRMath.LOG_TABLE[QRMath.EXP_TABLE[i]] = i;
}
function QRPolynomial(num, shift) {
  if (num.length == undefined) {
    throw new Error(num.length + "/" + shift);
  }
  var offset = 0;
  while (offset < num.length && num[offset] == 0) {
    offset++;
  }
  this.num = new Array(num.length - offset + shift);
  for (var i = 0; i < num.length - offset; i++) {
    this.num[i] = num[i + offset];
  }
}

QRPolynomial.prototype = {
  get: function get(index) {
    return this.num[index];
  }, getLength: function getLength() {
    return this.num.length;
  }, multiply: function multiply(e) {
    var num = new Array(this.getLength() + e.getLength() - 1);
    for (var i = 0; i < this.getLength(); i++) {
      for (var j = 0; j < e.getLength(); j++) {
        num[i + j] ^= QRMath.gexp(QRMath.glog(this.get(i)) + QRMath.glog(e.get(j)));
      }
    }
    return new QRPolynomial(num, 0);
  }, mod: function mod(e) {
    if (this.getLength() - e.getLength() < 0) {
      return this;
    }
    var ratio = QRMath.glog(this.get(0)) - QRMath.glog(e.get(0));
    var num = new Array(this.getLength());
    for (var i = 0; i < this.getLength(); i++) {
      num[i] = this.get(i);
    }
    for (var i = 0; i < e.getLength(); i++) {
      num[i] ^= QRMath.gexp(QRMath.glog(e.get(i)) + ratio);
    }
    return new QRPolynomial(num, 0).mod(e);
  }
};
function QRRSBlock(totalCount, dataCount) {
  this.totalCount = totalCount;
  this.dataCount = dataCount;
}

QRRSBlock.RS_BLOCK_TABLE = [[1, 26, 19], [1, 26, 16], [1, 26, 13], [1, 26, 9], [1, 44, 34], [1, 44, 28], [1, 44, 22], [1, 44, 16], [1, 70, 55], [1, 70, 44], [2, 35, 17], [2, 35, 13], [1, 100, 80], [2, 50, 32], [2, 50, 24], [4, 25, 9], [1, 134, 108], [2, 67, 43], [2, 33, 15, 2, 34, 16], [2, 33, 11, 2, 34, 12], [2, 86, 68], [4, 43, 27], [4, 43, 19], [4, 43, 15], [2, 98, 78], [4, 49, 31], [2, 32, 14, 4, 33, 15], [4, 39, 13, 1, 40, 14], [2, 121, 97], [2, 60, 38, 2, 61, 39], [4, 40, 18, 2, 41, 19], [4, 40, 14, 2, 41, 15], [2, 146, 116], [3, 58, 36, 2, 59, 37], [4, 36, 16, 4, 37, 17], [4, 36, 12, 4, 37, 13], [2, 86, 68, 2, 87, 69], [4, 69, 43, 1, 70, 44], [6, 43, 19, 2, 44, 20], [6, 43, 15, 2, 44, 16], [4, 101, 81], [1, 80, 50, 4, 81, 51], [4, 50, 22, 4, 51, 23], [3, 36, 12, 8, 37, 13], [2, 116, 92, 2, 117, 93], [6, 58, 36, 2, 59, 37], [4, 46, 20, 6, 47, 21], [7, 42, 14, 4, 43, 15], [4, 133, 107], [8, 59, 37, 1, 60, 38], [8, 44, 20, 4, 45, 21], [12, 33, 11, 4, 34, 12], [3, 145, 115, 1, 146, 116], [4, 64, 40, 5, 65, 41], [11, 36, 16, 5, 37, 17], [11, 36, 12, 5, 37, 13], [5, 109, 87, 1, 110, 88], [5, 65, 41, 5, 66, 42], [5, 54, 24, 7, 55, 25], [11, 36, 12], [5, 122, 98, 1, 123, 99], [7, 73, 45, 3, 74, 46], [15, 43, 19, 2, 44, 20], [3, 45, 15, 13, 46, 16], [1, 135, 107, 5, 136, 108], [10, 74, 46, 1, 75, 47], [1, 50, 22, 15, 51, 23], [2, 42, 14, 17, 43, 15], [5, 150, 120, 1, 151, 121], [9, 69, 43, 4, 70, 44], [17, 50, 22, 1, 51, 23], [2, 42, 14, 19, 43, 15], [3, 141, 113, 4, 142, 114], [3, 70, 44, 11, 71, 45], [17, 47, 21, 4, 48, 22], [9, 39, 13, 16, 40, 14], [3, 135, 107, 5, 136, 108], [3, 67, 41, 13, 68, 42], [15, 54, 24, 5, 55, 25], [15, 43, 15, 10, 44, 16], [4, 144, 116, 4, 145, 117], [17, 68, 42], [17, 50, 22, 6, 51, 23], [19, 46, 16, 6, 47, 17], [2, 139, 111, 7, 140, 112], [17, 74, 46], [7, 54, 24, 16, 55, 25], [34, 37, 13], [4, 151, 121, 5, 152, 122], [4, 75, 47, 14, 76, 48], [11, 54, 24, 14, 55, 25], [16, 45, 15, 14, 46, 16], [6, 147, 117, 4, 148, 118], [6, 73, 45, 14, 74, 46], [11, 54, 24, 16, 55, 25], [30, 46, 16, 2, 47, 17], [8, 132, 106, 4, 133, 107], [8, 75, 47, 13, 76, 48], [7, 54, 24, 22, 55, 25], [22, 45, 15, 13, 46, 16], [10, 142, 114, 2, 143, 115], [19, 74, 46, 4, 75, 47], [28, 50, 22, 6, 51, 23], [33, 46, 16, 4, 47, 17], [8, 152, 122, 4, 153, 123], [22, 73, 45, 3, 74, 46], [8, 53, 23, 26, 54, 24], [12, 45, 15, 28, 46, 16], [3, 147, 117, 10, 148, 118], [3, 73, 45, 23, 74, 46], [4, 54, 24, 31, 55, 25], [11, 45, 15, 31, 46, 16], [7, 146, 116, 7, 147, 117], [21, 73, 45, 7, 74, 46], [1, 53, 23, 37, 54, 24], [19, 45, 15, 26, 46, 16], [5, 145, 115, 10, 146, 116], [19, 75, 47, 10, 76, 48], [15, 54, 24, 25, 55, 25], [23, 45, 15, 25, 46, 16], [13, 145, 115, 3, 146, 116], [2, 74, 46, 29, 75, 47], [42, 54, 24, 1, 55, 25], [23, 45, 15, 28, 46, 16], [17, 145, 115], [10, 74, 46, 23, 75, 47], [10, 54, 24, 35, 55, 25], [19, 45, 15, 35, 46, 16], [17, 145, 115, 1, 146, 116], [14, 74, 46, 21, 75, 47], [29, 54, 24, 19, 55, 25], [11, 45, 15, 46, 46, 16], [13, 145, 115, 6, 146, 116], [14, 74, 46, 23, 75, 47], [44, 54, 24, 7, 55, 25], [59, 46, 16, 1, 47, 17], [12, 151, 121, 7, 152, 122], [12, 75, 47, 26, 76, 48], [39, 54, 24, 14, 55, 25], [22, 45, 15, 41, 46, 16], [6, 151, 121, 14, 152, 122], [6, 75, 47, 34, 76, 48], [46, 54, 24, 10, 55, 25], [2, 45, 15, 64, 46, 16], [17, 152, 122, 4, 153, 123], [29, 74, 46, 14, 75, 47], [49, 54, 24, 10, 55, 25], [24, 45, 15, 46, 46, 16], [4, 152, 122, 18, 153, 123], [13, 74, 46, 32, 75, 47], [48, 54, 24, 14, 55, 25], [42, 45, 15, 32, 46, 16], [20, 147, 117, 4, 148, 118], [40, 75, 47, 7, 76, 48], [43, 54, 24, 22, 55, 25], [10, 45, 15, 67, 46, 16], [19, 148, 118, 6, 149, 119], [18, 75, 47, 31, 76, 48], [34, 54, 24, 34, 55, 25], [20, 45, 15, 61, 46, 16]];
QRRSBlock.getRSBlocks = function (typeNumber, errorCorrectLevel) {
  var rsBlock = QRRSBlock.getRsBlockTable(typeNumber, errorCorrectLevel);
  if (rsBlock == undefined) {
    throw new Error("bad rs block @ typeNumber:" + typeNumber + "/errorCorrectLevel:" + errorCorrectLevel);
  }
  var length = rsBlock.length / 3;
  var list = [];
  for (var i = 0; i < length; i++) {
    var count = rsBlock[i * 3 + 0];
    var totalCount = rsBlock[i * 3 + 1];
    var dataCount = rsBlock[i * 3 + 2];
    for (var j = 0; j < count; j++) {
      list.push(new QRRSBlock(totalCount, dataCount));
    }
  }
  return list;
};
QRRSBlock.getRsBlockTable = function (typeNumber, errorCorrectLevel) {
  switch (errorCorrectLevel) {
    case QRErrorCorrectLevel.L:
      return QRRSBlock.RS_BLOCK_TABLE[(typeNumber - 1) * 4 + 0];
    case QRErrorCorrectLevel.M:
      return QRRSBlock.RS_BLOCK_TABLE[(typeNumber - 1) * 4 + 1];
    case QRErrorCorrectLevel.Q:
      return QRRSBlock.RS_BLOCK_TABLE[(typeNumber - 1) * 4 + 2];
    case QRErrorCorrectLevel.H:
      return QRRSBlock.RS_BLOCK_TABLE[(typeNumber - 1) * 4 + 3];
    default:
      return undefined;
  }
};
function QRBitBuffer() {
  this.buffer = [];
  this.length = 0;
}

QRBitBuffer.prototype = {
  get: function get(index) {
    var bufIndex = Math.floor(index / 8);
    return (this.buffer[bufIndex] >>> 7 - index % 8 & 1) == 1;
  }, put: function put(num, length) {
    for (var i = 0; i < length; i++) {
      this.putBit((num >>> length - i - 1 & 1) == 1);
    }
  }, getLengthInBits: function getLengthInBits() {
    return this.length;
  }, putBit: function putBit(bit) {
    var bufIndex = Math.floor(this.length / 8);
    if (this.buffer.length <= bufIndex) {
      this.buffer.push(0);
    }
    if (bit) {
      this.buffer[bufIndex] |= 0x80 >>> this.length % 8;
    }
    this.length++;
  }
};
var QRCodeLimitLength = [[17, 14, 11, 7], [32, 26, 20, 14], [53, 42, 32, 24], [78, 62, 46, 34], [106, 84, 60, 44], [134, 106, 74, 58], [154, 122, 86, 64], [192, 152, 108, 84], [230, 180, 130, 98], [271, 213, 151, 119], [321, 251, 177, 137], [367, 287, 203, 155], [425, 331, 241, 177], [458, 362, 258, 194], [520, 412, 292, 220], [586, 450, 322, 250], [644, 504, 364, 280], [718, 560, 394, 310], [792, 624, 442, 338], [858, 666, 482, 382], [929, 711, 509, 403], [1003, 779, 565, 439], [1091, 857, 611, 461], [1171, 911, 661, 511], [1273, 997, 715, 535], [1367, 1059, 751, 593], [1465, 1125, 805, 625], [1528, 1190, 868, 658], [1628, 1264, 908, 698], [1732, 1370, 982, 742], [1840, 1452, 1030, 790], [1952, 1538, 1112, 842], [2068, 1628, 1168, 898], [2188, 1722, 1228, 958], [2303, 1809, 1283, 983], [2431, 1911, 1351, 1051], [2563, 1989, 1423, 1093], [2699, 2099, 1499, 1139], [2809, 2213, 1579, 1219], [2953, 2331, 1663, 1273]];

// android 2.x doesn't support Data-URI spec
function _getAndroid() {
  var android = false;
  var sAgent = navigator.userAgent;

  if (/android/i.test(sAgent)) {
    // android
    android = true;
    var aMat = sAgent.toString().match(/android ([0-9]\.[0-9])/i);

    if (aMat && aMat[1]) {
      android = parseFloat(aMat[1]);
    }
  }

  return android;
}

// Drawing in DOM by using Table tag
var Drawing = function () {
  // Drawing in Canvas
  function _onMakeImage() {
    var src = this._elCanvas.toDataURL("image/png");
    this._htOption.title && console.log(this._htOption.title);
    console.log('%c', "padding:75px 80px 75px;line-height:160px;background:url(" + src + ") no-repeat;background-size:160px");
  }

  /**
   * Check whether the user's browser supports Data URI or not
   *
   * @private
   * @param {Function} fSuccess Occurs if it supports Data URI
   * @param {Function} fFail Occurs if it doesn't support Data URI
   */
  function _safeSetDataURI(fSuccess, fFail) {
    var self = this;
    self._fFail = fFail;
    self._fSuccess = fSuccess;

    // Check it just once
    if (self._bSupportDataURI === null) {
      var el = document.createElement("img");
      var fOnError = function fOnError() {
        self._bSupportDataURI = false;

        if (self._fFail) {
          self._fFail.call(self);
        }
      };
      var fOnSuccess = function fOnSuccess() {
        self._bSupportDataURI = true;

        if (self._fSuccess) {
          self._fSuccess.call(self);
        }
      };

      el.onabort = fOnError;
      el.onerror = fOnError;
      el.onload = fOnSuccess;
      el.src = "data:image/gif;base64,iVBORw0KGgoAAAANSUhEUgAAAAUAAAAFCAYAAACNbyblAAAAHElEQVQI12P4//8/w38GIAXDIBKE0DHxgljNBAAO9TXL0Y4OHwAAAABJRU5ErkJggg=="; // the Image contains 1px data.
      return;
    } else if (self._bSupportDataURI === true && self._fSuccess) {
      self._fSuccess.call(self);
    } else if (self._bSupportDataURI === false && self._fFail) {
      self._fFail.call(self);
    }
  };

  /**
   * Drawing QRCode by using canvas
   *
   * @constructor
   * @param {HTMLElement} el
   * @param {Object} htOption QRCode Options
   */
  var Drawing = function Drawing(htOption) {
    this._bIsPainted = false;
    this._android = _getAndroid();

    this._htOption = htOption;
    this._elCanvas = document.createElement("canvas");
    this._elCanvas.width = htOption.width;
    this._elCanvas.height = htOption.height;
    this._oContext = this._elCanvas.getContext("2d");
    this._bIsPainted = false;
    this._elImage = document.createElement("img");
    this._bSupportDataURI = null;
  };

  /**
   * Draw the QRCode
   *
   * @param {QRCode} oQRCode
   */
  Drawing.prototype.draw = function (oQRCode) {
    var _elImage = this._elImage;
    var _oContext = this._oContext;
    var _htOption = this._htOption;

    var nCount = oQRCode.getModuleCount();
    var nWidth = _htOption.width / nCount;
    var nHeight = _htOption.height / nCount;
    var nRoundedWidth = Math.round(nWidth);
    var nRoundedHeight = Math.round(nHeight);

    _elImage.style.display = "none";
    this.clear();

    for (var row = 0; row < nCount; row++) {
      for (var col = 0; col < nCount; col++) {
        var bIsDark = oQRCode.isDark(row, col);
        var nLeft = col * nWidth;
        var nTop = row * nHeight;
        _oContext.strokeStyle = bIsDark ? _htOption.colorDark : _htOption.colorLight;
        _oContext.lineWidth = 1;
        _oContext.fillStyle = bIsDark ? _htOption.colorDark : _htOption.colorLight;
        _oContext.fillRect(nLeft, nTop, nWidth, nHeight);

        _oContext.strokeRect(Math.floor(nLeft) + 0.5, Math.floor(nTop) + 0.5, nRoundedWidth, nRoundedHeight);

        _oContext.strokeRect(Math.ceil(nLeft) - 0.5, Math.ceil(nTop) - 0.5, nRoundedWidth, nRoundedHeight);
      }
    }
    this._bIsPainted = true;
  };

  /**
   * Make the image from Canvas if the browser supports Data URI.
   */
  Drawing.prototype.makeImage = function () {
    if (this._bIsPainted) {
      _safeSetDataURI.call(this, _onMakeImage);
    }
  };

  /**
   * Return whether the QRCode is painted or not
   *
   * @return {Boolean}
   */
  Drawing.prototype.isPainted = function () {
    return this._bIsPainted;
  };

  /**
   * Clear the QRCode
   */
  Drawing.prototype.clear = function () {
    this._oContext.clearRect(0, 0, this._elCanvas.width, this._elCanvas.height);
    this._bIsPainted = false;
  };

  /**
   * @private
   * @param {Number} nNumber
   */
  Drawing.prototype.round = function (nNumber) {
    if (!nNumber) {
      return nNumber;
    }

    return Math.floor(nNumber * 1000) / 1000;
  };

  return Drawing;
}();

/**
 * Get the type by string length
 *
 * @private
 * @param {String} sText
 * @param {Number} nCorrectLevel
 * @return {Number} type
 */
function _getTypeNumber(sText, nCorrectLevel) {
  var nType = 1;
  var length = _getUTF8Length(sText);

  for (var i = 0, len = QRCodeLimitLength.length; i <= len; i++) {
    var nLimit = 0;

    switch (nCorrectLevel) {
      case QRErrorCorrectLevel.L:
        nLimit = QRCodeLimitLength[i][0];
        break;
      case QRErrorCorrectLevel.M:
        nLimit = QRCodeLimitLength[i][1];
        break;
      case QRErrorCorrectLevel.Q:
        nLimit = QRCodeLimitLength[i][2];
        break;
      case QRErrorCorrectLevel.H:
        nLimit = QRCodeLimitLength[i][3];
        break;
    }

    if (length <= nLimit) {
      break;
    } else {
      nType++;
    }
  }

  if (nType > QRCodeLimitLength.length) {
    throw new Error("Too long data");
  }

  return nType;
}

function _getUTF8Length(sText) {
  var replacedText = encodeURI(sText).toString().replace(/\%[0-9a-fA-F]{2}/g, 'a');
  return replacedText.length + (replacedText.length != sText ? 3 : 0);
}

/**
 * @class QRCode
 * @constructor
 * @example
 * new QRCode(document.getElementById("test"), "http://jindo.dev.naver.com/collie");
 *
 * @example
 * var oQRCode = new QRCode("test", {
	 *    text : "http://naver.com",
	 *    width : 128,
	 *    height : 128
	 * });
 *
 * oQRCode.clear(); // Clear the QRCode.
 * oQRCode.makeCode("http://map.naver.com"); // Re-create the QRCode.
 *
 * @param {HTMLElement|String} el target element or 'id' attribute of element.
 * @param {Object|String} vOption
 * @param {String} vOption.text QRCode link data
 * @param {Number} [vOption.width=256]
 * @param {Number} [vOption.height=256]
 * @param {String} [vOption.colorDark="#000000"]
 * @param {String} [vOption.colorLight="#ffffff"]
 * @param {QRCode.CorrectLevel} [vOption.correctLevel=QRCode.CorrectLevel.H] [L|M|Q|H]
 */
QRCode = function QRCode(vOption) {
  this._htOption = {
    title: null,
    width: 256,
    height: 256,
    typeNumber: 4,
    colorDark: "#000000",
    colorLight: "#ffffff",
    correctLevel: QRErrorCorrectLevel.H
  };

  if (typeof vOption === 'string') {
    vOption = {
      text: vOption
    };
  }

  // Overwrites options
  if (vOption) {
    for (var i in vOption) {
      this._htOption[i] = vOption[i];
    }
  }

  if (typeof el == "string") {
    el = document.getElementById(el);
  }

  this._android = _getAndroid();
  this._oQRCode = null;
  this._oDrawing = new Drawing(this._htOption);

  if (this._htOption.text) {
    this.makeCode(this._htOption.text);
  }
};

/**
 * Make the QRCode
 *
 * @param {String} sText link data
 */
QRCode.prototype.makeCode = function (sText) {
  this._oQRCode = new QRCodeModel(_getTypeNumber(sText, this._htOption.correctLevel), this._htOption.correctLevel);
  this._oQRCode.addData(sText);
  this._oQRCode.make();
  // this._el.title = sText;
  this._oDrawing.draw(this._oQRCode);
  this.makeImage();
};

/**
 * Make the Image from Canvas element
 * - It occurs automatically
 * - Android below 3 doesn't support Data-URI spec.
 *
 * @private
 */
QRCode.prototype.makeImage = function () {
  if (typeof this._oDrawing.makeImage == "function" && (!this._android || this._android >= 3)) {
    this._oDrawing.makeImage();
  }
};

/**
 * Clear the QRCode
 */
QRCode.prototype.clear = function () {
  this._oDrawing.clear();
};

/**
 * @name QRCode.CorrectLevel
 */
QRCode.CorrectLevel = QRErrorCorrectLevel;

exports.default = {
  log: function log(info) {
    if (typeof info === 'string') {
      info = {
        text: info
      };
    }
    info.title || (info.title = '移动端请扫描以下二维码: ' + info.text);
    return new QRCode(info);
  }
};
module.exports = exports["default"];

/***/ }),

/***/ "Y6T+":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

__webpack_require__("p6gR");

var _loadingWaiting = __webpack_require__("Cn5t");

var _loadingWaiting2 = _interopRequireDefault(_loadingWaiting);

var _loadingSuccess = __webpack_require__("L4cK");

var _loadingSuccess2 = _interopRequireDefault(_loadingSuccess);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Loading = {
  show: function show(options) {
    _loadingWaiting2.default.show(options);
  },
  hide: function hide() {
    _loadingWaiting2.default.hide();
  },
  success: function success(el, options) {
    // eslint-disable-next-line
    return new _loadingSuccess2.default(el, options);
  }
};

exports.default = Loading;
module.exports = exports['default'];

/***/ }),

/***/ "YBGw":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
/* eslint-disable */
if (!Date.now) {
  Date.now = function () {
    return new Date().getTime();
  };
}
var vendors = ['ms', 'moz', 'webkit', 'o'];
for (var i = 0; i < vendors.length && !window.requestAnimationFrame; ++i) {
  var vendor = vendors[i];
  window.requestAnimationFrame = window[vendor + 'RequestAnimationFrame'];
  window.cancelAnimationFrame = window[vendor + 'CancelAnimationFrame'] || window[vendor + 'CancelRequestAnimationFrame'];
}
// iOS6 is buggy
if (/iP(ad|hone|od).*OS 6/.test(window.navigator.userAgent) || !window.requestAnimationFrame || !window.cancelAnimationFrame) {
  var lastTime = 0;
  window.requestAnimationFrame = function (callback) {
    var now = Date.now();
    var nextTime = Math.max(lastTime + 16, now);
    return setTimeout(function () {
      callback(lastTime = nextTime);
    }, nextTime - now);
  };
  window.cancelAnimationFrame = clearTimeout;
}

exports.default = {
  requestAnimationFrame: function requestAnimationFrame(callback) {
    return window.requestAnimationFrame(callback);
  },
  cancelAnimationFrame: function cancelAnimationFrame(requestID) {
    return window.cancelAnimationFrame(requestID);
  }
};
module.exports = exports['default'];

/***/ }),

/***/ "YGIn":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _tab = __webpack_require__("hjjS");

var _tab2 = _interopRequireDefault(_tab);

var _loading = __webpack_require__("Y6T+");

var _loading2 = _interopRequireDefault(_loading);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

exports.default = {
  data: function data() {
    return {
      person: {
        name: 'tomy'
      },
      product: {
        name: ''
      },
      desc: {
        name: ''
      },
      list: []
    };
  },

  mounted: function mounted() {
    var self = this;
    this.$nextTick(function () {
      // eslint-disable-next-line
      new _tab2.default('.bx-tab-two', {});
      // eslint-disable-next-line
      new _tab2.default('.bx-tab-three', {
        activeIndex: 1
      });
      // eslint-disable-next-line
      new _tab2.default('.bx-tab-four', {});
      // eslint-disable-next-line
      new _tab2.default('.bx-tab-five', {
        slide: false,
        transition: false
      });
      // eslint-disable-next-line
      new _tab2.default('.bx-tab-six', {
        lineWidth: 15,
        onInit: function onInit() {
          console.log('onInit');
        },
        onSlidePrev: function onSlidePrev() {
          console.log('onSlidePrev');
        },
        onSlideNext: function onSlideNext() {
          console.log('onSlideNext');
        },
        onChange: function onChange(index) {
          console.log('onChange', index);
          switch (index) {
            case 0:
              break;
            case 1:
              self.getProduct();
              break;
            case 2:
              self.getDesc();
              break;
            case 3:
              self.getPerson();
              break;
          }
        },
        onItemClick: function onItemClick(index) {
          console.log('onItemClick', index);
        }
      });
      // eslint-disable-next-line
      new _tab2.default('.bx-tab-single', {
        onChange: function onChange(index) {
          switch (index) {
            case 0:
              self.getList1();
              break;
            case 1:
              self.getList2();
              break;
            case 2:
              self.getList3();
              break;
          }
        }
      });
    });
  },
  methods: {
    getPerson: function getPerson() {
      var self = this;
      _loading2.default.show();
      window.setTimeout(function () {
        self.person.name = 'jerry';
        self.person.age = '23岁';
        _loading2.default.hide();
      }, 500);
    },
    getProduct: function getProduct() {
      var self = this;
      _loading2.default.show();
      window.setTimeout(function () {
        self.product.name = 'mac';
        _loading2.default.hide();
      }, 500);
    },
    getDesc: function getDesc() {
      var self = this;
      _loading2.default.show();
      window.setTimeout(function () {
        self.desc.name = '介绍';
        _loading2.default.hide();
      }, 500);
    },
    getList1: function getList1() {
      var self = this;
      _loading2.default.show();
      window.setTimeout(function () {
        var item = {};
        item.name = '内容一';
        self.list = [];
        self.list.push(item);
        self.list.push(item);
        self.list.push(item);
        _loading2.default.hide();
      }, 500);
    },
    getList2: function getList2() {
      var self = this;
      _loading2.default.show();
      window.setTimeout(function () {
        var item = {};
        item.name = '内容二';
        self.list = [];
        self.list.push(item);
        self.list.push(item);
        self.list.push(item);
        _loading2.default.hide();
      }, 500);
    },
    getList3: function getList3() {
      var self = this;
      _loading2.default.show();
      window.setTimeout(function () {
        var item = {};
        item.name = '内容三';
        self.list = [];
        self.list.push(item);
        self.list.push(item);
        self.list.push(item);
        _loading2.default.hide();
      }, 500);
    }
  }
};
module.exports = exports['default'];

/***/ }),

/***/ "YWdn":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "YaEn":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _vue = __webpack_require__("7+uW");

var _vue2 = _interopRequireDefault(_vue);

var _vueRouter = __webpack_require__("/ocq");

var _vueRouter2 = _interopRequireDefault(_vueRouter);

var _Home = __webpack_require__("j7e0");

var _Home2 = _interopRequireDefault(_Home);

var _Audio = __webpack_require__("AI4d");

var _Audio2 = _interopRequireDefault(_Audio);

var _Loading = __webpack_require__("PGcd");

var _Loading2 = _interopRequireDefault(_Loading);

var _Swiper = __webpack_require__("la1W");

var _Swiper2 = _interopRequireDefault(_Swiper);

var _Tab = __webpack_require__("Nlks");

var _Tab2 = _interopRequireDefault(_Tab);

var _Signature = __webpack_require__("CVwJ");

var _Signature2 = _interopRequireDefault(_Signature);

var _Uploader = __webpack_require__("U+De");

var _Uploader2 = _interopRequireDefault(_Uploader);

var _MessageBox = __webpack_require__("x/Va");

var _MessageBox2 = _interopRequireDefault(_MessageBox);

var _Home3 = __webpack_require__("LVVn");

var _Home4 = _interopRequireDefault(_Home3);

var _Flex = __webpack_require__("5X6r");

var _Flex2 = _interopRequireDefault(_Flex);

var _Panel = __webpack_require__("5Tcv");

var _Panel2 = _interopRequireDefault(_Panel);

var _List = __webpack_require__("9bCY");

var _List2 = _interopRequireDefault(_List);

var _Button = __webpack_require__("SEiN");

var _Button2 = _interopRequireDefault(_Button);

var _Icon = __webpack_require__("d3sS");

var _Icon2 = _interopRequireDefault(_Icon);

var _Form = __webpack_require__("iA4u");

var _Form2 = _interopRequireDefault(_Form);

var _Modal = __webpack_require__("DV5c");

var _Modal2 = _interopRequireDefault(_Modal);

var _Label = __webpack_require__("l8zQ");

var _Label2 = _interopRequireDefault(_Label);

var _Search = __webpack_require__("MPII");

var _Search2 = _interopRequireDefault(_Search);

var _Schedule = __webpack_require__("icP6");

var _Schedule2 = _interopRequireDefault(_Schedule);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_vue2.default.use(_vueRouter2.default);
exports.default = new _vueRouter2.default({
  routes: [{
    path: '/',
    redirect: 'Home'
  }, {
    path: '/home',
    name: 'Home',
    component: _Home2.default
  }, {
    path: '/audio',
    name: 'Audio',
    component: _Audio2.default
  }, {
    path: '/loading',
    name: 'Loading',
    component: _Loading2.default
  }, {
    path: '/swiper',
    name: 'Swiper',
    component: _Swiper2.default
  }, {
    path: '/tab',
    name: 'Tab',
    component: _Tab2.default
  }, {
    path: '/signature',
    name: 'Signature',
    component: _Signature2.default
  }, {
    path: '/uploader',
    name: 'Uploader',
    component: _Uploader2.default
  }, {
    path: '/messagebox',
    name: 'MessageBox',
    component: _MessageBox2.default
  }, {
    path: '/ui',
    component: _Home4.default,
    children: [{
      path: 'flex',
      name: 'UIFlex',
      component: _Flex2.default
    }, {
      path: 'panel',
      name: 'UIPanel',
      component: _Panel2.default
    }, {
      path: 'list',
      name: 'UIList',
      component: _List2.default
    }, {
      path: 'button',
      name: 'UIButton',
      component: _Button2.default
    }, {
      path: 'icon',
      name: 'UIIcon',
      component: _Icon2.default
    }, {
      path: 'form',
      name: 'UIFrom',
      component: _Form2.default
    }, {
      path: 'modal',
      name: 'UIModal',
      component: _Modal2.default
    }, {
      path: 'label',
      name: 'UILabel',
      component: _Label2.default
    }, {
      path: 'search',
      name: 'UISearch',
      component: _Search2.default
    }, {
      path: 'schedule',
      name: 'UISchedule',
      component: _Schedule2.default
    }]
  }]
});
module.exports = exports['default'];

/***/ }),

/***/ "Yhnh":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Yobk":
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
var anObject = __webpack_require__("77Pl");
var dPs = __webpack_require__("qio6");
var enumBugKeys = __webpack_require__("xnc9");
var IE_PROTO = __webpack_require__("ax3d")('IE_PROTO');
var Empty = function () { /* empty */ };
var PROTOTYPE = 'prototype';

// Create object with fake `null` prototype: use iframe Object with cleared prototype
var createDict = function () {
  // Thrash, waste and sodomy: IE GC bug
  var iframe = __webpack_require__("ON07")('iframe');
  var i = enumBugKeys.length;
  var lt = '<';
  var gt = '>';
  var iframeDocument;
  iframe.style.display = 'none';
  __webpack_require__("RPLV").appendChild(iframe);
  iframe.src = 'javascript:'; // eslint-disable-line no-script-url
  // createDict = iframe.contentWindow.Object;
  // html.removeChild(iframe);
  iframeDocument = iframe.contentWindow.document;
  iframeDocument.open();
  iframeDocument.write(lt + 'script' + gt + 'document.F=Object' + lt + '/script' + gt);
  iframeDocument.close();
  createDict = iframeDocument.F;
  while (i--) delete createDict[PROTOTYPE][enumBugKeys[i]];
  return createDict();
};

module.exports = Object.create || function create(O, Properties) {
  var result;
  if (O !== null) {
    Empty[PROTOTYPE] = anObject(O);
    result = new Empty();
    Empty[PROTOTYPE] = null;
    // add "__proto__" for Object.getPrototypeOf polyfill
    result[IE_PROTO] = O;
  } else result = createDict();
  return Properties === undefined ? result : dPs(result, Properties);
};


/***/ }),

/***/ "ZC1W":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "ZsRU":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "ax3d":
/***/ (function(module, exports, __webpack_require__) {

var shared = __webpack_require__("e8AB")('keys');
var uid = __webpack_require__("3Eo+");
module.exports = function (key) {
  return shared[key] || (shared[key] = uid(key));
};


/***/ }),

/***/ "c90P":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "cGG2":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var bind = __webpack_require__("JP+z");
var isBuffer = __webpack_require__("Re3r");

/*global toString:true*/

// utils is a library of generic helper functions non-specific to axios

var toString = Object.prototype.toString;

/**
 * Determine if a value is an Array
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an Array, otherwise false
 */
function isArray(val) {
  return toString.call(val) === '[object Array]';
}

/**
 * Determine if a value is an ArrayBuffer
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an ArrayBuffer, otherwise false
 */
function isArrayBuffer(val) {
  return toString.call(val) === '[object ArrayBuffer]';
}

/**
 * Determine if a value is a FormData
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an FormData, otherwise false
 */
function isFormData(val) {
  return (typeof FormData !== 'undefined') && (val instanceof FormData);
}

/**
 * Determine if a value is a view on an ArrayBuffer
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a view on an ArrayBuffer, otherwise false
 */
function isArrayBufferView(val) {
  var result;
  if ((typeof ArrayBuffer !== 'undefined') && (ArrayBuffer.isView)) {
    result = ArrayBuffer.isView(val);
  } else {
    result = (val) && (val.buffer) && (val.buffer instanceof ArrayBuffer);
  }
  return result;
}

/**
 * Determine if a value is a String
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a String, otherwise false
 */
function isString(val) {
  return typeof val === 'string';
}

/**
 * Determine if a value is a Number
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Number, otherwise false
 */
function isNumber(val) {
  return typeof val === 'number';
}

/**
 * Determine if a value is undefined
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if the value is undefined, otherwise false
 */
function isUndefined(val) {
  return typeof val === 'undefined';
}

/**
 * Determine if a value is an Object
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an Object, otherwise false
 */
function isObject(val) {
  return val !== null && typeof val === 'object';
}

/**
 * Determine if a value is a Date
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Date, otherwise false
 */
function isDate(val) {
  return toString.call(val) === '[object Date]';
}

/**
 * Determine if a value is a File
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a File, otherwise false
 */
function isFile(val) {
  return toString.call(val) === '[object File]';
}

/**
 * Determine if a value is a Blob
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Blob, otherwise false
 */
function isBlob(val) {
  return toString.call(val) === '[object Blob]';
}

/**
 * Determine if a value is a Function
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Function, otherwise false
 */
function isFunction(val) {
  return toString.call(val) === '[object Function]';
}

/**
 * Determine if a value is a Stream
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Stream, otherwise false
 */
function isStream(val) {
  return isObject(val) && isFunction(val.pipe);
}

/**
 * Determine if a value is a URLSearchParams object
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a URLSearchParams object, otherwise false
 */
function isURLSearchParams(val) {
  return typeof URLSearchParams !== 'undefined' && val instanceof URLSearchParams;
}

/**
 * Trim excess whitespace off the beginning and end of a string
 *
 * @param {String} str The String to trim
 * @returns {String} The String freed of excess whitespace
 */
function trim(str) {
  return str.replace(/^\s*/, '').replace(/\s*$/, '');
}

/**
 * Determine if we're running in a standard browser environment
 *
 * This allows axios to run in a web worker, and react-native.
 * Both environments support XMLHttpRequest, but not fully standard globals.
 *
 * web workers:
 *  typeof window -> undefined
 *  typeof document -> undefined
 *
 * react-native:
 *  navigator.product -> 'ReactNative'
 */
function isStandardBrowserEnv() {
  if (typeof navigator !== 'undefined' && navigator.product === 'ReactNative') {
    return false;
  }
  return (
    typeof window !== 'undefined' &&
    typeof document !== 'undefined'
  );
}

/**
 * Iterate over an Array or an Object invoking a function for each item.
 *
 * If `obj` is an Array callback will be called passing
 * the value, index, and complete array for each item.
 *
 * If 'obj' is an Object callback will be called passing
 * the value, key, and complete object for each property.
 *
 * @param {Object|Array} obj The object to iterate
 * @param {Function} fn The callback to invoke for each item
 */
function forEach(obj, fn) {
  // Don't bother if no value provided
  if (obj === null || typeof obj === 'undefined') {
    return;
  }

  // Force an array if not already something iterable
  if (typeof obj !== 'object') {
    /*eslint no-param-reassign:0*/
    obj = [obj];
  }

  if (isArray(obj)) {
    // Iterate over array values
    for (var i = 0, l = obj.length; i < l; i++) {
      fn.call(null, obj[i], i, obj);
    }
  } else {
    // Iterate over object keys
    for (var key in obj) {
      if (Object.prototype.hasOwnProperty.call(obj, key)) {
        fn.call(null, obj[key], key, obj);
      }
    }
  }
}

/**
 * Accepts varargs expecting each argument to be an object, then
 * immutably merges the properties of each object and returns result.
 *
 * When multiple objects contain the same key the later object in
 * the arguments list will take precedence.
 *
 * Example:
 *
 * ```js
 * var result = merge({foo: 123}, {foo: 456});
 * console.log(result.foo); // outputs 456
 * ```
 *
 * @param {Object} obj1 Object to merge
 * @returns {Object} Result of all merge properties
 */
function merge(/* obj1, obj2, obj3, ... */) {
  var result = {};
  function assignValue(val, key) {
    if (typeof result[key] === 'object' && typeof val === 'object') {
      result[key] = merge(result[key], val);
    } else {
      result[key] = val;
    }
  }

  for (var i = 0, l = arguments.length; i < l; i++) {
    forEach(arguments[i], assignValue);
  }
  return result;
}

/**
 * Extends object a by mutably adding to it the properties of object b.
 *
 * @param {Object} a The object to be extended
 * @param {Object} b The object to copy properties from
 * @param {Object} thisArg The object to bind function to
 * @return {Object} The resulting value of object a
 */
function extend(a, b, thisArg) {
  forEach(b, function assignValue(val, key) {
    if (thisArg && typeof val === 'function') {
      a[key] = bind(val, thisArg);
    } else {
      a[key] = val;
    }
  });
  return a;
}

module.exports = {
  isArray: isArray,
  isArrayBuffer: isArrayBuffer,
  isBuffer: isBuffer,
  isFormData: isFormData,
  isArrayBufferView: isArrayBufferView,
  isString: isString,
  isNumber: isNumber,
  isObject: isObject,
  isUndefined: isUndefined,
  isDate: isDate,
  isFile: isFile,
  isBlob: isBlob,
  isFunction: isFunction,
  isStream: isStream,
  isURLSearchParams: isURLSearchParams,
  isStandardBrowserEnv: isStandardBrowserEnv,
  forEach: forEach,
  merge: merge,
  extend: extend,
  trim: trim
};


/***/ }),

/***/ "cGza":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

exports.default = {};
module.exports = exports["default"];

/***/ }),

/***/ "cWxy":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var Cancel = __webpack_require__("dVOP");

/**
 * A `CancelToken` is an object that can be used to request cancellation of an operation.
 *
 * @class
 * @param {Function} executor The executor function.
 */
function CancelToken(executor) {
  if (typeof executor !== 'function') {
    throw new TypeError('executor must be a function.');
  }

  var resolvePromise;
  this.promise = new Promise(function promiseExecutor(resolve) {
    resolvePromise = resolve;
  });

  var token = this;
  executor(function cancel(message) {
    if (token.reason) {
      // Cancellation has already been requested
      return;
    }

    token.reason = new Cancel(message);
    resolvePromise(token.reason);
  });
}

/**
 * Throws a `Cancel` if cancellation has been requested.
 */
CancelToken.prototype.throwIfRequested = function throwIfRequested() {
  if (this.reason) {
    throw this.reason;
  }
};

/**
 * Returns an object that contains a new `CancelToken` and a function that, when called,
 * cancels the `CancelToken`.
 */
CancelToken.source = function source() {
  var cancel;
  var token = new CancelToken(function executor(c) {
    cancel = c;
  });
  return {
    token: token,
    cancel: cancel
  };
};

module.exports = CancelToken;


/***/ }),

/***/ "cr3o":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _swiper = __webpack_require__("8ueD");

var _swiper2 = _interopRequireDefault(_swiper);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  mounted: function mounted() {
    this.$nextTick(function () {
      _swiper2.default.create('.bx-swiper-color', {
        autoplay: false
      });
      _swiper2.default.create('.bx-swiper-page', {
        height: '30%',
        onInit: function onInit() {
          console.log('onInit');
        },
        onTouchStart: function onTouchStart() {
          console.log('onTouchStart');
        },
        onTouchMove: function onTouchMove() {
          console.log('onTouchMove');
        },
        onTouchEnd: function onTouchEnd() {
          console.log('onTouchEnd');
        },
        onSlide: function onSlide() {
          console.log('onSlide');
        },
        onSlidePrev: function onSlidePrev() {
          console.log('onSlidePrev');
        },
        onSlideNext: function onSlideNext() {
          console.log('onSlideNext');
        },
        onTransitionEnd: function onTransitionEnd() {
          console.log('onTransitionEnd');
        }
      });
      _swiper2.default.create('.bx-swiper-image');
      _swiper2.default.create('.bx-swiper-single');
      _swiper2.default.create('.bx-swiper-custom', {
        height: '30%',
        paginationClass: 'ui-swiper-paginations'
      });
    });
  }
}; //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

module.exports = exports['default'];

/***/ }),

/***/ "crlp":
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__("7KvD");
var core = __webpack_require__("FeBl");
var LIBRARY = __webpack_require__("O4g8");
var wksExt = __webpack_require__("Kh4W");
var defineProperty = __webpack_require__("evD5").f;
module.exports = function (name) {
  var $Symbol = core.Symbol || (core.Symbol = LIBRARY ? {} : global.Symbol || {});
  if (name.charAt(0) != '_' && !(name in $Symbol)) defineProperty($Symbol, name, { value: wksExt.f(name) });
};


/***/ }),

/***/ "d3sS":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/views/ui/Icon.vue
var Icon = __webpack_require__("mAdt");
var Icon_default = /*#__PURE__*/__webpack_require__.n(Icon);

// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c3f42fc4","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/ui/Icon.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0,false,false)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"demo-icon"},[_c('div',{staticClass:"demo-icon-list"},[_c('div',{staticClass:"demo-icon-group"},[_c('div',{staticClass:"demo-icon-item"},[_c('i',{staticClass:"bx-icon bx-icon-arrows-up"})]),_vm._v(" "),_c('div',{staticClass:"demo-icon-item"},[_c('i',{staticClass:"bx-icon bx-icon-arrows-right"})]),_vm._v(" "),_c('div',{staticClass:"demo-icon-item"},[_c('i',{staticClass:"bx-icon bx-icon-arrows-down"})]),_vm._v(" "),_c('div',{staticClass:"demo-icon-item"},[_c('i',{staticClass:"bx-icon bx-icon-arrows-left"})])]),_vm._v(" "),_c('div',{staticClass:"demo-icon-group"},[_c('div',{staticClass:"demo-icon-item"},[_c('i',{staticClass:"bx-icon bx-icon-close-circle-line"})]),_vm._v(" "),_c('div',{staticClass:"demo-icon-item"},[_c('i',{staticClass:"bx-icon bx-icon-close-circle-surface"})]),_vm._v(" "),_c('div',{staticClass:"demo-icon-item"},[_c('i',{staticClass:"bx-icon bx-icon-close-line"})]),_vm._v(" "),_c('div',{staticClass:"demo-icon-item"},[_c('i',{staticClass:"bx-icon bx-icon-delete-cell"})])]),_vm._v(" "),_c('div',{staticClass:"demo-icon-group"},[_c('div',{staticClass:"demo-icon-item"},[_c('i',{staticClass:"bx-icon bx-icon-add"})]),_vm._v(" "),_c('div',{staticClass:"demo-icon-item"},[_c('i',{staticClass:"bx-icon bx-icon-add-circle"})]),_vm._v(" "),_c('div',{staticClass:"demo-icon-item"},[_c('i',{staticClass:"bx-icon bx-icon-reduce"})]),_vm._v(" "),_c('div',{staticClass:"demo-icon-item"},[_c('i',{staticClass:"bx-icon bx-icon-reduce-circle"})])]),_vm._v(" "),_c('div',{staticClass:"demo-icon-group"},[_c('div',{staticClass:"demo-icon-item"},[_c('i',{staticClass:"bx-icon bx-icon-choose-done"})]),_vm._v(" "),_c('div',{staticClass:"demo-icon-item"},[_c('i',{staticClass:"bx-icon bx-icon-choose-none"})]),_vm._v(" "),_c('div',{staticClass:"demo-icon-item"},[_c('i',{staticClass:"bx-icon bx-icon-choose-done-line"})]),_vm._v(" "),_c('div',{staticClass:"demo-icon-item"},[_c('i',{staticClass:"bx-icon bx-icon-choose-done-surface"})])]),_vm._v(" "),_c('div',{staticClass:"demo-icon-group"},[_c('div',{staticClass:"demo-icon-item"},[_c('i',{staticClass:"bx-icon bx-icon-more-circle"})]),_vm._v(" "),_c('div',{staticClass:"demo-icon-item"},[_c('i',{staticClass:"bx-icon bx-icon-more"})]),_vm._v(" "),_c('div',{staticClass:"demo-icon-item"},[_c('i',{staticClass:"bx-icon bx-icon-menu"})]),_vm._v(" "),_c('div',{staticClass:"demo-icon-item"},[_c('i',{staticClass:"bx-icon bx-icon-refresh"})])]),_vm._v(" "),_c('div',{staticClass:"demo-icon-group"},[_c('div',{staticClass:"demo-icon-item"},[_c('i',{staticClass:"bx-icon bx-icon-warn"})]),_vm._v(" "),_c('div',{staticClass:"demo-icon-item"},[_c('i',{staticClass:"bx-icon bx-icon-notify"})]),_vm._v(" "),_c('div',{staticClass:"demo-icon-item"},[_c('i',{staticClass:"bx-icon bx-icon-help"})]),_vm._v(" "),_c('div',{staticClass:"demo-icon-item"},[_c('i',{staticClass:"bx-icon bx-icon-search"})])]),_vm._v(" "),_c('div',{staticClass:"demo-icon-group"},[_c('div',{staticClass:"demo-icon-item"},[_c('i',{staticClass:"bx-icon bx-icon-rubbish"})]),_vm._v(" "),_c('div',{staticClass:"demo-icon-item"},[_c('i',{staticClass:"bx-icon bx-icon-image"})]),_vm._v(" "),_c('div',{staticClass:"demo-icon-item"},[_c('i',{staticClass:"bx-icon bx-icon-image-after"})])])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var ui_Icon = (esExports);
// CONCATENATED MODULE: ./src/views/ui/Icon.vue
function injectStyle (ssrContext) {
  __webpack_require__("3BAx")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-c3f42fc4"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  Icon_default.a,
  ui_Icon,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var views_ui_Icon = __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "dIwP":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Determines whether the specified URL is absolute
 *
 * @param {string} url The URL to test
 * @returns {boolean} True if the specified URL is absolute, otherwise false
 */
module.exports = function isAbsoluteURL(url) {
  // A URL is considered absolute if it begins with "<scheme>://" or "//" (protocol-relative URL).
  // RFC 3986 defines scheme name as a sequence of characters beginning with a letter and followed
  // by any combination of letters, digits, plus, period, or hyphen.
  return /^([a-z][a-z\d\+\-\.]*:)?\/\//i.test(url);
};


/***/ }),

/***/ "dSzd":
/***/ (function(module, exports, __webpack_require__) {

var store = __webpack_require__("e8AB")('wks');
var uid = __webpack_require__("3Eo+");
var Symbol = __webpack_require__("7KvD").Symbol;
var USE_SYMBOL = typeof Symbol == 'function';

var $exports = module.exports = function (name) {
  return store[name] || (store[name] =
    USE_SYMBOL && Symbol[name] || (USE_SYMBOL ? Symbol : uid)('Symbol.' + name));
};

$exports.store = store;


/***/ }),

/***/ "dVOP":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * A `Cancel` is an object that is thrown when an operation is canceled.
 *
 * @class
 * @param {string=} message The message.
 */
function Cancel(message) {
  this.message = message;
}

Cancel.prototype.toString = function toString() {
  return 'Cancel' + (this.message ? ': ' + this.message : '');
};

Cancel.prototype.__CANCEL__ = true;

module.exports = Cancel;


/***/ }),

/***/ "e6n0":
/***/ (function(module, exports, __webpack_require__) {

var def = __webpack_require__("evD5").f;
var has = __webpack_require__("D2L2");
var TAG = __webpack_require__("dSzd")('toStringTag');

module.exports = function (it, tag, stat) {
  if (it && !has(it = stat ? it : it.prototype, TAG)) def(it, TAG, { configurable: true, value: tag });
};


/***/ }),

/***/ "e8AB":
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__("7KvD");
var SHARED = '__core-js_shared__';
var store = global[SHARED] || (global[SHARED] = {});
module.exports = function (key) {
  return store[key] || (store[key] = {});
};


/***/ }),

/***/ "ebYN":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
// 嗅探transform可支持的前缀
var _elementStyle = document.createElement('div').style;
var _vendor = function () {
  var vendors = ['t', 'webkitT', 'MozT', 'msT', 'OT'];
  var transform;
  var i = 0;
  var l = vendors.length;
  for (; i < l; i++) {
    transform = vendors[i] + 'ransform';
    if (transform in _elementStyle) return vendors[i].substr(0, vendors[i].length - 1);
  }

  return false;
}();
var _prefixStyle = function _prefixStyle(style) {
  if (_vendor === false) return false;
  if (_vendor === '') return style;
  return _vendor + style.charAt(0).toUpperCase() + style.substr(1);
};

var transition = {
  prefixStyle: _prefixStyle,
  transform: _prefixStyle('transform'),
  transformProperty: _prefixStyle('transitionProperty'),
  transitionDuration: _prefixStyle('transitionDuration'),
  transitionTimingFunction: _prefixStyle('transitionTimingFunction'),
  // 设置transition属性
  setProperty: function setProperty(obj, property) {
    obj.style[_prefixStyle('transitionProperty')] = property;
  },
  // 页面滑动到指定位置
  setTransform: function setTransform(obj, x, y) {
    obj.style[_prefixStyle('transform')] = 'translate3d(' + x + 'px,' + y + 'px, 0px)';
  },
  // 设置transition间隔时间
  setDuration: function setDuration(obj, time) {
    obj.style[_prefixStyle('transitionDuration')] = time + 'ms';
  },
  // 设置scale
  setScale: function setScale(obj, scale) {
    obj.style[_prefixStyle('transform')] = 'scale(' + scale + ')';
  },
  // 设置transition的动画贝塞尔曲线
  setTimingFunction: function setTimingFunction(obj, easing) {
    obj.style[_prefixStyle('transitionTimingFunction')] = easing;
  }
};
exports.default = transition;
module.exports = exports['default'];

/***/ }),

/***/ "es6P":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

__webpack_require__("ZsRU");

var _utils = __webpack_require__("Nvt7");

var _utils2 = _interopRequireDefault(_utils);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var eStart = _utils2.default.support.touch ? 'touchstart' : 'mousedown';
var eMove = _utils2.default.support.touch ? 'touchmove' : 'mousemove';
var eEnd = _utils2.default.support.touch ? 'touchend' : 'mouseup';

// 记录页面上所有的音频播放器
window.audioArr = [];
// 暂停所有正在播放的音频
window.pausePlayingAudio = function () {
  for (var i = 0; i < window.audioArr.length; i++) {
    if (_utils2.default.hasClass(window.audioArr[i].player, 'audio-playing')) {
      window.audioArr[i].audio.pause();
      _utils2.default.removeClass(window.audioArr[i].player, 'audio-playing');
    }
  }
};

var audioPlayer = function audioPlayer(element, options) {
  this.element = typeof element === 'string' ? document.querySelector(element) : element;
  this.settings = {
    debug: false
  };
  for (var i in options) {
    this.settings[i] = options[i];
  }
  this.init();
};

audioPlayer.prototype = {
  init: function init() {
    var self = this;

    // 如果不是audio标签,则不再往下执行
    if (this.element.tagName.toLowerCase() !== 'audio') {
      return false;
    }

    if (self.settings.debug) {
      _utils2.default._createDebug();
    }

    self.initAudio();
    self.audio = this.element;
    self.createBufferedTimer();
    self.player = self.createPlayer();

    self.timeCurrent.innerText = self.secondsToTime(0);
    self.timeTotal.innerText = self.secondsToTime(0);
    self.element.parentNode.appendChild(self.player);
    self.element.parentNode.removeChild(self.element);
    self.eventAttach();

    window.audioArr.push({
      audio: self.audio,
      player: self.player
    });
  },
  // 初始化音频参数
  initAudio: function initAudio() {
    var self = this;
    var $this = self.element;
    self.audioFile = $this.getAttribute('src');
    // 暂时未有使用,待完善
    // self.isAutoPlay = $this.getAttribute('autoplay');
    // self.isAutoPlay = self.isAutoPlay === '' || self.isAutoPlay === 'autoplay' ? true : false;
    // self.isLoop = $this.getAttribute('loop');
    // self.isLoop = self.isLoop === '' || self.isLoop === 'loop' ? true : false;
    // 暂时未有使用,待完善
    self.isSupport = false;
    if (typeof self.audioFile === 'undefined') {
      $this.getElementsByTagName('source').each(function () {
        self.audioFile = this.getAttribute('src');
      });
    }
  },
  // 创建自定义样式播放器
  createPlayer: function createPlayer() {
    var self = this;
    var html = '';
    html += '<div class="audio-switch">';
    html += '<i class="icon-audio-switch"></i>';
    html += '</div>';
    html += '<div class="audio-detail">';
    if (self.settings.title) {
      html += '<h3 class="audio-detail-title">' + self.settings.title + '</h3>';
    }
    if (self.settings.tips) {
      html += '<p class="audio-detail-tips">' + self.settings.tips + '</p>';
    }
    html += '<div class="audio-progress-wrap">';
    html += '<div class="audio-progress">';
    html += '<div class="audio-progress-buffer"></div>';
    html += '<div class="audio-progress-playing"></div>';
    html += '</div>';
    html += '<div class="audio-progress-handler"><div class="audio-handler-circle"></div></div>';
    html += '</div>';
    html += '<div class="audio-length">';
    html += '<p class="audio-length-current">00:00</p>';
    html += '<p class="audio-length-total">00:00</p>';
    html += '</div>';
    html += '</div>';

    var player = document.createElement('div');
    player.className = 'audio-wrap';
    player.innerHTML = html;

    self.theBar = player.querySelector('.audio-progress-wrap');
    self.barPlaying = player.querySelector('.audio-progress-playing');
    self.barBuffer = player.querySelector('.audio-progress-buffer');
    self.barHandler = player.querySelector('.audio-progress-handler');
    self.timeCurrent = player.querySelector('.audio-length-current');
    self.timeTotal = player.querySelector('.audio-length-total');

    if (self.settings.title && self.settings.tips) {
      // 不做处理
    } else if (!self.settings.title && !self.settings.tips) {
      player.querySelector('.audio-detail').style.marginTop = '22px';
    } else if (self.settings.title && !self.settings.tips) {
      player.querySelector('.audio-detail').style.marginTop = '-7px';
    } else if (!self.settings.title && self.settings.tips) {
      player.querySelector('.audio-detail').style.marginTop = '6px';
    }

    return player;
  },
  // 创建缓冲进度条定时器
  createBufferedTimer: function createBufferedTimer() {
    // readyState状态值
    // 0 = HAVE_NOTHING - 没有关于音频/视频是否就绪的信息
    // 1 = HAVE_METADATA - 关于音频/视频就绪的元数据
    // 2 = HAVE_CURRENT_DATA - 关于当前播放位置的数据是可用的，但没有足够的数据来播放下一帧/毫秒
    // 3 = HAVE_FUTURE_DATA - 当前及至少下一帧的数据是可用的
    // 4 = HAVE_ENOUGH_DATA - 可用数据足以开始播放

    var self = this;
    if (!self.bufferedTimer) {
      self.bufferedTimer = setInterval(function () {
        if (self.audio.buffered && self.audio.duration && self.audio.readyState >= 3) {
          self.barBuffer.style.width = self.audio.buffered.end(0) / self.audio.duration * 100 + '%';
          if (self.audio.buffered.end(0) >= self.audio.duration) {
            clearInterval(self.bufferedTimer);
            self.bufferedTimer = null;
          }
        }
      }, 200);
    }
  },
  // 事件绑定
  eventAttach: function eventAttach() {
    var self = this;

    // Chrome事件顺序: loadedmetadata(duration开始有值)、loadeddata
    // Chrome点击播放: play、playing、timeupdate
    // chrome点击暂停: pause
    // Chrome结束播放: ended

    // IOS事件顺序: loadedmetadata(duration开始有值)
    // IOS点击播放: play、loadeddata(仅第一次)、playing、timeupdate
    // IOS点击暂停: pause
    // IOS结束播放: ended

    // Android事件顺序:loadedmetadata(部分duration开始有值,Galaxy Note3 Lite 4G 4.3)、loadeddata、timeupdate
    // Android点击播放: play、playing、timeupdate(部分duration开始有值,vivo X5S L 4.4.4)
    // Android点击暂停: pause
    // Android结束播放: ended

    // 当元数据（比如分辨率和时长）被加载时运行的脚本。
    self.audio.addEventListener('loadedmetadata', function () {
      self.settings.debug && _utils2.default._appendDebug('p', 'loadedmetadata' + self.audio.duration);
      self.setTimeTotal(self.audio.duration);
    });
    // 当媒介数据已加载时运行的脚本。
    self.audio.addEventListener('loadeddata', function () {
      self.settings.debug && _utils2.default._appendDebug('p', 'loadeddata' + self.audio.duration);
      self.setTimeTotal(self.audio.duration);
    });
    // 当媒介已开始播放时运行的脚本。
    self.audio.addEventListener('playing', function () {
      self.settings.debug && _utils2.default._appendDebug('p', 'playing' + self.audio.duration);
      self.setTimeTotal(self.audio.duration);
    });
    // 当播放位置改变时（比如当用户快进到媒介中一个不同的位置时）运行的脚本。
    self.audio.addEventListener('timeupdate', function () {
      self.setTimeTotal(self.audio.duration);
      self.timeCurrent.innerText = self.secondsToTime(self.audio.currentTime);
      var percentage = self.audio.currentTime / self.audio.duration * 100 + '%';
      self.barPlaying.style.width = percentage;
      self.barHandler.style.left = percentage;
    });
    // 当媒介已到达结尾时运行的脚本（可发送类似“感谢观看”之类的消息）。
    self.audio.addEventListener('ended', function () {
      self.settings.debug && _utils2.default._appendDebug('p', 'ended');
      _utils2.default.removeClass(self.player, 'audio-playing');
      if (self.settings.autoplay && window.audioArr.length > self.settings.index + 1) {
        window.pausePlayingAudio();
        _utils2.default.addClass(window.audioArr[self.settings.index + 1].player, 'audio-playing');
        window.audioArr[self.settings.index + 1].audio.play();
      }
    });
    // 当媒介已就绪可以开始播放时运行的脚本。
    self.audio.addEventListener('play', function () {
      self.settings.debug && _utils2.default._appendDebug('p', 'play');
    });
    // 当媒介被用户或程序暂停时运行的脚本。
    self.audio.addEventListener('pause', function () {
      self.settings.debug && _utils2.default._appendDebug('p', 'pause');
    });

    self.theBar.addEventListener(eStart, function (e) {
      self.adjustCurrentTime(e);
      self.theBar.addEventListener(eMove, function (e) {
        self.adjustCurrentTime(e);
      });
    });
    self.theBar.addEventListener(eEnd, function () {
      self.theBar.removeEventListener(eMove, null);
    });

    self.barHandler.addEventListener(eStart, function (e) {
      self.barHandler.addEventListener(eMove, function (e) {
        self.adjustCurrentTime(e);
        // 阻止事件冒泡到theBar move事件上
        // 如不加会在IOS 8会产生影响,导致无法滑动
        e.preventDefault();
        e.stopPropagation();
      });
    });
    self.barHandler.addEventListener(eEnd, function () {
      self.barHandler.removeEventListener(eMove, null);
    });

    self.player.querySelector('.audio-switch').addEventListener('click', function () {
      if (_utils2.default.hasClass(self.player, 'audio-playing')) {
        _utils2.default.removeClass(self.player, 'audio-playing');
        self.audio.pause();
      } else {
        window.pausePlayingAudio();
        _utils2.default.addClass(self.player, 'audio-playing');
        self.audio.play();
      }
    });
  },
  // 调节当前播放时间
  adjustCurrentTime: function adjustCurrentTime(e) {
    var self = this;
    if (e.originalEvent) e = e.originalEvent;
    var theRealEvent = _utils2.default.support.touch ? e.touches[0] : e;
    self.audio.currentTime = Math.round(self.audio.duration * (theRealEvent.pageX - self.theBar.offsetLeft) / self.theBar.clientWidth);
  },
  // 设置总时间
  setTimeTotal: function setTimeTotal(duration) {
    var self = this;
    if (duration > 0 && !self.timeTotal.getAttribute('duration')) {
      self.timeTotal.setAttribute('duration', duration);
      self.timeTotal.innerText = self.secondsToTime(self.audio.duration);
    }
  },
  // 将秒转换成固定格式的时间
  secondsToTime: function secondsToTime(secs) {
    var hours = Math.floor(secs / 3600);
    var minutes = Math.floor(secs % 3600 / 60);
    var seconds = Math.ceil(secs % 3600 % 60);
    return (hours === 0 ? '' : hours > 0 && hours.toString().length < 2 ? '0' + hours + ':' : hours + ':') + (minutes.toString().length < 2 ? '0' + minutes : minutes) + ':' + (seconds.toString().length < 2 ? '0' + seconds : seconds);
  },
  // android 兼容性有问题,需要优化
  canPlayType: function canPlayType(file) {
    var audioElement = document.createElement('audio');
    return !!(audioElement.canPlayType && audioElement.canPlayType('audio/' + file.split('.').pop().toLowerCase() + ';').replace(/no/, ''));
  }
};
exports.default = audioPlayer;
module.exports = exports['default'];

/***/ }),

/***/ "evD5":
/***/ (function(module, exports, __webpack_require__) {

var anObject = __webpack_require__("77Pl");
var IE8_DOM_DEFINE = __webpack_require__("SfB7");
var toPrimitive = __webpack_require__("MmMw");
var dP = Object.defineProperty;

exports.f = __webpack_require__("+E39") ? Object.defineProperty : function defineProperty(O, P, Attributes) {
  anObject(O);
  P = toPrimitive(P, true);
  anObject(Attributes);
  if (IE8_DOM_DEFINE) try {
    return dP(O, P, Attributes);
  } catch (e) { /* empty */ }
  if ('get' in Attributes || 'set' in Attributes) throw TypeError('Accessors not supported!');
  if ('value' in Attributes) O[P] = Attributes.value;
  return O;
};


/***/ }),

/***/ "fWfb":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// ECMAScript 6 symbols shim
var global = __webpack_require__("7KvD");
var has = __webpack_require__("D2L2");
var DESCRIPTORS = __webpack_require__("+E39");
var $export = __webpack_require__("kM2E");
var redefine = __webpack_require__("880/");
var META = __webpack_require__("06OY").KEY;
var $fails = __webpack_require__("S82l");
var shared = __webpack_require__("e8AB");
var setToStringTag = __webpack_require__("e6n0");
var uid = __webpack_require__("3Eo+");
var wks = __webpack_require__("dSzd");
var wksExt = __webpack_require__("Kh4W");
var wksDefine = __webpack_require__("crlp");
var enumKeys = __webpack_require__("Xc4G");
var isArray = __webpack_require__("7UMu");
var anObject = __webpack_require__("77Pl");
var toIObject = __webpack_require__("TcQ7");
var toPrimitive = __webpack_require__("MmMw");
var createDesc = __webpack_require__("X8DO");
var _create = __webpack_require__("Yobk");
var gOPNExt = __webpack_require__("Rrel");
var $GOPD = __webpack_require__("LKZe");
var $DP = __webpack_require__("evD5");
var $keys = __webpack_require__("lktj");
var gOPD = $GOPD.f;
var dP = $DP.f;
var gOPN = gOPNExt.f;
var $Symbol = global.Symbol;
var $JSON = global.JSON;
var _stringify = $JSON && $JSON.stringify;
var PROTOTYPE = 'prototype';
var HIDDEN = wks('_hidden');
var TO_PRIMITIVE = wks('toPrimitive');
var isEnum = {}.propertyIsEnumerable;
var SymbolRegistry = shared('symbol-registry');
var AllSymbols = shared('symbols');
var OPSymbols = shared('op-symbols');
var ObjectProto = Object[PROTOTYPE];
var USE_NATIVE = typeof $Symbol == 'function';
var QObject = global.QObject;
// Don't use setters in Qt Script, https://github.com/zloirock/core-js/issues/173
var setter = !QObject || !QObject[PROTOTYPE] || !QObject[PROTOTYPE].findChild;

// fallback for old Android, https://code.google.com/p/v8/issues/detail?id=687
var setSymbolDesc = DESCRIPTORS && $fails(function () {
  return _create(dP({}, 'a', {
    get: function () { return dP(this, 'a', { value: 7 }).a; }
  })).a != 7;
}) ? function (it, key, D) {
  var protoDesc = gOPD(ObjectProto, key);
  if (protoDesc) delete ObjectProto[key];
  dP(it, key, D);
  if (protoDesc && it !== ObjectProto) dP(ObjectProto, key, protoDesc);
} : dP;

var wrap = function (tag) {
  var sym = AllSymbols[tag] = _create($Symbol[PROTOTYPE]);
  sym._k = tag;
  return sym;
};

var isSymbol = USE_NATIVE && typeof $Symbol.iterator == 'symbol' ? function (it) {
  return typeof it == 'symbol';
} : function (it) {
  return it instanceof $Symbol;
};

var $defineProperty = function defineProperty(it, key, D) {
  if (it === ObjectProto) $defineProperty(OPSymbols, key, D);
  anObject(it);
  key = toPrimitive(key, true);
  anObject(D);
  if (has(AllSymbols, key)) {
    if (!D.enumerable) {
      if (!has(it, HIDDEN)) dP(it, HIDDEN, createDesc(1, {}));
      it[HIDDEN][key] = true;
    } else {
      if (has(it, HIDDEN) && it[HIDDEN][key]) it[HIDDEN][key] = false;
      D = _create(D, { enumerable: createDesc(0, false) });
    } return setSymbolDesc(it, key, D);
  } return dP(it, key, D);
};
var $defineProperties = function defineProperties(it, P) {
  anObject(it);
  var keys = enumKeys(P = toIObject(P));
  var i = 0;
  var l = keys.length;
  var key;
  while (l > i) $defineProperty(it, key = keys[i++], P[key]);
  return it;
};
var $create = function create(it, P) {
  return P === undefined ? _create(it) : $defineProperties(_create(it), P);
};
var $propertyIsEnumerable = function propertyIsEnumerable(key) {
  var E = isEnum.call(this, key = toPrimitive(key, true));
  if (this === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key)) return false;
  return E || !has(this, key) || !has(AllSymbols, key) || has(this, HIDDEN) && this[HIDDEN][key] ? E : true;
};
var $getOwnPropertyDescriptor = function getOwnPropertyDescriptor(it, key) {
  it = toIObject(it);
  key = toPrimitive(key, true);
  if (it === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key)) return;
  var D = gOPD(it, key);
  if (D && has(AllSymbols, key) && !(has(it, HIDDEN) && it[HIDDEN][key])) D.enumerable = true;
  return D;
};
var $getOwnPropertyNames = function getOwnPropertyNames(it) {
  var names = gOPN(toIObject(it));
  var result = [];
  var i = 0;
  var key;
  while (names.length > i) {
    if (!has(AllSymbols, key = names[i++]) && key != HIDDEN && key != META) result.push(key);
  } return result;
};
var $getOwnPropertySymbols = function getOwnPropertySymbols(it) {
  var IS_OP = it === ObjectProto;
  var names = gOPN(IS_OP ? OPSymbols : toIObject(it));
  var result = [];
  var i = 0;
  var key;
  while (names.length > i) {
    if (has(AllSymbols, key = names[i++]) && (IS_OP ? has(ObjectProto, key) : true)) result.push(AllSymbols[key]);
  } return result;
};

// 19.4.1.1 Symbol([description])
if (!USE_NATIVE) {
  $Symbol = function Symbol() {
    if (this instanceof $Symbol) throw TypeError('Symbol is not a constructor!');
    var tag = uid(arguments.length > 0 ? arguments[0] : undefined);
    var $set = function (value) {
      if (this === ObjectProto) $set.call(OPSymbols, value);
      if (has(this, HIDDEN) && has(this[HIDDEN], tag)) this[HIDDEN][tag] = false;
      setSymbolDesc(this, tag, createDesc(1, value));
    };
    if (DESCRIPTORS && setter) setSymbolDesc(ObjectProto, tag, { configurable: true, set: $set });
    return wrap(tag);
  };
  redefine($Symbol[PROTOTYPE], 'toString', function toString() {
    return this._k;
  });

  $GOPD.f = $getOwnPropertyDescriptor;
  $DP.f = $defineProperty;
  __webpack_require__("n0T6").f = gOPNExt.f = $getOwnPropertyNames;
  __webpack_require__("NpIQ").f = $propertyIsEnumerable;
  __webpack_require__("1kS7").f = $getOwnPropertySymbols;

  if (DESCRIPTORS && !__webpack_require__("O4g8")) {
    redefine(ObjectProto, 'propertyIsEnumerable', $propertyIsEnumerable, true);
  }

  wksExt.f = function (name) {
    return wrap(wks(name));
  };
}

$export($export.G + $export.W + $export.F * !USE_NATIVE, { Symbol: $Symbol });

for (var es6Symbols = (
  // 19.4.2.2, 19.4.2.3, 19.4.2.4, 19.4.2.6, 19.4.2.8, 19.4.2.9, 19.4.2.10, 19.4.2.11, 19.4.2.12, 19.4.2.13, 19.4.2.14
  'hasInstance,isConcatSpreadable,iterator,match,replace,search,species,split,toPrimitive,toStringTag,unscopables'
).split(','), j = 0; es6Symbols.length > j;)wks(es6Symbols[j++]);

for (var wellKnownSymbols = $keys(wks.store), k = 0; wellKnownSymbols.length > k;) wksDefine(wellKnownSymbols[k++]);

$export($export.S + $export.F * !USE_NATIVE, 'Symbol', {
  // 19.4.2.1 Symbol.for(key)
  'for': function (key) {
    return has(SymbolRegistry, key += '')
      ? SymbolRegistry[key]
      : SymbolRegistry[key] = $Symbol(key);
  },
  // 19.4.2.5 Symbol.keyFor(sym)
  keyFor: function keyFor(sym) {
    if (!isSymbol(sym)) throw TypeError(sym + ' is not a symbol!');
    for (var key in SymbolRegistry) if (SymbolRegistry[key] === sym) return key;
  },
  useSetter: function () { setter = true; },
  useSimple: function () { setter = false; }
});

$export($export.S + $export.F * !USE_NATIVE, 'Object', {
  // 19.1.2.2 Object.create(O [, Properties])
  create: $create,
  // 19.1.2.4 Object.defineProperty(O, P, Attributes)
  defineProperty: $defineProperty,
  // 19.1.2.3 Object.defineProperties(O, Properties)
  defineProperties: $defineProperties,
  // 19.1.2.6 Object.getOwnPropertyDescriptor(O, P)
  getOwnPropertyDescriptor: $getOwnPropertyDescriptor,
  // 19.1.2.7 Object.getOwnPropertyNames(O)
  getOwnPropertyNames: $getOwnPropertyNames,
  // 19.1.2.8 Object.getOwnPropertySymbols(O)
  getOwnPropertySymbols: $getOwnPropertySymbols
});

// 24.3.2 JSON.stringify(value [, replacer [, space]])
$JSON && $export($export.S + $export.F * (!USE_NATIVE || $fails(function () {
  var S = $Symbol();
  // MS Edge converts symbol values to JSON as {}
  // WebKit converts symbol values to JSON as null
  // V8 throws on boxed symbols
  return _stringify([S]) != '[null]' || _stringify({ a: S }) != '{}' || _stringify(Object(S)) != '{}';
})), 'JSON', {
  stringify: function stringify(it) {
    if (it === undefined || isSymbol(it)) return; // IE8 returns string on undefined
    var args = [it];
    var i = 1;
    var replacer, $replacer;
    while (arguments.length > i) args.push(arguments[i++]);
    replacer = args[1];
    if (typeof replacer == 'function') $replacer = replacer;
    if ($replacer || !isArray(replacer)) replacer = function (key, value) {
      if ($replacer) value = $replacer.call(this, key, value);
      if (!isSymbol(value)) return value;
    };
    args[1] = replacer;
    return _stringify.apply($JSON, args);
  }
});

// 19.4.3.4 Symbol.prototype[@@toPrimitive](hint)
$Symbol[PROTOTYPE][TO_PRIMITIVE] || __webpack_require__("hJx8")($Symbol[PROTOTYPE], TO_PRIMITIVE, $Symbol[PROTOTYPE].valueOf);
// 19.4.3.5 Symbol.prototype[@@toStringTag]
setToStringTag($Symbol, 'Symbol');
// 20.2.1.9 Math[@@toStringTag]
setToStringTag(Math, 'Math', true);
// 24.3.3 JSON[@@toStringTag]
setToStringTag(global.JSON, 'JSON', true);


/***/ }),

/***/ "fkB2":
/***/ (function(module, exports, __webpack_require__) {

var toInteger = __webpack_require__("UuGF");
var max = Math.max;
var min = Math.min;
module.exports = function (index, length) {
  index = toInteger(index);
  return index < 0 ? max(index + length, 0) : min(index, length);
};


/***/ }),

/***/ "fuGk":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__("cGG2");

function InterceptorManager() {
  this.handlers = [];
}

/**
 * Add a new interceptor to the stack
 *
 * @param {Function} fulfilled The function to handle `then` for a `Promise`
 * @param {Function} rejected The function to handle `reject` for a `Promise`
 *
 * @return {Number} An ID used to remove interceptor later
 */
InterceptorManager.prototype.use = function use(fulfilled, rejected) {
  this.handlers.push({
    fulfilled: fulfilled,
    rejected: rejected
  });
  return this.handlers.length - 1;
};

/**
 * Remove an interceptor from the stack
 *
 * @param {Number} id The ID that was returned by `use`
 */
InterceptorManager.prototype.eject = function eject(id) {
  if (this.handlers[id]) {
    this.handlers[id] = null;
  }
};

/**
 * Iterate over all the registered interceptors
 *
 * This method is particularly useful for skipping over any
 * interceptors that may have become `null` calling `eject`.
 *
 * @param {Function} fn The function to call for each interceptor
 */
InterceptorManager.prototype.forEach = function forEach(fn) {
  utils.forEach(this.handlers, function forEachHandler(h) {
    if (h !== null) {
      fn(h);
    }
  });
};

module.exports = InterceptorManager;


/***/ }),

/***/ "g2Sx":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

exports.default = {
  data: function data() {
    return {
      key: '',
      showDelete: false,
      showCancel: false
    };
  },

  methods: {
    focus: function focus() {
      this.showCancel = true;
    },
    cancel: function cancel() {
      this.showCancel = false;
    },
    input: function input() {
      // eslint-disable-next-line
      this.showDelete = this.key ? true : false;
    },
    clear: function clear() {
      this.key = '';
    }
  }
};
module.exports = exports['default'];

/***/ }),

/***/ "gCjl":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

exports.default = {};
module.exports = exports["default"];

/***/ }),

/***/ "gepI":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _loading = __webpack_require__("Y6T+");

var _loading2 = _interopRequireDefault(_loading);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  data: function data() {
    return {
      stroke: [],
      loading: null
    };
  },

  methods: {
    showLoading: function showLoading() {
      _loading2.default.show({
        canvas: true
      });
    },
    hideLoading: function hideLoading() {
      _loading2.default.hide();
    },
    loadingToSuccess: function loadingToSuccess() {
      this.loading.success();
    },
    loadingReset: function loadingReset() {
      this.loading.start();
    },
    loadingPause: function loadingPause() {
      this.loading.stop();
    }
  },
  mounted: function mounted() {
    var self = this;
    this.$nextTick(function () {
      self.loading = _loading2.default.success('.loading-success', {
        onSuccess: function onSuccess() {
          console.log('success');
        }
      });
      self.loading.start();
    });
  }
}; //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

module.exports = exports['default'];

/***/ }),

/***/ "hJx8":
/***/ (function(module, exports, __webpack_require__) {

var dP = __webpack_require__("evD5");
var createDesc = __webpack_require__("X8DO");
module.exports = __webpack_require__("+E39") ? function (object, key, value) {
  return dP.f(object, key, createDesc(1, value));
} : function (object, key, value) {
  object[key] = value;
  return object;
};


/***/ }),

/***/ "hNRi":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "hjjS":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

__webpack_require__("WHXa");

var _utils = __webpack_require__("Nvt7");

var _utils2 = _interopRequireDefault(_utils);

var _transition = __webpack_require__("ebYN");

var _transition2 = _interopRequireDefault(_transition);

var _eventBus = __webpack_require__("Us91");

var _eventBus2 = _interopRequireDefault(_eventBus);

var _extends = __webpack_require__("KkIu");

var _extends2 = _interopRequireDefault(_extends);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var touchEvents = {
  start: _utils2.default.support.touch ? 'touchstart' : 'mousedown',
  move: _utils2.default.support.touch ? 'touchmove' : 'mousemove',
  end: _utils2.default.support.touch ? 'touchend' : 'mouseup'
};
var startTime = 0;
var endTime = 0;
var duration = 0;
var isTouchEvent = false;
var isTouch = false;
var isSliding;
var Tab = function Tab(el, options) {
  this.wrapper = typeof el === 'string' ? document.querySelector(el) : el;
  this.contents = this.wrapper.querySelector('.bx-tab-contents');
  this.scroller = this.wrapper.querySelector('.bx-tab-scroller');
  this.line = null;
  var defaults = {
    width: null,
    lineWidth: 22,
    scale: null,
    slide: true,
    transition: true,
    transitionSpeed: 300,
    bounce: true,
    angle: 45,
    activeIndex: 0,
    onInit: _utils2.default.noop(),
    onSlidePrev: _utils2.default.noop,
    onSlideNext: _utils2.default.noop,
    onChange: _utils2.default.noop(),
    onTabClick: _utils2.default.noop()
  };
  this.options = defaults;
  (0, _extends2.default)(this.options, options);
  this.options.$parent = this;
  this.total = 0;
  this.currentIndex = this.options.activeIndex || 0;
  this.direction = null;
  this.offset = {
    x: 0, // 横向滑动距离
    y: 0 // 纵向滑动距离
  };
  this.touches = {
    startX: 0, // touch前一个点
    startY: 0, // touch前一个点
    currentX: 0, // touch后一个点
    currentY: 0, // touch后一个点
    distanceX: 0, // 两个touch之间的距离
    distanceY: 0 // 两个touch之间的距离
  };
  this.distance = 0;
  this.singleContent = false;
  this.unique = this.options.unique || _utils2.default.getUnique();
  this.init();
};
Tab.prototype = {
  init: function init() {
    var self = this;
    self.setWidth();
    self.setScale();
    self.setSlide();
    self.total = self.getTotal();
    self.observer = _eventBus2.default.create(self.unique);
    self.line = new Line(self.wrapper.querySelector('.bx-tab-line'), {
      unique: self.unique,
      total: self.total,
      width: self.options.lineWidth,
      containerWidth: self.computedWidth
    });
    self.line.setParent(self);
    self._addEvent();
    self.goToIndex(self.currentIndex, 0);
    self.observer.emit('onInit');
  },
  // 设置容器宽度
  setWidth: function setWidth() {
    var self = this;
    var _width = 0;
    if (self.options.width) {
      self.wrapper.style.width = _utils2.default.isPercentage(self.options.width) ? self.options.width : self.options.width + 'px';
    }
    _width = self.wrapper.clientWidth;
    self.computedWidth = _width;
  },
  // 设置元素放大倍数
  setScale: function setScale() {
    var self = this;
    if (!self.options.scale) {
      self.options.scale = _utils2.default.getScale();
    }
    this.wrapper.querySelector('.bx-tab-wrap').style['zoom'] = self.options.scale;
  },
  getTotal: function getTotal() {
    var self = this;
    var items = self.wrapper.querySelectorAll('.bx-tab-item');
    return items.length;
  },
  setSlide: function setSlide() {
    var self = this;
    var items = self.wrapper.querySelectorAll('.bx-tab-content');
    if (items.length <= 1) {
      self.options.slide = false;
      self.options.transition = false;
      self.singleContent = true;
    }
  },
  slideTo: function slideTo(x, y, time) {
    var self = this;
    _transition2.default.setProperty(self.scroller, _transition2.default.prefixStyle('transform'));
    time !== 0 && (time = self.options.transitionSpeed);
    self.options.slide || self.options.transition || (time = 0);
    _transition2.default.setDuration(self.scroller, time);
    self._translate(x, y);
  },
  slideToIndex: function slideToIndex(index) {
    var self = this;
    self.slideTo(-1 * index * self.computedWidth, 0);
    self.setContentActive();
  },
  clickToIndex: function clickToIndex(index) {
    var self = this;
    self.goToIndex(index);
  },
  goToIndex: function goToIndex(index, time) {
    var self = this;
    self.setTabActive();
    self.setContentActive();
    self.singleContent ? self.slideTo(0, 0, 0) : self.slideTo(-1 * index * self.computedWidth, 0, time);
    self.line.clickToIndex(index, time);
  },
  setTabActive: function setTabActive() {
    var self = this;
    var items = self.wrapper.querySelectorAll('.bx-tab-item');
    for (var index = 0; index < items.length; index++) {
      if (index === self.currentIndex) {
        !_utils2.default.hasClass(items[index], 'bx-tab--active') && _utils2.default.addClass(items[index], 'bx-tab--active');
      } else {
        _utils2.default.hasClass(items[index], 'bx-tab--active') && _utils2.default.removeClass(items[index], 'bx-tab--active');
      }
    }
    self.observer.emit('onChange', self.currentIndex);
  },
  setContentActive: function setContentActive() {
    var self = this;
    var items = self.wrapper.querySelectorAll('.bx-tab-content');
    if (self.singleContent) {
      !_utils2.default.hasClass(items[0], 'bx-tab-content--active') && _utils2.default.addClass(items[0], 'bx-tab-content--active');
    } else {
      for (var index = 0; index < items.length; index++) {
        if (index === self.currentIndex) {
          !_utils2.default.hasClass(items[index], 'bx-tab-content--active') && _utils2.default.addClass(items[index], 'bx-tab-content--active');
        } else {
          _utils2.default.hasClass(items[index], 'bx-tab-content--active') && _utils2.default.removeClass(items[index], 'bx-tab-content--active');
        }
      }
    }
  },
  prev: function prev() {
    var self = this;
    self.currentIndex--;
    if (self.currentIndex < 0) {
      self.currentIndex = 0;
    }
    self.observer.emit('onSlidePrev');
    self.slideToIndex(self.currentIndex);
    self.line.slideToIndex(self.currentIndex);
  },
  next: function next() {
    var self = this;
    self.currentIndex++;
    if (self.currentIndex >= self.total) {
      self.currentIndex = self.total - 1;
    }
    self.observer.emit('onSlideNext');
    self.slideToIndex(self.currentIndex);
    self.line.slideToIndex(self.currentIndex);
  },
  handleEvent: function handleEvent(e) {
    switch (e.type) {
      case 'click':
        this._onItemClick(e);
        break;
      case 'touchstart':
        this._onTouchStart(e);
        break;
      case 'touchmove':
        this._onTouchMove(e);
        break;
      case 'touchend':
        this._onTouchEnd(e);
        break;
      case 'mousedown':
        this._onTouchStart(e);
        break;
      case 'mousemove':
        this._onTouchMove(e);
        break;
      case 'mouseup':
        this._onTouchEnd(e);
        break;
      case 'transitionend':
        this._transitionEnd(e);
        break;
      case 'webkitTransitionEnd':
        this._transitionEnd(e);
        break;
      case 'resize':
        this._onResize(e);
        break;
    }
  },
  // 判断是否需要回弹
  setBounce: function setBounce() {
    var self = this;
    if (self.currentIndex === 0 && self.direction === 'right' && self.offset.x > 0) {
      return true;
    }
    if (self.currentIndex === self.total - 1 && self.direction === 'left' && Math.abs(self.offset.x) > (self.total - 1) * self.computedWidth) {
      return true;
    }
    return false;
  },
  _addEvent: function _addEvent() {
    var self = this;
    if (self.options.slide) {
      self.contents['addEventListener'](touchEvents.start, this, false);
      self.contents['addEventListener'](touchEvents.move, this, false);
      self.contents['addEventListener'](touchEvents.end, this, false);
      self.scroller['addEventListener']('transitionend', this, false);
      self.scroller['addEventListener']('webkitTransitionEnd', this, false);
    }
    window['addEventListener']('resize', this, false);
    self._addClick();
    self.observer.on('setTabActive', function () {
      self.setTabActive();
    });
    for (var item in self.options) {
      if (item.indexOf('on') === 0) {
        if (self.options[item] instanceof Function) {
          (function (item, _self) {
            _self.observer.on(item, function () {
              _self.options[item].apply(_self, Array.prototype.slice.call(arguments));
            });
          })(item, self);
        }
      }
    }
  },
  _addClick: function _addClick() {
    var self = this;
    var items = self.wrapper.querySelectorAll('.bx-tab-item');
    for (var i = 0; i < items.length; i++) {
      (function (index) {
        items[index]['addEventListener']('click', function (e) {
          self._onItemClick(e, index);
        }, false);
      })(i);
    }
  },
  _onItemClick: function _onItemClick(e, index) {
    var self = this;
    self.currentIndex = index;
    self.observer.emit('onItemClick', index);
    self.clickToIndex(index);
  },
  _onTouchStart: function _onTouchStart(e) {
    var self = this;
    // 兼容jq自己封装的originalEvent,指向原始的事件对象
    if (e.originalEvent) e = e.originalEvent;
    // 大于一个touch点,不做处理
    if (e.touches && e.touches.length > 1) {
      e.preventDefault();
      return;
    }
    isTouchEvent = e.type === 'touchstart';
    isTouch = true;
    isSliding = undefined;
    self.touches.startX = isTouchEvent ? e.touches[0].clientX : e.clientX;
    self.touches.startY = isTouchEvent ? e.touches[0].clientY : e.clientY;
    startTime = _utils2.default.now();
    self.distance = 0;
    self.line.touchStart();
    _transition2.default.setDuration(self.scroller, 0);
  },
  _onTouchMove: function _onTouchMove(e) {
    var self = this;
    if (e.originalEvent) e = e.originalEvent;
    if (!isTouch && e.type === 'mousemove') {
      e.preventDefault();
      return;
    }
    if (e.touches && e.touches.length > 1) {
      e.preventDefault();
      return;
    }
    self.touches.currentX = e.type === 'touchmove' ? e.touches[0].clientX : e.clientX;
    self.touches.currentY = e.type === 'touchmove' ? e.touches[0].clientY : e.clientY;
    var touchAngle = Math.atan2(Math.abs(self.touches.currentY - self.touches.startY), Math.abs(self.touches.currentX - self.touches.startX)) * 180 / Math.PI;
    if (typeof isSliding === 'undefined') {
      isSliding = touchAngle <= self.options.angle;
    }
    if (!isSliding) {
      return;
    }
    self.touches.distanceX = self.touches.currentX - self.touches.startX;
    self.touches.distanceX > 0 ? self.direction = 'right' : self.direction = 'left';
    self.options.bounce && (self.bounce = self.setBounce());
    self.bounce && (self.touches.distanceX = self.touches.distanceX / 2);
    self.offset.x += self.touches.distanceX;
    self.distance += self.touches.distanceX;
    self._translate(self.offset.x, 0);
    self.line.touchMove(self.touches.distanceX, self.distance);

    self.touches.startX = self.touches.currentX;
    self.touches.startY = self.touches.currentY;

    e.preventDefault();
  },
  _onTouchEnd: function _onTouchEnd(e) {
    var self = this;
    endTime = _utils2.default.now();
    duration = endTime - startTime;
    if (!self.bounce && (duration <= 300 && Math.abs(self.distance) > 30 || Math.abs(self.distance) > self.computedWidth / 2)) {
      self.distance > 0 ? self.prev() : self.next();
    } else {
      self.slideTo(self.offset.x - self.distance, 0);
      self.line.stretchTo(self.line.options.width);
    }
    isTouch = false;
  },
  _onResize: function _onResize(e) {
    var self = this;
    self.setWidth();
    self.slideTo(-1 * self.currentIndex * self.computedWidth, 0, 0);
    self.line.options.containerWidth = self.computedWidth;
    self.line._onResize(e);
  },
  // transition动画结束后回调
  _transitionEnd: function _transitionEnd(e) {},
  // 页面滑动到指定位置
  _translate: function _translate(x, y) {
    var self = this;
    if (!self.options.bounce) {
      if (x > 0) {
        x = 0;
      }
      var totalDistance = (self.total - 1) * self.computedWidth;
      if (Math.abs(x) > totalDistance) {
        x = -1 * totalDistance;
      }
    }
    self.offset.x = x;
    _transition2.default.setTransform(self.scroller, x, y);
  }
};

var Line = function Line(el, options) {
  this.el = typeof el === 'string' ? document.querySelector(el) : el;
  this.options = {
    width: 22,
    speed: 200,
    total: 1,
    containerWidth: null
  };
  (0, _extends2.default)(this.options, options);
  this.unique = this.options.unique || _utils2.default.getUnique();
  this.init();
};
Line.prototype = {
  parent: null,
  currentIndex: 0,
  direction: null,
  distance: 0,
  isTransition: false,
  positionType: 'left',
  init: function init() {
    var self = this;
    self.setScale();
    self.setWidth();
    self.setPosition();
    self.observer = _eventBus2.default.create(self.unique);
    self.addEvent();
  },
  setWidth: function setWidth() {
    var self = this;
    if (self.options.width) {
      self.el.style.width = self.options.width + 'px';
    }
    self.tabWidth = self.options.containerWidth / self.options.total;
    self.maxWidth = self.tabWidth + self.options.width;
  },
  // 设置元素放大倍数
  setScale: function setScale() {
    var self = this;
    if (!self.options.scale) {
      self.options.scale = _utils2.default.getScale();
    }
    self.options.width = self.options.scale * self.options.width;
    self.el.style['height'] = self.el.clientHeight * self.options.scale + 'px';
  },
  setParent: function setParent(obj) {
    this.parent = obj;
  },
  setDirection: function setDirection(distance) {
    var self = this;
    self.direction = distance < 0 ? 'right' : 'left';
  },
  setPosition: function setPosition(type, index) {
    var self = this;
    (index === undefined || index === null) && (index = self.currentIndex);
    var tabWidth = self.options.containerWidth / self.options.total;
    var left = (tabWidth - self.options.width) / 2 + index * tabWidth;
    var right = self.options.containerWidth - left - self.options.width;
    self.positionType = type || 'left';
    if (type === 'right') {
      self.el.style['right'] = right + 'px';
      self.el.style['left'] = 'auto';
    } else {
      self.el.style['left'] = left + 'px';
      self.el.style['right'] = 'auto';
    }
  },
  touchStart: function touchStart() {
    var self = this;
    self.distance = 0;
  },
  touchMove: function touchMove(x) {
    var self = this;
    self.distance += 2 * x / self.options.total;
    self.setDirection(self.distance);
    // 边界判断
    if (self.currentIndex === 0 && self.direction === 'left' || self.currentIndex === self.options.total - 1 && self.direction === 'right') {
      return;
    }

    var width = 0;
    var index = self.currentIndex;
    var direction = self.direction;
    var distance = Math.abs(self.distance);
    if (distance >= self.tabWidth) {
      distance >= 2 * self.tabWidth && (distance = 2 * self.tabWidth);
      width = self.options.width + 2 * self.tabWidth - distance;
      index = self.direction === 'left' ? self.currentIndex - 1 : self.currentIndex + 1;
    } else {
      width = self.options.width + distance;
      direction = self.direction === 'left' ? 'right' : 'left';
    }
    self.setPosition(direction, index);
    self.stretchTo(width, 0);
  },
  stretchTo: function stretchTo(width, time) {
    var self = this;
    _transition2.default.setProperty(self.el, 'width');
    time !== 0 && time === undefined && (time = self.options.speed);
    _transition2.default.setDuration(self.el, time);
    // 强制开启硬件加速
    _transition2.default.setTransform(self.el, 0, 0);
    self.el.style.width = width + 'px';
  },
  moveTo: function moveTo(index, time) {
    var self = this;
    _transition2.default.setProperty(self.el, self.positionType);
    time !== 0 && time === undefined && (time = self.options.speed);
    _transition2.default.setDuration(self.el, time);
    self.currentIndex = index;
    self.setPosition(self.positionType);
  },
  slideToIndex: function slideToIndex(index) {
    var self = this;
    if (self.currentIndex === 0 && self.direction === 'left' || self.currentIndex === self.options.total - 1 && self.direction === 'right') {
      return;
    }
    self.currentIndex = index;
    var width = self.options.width;
    if (Math.abs(self.distance) < self.tabWidth) {
      self.isTransition = true;
      width = self.maxWidth;
    }
    self.stretchTo(width);
    self.observer.emit('setTabActive');
  },
  clickToIndex: function clickToIndex(index, time) {
    var self = this;
    self.moveTo(index, time);
  },
  prev: function prev() {
    var self = this;
    self.currentIndex--;
    if (self.currentIndex < 0) {
      self.currentIndex = 0;
    }
    self.slideToIndex(self.currentIndex);
  },
  next: function next() {
    var self = this;
    self.currentIndex++;
    if (self.currentIndex >= self.options.total) {
      self.currentIndex = self.options.total - 1;
    }
    self.slideToIndex(self.currentIndex);
  },
  addEvent: function addEvent() {
    var self = this;
    self.el['addEventListener']('transitionend', this, false);
    self.el['addEventListener']('webkitTransitionEnd', this, false);
  },
  handleEvent: function handleEvent(e) {
    var self = this;
    switch (e.type) {
      case 'transitionend':
        self._transitionEnd(e);
        break;
      case 'webkitTransitionEnd':
        self._transitionEnd(e);
        break;
    }
  },
  _onResize: function _onResize(e) {
    var self = this;
    self.setWidth();
    self.setPosition();
  },
  _transitionEnd: function _transitionEnd(e) {
    var self = this;
    if (self.isTransition) {
      self.setPosition(self.direction);
      self.stretchTo(self.options.width, self.options.speed);
      self.isTransition = false;
    }
  }
};
exports.default = Tab;
module.exports = exports['default'];

/***/ }),

/***/ "i36v":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _utils = __webpack_require__("Nvt7");

var _utils2 = _interopRequireDefault(_utils);

var _eventBus = __webpack_require__("Us91");

var _eventBus2 = _interopRequireDefault(_eventBus);

var _image = __webpack_require__("AV57");

var _image2 = _interopRequireDefault(_image);

var _extends = __webpack_require__("KkIu");

var _extends2 = _interopRequireDefault(_extends);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// 参考借鉴
// http://www.w3school.com.cn/xmldom/dom_http.asp
// https://github.com/Tencent/weui.js/blob/master/src/uploader/upload.js
var Uploader = function Uploader(el, options) {
  this.wrapper = typeof el === 'string' ? document.querySelector(el) : el;
  var defaults = {
    url: null,
    type: 'POST',
    async: true,
    data: {},
    headers: {},
    xhrFields: {},
    compress: {
      type: 'image/png',
      quality: '0.92',
      width: null,
      height: null
    },
    base64: null,
    autoUpload: true,
    fileType: [],
    onInit: _utils2.default.noop,
    onBefore: _utils2.default.noop,
    onSuccess: _utils2.default.noop,
    onError: _utils2.default.noop,
    onComplete: _utils2.default.noop,
    onProgress: _utils2.default.noop
  };
  this.options = defaults;
  (0, _extends2.default)(this.options, options);
  this.unique = this.options.unique || _utils2.default.getUnique();
  this._init();
};
Uploader.prototype = {
  _init: function _init() {
    var self = this;
    self.observer = _eventBus2.default.create(self.unique);
    self._addEvent();
    self.observer.emit('onInit');
    self.options.base64 && self._sendBase64();
  },
  _addEvent: function _addEvent() {
    var self = this;
    if (!self.options.base64) {
      var $wrapper = self.wrapper;
      $wrapper.querySelector('input[type="file"]').addEventListener('change', function (event) {
        self._onChange(event);
      }, false);
    }
    for (var item in self.options) {
      if (item.indexOf('on') === 0) {
        if (self.options[item] instanceof Function) {
          (function (item, _self) {
            _self.observer.on(item, function () {
              _self.options[item].apply(_self, Array.prototype.slice.call(arguments));
            });
          })(item, self);
        }
      }
    }
  },
  _onChange: function _onChange(event) {
    var self = this;
    var _files = event.target.files;
    if (_files.length === 0) {
      return;
    }
    self.files = _files;
    if (!self._isLegalType(self.files[0])) {
      return false;
    }
    self._handleImage(self.files[0], function (file) {
      self.file = file;
      self.observer.emit('onBefore', file);
      self.options.autoUpload && self._sendXHR(file);
    });
  },
  _sendXHR: function _sendXHR(file) {
    var self = this;
    var _xhr = new XMLHttpRequest();
    self._xhr = _xhr;
    var _options = self.options;
    self._setFormDate(file);
    self._setXhrFields();
    _xhr.onreadystatechange = function () {
      self._onReadyStateChange();
    };
    _xhr.upload.onprogress = function (event) {
      self._onProgress(event);
    };
    _xhr.open(_options.type, _options.url, _options.async);
    self._setHeaders();
    _xhr.send(self._formData);
  },
  _sendBase64: function _sendBase64() {
    var self = this;
    var blob = _image2.default.dataURItoBlob(self.options.base64);
    self.file = blob;
    self.observer.emit('onBefore', blob);
    self.options.autoUpload && self._sendXHR(blob);
  },
  _onReadyStateChange: function _onReadyStateChange() {
    var self = this;
    var _xhr = self._xhr;
    var response = '';
    // readyState, http://www.w3school.com.cn/xmldom/dom_http.asp
    // 0,Uninitialized,初始化状态。XMLHttpRequest 对象已创建或已被 abort() 方法重置。
    // 1,Open,open() 方法已调用，但是 send() 方法未调用。请求还没有被发送。
    // 2,Sent,Send() 方法已调用，HTTP 请求已发送到 Web 服务器。未接收到响应。
    // 3,Receiving,所有响应头部都已经接收到。响应体开始接收但未完成。
    // 4,Loaded,HTTP 响应已经完全接收。
    if (_xhr.readyState === 4) {
      if (_xhr.status === 200) {
        try {
          _xhr.responseText && (response = JSON.parse(_xhr.responseText));
          self.observer.emit('onSuccess', response);
        } catch (error) {
          self.observer.emit('onError', _xhr, _xhr.status, error);
        }
      } else {
        self.observer.emit('onError', _xhr, _xhr.status, _xhr.statusText);
      }
      self.observer.emit('onComplete', _xhr);
      _xhr.abort();
    }
  },
  _onProgress: function _onProgress(event) {
    var self = this;
    if (event.total === 0) return;
    var percent = Math.ceil(event.loaded / event.total) * 100;
    self.observer.emit('onProgress', percent);
  },
  _setFormDate: function _setFormDate(file) {
    var self = this;
    var _formData = new FormData();
    var _data = self.options.data;
    for (var key in _data) {
      _formData.append(key, _data[key]);
    }
    _formData.append('file', file);
    self._formData = _formData;
  },
  _setHeaders: function _setHeaders() {
    var self = this;
    var _xhr = self._xhr;
    var _headers = self.options.headers;
    for (var key in _headers) {
      _xhr.setRequestHeader(key, _headers[key]);
    }
  },
  _setXhrFields: function _setXhrFields() {
    var self = this;
    var _xhr = self._xhr;
    var _xhrFields = self.options.xhrFields;
    for (var key in _xhrFields) {
      _xhr[key] = _xhrFields[key];
    }
  },
  _handleImage: function _handleImage(file, callback) {
    var self = this;
    var reader = new FileReader();
    reader.onload = function (event) {
      self._imageToBlob(file, event, callback);
    };
    reader.readAsDataURL(file);
  },
  _imageToBlob: function _imageToBlob(file, event, callback) {
    var self = this;
    var img = new Image();
    img.src = event.target.result;
    img.onload = function () {
      // var ratio = ImageHelper.detectVerticalSquash(img);
      var orientation = _image2.default.getOrientation(_image2.default.dataURItoBuffer(img.src));
      var canvas = document.createElement('canvas');
      var ctx = canvas.getContext('2d');
      var width = img.width;
      var height = img.height;
      var maxW = self.options.compress.width;
      var maxH = self.options.compress.height;
      if (maxH && width < height && height > maxH) {
        width = parseInt(maxH * img.width / img.height);
        height = maxH;
      } else if (maxW && width >= height && width > maxW) {
        height = parseInt(maxW * img.height / img.width);
        width = maxW;
      }
      canvas.width = width;
      canvas.height = height;
      if (orientation > 0) {
        _image2.default.orientationHelper(canvas, ctx, orientation);
      }
      ctx.drawImage(img, 0, 0, width, height);
      var dataURL = canvas.toDataURL(self.options.compress.type, self.options.compress.quality);
      if (/;base64,null/.test(dataURL) || /;base64,$/.test(dataURL)) {
        callback(file);
      } else {
        var blob = _image2.default.dataURItoBlob(dataURL);
        blob.name = file.name;
        blob.lastModified = file.lastModified;
        blob.lastModifiedDate = file.lastModifiedDate;
        callback(blob);
      }
    };
  },
  _isLegalType: function _isLegalType(file) {
    var self = this;
    var _fileType = self.options.fileType;
    _fileType || (_fileType = []);
    if (_fileType.length <= 0) {
      _fileType.push('jpg');
      _fileType.push('jpeg');
      _fileType.push('png');
      _fileType.push('gif');
      _fileType.push('bmp');
      _fileType.push('svg');
    }
    for (var i = 0; i < _fileType.length; i++) {
      if (file.type.toLowerCase().indexOf(_fileType[i]) !== -1) {
        return true;
      }
    }
    self.observer.emit('onError', null, 404, '请上传指定格式文件');
    return false;
  },
  upload: function upload() {
    var self = this;
    self._sendXHR(self.file);
  }
};
exports.default = Uploader;
module.exports = exports['default'];

/***/ }),

/***/ "iA4u":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/views/ui/Form.vue
var Form = __webpack_require__("cGza");
var Form_default = /*#__PURE__*/__webpack_require__.n(Form);

// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3194df39","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/ui/Form.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0,false,false)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"demo-form"},[_c('div',{staticClass:"demo-form-group"},[_c('h3',{staticClass:"demo-title"},[_vm._v("标题(四个字及以下)、暗提示")]),_vm._v(" "),_c('div',{staticClass:"bx-cell"},[_c('div',{staticClass:"bx-cell-inner"},[_c('div',{staticClass:"bx-cell-label"},[_vm._v("标题")]),_vm._v(" "),_c('div',{staticClass:"bx-cell-input"},[_c('input',{attrs:{"type":"text","placeholder":"暗提示内容"}})])])]),_vm._v(" "),_c('div',{staticClass:"bx-cell"},[_c('div',{staticClass:"bx-cell-inner"},[_c('div',{staticClass:"bx-cell-label"},[_vm._v("标题标")]),_vm._v(" "),_c('div',{staticClass:"bx-cell-input"},[_c('input',{attrs:{"type":"text","placeholder":"暗提示内容"}})])])]),_vm._v(" "),_c('div',{staticClass:"bx-cell"},[_c('div',{staticClass:"bx-cell-inner"},[_c('div',{staticClass:"bx-cell-label"},[_vm._v("标题标题")]),_vm._v(" "),_c('div',{staticClass:"bx-cell-input"},[_c('input',{attrs:{"type":"text","placeholder":"暗提示内容"}})])])])]),_vm._v(" "),_c('div',{staticClass:"demo-form-group"},[_c('h3',{staticClass:"demo-title"},[_vm._v("标题(四个字以上下)、暗提示")]),_vm._v(" "),_c('div',{staticClass:"bx-cell"},[_c('div',{staticClass:"bx-cell-inner"},[_c('div',{staticClass:"bx-cell-label bx-cell-label--lg"},[_vm._v("标题标题标")]),_vm._v(" "),_c('div',{staticClass:"bx-cell-input"},[_c('input',{attrs:{"type":"text","placeholder":"暗提示内容"}})])])]),_vm._v(" "),_c('div',{staticClass:"bx-cell"},[_c('div',{staticClass:"bx-cell-inner"},[_c('div',{staticClass:"bx-cell-label bx-cell-label--lg"},[_vm._v("标题标题标题")]),_vm._v(" "),_c('div',{staticClass:"bx-cell-input"},[_c('input',{attrs:{"type":"text","placeholder":"暗提示内容"}})])])]),_vm._v(" "),_c('div',{staticClass:"bx-cell"},[_c('div',{staticClass:"bx-cell-inner"},[_c('div',{staticClass:"bx-cell-label bx-cell-label--lg"},[_vm._v("标题标题标题标")]),_vm._v(" "),_c('div',{staticClass:"bx-cell-input"},[_c('input',{attrs:{"type":"text","placeholder":"暗提示内容"}})])])])]),_vm._v(" "),_c('div',{staticClass:"demo-form-group"},[_c('h3',{staticClass:"demo-title"},[_vm._v("右侧图标、图片、按钮")]),_vm._v(" "),_c('div',{staticClass:"bx-cell"},[_c('div',{staticClass:"bx-cell-inner"},[_c('div',{staticClass:"bx-cell-label"},[_vm._v("标题")]),_vm._v(" "),_c('div',{staticClass:"bx-cell-input"},[_c('input',{attrs:{"type":"text","placeholder":"暗提示内容"}})]),_vm._v(" "),_c('div',{staticClass:"bx-cell-extra"},[_c('i',{staticClass:"bx-icon bx-icon-close-circle-surface"})])])]),_vm._v(" "),_c('div',{staticClass:"bx-cell"},[_c('div',{staticClass:"bx-cell-inner"},[_c('div',{staticClass:"bx-cell-label"},[_vm._v("标题")]),_vm._v(" "),_c('div',{staticClass:"bx-cell-input"},[_c('input',{attrs:{"type":"text","placeholder":"暗提示内容"}})]),_vm._v(" "),_c('div',{staticClass:"bx-cell-extra"},[_c('i',{staticClass:"bx-icon bx-icon-arrows-right"})])])]),_vm._v(" "),_c('div',{staticClass:"bx-cell"},[_c('div',{staticClass:"bx-cell-inner"},[_c('div',{staticClass:"bx-cell-label"},[_vm._v("标题")]),_vm._v(" "),_c('div',{staticClass:"bx-cell-input"},[_c('input',{attrs:{"type":"text","placeholder":"暗提示内容"}})]),_vm._v(" "),_c('div',{staticClass:"bx-cell-extra"},[_c('img',{staticClass:"bx-image-responsive",attrs:{"src":"http://img.winbaoxian.com/autoUpload/learning/avatar_default_79148af363.png"}})])])]),_vm._v(" "),_c('div',{staticClass:"bx-cell"},[_c('div',{staticClass:"bx-cell-inner"},[_c('div',{staticClass:"bx-cell-label"},[_vm._v("标题")]),_vm._v(" "),_c('div',{staticClass:"bx-cell-input"},[_c('input',{attrs:{"type":"text","placeholder":"暗提示内容"}})]),_vm._v(" "),_c('div',{staticClass:"bx-cell-extra"},[_c('a',{staticClass:"bx-cell-link"},[_vm._v("获取验证码")])])])]),_vm._v(" "),_c('div',{staticClass:"bx-cell"},[_c('div',{staticClass:"bx-cell-inner"},[_c('div',{staticClass:"bx-cell-label"},[_vm._v("标题")]),_vm._v(" "),_c('div',{staticClass:"bx-cell-input"},[_c('input',{attrs:{"type":"text","placeholder":"暗提示内容"}})]),_vm._v(" "),_c('div',{staticClass:"bx-cell-extra"},[_c('a',{staticClass:"bx-cell-btn"},[_vm._v("获取验证码")])])])])]),_vm._v(" "),_c('div',{staticClass:"demo-form-group"},[_c('h3',{staticClass:"demo-title"},[_vm._v("标题展开、折叠")]),_vm._v(" "),_c('div',{staticClass:"bx-accordion-cells"},[_c('div',{staticClass:"bx-accordion-header"},[_c('div',{staticClass:"bx-cell"},[_c('div',{staticClass:"bx-cell-inner"},[_c('div',{staticClass:"bx-cell-title"},[_vm._v("标题文字")]),_vm._v(" "),_c('div',{staticClass:"bx-cell-extra"},[_c('i',{staticClass:"bx-icon"})])])])]),_vm._v(" "),_c('div',{staticClass:"bx-accordion-body"},[_c('div',{staticClass:"bx-cell"},[_c('div',{staticClass:"bx-cell-inner"},[_c('div',{staticClass:"bx-cell-title"},[_vm._v("标题文字")]),_vm._v(" "),_c('div',{staticClass:"bx-cell-extra"},[_c('i',{staticClass:"bx-icon bx-icon-choose-done"})])])]),_vm._v(" "),_c('div',{staticClass:"bx-cell"},[_c('div',{staticClass:"bx-cell-inner"},[_c('div',{staticClass:"bx-cell-title"},[_vm._v("标题文字")])])]),_vm._v(" "),_c('div',{staticClass:"bx-cell"},[_c('div',{staticClass:"bx-cell-inner"},[_c('div',{staticClass:"bx-cell-title"},[_vm._v("标题文字")])])])])]),_vm._v(" "),_c('div',{staticClass:"bx-accordion-cells bx-accordion-active"},[_c('div',{staticClass:"bx-accordion-header"},[_c('div',{staticClass:"bx-cell"},[_c('div',{staticClass:"bx-cell-inner"},[_c('div',{staticClass:"bx-cell-title"},[_vm._v("标题文字")]),_vm._v(" "),_c('div',{staticClass:"bx-cell-extra"},[_c('i',{staticClass:"bx-icon"})])])])]),_vm._v(" "),_c('div',{staticClass:"bx-accordion-body"},[_c('div',{staticClass:"bx-cell"},[_c('div',{staticClass:"bx-cell-inner"},[_c('div',{staticClass:"bx-cell-title"},[_vm._v("标题文字")]),_vm._v(" "),_c('div',{staticClass:"bx-cell-extra"},[_c('i',{staticClass:"bx-icon bx-icon-arrows-right"})])])]),_vm._v(" "),_c('div',{staticClass:"bx-cell"},[_c('div',{staticClass:"bx-cell-inner"},[_c('div',{staticClass:"bx-cell-title"},[_vm._v("标题文字")])])]),_vm._v(" "),_c('div',{staticClass:"bx-cell"},[_c('div',{staticClass:"bx-cell-inner"},[_c('div',{staticClass:"bx-cell-title"},[_vm._v("标题文字")])])])])]),_vm._v(" "),_c('div',{staticClass:"bx-accordion-cells bx-accordion-active"},[_c('div',{staticClass:"bx-accordion-header"},[_c('div',{staticClass:"bx-cell"},[_c('div',{staticClass:"bx-cell-inner"},[_c('div',{staticClass:"bx-cell-title"},[_vm._v("标题文字")]),_vm._v(" "),_c('div',{staticClass:"bx-cell-extra"},[_c('i',{staticClass:"bx-icon"})])])])]),_vm._v(" "),_c('div',{staticClass:"bx-accordion-body bx-radio-cells"},[_c('div',{staticClass:"bx-cell"},[_c('label',{staticClass:"bx-cell-inner"},[_c('div',{staticClass:"bx-cell-title"},[_vm._v("单项选择")]),_vm._v(" "),_c('div',{staticClass:"bx-cell-radio bx-cell-checked-tick"},[_c('input',{staticClass:"bx-cell-input",attrs:{"type":"radio","name":"radio-cells-tick"}}),_vm._v(" "),_c('i',{staticClass:"bx-icon"})])])]),_vm._v(" "),_c('div',{staticClass:"bx-cell"},[_c('label',{staticClass:"bx-cell-inner"},[_c('div',{staticClass:"bx-cell-title"},[_vm._v("单项选择")]),_vm._v(" "),_c('div',{staticClass:"bx-cell-radio bx-cell-checked-tick"},[_c('input',{staticClass:"bx-cell-input",attrs:{"type":"radio","name":"radio-cells-tick"}}),_vm._v(" "),_c('i',{staticClass:"bx-icon"})])])]),_vm._v(" "),_c('div',{staticClass:"bx-cell"},[_c('label',{staticClass:"bx-cell-inner"},[_c('div',{staticClass:"bx-cell-title"},[_vm._v("单项选择")]),_vm._v(" "),_c('div',{staticClass:"bx-cell-radio bx-cell-checked-tick"},[_c('input',{staticClass:"bx-cell-input",attrs:{"type":"radio","name":"radio-cells-tick"}}),_vm._v(" "),_c('i',{staticClass:"bx-icon"})])])])])])]),_vm._v(" "),_c('div',{staticClass:"demo-form-group"},[_c('h3',{staticClass:"demo-title"},[_vm._v("单项选择")]),_vm._v(" "),_c('div',{staticClass:"bx-radio-cells"},[_c('div',{staticClass:"bx-cell"},[_c('label',{staticClass:"bx-cell-inner"},[_c('div',{staticClass:"bx-cell-radio"},[_c('input',{staticClass:"bx-cell-input",attrs:{"type":"radio","name":"radio-cells"}}),_vm._v(" "),_c('i',{staticClass:"bx-icon bx-icon-choose-none-line"})]),_vm._v(" "),_c('div',{staticClass:"bx-cell-title"},[_vm._v("单项选择")])])]),_vm._v(" "),_c('div',{staticClass:"bx-cell"},[_c('label',{staticClass:"bx-cell-inner"},[_c('div',{staticClass:"bx-cell-radio"},[_c('input',{staticClass:"bx-cell-input",attrs:{"type":"radio","name":"radio-cells"}}),_vm._v(" "),_c('i',{staticClass:"bx-icon bx-icon-choose-none-line"})]),_vm._v(" "),_c('div',{staticClass:"bx-cell-title"},[_vm._v("单项选择")])])]),_vm._v(" "),_c('div',{staticClass:"bx-cell"},[_c('label',{staticClass:"bx-cell-inner"},[_c('div',{staticClass:"bx-cell-radio"},[_c('input',{staticClass:"bx-cell-input",attrs:{"type":"radio","name":"radio-cells"}}),_vm._v(" "),_c('i',{staticClass:"bx-icon bx-icon-choose-none-line"})]),_vm._v(" "),_c('div',{staticClass:"bx-cell-title"},[_vm._v("单项选择")])])])]),_vm._v(" "),_c('div',{staticClass:"bx-radio-cells"},[_c('div',{staticClass:"bx-cell"},[_c('label',{staticClass:"bx-cell-inner"},[_c('div',{staticClass:"bx-cell-title"},[_vm._v("单项选择")]),_vm._v(" "),_c('div',{staticClass:"bx-cell-radio bx-cell-checked-tick"},[_c('input',{staticClass:"bx-cell-input",attrs:{"type":"radio","name":"radio-cells-tick"}}),_vm._v(" "),_c('i',{staticClass:"bx-icon"})])])]),_vm._v(" "),_c('div',{staticClass:"bx-cell"},[_c('label',{staticClass:"bx-cell-inner"},[_c('div',{staticClass:"bx-cell-title"},[_vm._v("单项选择")]),_vm._v(" "),_c('div',{staticClass:"bx-cell-radio bx-cell-checked-tick"},[_c('input',{staticClass:"bx-cell-input",attrs:{"type":"radio","name":"radio-cells-tick"}}),_vm._v(" "),_c('i',{staticClass:"bx-icon"})])])]),_vm._v(" "),_c('div',{staticClass:"bx-cell"},[_c('label',{staticClass:"bx-cell-inner"},[_c('div',{staticClass:"bx-cell-title"},[_vm._v("单项选择")]),_vm._v(" "),_c('div',{staticClass:"bx-cell-radio bx-cell-checked-tick"},[_c('input',{staticClass:"bx-cell-input",attrs:{"type":"radio","name":"radio-cells-tick"}}),_vm._v(" "),_c('i',{staticClass:"bx-icon"})])])])])]),_vm._v(" "),_c('div',{staticClass:"demo-form-group"},[_c('h3',{staticClass:"demo-title"},[_vm._v("标题单选")]),_vm._v(" "),_c('div',{staticClass:"bx-cell"},[_c('div',{staticClass:"bx-cell-inner"},[_c('div',{staticClass:"bx-cell-label"},[_vm._v("标题文字")]),_vm._v(" "),_c('div',{staticClass:"bx-cell-input"},[_c('div',{staticClass:"bx-radio-inline bx-flex-align bx-flex-main-end"},[_c('div',{staticClass:"bx-cell"},[_c('label',[_c('input',{staticClass:"bx-cell-input",attrs:{"type":"radio","name":"radio-inline-cells"}}),_vm._v(" "),_c('div',{staticClass:"bx-cell-radio"},[_vm._v("计划一")])])]),_vm._v(" "),_c('div',{staticClass:"bx-cell"},[_c('label',[_c('input',{staticClass:"bx-cell-input",attrs:{"type":"radio","name":"radio-inline-cells"}}),_vm._v(" "),_c('div',{staticClass:"bx-cell-radio"},[_vm._v("计划二")])])]),_vm._v(" "),_c('div',{staticClass:"bx-cell"},[_c('label',[_c('input',{staticClass:"bx-cell-input",attrs:{"type":"radio","name":"radio-inline-cells"}}),_vm._v(" "),_c('div',{staticClass:"bx-cell-radio"},[_vm._v("计划三")])])])])])])]),_vm._v(" "),_c('div',{staticClass:"bx-cell"},[_c('div',{staticClass:"bx-cell-inner"},[_c('div',{staticClass:"bx-cell-label"},[_vm._v("标题文字")]),_vm._v(" "),_c('div',{staticClass:"bx-cell-input"},[_c('div',{staticClass:"bx-radio-inline bx-flex-align bx-flex-main-end"},[_c('div',{staticClass:"bx-cell"},[_c('label',[_c('input',{staticClass:"bx-cell-input",attrs:{"type":"radio","name":"radio-inline-cells"}}),_vm._v(" "),_c('div',{staticClass:"bx-cell-radio"},[_vm._v("男")])])]),_vm._v(" "),_c('div',{staticClass:"bx-cell"},[_c('label',[_c('input',{staticClass:"bx-cell-input",attrs:{"type":"radio","name":"radio-inline-cells"}}),_vm._v(" "),_c('div',{staticClass:"bx-cell-radio"},[_vm._v("女")])])])])])])]),_vm._v(" "),_c('div',{staticClass:"bx-cell"},[_c('div',{staticClass:"bx-cell-inner"},[_c('div',{staticClass:"bx-cell-label"},[_vm._v("标题文字")]),_vm._v(" "),_c('div',{staticClass:"bx-cell-input"},[_c('div',{staticClass:"bx-radio-inline bx-radio-multiline"},[_c('div',{staticClass:"bx-cell"},[_c('label',[_c('input',{staticClass:"bx-cell-input",attrs:{"type":"radio","name":"radio-inline-cells"}}),_vm._v(" "),_c('div',{staticClass:"bx-cell-radio"},[_vm._v("标题一")])])]),_vm._v(" "),_c('div',{staticClass:"bx-cell"},[_c('label',[_c('input',{staticClass:"bx-cell-input",attrs:{"type":"radio","name":"radio-inline-cells"}}),_vm._v(" "),_c('div',{staticClass:"bx-cell-radio"},[_vm._v("标题二")])])]),_vm._v(" "),_c('div',{staticClass:"bx-cell"},[_c('label',[_c('input',{staticClass:"bx-cell-input",attrs:{"type":"radio","name":"radio-inline-cells"}}),_vm._v(" "),_c('div',{staticClass:"bx-cell-radio"},[_vm._v("标题三")])])]),_vm._v(" "),_c('div',{staticClass:"bx-cell"},[_c('label',[_c('input',{staticClass:"bx-cell-input",attrs:{"type":"radio","name":"radio-inline-cells"}}),_vm._v(" "),_c('div',{staticClass:"bx-cell-radio"},[_vm._v("标题四")])])]),_vm._v(" "),_c('div',{staticClass:"bx-cell"},[_c('label',[_c('input',{staticClass:"bx-cell-input",attrs:{"type":"radio","name":"radio-inline-cells"}}),_vm._v(" "),_c('div',{staticClass:"bx-cell-radio"},[_vm._v("标题五")])])]),_vm._v(" "),_c('div',{staticClass:"bx-cell"},[_c('label',[_c('input',{staticClass:"bx-cell-input",attrs:{"type":"radio","name":"radio-inline-cells"}}),_vm._v(" "),_c('div',{staticClass:"bx-cell-radio"},[_vm._v("标题六")])])])])])])])]),_vm._v(" "),_c('div',{staticClass:"demo-form-group"},[_c('h3',{staticClass:"demo-title"},[_vm._v("多项选择")]),_vm._v(" "),_c('div',{staticClass:"bx-checkbox-cells"},[_c('div',{staticClass:"bx-cell"},[_c('label',{staticClass:"bx-cell-inner"},[_c('div',{staticClass:"bx-cell-checkbox"},[_c('input',{staticClass:"bx-cell-input",attrs:{"type":"checkbox","name":"checkbox-cells"}}),_vm._v(" "),_c('i',{staticClass:"bx-icon"})]),_vm._v(" "),_c('div',{staticClass:"bx-cell-title"},[_vm._v("多项选择")])])]),_vm._v(" "),_c('div',{staticClass:"bx-cell"},[_c('label',{staticClass:"bx-cell-inner"},[_c('div',{staticClass:"bx-cell-checkbox"},[_c('input',{staticClass:"bx-cell-input",attrs:{"type":"checkbox","name":"checkbox-cells"}}),_vm._v(" "),_c('i',{staticClass:"bx-icon"})]),_vm._v(" "),_c('div',{staticClass:"bx-cell-title"},[_vm._v("多项选择")])])]),_vm._v(" "),_c('div',{staticClass:"bx-cell"},[_c('label',{staticClass:"bx-cell-inner"},[_c('div',{staticClass:"bx-cell-checkbox"},[_c('input',{staticClass:"bx-cell-input",attrs:{"type":"checkbox","name":"checkbox-cells"}}),_vm._v(" "),_c('i',{staticClass:"bx-icon"})]),_vm._v(" "),_c('div',{staticClass:"bx-cell-title"},[_vm._v("多项选择")])])])]),_vm._v(" "),_c('div',{staticClass:"bx-checkbox-cells"},[_c('div',{staticClass:"bx-cell"},[_c('label',{staticClass:"bx-cell-inner"},[_c('div',{staticClass:"bx-cell-title"},[_vm._v("多项选择")]),_vm._v(" "),_c('div',{staticClass:"bx-cell-checkbox bx-cell-checked-tick"},[_c('input',{staticClass:"bx-cell-input",attrs:{"type":"checkbox","name":"checkbox-cells-tick"}}),_vm._v(" "),_c('i',{staticClass:"bx-icon"})])])]),_vm._v(" "),_c('div',{staticClass:"bx-cell"},[_c('label',{staticClass:"bx-cell-inner"},[_c('div',{staticClass:"bx-cell-title"},[_vm._v("多项选择")]),_vm._v(" "),_c('div',{staticClass:"bx-cell-checkbox bx-cell-checked-tick"},[_c('input',{staticClass:"bx-cell-input",attrs:{"type":"checkbox","name":"checkbox-cells-tick"}}),_vm._v(" "),_c('i',{staticClass:"bx-icon"})])])]),_vm._v(" "),_c('div',{staticClass:"bx-cell"},[_c('label',{staticClass:"bx-cell-inner"},[_c('div',{staticClass:"bx-cell-title"},[_vm._v("多项选择")]),_vm._v(" "),_c('div',{staticClass:"bx-cell-checkbox bx-cell-checked-tick"},[_c('input',{staticClass:"bx-cell-input",attrs:{"type":"checkbox","name":"checkbox-cells-tick"}}),_vm._v(" "),_c('i',{staticClass:"bx-icon"})])])])])]),_vm._v(" "),_c('div',{staticClass:"demo-form-group"},[_c('h3',{staticClass:"demo-title"},[_vm._v("标题多选")]),_vm._v(" "),_c('div',{staticClass:"bx-cell"},[_c('div',{staticClass:"bx-cell-inner"},[_c('div',{staticClass:"bx-cell-label"},[_vm._v("标题文字")]),_vm._v(" "),_c('div',{staticClass:"bx-cell-input"},[_c('div',{staticClass:"bx-checkbox-inline bx-flex-align bx-flex-main-end"},[_c('div',{staticClass:"bx-cell"},[_c('label',[_c('input',{staticClass:"bx-cell-input",attrs:{"type":"checkbox","name":"checkbox-inline-cells"}}),_vm._v(" "),_c('div',{staticClass:"bx-cell-checkbox"},[_vm._v("计划一")])])]),_vm._v(" "),_c('div',{staticClass:"bx-cell"},[_c('label',[_c('input',{staticClass:"bx-cell-input",attrs:{"type":"checkbox","name":"checkbox-inline-cells"}}),_vm._v(" "),_c('div',{staticClass:"bx-cell-checkbox"},[_vm._v("计划二")])])]),_vm._v(" "),_c('div',{staticClass:"bx-cell"},[_c('label',[_c('input',{staticClass:"bx-cell-input",attrs:{"type":"checkbox","name":"checkbox-inline-cells"}}),_vm._v(" "),_c('div',{staticClass:"bx-cell-checkbox"},[_vm._v("计划三")])])])])])])]),_vm._v(" "),_c('div',{staticClass:"bx-cell"},[_c('div',{staticClass:"bx-cell-inner"},[_c('div',{staticClass:"bx-cell-label"},[_vm._v("标题文字")]),_vm._v(" "),_c('div',{staticClass:"bx-cell-input"},[_c('div',{staticClass:"bx-checkbox-inline bx-checkbox-multiline"},[_c('div',{staticClass:"bx-cell"},[_c('label',[_c('input',{staticClass:"bx-cell-input",attrs:{"type":"checkbox","name":"checkbox-inline-cells"}}),_vm._v(" "),_c('div',{staticClass:"bx-cell-checkbox"},[_vm._v("标题")])])]),_vm._v(" "),_c('div',{staticClass:"bx-cell"},[_c('label',[_c('input',{staticClass:"bx-cell-input",attrs:{"type":"checkbox","name":"checkbox-inline-cells"}}),_vm._v(" "),_c('div',{staticClass:"bx-cell-checkbox"},[_vm._v("标题")])])]),_vm._v(" "),_c('div',{staticClass:"bx-cell"},[_c('label',[_c('input',{staticClass:"bx-cell-input",attrs:{"type":"checkbox","name":"checkbox-inline-cells"}}),_vm._v(" "),_c('div',{staticClass:"bx-cell-checkbox"},[_vm._v("标题")])])]),_vm._v(" "),_c('div',{staticClass:"bx-cell"},[_c('label',[_c('input',{staticClass:"bx-cell-input",attrs:{"type":"checkbox","name":"checkbox-inline-cells"}}),_vm._v(" "),_c('div',{staticClass:"bx-cell-checkbox"},[_vm._v("标题")])])]),_vm._v(" "),_c('div',{staticClass:"bx-cell"},[_c('label',[_c('input',{staticClass:"bx-cell-input",attrs:{"type":"checkbox","name":"checkbox-inline-cells"}}),_vm._v(" "),_c('div',{staticClass:"bx-cell-checkbox"},[_vm._v("标题")])])]),_vm._v(" "),_c('div',{staticClass:"bx-cell"},[_c('label',[_c('input',{staticClass:"bx-cell-input",attrs:{"type":"checkbox","name":"checkbox-inline-cells"}}),_vm._v(" "),_c('div',{staticClass:"bx-cell-checkbox"},[_vm._v("标题")])])]),_vm._v(" "),_c('div',{staticClass:"bx-cell"},[_c('label',[_c('input',{staticClass:"bx-cell-input",attrs:{"type":"checkbox","name":"checkbox-inline-cells"}}),_vm._v(" "),_c('div',{staticClass:"bx-cell-checkbox"},[_vm._v("标题")])])]),_vm._v(" "),_c('div',{staticClass:"bx-cell"},[_c('label',[_c('input',{staticClass:"bx-cell-input",attrs:{"type":"checkbox","name":"checkbox-inline-cells"}}),_vm._v(" "),_c('div',{staticClass:"bx-cell-checkbox"},[_vm._v("标题")])])])])])])])]),_vm._v(" "),_c('div',{staticClass:"demo-form-group"},[_c('h3',{staticClass:"demo-title"},[_vm._v("带开关")]),_vm._v(" "),_c('div',{staticClass:"bx-cell"},[_c('div',{staticClass:"bx-cell-inner"},[_c('div',{staticClass:"bx-cell-title"},[_vm._v("开启(left)")]),_vm._v(" "),_c('div',{staticClass:"bx-cell-extra"},[_c('input',{staticClass:"bx-switch",attrs:{"type":"checkbox","checked":"checked"}})])])]),_vm._v(" "),_c('div',{staticClass:"bx-cell"},[_c('div',{staticClass:"bx-cell-inner"},[_c('div',{staticClass:"bx-cell-title"},[_vm._v("关闭(left)")]),_vm._v(" "),_c('div',{staticClass:"bx-cell-extra"},[_c('input',{staticClass:"bx-switch",attrs:{"type":"checkbox"}})])])]),_vm._v(" "),_c('div',{staticClass:"bx-cell"},[_c('div',{staticClass:"bx-cell-inner"},[_c('div',{staticClass:"bx-cell-title"},[_vm._v("开关(transform)")]),_vm._v(" "),_c('div',{staticClass:"bx-cell-extra"},[_c('input',{staticClass:"bx-switch bx-switch-transform",attrs:{"type":"checkbox"}})])])])]),_vm._v(" "),_c('div',{staticClass:"demo-form-group"},[_c('h3',{staticClass:"demo-title"},[_vm._v("数量")]),_vm._v(" "),_c('div',{staticClass:"bx-cell"},[_c('div',{staticClass:"bx-cell-inner"},[_c('div',{staticClass:"bx-cell-title"},[_vm._v("数量=1")]),_vm._v(" "),_c('div',{staticClass:"bx-cell-extra"},[_c('div',{staticClass:"bx-number-control"},[_c('div',{staticClass:"bx-number-minus bx-number-disabled"}),_vm._v(" "),_c('input',{staticClass:"bx-number-input",attrs:{"type":"text","value":"1"}}),_vm._v(" "),_c('div',{staticClass:"bx-number-plus"})])])])]),_vm._v(" "),_c('div',{staticClass:"bx-cell"},[_c('div',{staticClass:"bx-cell-inner"},[_c('div',{staticClass:"bx-cell-title"},[_vm._v("数量>1")]),_vm._v(" "),_c('div',{staticClass:"bx-cell-extra"},[_c('div',{staticClass:"bx-number-control"},[_c('div',{staticClass:"bx-number-minus"}),_vm._v(" "),_c('input',{staticClass:"bx-number-input",attrs:{"type":"text","value":"1"}}),_vm._v(" "),_c('div',{staticClass:"bx-number-plus"})])])])])]),_vm._v(" "),_c('div',{staticClass:"demo-form-group"},[_c('h3',{staticClass:"demo-title"},[_vm._v("其它")]),_vm._v(" "),_c('div',{staticClass:"bx-cell"},[_c('div',{staticClass:"bx-cell-left demo-cell-left"},[_c('img',{staticClass:"bx-image-responsive",attrs:{"src":"http://img.winbaoxian.com/autoUpload/learning/avatar_default_79148af363.png"}})]),_vm._v(" "),_c('div',{staticClass:"bx-cell-inner bx-flex-cross--center"},[_c('div',{staticClass:"bx-cell-label"},[_vm._v("标题")]),_vm._v(" "),_c('div',{staticClass:"bx-cell-input"},[_c('input',{attrs:{"type":"text","placeholder":"暗提示内容"}})])])])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var ui_Form = (esExports);
// CONCATENATED MODULE: ./src/views/ui/Form.vue
function injectStyle (ssrContext) {
  __webpack_require__("OWXg")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  Form_default.a,
  ui_Form,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var views_ui_Form = __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "iIDT":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "iTU9":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "icP6":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/views/ui/Schedule.vue
var Schedule = __webpack_require__("B7pF");
var Schedule_default = /*#__PURE__*/__webpack_require__.n(Schedule);

// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-18db2d43","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/ui/Schedule.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"demo-panel-title"},[_vm._v("动态效果展示")]),_vm._v(" "),_c('div',{staticClass:"demo-panel"},[_c('div',{staticClass:"demo-title"},[_vm._v("横向进度(效果展示)")]),_vm._v(" "),_c('div',{staticClass:"bx-schedule"},_vm._l((_vm.horizontal),function(item,$index){return _c('div',{staticClass:"bx-schedule-step",class:[(_vm.horizontal.length == ($index+1) && 'bx-schedule--final'),(item.doing && 'bx-schedule--doing'),(item.done && 'bx-schedule--done')]},[(_vm.horizontal.length != ($index+1))?_c('div',{staticClass:"bx-schedule-label"},[_vm._v("\n          "+_vm._s($index+1)+"\n        ")]):_vm._e(),_vm._v(" "),(_vm.horizontal.length == ($index+1))?_c('div',{staticClass:"bx-schedule-label"},[_c('i',{staticClass:"bx-icon"})]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"bx-schedule-title"},[_vm._v(_vm._s(item.title))])])}))]),_vm._v(" "),_c('div',{staticClass:"demo-panel"},[_c('div',{staticClass:"demo-title"},[_vm._v("纵向进度(效果展示)")]),_vm._v(" "),_c('div',{staticClass:"bx-schedule-vertical"},_vm._l((_vm.vertical),function(item,$index){return _c('div',{staticClass:"bx-schedule-step",class:[(_vm.vertical.length == ($index+1) && 'bx-schedule--final'),(item.doing && 'bx-schedule--doing'),(item.done && 'bx-schedule--done')]},[(_vm.vertical.length != ($index+1))?_c('div',{staticClass:"bx-schedule-label"},[_vm._v("\n          "+_vm._s($index+1)+"\n        ")]):_vm._e(),_vm._v(" "),(_vm.vertical.length == ($index+1))?_c('div',{staticClass:"bx-schedule-label"},[_c('i',{staticClass:"bx-icon"})]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"bx-schedule-content"},[_c('div',{staticClass:"bx-schedule-title"},[_vm._v(_vm._s(item.title))]),_vm._v(" "),_c('p',[_vm._v(_vm._s(item.content))])])])}))]),_vm._v(" "),_c('div',{staticClass:"demo-panel-title"},[_vm._v("横向进度")]),_vm._v(" "),_vm._m(0,false,false),_vm._v(" "),_vm._m(1,false,false),_vm._v(" "),_vm._m(2,false,false),_vm._v(" "),_vm._m(3,false,false),_vm._v(" "),_vm._m(4,false,false),_vm._v(" "),_c('div',{staticClass:"demo-panel-title"},[_vm._v("纵向进度")]),_vm._v(" "),_vm._m(5,false,false),_vm._v(" "),_vm._m(6,false,false),_vm._v(" "),_vm._m(7,false,false),_vm._v(" "),_vm._m(8,false,false)])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"demo-panel"},[_c('div',{staticClass:"demo-title"},[_vm._v("横向进度(三个)")]),_vm._v(" "),_c('div',{staticClass:"bx-schedule"},[_c('div',{staticClass:"bx-schedule-step"},[_c('div',{staticClass:"bx-schedule-label"},[_vm._v("1")]),_vm._v(" "),_c('div',{staticClass:"bx-schedule-title"},[_vm._v("方案一")])]),_vm._v(" "),_c('div',{staticClass:"bx-schedule-step"},[_c('div',{staticClass:"bx-schedule-label"},[_vm._v("2")]),_vm._v(" "),_c('div',{staticClass:"bx-schedule-title"},[_vm._v("方案二")])]),_vm._v(" "),_c('div',{staticClass:"bx-schedule-step"},[_c('div',{staticClass:"bx-schedule-label"},[_vm._v("3")]),_vm._v(" "),_c('div',{staticClass:"bx-schedule-title"},[_vm._v("方案三")])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"demo-panel"},[_c('div',{staticClass:"demo-title"},[_vm._v("横向进度(五个)")]),_vm._v(" "),_c('div',{staticClass:"bx-schedule"},[_c('div',{staticClass:"bx-schedule-step"},[_c('div',{staticClass:"bx-schedule-label"},[_vm._v("1")]),_vm._v(" "),_c('div',{staticClass:"bx-schedule-title"},[_vm._v("方案一")])]),_vm._v(" "),_c('div',{staticClass:"bx-schedule-step"},[_c('div',{staticClass:"bx-schedule-label"},[_vm._v("2")]),_vm._v(" "),_c('div',{staticClass:"bx-schedule-title"},[_vm._v("方案二")])]),_vm._v(" "),_c('div',{staticClass:"bx-schedule-step"},[_c('div',{staticClass:"bx-schedule-label"},[_vm._v("3")]),_vm._v(" "),_c('div',{staticClass:"bx-schedule-title"},[_vm._v("方案三")])]),_vm._v(" "),_c('div',{staticClass:"bx-schedule-step"},[_c('div',{staticClass:"bx-schedule-label"},[_vm._v("4")]),_vm._v(" "),_c('div',{staticClass:"bx-schedule-title"},[_vm._v("方案四")])]),_vm._v(" "),_c('div',{staticClass:"bx-schedule-step bx-schedule--final"},[_c('div',{staticClass:"bx-schedule-label"},[_c('i',{staticClass:"bx-icon"})]),_vm._v(" "),_c('div',{staticClass:"bx-schedule-title"},[_vm._v("已完成")])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"demo-panel"},[_c('div',{staticClass:"demo-title"},[_vm._v("横向进度(圆点)")]),_vm._v(" "),_c('div',{staticClass:"bx-schedule"},[_c('div',{staticClass:"bx-schedule-step bx-schedule--dot"},[_c('div',{staticClass:"bx-schedule-label"}),_vm._v(" "),_c('div',{staticClass:"bx-schedule-title"},[_vm._v("方案A")])]),_vm._v(" "),_c('div',{staticClass:"bx-schedule-step bx-schedule--dot"},[_c('div',{staticClass:"bx-schedule-label"}),_vm._v(" "),_c('div',{staticClass:"bx-schedule-title"},[_vm._v("方案B")])]),_vm._v(" "),_c('div',{staticClass:"bx-schedule-step bx-schedule--dot"},[_c('div',{staticClass:"bx-schedule-label"}),_vm._v(" "),_c('div',{staticClass:"bx-schedule-title"},[_vm._v("方案C")])]),_vm._v(" "),_c('div',{staticClass:"bx-schedule-step bx-schedule--dot"},[_c('div',{staticClass:"bx-schedule-label"}),_vm._v(" "),_c('div',{staticClass:"bx-schedule-title"},[_vm._v("方案S")])]),_vm._v(" "),_c('div',{staticClass:"bx-schedule-step bx-schedule--dot"},[_c('div',{staticClass:"bx-schedule-label"}),_vm._v(" "),_c('div',{staticClass:"bx-schedule-title"},[_vm._v("已完成")])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"demo-panel"},[_c('div',{staticClass:"demo-title"},[_vm._v("横向进度(带状态)")]),_vm._v(" "),_c('div',{staticClass:"bx-schedule"},[_c('div',{staticClass:"bx-schedule-step bx-schedule--done"},[_c('div',{staticClass:"bx-schedule-label"},[_vm._v("1")]),_vm._v(" "),_c('div',{staticClass:"bx-schedule-title"},[_vm._v("方案A")])]),_vm._v(" "),_c('div',{staticClass:"bx-schedule-step bx-schedule--done"},[_c('div',{staticClass:"bx-schedule-label"},[_vm._v("2")]),_vm._v(" "),_c('div',{staticClass:"bx-schedule-title"},[_vm._v("方案B")])]),_vm._v(" "),_c('div',{staticClass:"bx-schedule-step bx-schedule--warning"},[_c('div',{staticClass:"bx-schedule-label"},[_c('i',{staticClass:"bx-icon"})]),_vm._v(" "),_c('div',{staticClass:"bx-schedule-title"},[_vm._v("方案C")])]),_vm._v(" "),_c('div',{staticClass:"bx-schedule-step bx-schedule--doing"},[_c('div',{staticClass:"bx-schedule-label"},[_vm._v("4")]),_vm._v(" "),_c('div',{staticClass:"bx-schedule-title"},[_vm._v("方案S")])]),_vm._v(" "),_c('div',{staticClass:"bx-schedule-step bx-schedule--final bx-schedule--done"},[_c('div',{staticClass:"bx-schedule-label bx-icon"},[_c('i',{staticClass:"bx-icon"})]),_vm._v(" "),_c('div',{staticClass:"bx-schedule-title"},[_vm._v("已完成")])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"demo-panel"},[_c('div',{staticClass:"demo-title"},[_vm._v("横向进度(圆点带状态)")]),_vm._v(" "),_c('div',{staticClass:"bx-schedule"},[_c('div',{staticClass:"bx-schedule-step bx-schedule--dot bx-schedule--done"},[_c('div',{staticClass:"bx-schedule-label"}),_vm._v(" "),_c('div',{staticClass:"bx-schedule-title"},[_vm._v("方案一")])]),_vm._v(" "),_c('div',{staticClass:"bx-schedule-step bx-schedule--dot bx-schedule--done"},[_c('div',{staticClass:"bx-schedule-label"}),_vm._v(" "),_c('div',{staticClass:"bx-schedule-title"},[_vm._v("方案B")])]),_vm._v(" "),_c('div',{staticClass:"bx-schedule-step bx-schedule--dot bx-schedule--warning"},[_c('div',{staticClass:"bx-schedule-label"}),_vm._v(" "),_c('div',{staticClass:"bx-schedule-title"},[_vm._v("方案B")])]),_vm._v(" "),_c('div',{staticClass:"bx-schedule-step bx-schedule--dot bx-schedule--doing"},[_c('div',{staticClass:"bx-schedule-label"}),_vm._v(" "),_c('div',{staticClass:"bx-schedule-title"},[_vm._v("方案B")])]),_vm._v(" "),_c('div',{staticClass:"bx-schedule-step bx-schedule--dot"},[_c('div',{staticClass:"bx-schedule-label"}),_vm._v(" "),_c('div',{staticClass:"bx-schedule-title"},[_vm._v("已完成")])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"demo-panel"},[_c('div',{staticClass:"demo-title"},[_vm._v("纵向进度(三个)")]),_vm._v(" "),_c('div',{staticClass:"bx-schedule-vertical"},[_c('div',{staticClass:"bx-schedule-step"},[_c('div',{staticClass:"bx-schedule-label"},[_vm._v("1")]),_vm._v(" "),_c('div',{staticClass:"bx-schedule-content"},[_c('div',{staticClass:"bx-schedule-title"},[_vm._v("方案一")]),_vm._v(" "),_c('p',[_vm._v("这里是说明文案")])])]),_vm._v(" "),_c('div',{staticClass:"bx-schedule-step"},[_c('div',{staticClass:"bx-schedule-label"},[_vm._v("2")]),_vm._v(" "),_c('div',{staticClass:"bx-schedule-content"},[_c('div',{staticClass:"bx-schedule-title"},[_vm._v("方案二")]),_vm._v(" "),_c('p',[_vm._v("这里是说明文案")])])]),_vm._v(" "),_c('div',{staticClass:"bx-schedule-step"},[_c('div',{staticClass:"bx-schedule-label"},[_vm._v("3")]),_vm._v(" "),_c('div',{staticClass:"bx-schedule-content"},[_c('div',{staticClass:"bx-schedule-title"},[_vm._v("方案三")]),_vm._v(" "),_c('p',[_vm._v("这里是说明文案")])])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"demo-panel"},[_c('div',{staticClass:"demo-title"},[_vm._v("纵向进度(圆点)")]),_vm._v(" "),_c('div',{staticClass:"bx-schedule-vertical"},[_c('div',{staticClass:"bx-schedule-step bx-schedule--dot"},[_c('div',{staticClass:"bx-schedule-label"}),_vm._v(" "),_c('div',{staticClass:"bx-schedule-content"},[_c('div',{staticClass:"bx-schedule-title"},[_vm._v("方案一")]),_vm._v(" "),_c('p',[_vm._v("这里是说明文案,这里是说明文案,这里是说明文案,这里是说明文案,这里是说明文案,这里是说明文案,这里是说明文案,这里是说明文案,这里是说明文案,这里是说明文案,这里是说明文案,这里是说明文案。")])])]),_vm._v(" "),_c('div',{staticClass:"bx-schedule-step bx-schedule--dot"},[_c('div',{staticClass:"bx-schedule-label"}),_vm._v(" "),_c('div',{staticClass:"bx-schedule-content"},[_c('div',{staticClass:"bx-schedule-title"},[_vm._v("方案二")]),_vm._v(" "),_c('p',[_vm._v("这里是说明文案")])])]),_vm._v(" "),_c('div',{staticClass:"bx-schedule-step bx-schedule--dot"},[_c('div',{staticClass:"bx-schedule-label"}),_vm._v(" "),_c('div',{staticClass:"bx-schedule-content"},[_c('div',{staticClass:"bx-schedule-title"},[_vm._v("方案三")]),_vm._v(" "),_c('p',[_vm._v("这里是说明文案")])])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"demo-panel"},[_c('div',{staticClass:"demo-title"},[_vm._v("纵向进度(带状态)")]),_vm._v(" "),_c('div',{staticClass:"bx-schedule-vertical"},[_c('div',{staticClass:"bx-schedule-step bx-schedule--done"},[_c('div',{staticClass:"bx-schedule-label"},[_vm._v("1")]),_vm._v(" "),_c('div',{staticClass:"bx-schedule-content"},[_c('div',{staticClass:"bx-schedule-title"},[_vm._v("方案一")]),_vm._v(" "),_c('p',[_vm._v("这里是说明文案")])])]),_vm._v(" "),_c('div',{staticClass:"bx-schedule-step bx-schedule--done"},[_c('div',{staticClass:"bx-schedule-label"},[_vm._v("2")]),_vm._v(" "),_c('div',{staticClass:"bx-schedule-content"},[_c('div',{staticClass:"bx-schedule-title"},[_vm._v("方案二")]),_vm._v(" "),_c('p',[_vm._v("这里是说明文案")])])]),_vm._v(" "),_c('div',{staticClass:"bx-schedule-step bx-schedule--warning"},[_c('div',{staticClass:"bx-schedule-label"},[_c('i',{staticClass:"bx-icon"})]),_vm._v(" "),_c('div',{staticClass:"bx-schedule-content"},[_c('div',{staticClass:"bx-schedule-title"},[_vm._v("方案三")]),_vm._v(" "),_c('p',[_vm._v("这里是说明文案")])])]),_vm._v(" "),_c('div',{staticClass:"bx-schedule-step bx-schedule--doing"},[_c('div',{staticClass:"bx-schedule-label"},[_vm._v("4")]),_vm._v(" "),_c('div',{staticClass:"bx-schedule-content"},[_c('div',{staticClass:"bx-schedule-title"},[_vm._v("方案四")]),_vm._v(" "),_c('p',[_vm._v("这里是说明文案")])])]),_vm._v(" "),_c('div',{staticClass:"bx-schedule-step bx-schedule--final bx-schedule--done"},[_c('div',{staticClass:"bx-schedule-label"},[_c('i',{staticClass:"bx-icon"})]),_vm._v(" "),_c('div',{staticClass:"bx-schedule-content"},[_c('div',{staticClass:"bx-schedule-title"},[_vm._v("方案三")]),_vm._v(" "),_c('p',[_vm._v("这里是说明文案")])])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"demo-panel"},[_c('div',{staticClass:"demo-title"},[_vm._v("纵向进度(圆点带状态)")]),_vm._v(" "),_c('div',{staticClass:"bx-schedule-vertical"},[_c('div',{staticClass:"bx-schedule-step bx-schedule--dot bx-schedule--done"},[_c('div',{staticClass:"bx-schedule-label"}),_vm._v(" "),_c('div',{staticClass:"bx-schedule-content"},[_c('div',{staticClass:"bx-schedule-title"},[_vm._v("方案一")]),_vm._v(" "),_c('p',[_vm._v("这里是说明文案")])])]),_vm._v(" "),_c('div',{staticClass:"bx-schedule-step bx-schedule--dot bx-schedule--done"},[_c('div',{staticClass:"bx-schedule-label"}),_vm._v(" "),_c('div',{staticClass:"bx-schedule-content"},[_c('div',{staticClass:"bx-schedule-title"},[_vm._v("方案二")]),_vm._v(" "),_c('p',[_vm._v("这里是说明文案")])])]),_vm._v(" "),_c('div',{staticClass:"bx-schedule-step bx-schedule--dot bx-schedule--warning"},[_c('div',{staticClass:"bx-schedule-label"}),_vm._v(" "),_c('div',{staticClass:"bx-schedule-content"},[_c('div',{staticClass:"bx-schedule-title"},[_vm._v("方案三")]),_vm._v(" "),_c('p',[_vm._v("这里是说明文案")])])]),_vm._v(" "),_c('div',{staticClass:"bx-schedule-step bx-schedule--dot bx-schedule--doing"},[_c('div',{staticClass:"bx-schedule-label"}),_vm._v(" "),_c('div',{staticClass:"bx-schedule-content"},[_c('div',{staticClass:"bx-schedule-title"},[_vm._v("方案四")]),_vm._v(" "),_c('p',[_vm._v("这里是说明文案")])])]),_vm._v(" "),_c('div',{staticClass:"bx-schedule-step bx-schedule--dot bx-schedule--done"},[_c('div',{staticClass:"bx-schedule-label"}),_vm._v(" "),_c('div',{staticClass:"bx-schedule-content"},[_c('div',{staticClass:"bx-schedule-title"},[_vm._v("方案三")]),_vm._v(" "),_c('p',[_vm._v("这里是说明文案")])])])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var ui_Schedule = (esExports);
// CONCATENATED MODULE: ./src/views/ui/Schedule.vue
function injectStyle (ssrContext) {
  __webpack_require__("+W95")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-18db2d43"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  Schedule_default.a,
  ui_Schedule,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var views_ui_Schedule = __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "j7e0":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/views/Home.vue
var Home = __webpack_require__("UOlw");
var Home_default = /*#__PURE__*/__webpack_require__.n(Home);

// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3939b49a","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/Home.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"demo-home"},[_vm._m(0,false,false),_vm._v(" "),_vm._m(1,false,false),_vm._v(" "),_c('ul',{staticClass:"bx-list"},[_c('li',{staticClass:"bx-list-item"},[_c('div',{staticClass:"bx-list-item-title"},[_c('router-link',{attrs:{"to":"messagebox"}},[_vm._v("MessageBox对话框")])],1),_vm._v(" "),_vm._m(2,false,false)]),_vm._v(" "),_c('li',{staticClass:"bx-list-item"},[_c('div',{staticClass:"bx-list-item-title"},[_c('router-link',{attrs:{"to":"loading"}},[_vm._v("Loading加载")])],1),_vm._v(" "),_vm._m(3,false,false)]),_vm._v(" "),_c('li',{staticClass:"bx-list-item"},[_c('div',{staticClass:"bx-list-item-title"},[_c('router-link',{attrs:{"to":"audio"}},[_vm._v("Audio音频")])],1),_vm._v(" "),_vm._m(4,false,false)]),_vm._v(" "),_c('li',{staticClass:"bx-list-item"},[_c('div',{staticClass:"bx-list-item-title"},[_c('router-link',{attrs:{"to":"swiper"}},[_vm._v("Swiper轮播")])],1),_vm._v(" "),_vm._m(5,false,false)]),_vm._v(" "),_c('li',{staticClass:"bx-list-item"},[_c('div',{staticClass:"bx-list-item-title"},[_c('router-link',{attrs:{"to":"tab"}},[_vm._v("Tab切换")])],1),_vm._v(" "),_vm._m(6,false,false)]),_vm._v(" "),_c('li',{staticClass:"bx-list-item"},[_c('div',{staticClass:"bx-list-item-title"},[_c('router-link',{attrs:{"to":"signature"}},[_vm._v("Signature电子签名")])],1),_vm._v(" "),_vm._m(7,false,false)]),_vm._v(" "),_c('li',{staticClass:"bx-list-item"},[_c('div',{staticClass:"bx-list-item-title"},[_c('router-link',{attrs:{"to":"uploader"}},[_vm._v("Uploader上传")])],1),_vm._v(" "),_vm._m(8,false,false)])]),_vm._v(" "),_vm._m(9,false,false),_vm._v(" "),_c('ul',{staticClass:"bx-list"},[_c('li',{staticClass:"bx-list-item"},[_c('div',{staticClass:"bx-list-item-title"},[_c('router-link',{attrs:{"to":"/ui/flex"}},[_vm._v("Flex布局")])],1),_vm._v(" "),_vm._m(10,false,false)]),_vm._v(" "),_c('li',{staticClass:"bx-list-item"},[_c('div',{staticClass:"bx-list-item-title"},[_c('router-link',{attrs:{"to":"/ui/panel"}},[_vm._v("Panel面板")])],1),_vm._v(" "),_vm._m(11,false,false)]),_vm._v(" "),_c('li',{staticClass:"bx-list-item"},[_c('div',{staticClass:"bx-list-item-title"},[_c('router-link',{attrs:{"to":"/ui/list"}},[_vm._v("List列表")])],1),_vm._v(" "),_vm._m(12,false,false)]),_vm._v(" "),_c('li',{staticClass:"bx-list-item"},[_c('div',{staticClass:"bx-list-item-title"},[_c('router-link',{attrs:{"to":"/ui/button"}},[_vm._v("Button按钮")])],1),_vm._v(" "),_vm._m(13,false,false)]),_vm._v(" "),_c('li',{staticClass:"bx-list-item"},[_c('div',{staticClass:"bx-list-item-title"},[_c('router-link',{attrs:{"to":"/ui/icon"}},[_vm._v("Icon内置图标")])],1),_vm._v(" "),_vm._m(14,false,false)]),_vm._v(" "),_c('li',{staticClass:"bx-list-item"},[_c('div',{staticClass:"bx-list-item-title"},[_c('router-link',{attrs:{"to":"/ui/form"}},[_vm._v("Form表单集合")])],1),_vm._v(" "),_vm._m(15,false,false)]),_vm._v(" "),_c('li',{staticClass:"bx-list-item"},[_c('div',{staticClass:"bx-list-item-title"},[_c('router-link',{attrs:{"to":"/ui/modal"}},[_vm._v("Modal模态框")])],1),_vm._v(" "),_vm._m(16,false,false)]),_vm._v(" "),_c('li',{staticClass:"bx-list-item"},[_c('div',{staticClass:"bx-list-item-title"},[_c('router-link',{attrs:{"to":"/ui/label"}},[_vm._v("Label标签 / Badge徽章")])],1),_vm._v(" "),_vm._m(17,false,false)]),_vm._v(" "),_c('li',{staticClass:"bx-list-item"},[_c('div',{staticClass:"bx-list-item-title"},[_c('router-link',{attrs:{"to":"/ui/search"}},[_vm._v("Search搜索栏")])],1),_vm._v(" "),_vm._m(18,false,false)]),_vm._v(" "),_c('li',{staticClass:"bx-list-item"},[_c('div',{staticClass:"bx-list-item-title"},[_c('router-link',{attrs:{"to":"/ui/schedule"}},[_vm._v("Schedule进度")])],1),_vm._v(" "),_vm._m(19,false,false)])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"demo-home-top"},[_c('h3',{staticClass:"demo-home-title"},[_c('a',{attrs:{"href":"#","target":"_blank"}},[_vm._v("Hello-UI")])]),_vm._v(" "),_c('p',{staticClass:"demo-home-subtitle"},[_vm._v("\n      Hello移动组件库, 请查看\n      "),_c('a',{attrs:{"href":"https://qiuguorong.github.io/hello-ui/docs/#/","target":"_blank"}},[_vm._v("文档")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"demo-home-top"},[_c('h3',{staticClass:"demo-home-title"},[_vm._v("业务组件")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"bx-list-item-link"},[_c('i',{staticClass:"bx-icon bx-icon-arrows-right"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"bx-list-item-link"},[_c('i',{staticClass:"bx-icon bx-icon-arrows-right"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"bx-list-item-link"},[_c('i',{staticClass:"bx-icon bx-icon-arrows-right"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"bx-list-item-link"},[_c('i',{staticClass:"bx-icon bx-icon-arrows-right"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"bx-list-item-link"},[_c('i',{staticClass:"bx-icon bx-icon-arrows-right"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"bx-list-item-link"},[_c('i',{staticClass:"bx-icon bx-icon-arrows-right"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"bx-list-item-link"},[_c('i',{staticClass:"bx-icon bx-icon-arrows-right"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"demo-home-top"},[_c('h3',{staticClass:"demo-home-title"},[_vm._v("基础样式")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"bx-list-item-link"},[_c('i',{staticClass:"bx-icon bx-icon-arrows-right"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"bx-list-item-link"},[_c('i',{staticClass:"bx-icon bx-icon-arrows-right"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"bx-list-item-link"},[_c('i',{staticClass:"bx-icon bx-icon-arrows-right"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"bx-list-item-link"},[_c('i',{staticClass:"bx-icon bx-icon-arrows-right"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"bx-list-item-link"},[_c('i',{staticClass:"bx-icon bx-icon-arrows-right"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"bx-list-item-link"},[_c('i',{staticClass:"bx-icon bx-icon-arrows-right"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"bx-list-item-link"},[_c('i',{staticClass:"bx-icon bx-icon-arrows-right"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"bx-list-item-link"},[_c('i',{staticClass:"bx-icon bx-icon-arrows-right"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"bx-list-item-link"},[_c('i',{staticClass:"bx-icon bx-icon-arrows-right"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"bx-list-item-link"},[_c('i',{staticClass:"bx-icon bx-icon-arrows-right"})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var views_Home = (esExports);
// CONCATENATED MODULE: ./src/views/Home.vue
function injectStyle (ssrContext) {
  __webpack_require__("AXd+")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-3939b49a"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  Home_default.a,
  views_Home,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var src_views_Home = __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "j9++":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _signature = __webpack_require__("7HnR");

var _signature2 = _interopRequireDefault(_signature);

var _uploader = __webpack_require__("i36v");

var _uploader2 = _interopRequireDefault(_uploader);

var _common = __webpack_require__("X2Oc");

var _common2 = _interopRequireDefault(_common);

var _api = __webpack_require__("VsUZ");

var _api2 = _interopRequireDefault(_api);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

var FILEDIR = 'tinsurance_refund';
exports.default = {
  data: function data() {
    return {
      show: false,
      base64: null,
      image: null,
      signature: null
    };
  },

  methods: {
    getSuffix: function getSuffix(filename) {
      var pos = filename.lastIndexOf('.');
      var suffix = '';
      if (pos !== -1) {
        suffix = filename.substring(pos);
      }
      return suffix;
    },
    createImage: function createImage() {
      var self = this;
      self.base64 = self.signature.toImage();
      self.base64 && self.uploadBase64();
    },
    clearCanvas: function clearCanvas() {
      var self = this;
      self.signature.reset();
      self.image = null;
      self.base64 = null;
    },
    showPopup: function showPopup() {
      var self = this;
      self.show = true;
      self.$nextTick(function () {
        if (!self.signature) {
          // eslint-disable-next-line
          self.signature = new _signature2.default('.bx-signature', {});
        }
      });
    },
    hidePopup: function hidePopup() {
      var self = this;
      self.show = false;
    },
    uploadBase64: function uploadBase64() {
      var self = this;
      // eslint-disable-next-line
      var uploader = new _uploader2.default(null, {
        url: window.location.origin + '/oss/upload',
        data: {
          success_action_status: 200
        },
        autoUpload: false,
        base64: self.base64,
        onBefore: function onBefore(file) {
          _api2.default.getAuthInfo(FILEDIR).then(function (response) {
            var data = response.data.data;
            // 正式情况使用
            // uploader.options.url = data.host;
            uploader.options.data.signature = data.signature;
            uploader.options.data.policy = data.policy;
            uploader.options.data.OSSAccessKeyId = data.accessid;
            uploader.options.data.key = data.dir + data.fileName + '.png';
            uploader.upload();
          });
        },
        onSuccess: function onSuccess() {
          self.image = 'http://media.winbaoxian.com/' + this.options.data.key;
        },
        onError: function onError(xhr, status, message) {
          console.log(xhr, status, message);
        }
      });
    }
  },
  created: function created() {
    _common2.default.setCookie('adminToken', '2909498feecb4ef1a571b4ec4dda36f7');
  },
  mounted: function mounted() {}
};
module.exports = exports['default'];

/***/ }),

/***/ "jgQM":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "kM2E":
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__("7KvD");
var core = __webpack_require__("FeBl");
var ctx = __webpack_require__("+ZMJ");
var hide = __webpack_require__("hJx8");
var PROTOTYPE = 'prototype';

var $export = function (type, name, source) {
  var IS_FORCED = type & $export.F;
  var IS_GLOBAL = type & $export.G;
  var IS_STATIC = type & $export.S;
  var IS_PROTO = type & $export.P;
  var IS_BIND = type & $export.B;
  var IS_WRAP = type & $export.W;
  var exports = IS_GLOBAL ? core : core[name] || (core[name] = {});
  var expProto = exports[PROTOTYPE];
  var target = IS_GLOBAL ? global : IS_STATIC ? global[name] : (global[name] || {})[PROTOTYPE];
  var key, own, out;
  if (IS_GLOBAL) source = name;
  for (key in source) {
    // contains in native
    own = !IS_FORCED && target && target[key] !== undefined;
    if (own && key in exports) continue;
    // export native or passed
    out = own ? target[key] : source[key];
    // prevent global pollution for namespaces
    exports[key] = IS_GLOBAL && typeof target[key] != 'function' ? source[key]
    // bind timers to global for call from export context
    : IS_BIND && own ? ctx(out, global)
    // wrap global constructors for prevent change them in library
    : IS_WRAP && target[key] == out ? (function (C) {
      var F = function (a, b, c) {
        if (this instanceof C) {
          switch (arguments.length) {
            case 0: return new C();
            case 1: return new C(a);
            case 2: return new C(a, b);
          } return new C(a, b, c);
        } return C.apply(this, arguments);
      };
      F[PROTOTYPE] = C[PROTOTYPE];
      return F;
    // make static versions for prototype methods
    })(out) : IS_PROTO && typeof out == 'function' ? ctx(Function.call, out) : out;
    // export proto methods to core.%CONSTRUCTOR%.methods.%NAME%
    if (IS_PROTO) {
      (exports.virtual || (exports.virtual = {}))[key] = out;
      // export proto methods to core.%CONSTRUCTOR%.prototype.%NAME%
      if (type & $export.R && expProto && !expProto[key]) hide(expProto, key, out);
    }
  }
};
// type bitmap
$export.F = 1;   // forced
$export.G = 2;   // global
$export.S = 4;   // static
$export.P = 8;   // proto
$export.B = 16;  // bind
$export.W = 32;  // wrap
$export.U = 64;  // safe
$export.R = 128; // real proto method for `library`
module.exports = $export;


/***/ }),

/***/ "l8zQ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/views/ui/Label.vue
var Label = __webpack_require__("MQ77");
var Label_default = /*#__PURE__*/__webpack_require__.n(Label);

// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-e14ae1f4","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/ui/Label.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0,false,false)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"demo-label"},[_c('div',{staticClass:"demo-panel-title"},[_vm._v("标准内容")]),_vm._v(" "),_c('div',{staticClass:"demo-label-group"},[_c('div',{staticClass:"demo-title"},[_vm._v("Badge(标准,12px)")]),_vm._v(" "),_c('div',{staticClass:"bx-panel"},[_c('div',{staticClass:"bx-panel-body"},[_c('div',{staticClass:"bx-panel-inner"},[_c('div',{staticClass:"bx-badge"},[_vm._v("0")]),_vm._v(" "),_c('div',{staticClass:"bx-badge"},[_vm._v("1")]),_vm._v(" "),_c('div',{staticClass:"bx-badge"},[_vm._v("2")]),_vm._v(" "),_c('div',{staticClass:"bx-badge"},[_vm._v("3")]),_vm._v(" "),_c('div',{staticClass:"bx-badge"},[_vm._v("4")]),_vm._v(" "),_c('div',{staticClass:"bx-badge"},[_vm._v("5")]),_vm._v(" "),_c('div',{staticClass:"bx-badge"},[_vm._v("6")]),_vm._v(" "),_c('div',{staticClass:"bx-badge"},[_vm._v("7")]),_vm._v(" "),_c('div',{staticClass:"bx-badge"},[_vm._v("8")]),_vm._v(" "),_c('div',{staticClass:"bx-badge"},[_vm._v("9")])]),_vm._v(" "),_c('div',{staticClass:"bx-panel-inner"},[_c('div',{staticClass:"bx-badge bx-badge-dot"}),_vm._v(" "),_c('div',{staticClass:"bx-badge"},[_vm._v("10")]),_vm._v(" "),_c('div',{staticClass:"bx-badge"},[_vm._v("200")]),_vm._v(" "),_c('div',{staticClass:"bx-badge"},[_vm._v("99+")])])])])]),_vm._v(" "),_c('div',{staticClass:"demo-label-group"},[_c('div',{staticClass:"demo-title"},[_vm._v("Label(标准,12px)")]),_vm._v(" "),_c('div',{staticClass:"bx-panel"},[_c('div',{staticClass:"bx-panel-body"},[_c('div',{staticClass:"bx-panel-inner"},[_c('div',{staticClass:"bx-label"},[_vm._v("默认标签")]),_vm._v(" "),_c('div',{staticClass:"bx-label bx-label--red"},[_vm._v("红色标签")]),_vm._v(" "),_c('div',{staticClass:"bx-label bx-label--orange"},[_vm._v("橙色标签")]),_vm._v(" "),_c('div',{staticClass:"bx-label bx-label--yellow"},[_vm._v("黄色标签")]),_vm._v(" "),_c('div',{staticClass:"bx-label bx-label--gray"},[_vm._v("灰色标签")])]),_vm._v(" "),_c('div',{staticClass:"bx-panel-inner"},[_c('div',{staticClass:"bx-label bx-label--plain"},[_vm._v("默认标签")]),_vm._v(" "),_c('div',{staticClass:"bx-label bx-label--red bx-label--plain"},[_vm._v("红色标签")]),_vm._v(" "),_c('div',{staticClass:"bx-label bx-label--orange bx-label--plain"},[_vm._v("橙色标签")]),_vm._v(" "),_c('div',{staticClass:"bx-label bx-label--yellow bx-label--plain"},[_vm._v("黄色标签")]),_vm._v(" "),_c('div',{staticClass:"bx-label bx-label--gray bx-label--plain"},[_vm._v("灰色标签")])])])])]),_vm._v(" "),_c('div',{staticClass:"demo-panel-title"},[_vm._v("效果调试"),_c('span',{staticClass:"demo-panel-title-subtitle"},[_vm._v("(可IOS与Android设备同时访问,对比效果)")])]),_vm._v(" "),_c('div',{staticClass:"demo-label-group"},[_c('div',{staticClass:"demo-title"},[_vm._v("Badge(10px)")]),_vm._v(" "),_c('div',{staticClass:"bx-panel"},[_c('div',{staticClass:"bx-panel-body"},[_c('div',{staticClass:"bx-panel-inner"},[_c('div',{staticClass:"bx-badge bx-badge--sm"},[_vm._v("0")]),_vm._v(" "),_c('div',{staticClass:"bx-badge bx-badge--sm"},[_vm._v("1")]),_vm._v(" "),_c('div',{staticClass:"bx-badge bx-badge--sm"},[_vm._v("2")]),_vm._v(" "),_c('div',{staticClass:"bx-badge bx-badge--sm"},[_vm._v("3")])]),_vm._v(" "),_c('div',{staticClass:"bx-panel-inner"},[_c('div',{staticClass:"bx-badge bx-badge--sm"},[_vm._v("10")]),_vm._v(" "),_c('div',{staticClass:"bx-badge bx-badge--sm"},[_vm._v("200")]),_vm._v(" "),_c('div',{staticClass:"bx-badge bx-badge--sm"},[_vm._v("99+")]),_vm._v(" "),_c('div',{staticClass:"bx-badge bx-badge--sm"},[_vm._v("9999+")])])])])]),_vm._v(" "),_c('div',{staticClass:"demo-label-group"},[_c('div',{staticClass:"demo-title"},[_vm._v("Badge-VerticalAlign(10px,-2px)")]),_vm._v(" "),_c('div',{staticClass:"bx-panel"},[_c('div',{staticClass:"bx-panel-body"},[_c('div',{staticClass:"bx-panel-inner"},[_c('div',{staticClass:"bx-badge bx-badge--sm"},[_c('span',{staticClass:"bx-badge-content"},[_vm._v("0")])]),_vm._v(" "),_c('div',{staticClass:"bx-badge bx-badge--sm"},[_c('span',{staticClass:"bx-badge-content"},[_vm._v("1")])]),_vm._v(" "),_c('div',{staticClass:"bx-badge bx-badge--sm"},[_c('span',{staticClass:"bx-badge-content"},[_vm._v("2")])]),_vm._v(" "),_c('div',{staticClass:"bx-badge bx-badge--sm"},[_c('span',{staticClass:"bx-badge-content"},[_vm._v("3")])])]),_vm._v(" "),_c('div',{staticClass:"bx-panel-inner"},[_c('div',{staticClass:"bx-badge bx-badge--sm"},[_c('span',{staticClass:"bx-badge-content"},[_vm._v("10")])]),_vm._v(" "),_c('div',{staticClass:"bx-badge bx-badge--sm"},[_c('span',{staticClass:"bx-badge-content"},[_vm._v("200")])]),_vm._v(" "),_c('div',{staticClass:"bx-badge bx-badge--sm"},[_c('span',{staticClass:"bx-badge-content"},[_vm._v("99+")])])])])])]),_vm._v(" "),_c('div',{staticClass:"demo-label-group"},[_c('div',{staticClass:"demo-title"},[_vm._v("Badge-scale(10px)")]),_vm._v(" "),_c('div',{staticClass:"bx-panel"},[_c('div',{staticClass:"bx-panel-body"},[_c('div',{staticClass:"bx-panel-inner"},[_c('div',{staticClass:"bx-badge-scale"},[_vm._v("0")]),_vm._v(" "),_c('div',{staticClass:"bx-badge-scale"},[_vm._v("1")]),_vm._v(" "),_c('div',{staticClass:"bx-badge-scale"},[_vm._v("2")]),_vm._v(" "),_c('div',{staticClass:"bx-badge-scale"},[_vm._v("3")]),_vm._v(" "),_c('div',{staticClass:"bx-badge-scale"},[_vm._v("4")]),_vm._v(" "),_c('div',{staticClass:"bx-badge-scale"},[_vm._v("5")]),_vm._v(" "),_c('div',{staticClass:"bx-badge-scale"},[_vm._v("6")]),_vm._v(" "),_c('div',{staticClass:"bx-badge-scale"},[_vm._v("7")]),_vm._v(" "),_c('div',{staticClass:"bx-badge-scale"},[_vm._v("8")]),_vm._v(" "),_c('div',{staticClass:"bx-badge-scale"},[_vm._v("9")])]),_vm._v(" "),_c('div',{staticClass:"bx-panel-inner"},[_c('div',{staticClass:"bx-badge-scale"},[_vm._v("10")]),_vm._v(" "),_c('div',{staticClass:"bx-badge-scale"},[_vm._v("200")]),_vm._v(" "),_c('div',{staticClass:"bx-badge-scale"},[_vm._v("99+")])])])])]),_vm._v(" "),_c('div',{staticClass:"demo-label-group"},[_c('div',{staticClass:"demo-title"},[_vm._v("Label(11px)")]),_vm._v(" "),_c('div',{staticClass:"bx-panel"},[_c('div',{staticClass:"bx-panel-body"},[_c('div',{staticClass:"bx-panel-inner"},[_c('div',{staticClass:"bx-label",staticStyle:{"font-size":"11px"}},[_vm._v("默认标签")]),_vm._v(" "),_c('div',{staticClass:"bx-label bx-label--red",staticStyle:{"font-size":"11px"}},[_vm._v("红色标签")])]),_vm._v(" "),_c('div',{staticClass:"bx-panel-inner"},[_c('div',{staticClass:"bx-label bx-label--plain",staticStyle:{"font-size":"11px"}},[_vm._v("默认标签")]),_vm._v(" "),_c('div',{staticClass:"bx-label bx-label--red bx-label--plain",staticStyle:{"font-size":"11px"}},[_vm._v("红色标签")])])])])]),_vm._v(" "),_c('div',{staticClass:"demo-label-group"},[_c('div',{staticClass:"demo-title"},[_vm._v("Label(10px)")]),_vm._v(" "),_c('div',{staticClass:"bx-panel"},[_c('div',{staticClass:"bx-panel-body"},[_c('div',{staticClass:"bx-panel-inner"},[_c('div',{staticClass:"bx-label bx-label--sm",staticStyle:{"padding":"0 3px","line-height":"15px","height":"15px"}},[_vm._v("默认标签")]),_vm._v(" "),_c('div',{staticClass:"bx-label bx-label--sm bx-label--red"},[_vm._v("红色标签")]),_vm._v(" "),_c('div',{staticClass:"bx-label bx-label--sm bx-label--orange",staticStyle:{"padding":"1px 3px"}},[_c('span',{staticStyle:{"vertical-align":"-2px"}},[_vm._v("abc标签")])]),_vm._v(" "),_c('div',{staticClass:"bx-label bx-label--sm bx-label--yellow"},[_vm._v("黄色标签")]),_vm._v(" "),_c('div',{staticClass:"bx-label bx-label--sm bx-label--gray",staticStyle:{"padding":"0 3px","line-height":"17px","height":"17px"}},[_vm._v("灰色标签")])]),_vm._v(" "),_c('div',{staticClass:"bx-panel-inner"},[_c('div',{staticClass:"bx-label bx-label--sm bx-label--plain"},[_vm._v("默认标签")]),_vm._v(" "),_c('div',{staticClass:"bx-label bx-label--sm bx-label--plain bx-label--red"},[_vm._v("红色标签")]),_vm._v(" "),_c('div',{staticClass:"bx-label bx-label--sm bx-label--plain bx-label--orange"},[_vm._v("橙色标签")]),_vm._v(" "),_c('div',{staticClass:"bx-label bx-label--sm bx-label--plain bx-label--yellow"},[_vm._v("黄色标签")]),_vm._v(" "),_c('div',{staticClass:"bx-label bx-label--sm bx-label--gray bx-label--plain"},[_vm._v("灰色标签")])])])])]),_vm._v(" "),_c('div',{staticClass:"demo-label-group"},[_c('div',{staticClass:"demo-title"},[_vm._v("Label-Scale(10px)")]),_vm._v(" "),_c('div',{staticClass:"bx-panel"},[_c('div',{staticClass:"bx-panel-body"},[_c('div',{staticClass:"bx-panel-inner"},[_c('div',{staticClass:"bx-label-scale"},[_vm._v("默认标签")]),_vm._v(" "),_c('div',{staticClass:"bx-label-scale bx-label--red"},[_vm._v("红色标签")]),_vm._v(" "),_c('div',{staticClass:"bx-label-scale bx-label--plain"},[_vm._v("默认标签")]),_vm._v(" "),_c('div',{staticClass:"bx-label-scale bx-label--red bx-label--plain"},[_vm._v("默认标签")])])])])]),_vm._v(" "),_c('div',{staticClass:"demo-label-group"},[_c('div',{staticClass:"demo-title"},[_vm._v("Label-Tabel(10px)")]),_vm._v(" "),_c('div',{staticClass:"bx-panel"},[_c('div',{staticClass:"bx-panel-body"},[_c('div',{staticClass:"bx-panel-inner"},[_c('div',{staticClass:"bx-label-table"},[_c('div',{staticClass:"bx-label-cell"},[_vm._v("默认标签")])])])])])]),_vm._v(" "),_c('div',{staticClass:"demo-label-group"},[_c('div',{staticClass:"demo-title"},[_vm._v("Label-Flex(10px)")]),_vm._v(" "),_c('div',{staticClass:"bx-panel"},[_c('div',{staticClass:"bx-panel-body"},[_c('div',{staticClass:"bx-panel-inner"},[_c('div',{staticClass:"bx-label bx-label--sm bx-flex bx-flex-align bx-flex-main-center bx-flex-cross-center bx-flex-item-align-center"},[_c('div',{staticClass:"bx-flex-item"},[_vm._v("默认标签默认标签")])])])])])]),_vm._v(" "),_c('div',{staticClass:"demo-label-group"},[_c('div',{staticClass:"demo-title"},[_vm._v("Label-Position(10px)")]),_vm._v(" "),_c('div',{staticClass:"bx-panel"},[_c('div',{staticClass:"bx-panel-body"},[_c('div',{staticClass:"bx-panel-inner"},[_c('div',{staticStyle:{"color":"#FFF","position":"relative","font-size":"10px","background-color":"red","width":"100px","height":"16px"}},[_c('div',{staticStyle:{"position":"absolute","top":"50%","left":"50%","transform":"translate(-50%,-50%)"}},[_vm._v("默认标签")])]),_vm._v(" "),_c('div',{staticStyle:{"margin-top":"10px","color":"#FFF","position":"relative","font-size":"10px","background-color":"red","width":"100px","height":"16px"}},[_c('div',{staticStyle:{"position":"absolute","top":"3px","left":"50%","transform":"translateX(-50%)"}},[_vm._v("默认标签")])])])])])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var ui_Label = (esExports);
// CONCATENATED MODULE: ./src/views/ui/Label.vue
function injectStyle (ssrContext) {
  __webpack_require__("Yhnh")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  Label_default.a,
  ui_Label,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var views_ui_Label = __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "lOnJ":
/***/ (function(module, exports) {

module.exports = function (it) {
  if (typeof it != 'function') throw TypeError(it + ' is not a function!');
  return it;
};


/***/ }),

/***/ "la1W":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/views/Swiper.vue
var Swiper = __webpack_require__("cr3o");
var Swiper_default = /*#__PURE__*/__webpack_require__.n(Swiper);

// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-614edef9","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/Swiper.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0,false,false)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"demo-swiper-panel"},[_c('div',{staticClass:"demo-title"},[_vm._v("默认情况")]),_vm._v(" "),_c('div',{staticClass:"bx-swiper bx-swiper-image"},[_c('div',{staticClass:"bx-swiper-scroller"},[_c('a',{staticClass:"bx-swiper-slide"},[_c('img',{staticClass:"img-responsive",attrs:{"src":"http://img.winbaoxian.com/learning/banner/2016/11/10/135336317.png@!banner"}})]),_vm._v(" "),_c('a',{staticClass:"bx-swiper-slide"},[_c('img',{staticClass:"img-responsive",attrs:{"src":"http://img.winbaoxian.com/learning/banner/2017/02/28/214011694.png@!banner"}})]),_vm._v(" "),_c('a',{staticClass:"bx-swiper-slide"},[_c('img',{staticClass:"img-responsive",attrs:{"src":"http://img.winbaoxian.com/learning/banner/2016/12/30/094713105.png@!banner"}})]),_vm._v(" "),_c('a',{staticClass:"bx-swiper-slide"},[_c('img',{staticClass:"img-responsive",attrs:{"src":"http://img.winbaoxian.com/learning/banner/2016/03/16/145053945.jpeg@!banner"}})])])])]),_vm._v(" "),_c('div',{staticClass:"demo-swiper-panel"},[_c('div',{staticClass:"demo-title"},[_vm._v("高度为宽度的30%")]),_vm._v(" "),_c('div',{staticClass:"bx-swiper bx-swiper-page"},[_c('div',{staticClass:"bx-swiper-scroller"},[_c('div',{staticClass:"bx-swiper-slide"},[_c('div',{staticStyle:{"height":"160px","background-color":"red","font-size":"60px","text-align":"center"}},[_vm._v("1")])]),_vm._v(" "),_c('div',{staticClass:"bx-swiper-slide"},[_c('div',{staticStyle:{"height":"170px","background-color":"green","font-size":"60px","text-align":"center"}},[_vm._v("2")])]),_vm._v(" "),_c('div',{staticClass:"bx-swiper-slide"},[_c('div',{staticStyle:{"height":"150px","background-color":"plum","font-size":"60px","text-align":"center"}},[_vm._v("3")])]),_vm._v(" "),_c('div',{staticClass:"bx-swiper-slide"},[_c('div',{staticStyle:{"height":"150px","background-color":"tomato","font-size":"60px","text-align":"center"}},[_vm._v("4")])])])])]),_vm._v(" "),_c('div',{staticClass:"demo-swiper-panel"},[_c('div',{staticClass:"demo-title"},[_vm._v("取消自动播放")]),_vm._v(" "),_c('div',{staticClass:"bx-swiper bx-swiper-color"},[_c('div',{staticClass:"bx-swiper-scroller"},[_c('a',{staticClass:"bx-swiper-slide"},[_c('img',{staticClass:"img-responsive",attrs:{"src":"http://img.winbaoxian.com/learning/banner/2016/11/10/135336317.png@!banner"}})]),_vm._v(" "),_c('div',{staticClass:"bx-swiper-slide"},[_c('div',{staticStyle:{"height":"160px","background-color":"red","font-size":"60px","text-align":"center"}},[_vm._v("1")])]),_vm._v(" "),_c('div',{staticClass:"bx-swiper-slide"},[_c('div',{staticStyle:{"height":"170px","background-color":"green","font-size":"60px","text-align":"center"}},[_vm._v("2")])]),_vm._v(" "),_c('div',{staticClass:"bx-swiper-slide"},[_c('div',{staticStyle:{"height":"150px","background-color":"plum","font-size":"60px","text-align":"center"}},[_vm._v("3")])])])])]),_vm._v(" "),_c('div',{staticClass:"demo-swiper-panel"},[_c('div',{staticClass:"demo-title"},[_vm._v("单项默认情况")]),_vm._v(" "),_c('div',{staticClass:"bx-swiper bx-swiper-single"},[_c('div',{staticClass:"bx-swiper-scroller"},[_c('a',{staticClass:"bx-swiper-slide"},[_c('img',{staticClass:"img-responsive",attrs:{"src":"http://img.winbaoxian.com/learning/banner/2016/11/10/135336317.png@!banner"}})])])])]),_vm._v(" "),_c('div',{staticClass:"demo-swiper-panel"},[_c('div',{staticClass:"demo-title"},[_vm._v("自定义分页器/指示器样式")]),_vm._v(" "),_c('div',{staticClass:"bx-swiper bx-swiper-custom"},[_c('div',{staticClass:"bx-swiper-scroller"},[_c('div',{staticClass:"bx-swiper-slide bx-swiper-slide--active"},[_c('div',{staticStyle:{"height":"160px","background-color":"red","font-size":"60px","text-align":"center"}},[_vm._v("1")])]),_vm._v(" "),_c('div',{staticClass:"bx-swiper-slide"},[_c('div',{staticStyle:{"height":"170px","background-color":"green","font-size":"60px","text-align":"center"}},[_vm._v("2")])]),_vm._v(" "),_c('div',{staticClass:"bx-swiper-slide"},[_c('div',{staticStyle:{"height":"150px","background-color":"plum","font-size":"60px","text-align":"center"}},[_vm._v("3")])]),_vm._v(" "),_c('div',{staticClass:"bx-swiper-slide"},[_c('div',{staticStyle:{"height":"150px","background-color":"tomato","font-size":"60px","text-align":"center"}},[_vm._v("4")])])])])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var views_Swiper = (esExports);
// CONCATENATED MODULE: ./src/views/Swiper.vue
function injectStyle (ssrContext) {
  __webpack_require__("jgQM")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  Swiper_default.a,
  views_Swiper,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var src_views_Swiper = __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "lktj":
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.14 / 15.2.3.14 Object.keys(O)
var $keys = __webpack_require__("Ibhu");
var enumBugKeys = __webpack_require__("xnc9");

module.exports = Object.keys || function keys(O) {
  return $keys(O, enumBugKeys);
};


/***/ }),

/***/ "m0yP":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

exports.default = {};
module.exports = exports["default"];

/***/ }),

/***/ "mAdt":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

exports.default = {};
module.exports = exports["default"];

/***/ }),

/***/ "mZY2":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "mqfF":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "mtWM":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__("tIFN");

/***/ }),

/***/ "mypn":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global, process) {(function (global, undefined) {
    "use strict";

    if (global.setImmediate) {
        return;
    }

    var nextHandle = 1; // Spec says greater than zero
    var tasksByHandle = {};
    var currentlyRunningATask = false;
    var doc = global.document;
    var registerImmediate;

    function setImmediate(callback) {
      // Callback can either be a function or a string
      if (typeof callback !== "function") {
        callback = new Function("" + callback);
      }
      // Copy function arguments
      var args = new Array(arguments.length - 1);
      for (var i = 0; i < args.length; i++) {
          args[i] = arguments[i + 1];
      }
      // Store and register the task
      var task = { callback: callback, args: args };
      tasksByHandle[nextHandle] = task;
      registerImmediate(nextHandle);
      return nextHandle++;
    }

    function clearImmediate(handle) {
        delete tasksByHandle[handle];
    }

    function run(task) {
        var callback = task.callback;
        var args = task.args;
        switch (args.length) {
        case 0:
            callback();
            break;
        case 1:
            callback(args[0]);
            break;
        case 2:
            callback(args[0], args[1]);
            break;
        case 3:
            callback(args[0], args[1], args[2]);
            break;
        default:
            callback.apply(undefined, args);
            break;
        }
    }

    function runIfPresent(handle) {
        // From the spec: "Wait until any invocations of this algorithm started before this one have completed."
        // So if we're currently running a task, we'll need to delay this invocation.
        if (currentlyRunningATask) {
            // Delay by doing a setTimeout. setImmediate was tried instead, but in Firefox 7 it generated a
            // "too much recursion" error.
            setTimeout(runIfPresent, 0, handle);
        } else {
            var task = tasksByHandle[handle];
            if (task) {
                currentlyRunningATask = true;
                try {
                    run(task);
                } finally {
                    clearImmediate(handle);
                    currentlyRunningATask = false;
                }
            }
        }
    }

    function installNextTickImplementation() {
        registerImmediate = function(handle) {
            process.nextTick(function () { runIfPresent(handle); });
        };
    }

    function canUsePostMessage() {
        // The test against `importScripts` prevents this implementation from being installed inside a web worker,
        // where `global.postMessage` means something completely different and can't be used for this purpose.
        if (global.postMessage && !global.importScripts) {
            var postMessageIsAsynchronous = true;
            var oldOnMessage = global.onmessage;
            global.onmessage = function() {
                postMessageIsAsynchronous = false;
            };
            global.postMessage("", "*");
            global.onmessage = oldOnMessage;
            return postMessageIsAsynchronous;
        }
    }

    function installPostMessageImplementation() {
        // Installs an event handler on `global` for the `message` event: see
        // * https://developer.mozilla.org/en/DOM/window.postMessage
        // * http://www.whatwg.org/specs/web-apps/current-work/multipage/comms.html#crossDocumentMessages

        var messagePrefix = "setImmediate$" + Math.random() + "$";
        var onGlobalMessage = function(event) {
            if (event.source === global &&
                typeof event.data === "string" &&
                event.data.indexOf(messagePrefix) === 0) {
                runIfPresent(+event.data.slice(messagePrefix.length));
            }
        };

        if (global.addEventListener) {
            global.addEventListener("message", onGlobalMessage, false);
        } else {
            global.attachEvent("onmessage", onGlobalMessage);
        }

        registerImmediate = function(handle) {
            global.postMessage(messagePrefix + handle, "*");
        };
    }

    function installMessageChannelImplementation() {
        var channel = new MessageChannel();
        channel.port1.onmessage = function(event) {
            var handle = event.data;
            runIfPresent(handle);
        };

        registerImmediate = function(handle) {
            channel.port2.postMessage(handle);
        };
    }

    function installReadyStateChangeImplementation() {
        var html = doc.documentElement;
        registerImmediate = function(handle) {
            // Create a <script> element; its readystatechange event will be fired asynchronously once it is inserted
            // into the document. Do so, thus queuing up the task. Remember to clean up once it's been called.
            var script = doc.createElement("script");
            script.onreadystatechange = function () {
                runIfPresent(handle);
                script.onreadystatechange = null;
                html.removeChild(script);
                script = null;
            };
            html.appendChild(script);
        };
    }

    function installSetTimeoutImplementation() {
        registerImmediate = function(handle) {
            setTimeout(runIfPresent, 0, handle);
        };
    }

    // If supported, we should attach to the prototype of global, since that is where setTimeout et al. live.
    var attachTo = Object.getPrototypeOf && Object.getPrototypeOf(global);
    attachTo = attachTo && attachTo.setTimeout ? attachTo : global;

    // Don't get fooled by e.g. browserify environments.
    if ({}.toString.call(global.process) === "[object process]") {
        // For Node.js before 0.9
        installNextTickImplementation();

    } else if (canUsePostMessage()) {
        // For non-IE10 modern browsers
        installPostMessageImplementation();

    } else if (global.MessageChannel) {
        // For web workers, where supported
        installMessageChannelImplementation();

    } else if (doc && "onreadystatechange" in doc.createElement("script")) {
        // For IE 6–8
        installReadyStateChangeImplementation();

    } else {
        // For older browsers
        installSetTimeoutImplementation();
    }

    attachTo.setImmediate = setImmediate;
    attachTo.clearImmediate = clearImmediate;
}(typeof self === "undefined" ? typeof global === "undefined" ? this : global : self));

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("DuR2"), __webpack_require__("W2nU")))

/***/ }),

/***/ "n0T6":
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.7 / 15.2.3.4 Object.getOwnPropertyNames(O)
var $keys = __webpack_require__("Ibhu");
var hiddenKeys = __webpack_require__("xnc9").concat('length', 'prototype');

exports.f = Object.getOwnPropertyNames || function getOwnPropertyNames(O) {
  return $keys(O, hiddenKeys);
};


/***/ }),

/***/ "oJlt":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__("cGG2");

// Headers whose duplicates are ignored by node
// c.f. https://nodejs.org/api/http.html#http_message_headers
var ignoreDuplicateOf = [
  'age', 'authorization', 'content-length', 'content-type', 'etag',
  'expires', 'from', 'host', 'if-modified-since', 'if-unmodified-since',
  'last-modified', 'location', 'max-forwards', 'proxy-authorization',
  'referer', 'retry-after', 'user-agent'
];

/**
 * Parse headers into an object
 *
 * ```
 * Date: Wed, 27 Aug 2014 08:58:49 GMT
 * Content-Type: application/json
 * Connection: keep-alive
 * Transfer-Encoding: chunked
 * ```
 *
 * @param {String} headers Headers needing to be parsed
 * @returns {Object} Headers parsed into an object
 */
module.exports = function parseHeaders(headers) {
  var parsed = {};
  var key;
  var val;
  var i;

  if (!headers) { return parsed; }

  utils.forEach(headers.split('\n'), function parser(line) {
    i = line.indexOf(':');
    key = utils.trim(line.substr(0, i)).toLowerCase();
    val = utils.trim(line.substr(i + 1));

    if (key) {
      if (parsed[key] && ignoreDuplicateOf.indexOf(key) >= 0) {
        return;
      }
      if (key === 'set-cookie') {
        parsed[key] = (parsed[key] ? parsed[key] : []).concat([val]);
      } else {
        parsed[key] = parsed[key] ? parsed[key] + ', ' + val : val;
      }
    }
  });

  return parsed;
};


/***/ }),

/***/ "oyy5":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "p1b6":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__("cGG2");

module.exports = (
  utils.isStandardBrowserEnv() ?

  // Standard browser envs support document.cookie
  (function standardBrowserEnv() {
    return {
      write: function write(name, value, expires, path, domain, secure) {
        var cookie = [];
        cookie.push(name + '=' + encodeURIComponent(value));

        if (utils.isNumber(expires)) {
          cookie.push('expires=' + new Date(expires).toGMTString());
        }

        if (utils.isString(path)) {
          cookie.push('path=' + path);
        }

        if (utils.isString(domain)) {
          cookie.push('domain=' + domain);
        }

        if (secure === true) {
          cookie.push('secure');
        }

        document.cookie = cookie.join('; ');
      },

      read: function read(name) {
        var match = document.cookie.match(new RegExp('(^|;\\s*)(' + name + ')=([^;]*)'));
        return (match ? decodeURIComponent(match[3]) : null);
      },

      remove: function remove(name) {
        this.write(name, '', Date.now() - 86400000);
      }
    };
  })() :

  // Non standard browser env (web workers, react-native) lack needed support.
  (function nonStandardBrowserEnv() {
    return {
      write: function write() {},
      read: function read() { return null; },
      remove: function remove() {}
    };
  })()
);


/***/ }),

/***/ "p6gR":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "pBtG":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function isCancel(value) {
  return !!(value && value.__CANCEL__);
};


/***/ }),

/***/ "phXb":
/***/ (function(module, exports) {

module.exports = "<div class=\"bx-modal-panel bx-modal-sms\">\n  <div class=\"bx-modal-overlay\"></div>\n  <div class=\"bx-modal\">\n    <div class=\"bx-modal-body\">\n      <div class=\"bx-modal-inner\">\n        <div class=\"bx-modal-title\">短信验证码</div>\n        <div class=\"bx-modal-content\">\n          <div class=\"bx-sms-panel\">\n            <div class=\"bx-sms-form\">\n              <input class=\"bx-sms-input\" type=\"text\" placeholder=\"请输入短信验证码\"/>\n            </div>\n            <a class=\"bx-sms-btn js-btn-sms\">获取验证码</a>\n            <a class=\"bx-sms-btn bx-sms-btn--disable\">重新获取(<span class=\"bx-sms-count\">5</span>s)</a>\n          </div>\n        </div>\n      </div>\n    </div>\n    <div class=\"bx-modal-footer\">\n      <div class=\"bx-modal-buttons\">\n        <a class=\"bx-modal-btn js-btn-cancel\">取消</a>\n        <a class=\"bx-modal-btn bx-modal-link js-btn-submit\">提交</a>\n      </div>\n    </div>\n  </div>\n</div>\n";

/***/ }),

/***/ "pxG4":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Syntactic sugar for invoking a function and expanding an array for arguments.
 *
 * Common use case would be to use `Function.prototype.apply`.
 *
 *  ```js
 *  function f(x, y, z) {}
 *  var args = [1, 2, 3];
 *  f.apply(null, args);
 *  ```
 *
 * With `spread` this example can be re-written.
 *
 *  ```js
 *  spread(function(x, y, z) {})([1, 2, 3]);
 *  ```
 *
 * @param {Function} callback
 * @returns {Function}
 */
module.exports = function spread(callback) {
  return function wrap(arr) {
    return callback.apply(null, arr);
  };
};


/***/ }),

/***/ "qRfI":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Creates a new URL by combining the specified URLs
 *
 * @param {string} baseURL The base URL
 * @param {string} relativeURL The relative URL
 * @returns {string} The combined URL
 */
module.exports = function combineURLs(baseURL, relativeURL) {
  return relativeURL
    ? baseURL.replace(/\/+$/, '') + '/' + relativeURL.replace(/^\/+/, '')
    : baseURL;
};


/***/ }),

/***/ "qio6":
/***/ (function(module, exports, __webpack_require__) {

var dP = __webpack_require__("evD5");
var anObject = __webpack_require__("77Pl");
var getKeys = __webpack_require__("lktj");

module.exports = __webpack_require__("+E39") ? Object.defineProperties : function defineProperties(O, Properties) {
  anObject(O);
  var keys = getKeys(Properties);
  var length = keys.length;
  var i = 0;
  var P;
  while (length > i) dP.f(O, P = keys[i++], Properties[P]);
  return O;
};


/***/ }),

/***/ "t8qj":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Update an Error with the specified config, error code, and response.
 *
 * @param {Error} error The error to update.
 * @param {Object} config The config.
 * @param {string} [code] The error code (for example, 'ECONNABORTED').
 * @param {Object} [request] The request.
 * @param {Object} [response] The response.
 * @returns {Error} The error.
 */
module.exports = function enhanceError(error, config, code, request, response) {
  error.config = config;
  if (code) {
    error.code = code;
  }
  error.request = request;
  error.response = response;
  return error;
};


/***/ }),

/***/ "tIFN":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__("cGG2");
var bind = __webpack_require__("JP+z");
var Axios = __webpack_require__("XmWM");
var defaults = __webpack_require__("KCLY");

/**
 * Create an instance of Axios
 *
 * @param {Object} defaultConfig The default config for the instance
 * @return {Axios} A new instance of Axios
 */
function createInstance(defaultConfig) {
  var context = new Axios(defaultConfig);
  var instance = bind(Axios.prototype.request, context);

  // Copy axios.prototype to instance
  utils.extend(instance, Axios.prototype, context);

  // Copy context to instance
  utils.extend(instance, context);

  return instance;
}

// Create the default instance to be exported
var axios = createInstance(defaults);

// Expose Axios class to allow class inheritance
axios.Axios = Axios;

// Factory for creating new instances
axios.create = function create(instanceConfig) {
  return createInstance(utils.merge(defaults, instanceConfig));
};

// Expose Cancel & CancelToken
axios.Cancel = __webpack_require__("dVOP");
axios.CancelToken = __webpack_require__("cWxy");
axios.isCancel = __webpack_require__("pBtG");

// Expose all/spread
axios.all = function all(promises) {
  return Promise.all(promises);
};
axios.spread = __webpack_require__("pxG4");

module.exports = axios;

// Allow use of default import syntax in TypeScript
module.exports.default = axios;


/***/ }),

/***/ "tcli":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
//
//
//
//
//
//

exports.default = {
  name: 'UI'
};
module.exports = exports['default'];

/***/ }),

/***/ "thJu":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// btoa polyfill for IE<10 courtesy https://github.com/davidchambers/Base64.js

var chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=';

function E() {
  this.message = 'String contains an invalid character';
}
E.prototype = new Error;
E.prototype.code = 5;
E.prototype.name = 'InvalidCharacterError';

function btoa(input) {
  var str = String(input);
  var output = '';
  for (
    // initialize result and counter
    var block, charCode, idx = 0, map = chars;
    // if the next str index does not exist:
    //   change the mapping table to "="
    //   check if d has no fractional digits
    str.charAt(idx | 0) || (map = '=', idx % 1);
    // "8 - idx % 1 * 8" generates the sequence 2, 4, 6, 8
    output += map.charAt(63 & block >> 8 - idx % 1 * 8)
  ) {
    charCode = str.charCodeAt(idx += 3 / 4);
    if (charCode > 0xFF) {
      throw new E();
    }
    block = block << 8 | charCode;
  }
  return output;
}

module.exports = btoa;


/***/ }),

/***/ "vFc/":
/***/ (function(module, exports, __webpack_require__) {

// false -> Array#indexOf
// true  -> Array#includes
var toIObject = __webpack_require__("TcQ7");
var toLength = __webpack_require__("QRG4");
var toAbsoluteIndex = __webpack_require__("fkB2");
module.exports = function (IS_INCLUDES) {
  return function ($this, el, fromIndex) {
    var O = toIObject($this);
    var length = toLength(O.length);
    var index = toAbsoluteIndex(fromIndex, length);
    var value;
    // Array#includes uses SameValueZero equality algorithm
    // eslint-disable-next-line no-self-compare
    if (IS_INCLUDES && el != el) while (length > index) {
      value = O[index++];
      // eslint-disable-next-line no-self-compare
      if (value != value) return true;
    // Array#indexOf ignores holes, Array#includes - not
    } else for (;length > index; index++) if (IS_INCLUDES || index in O) {
      if (O[index] === el) return IS_INCLUDES || index || 0;
    } return !IS_INCLUDES && -1;
  };
};


/***/ }),

/***/ "wCRF":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "wDn8":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

exports.default = {};
module.exports = exports["default"];

/***/ }),

/***/ "x/Va":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/views/MessageBox.vue
var MessageBox = __webpack_require__("2ds3");
var MessageBox_default = /*#__PURE__*/__webpack_require__.n(MessageBox);

// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-44350928","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/MessageBox.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"demo-panel"},[_c('div',{staticClass:"demo-title"},[_vm._v("短信验证码")]),_vm._v(" "),_c('div',{staticClass:"demo-content"},[_c('div',{staticClass:"bx-btn",on:{"click":function($event){_vm.showSMS()}}},[_vm._v("显示短信验证码")])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var views_MessageBox = (esExports);
// CONCATENATED MODULE: ./src/views/MessageBox.vue
function injectStyle (ssrContext) {
  __webpack_require__("HJES")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-44350928"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  MessageBox_default.a,
  views_MessageBox,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var src_views_MessageBox = __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "xJD8":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
//
//
//
//
//
//

exports.default = {
  name: 'app'
};
module.exports = exports['default'];

/***/ }),

/***/ "xLtR":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__("cGG2");
var transformData = __webpack_require__("TNV1");
var isCancel = __webpack_require__("pBtG");
var defaults = __webpack_require__("KCLY");
var isAbsoluteURL = __webpack_require__("dIwP");
var combineURLs = __webpack_require__("qRfI");

/**
 * Throws a `Cancel` if cancellation has been requested.
 */
function throwIfCancellationRequested(config) {
  if (config.cancelToken) {
    config.cancelToken.throwIfRequested();
  }
}

/**
 * Dispatch a request to the server using the configured adapter.
 *
 * @param {object} config The config that is to be used for the request
 * @returns {Promise} The Promise to be fulfilled
 */
module.exports = function dispatchRequest(config) {
  throwIfCancellationRequested(config);

  // Support baseURL config
  if (config.baseURL && !isAbsoluteURL(config.url)) {
    config.url = combineURLs(config.baseURL, config.url);
  }

  // Ensure headers exist
  config.headers = config.headers || {};

  // Transform request data
  config.data = transformData(
    config.data,
    config.headers,
    config.transformRequest
  );

  // Flatten headers
  config.headers = utils.merge(
    config.headers.common || {},
    config.headers[config.method] || {},
    config.headers || {}
  );

  utils.forEach(
    ['delete', 'get', 'head', 'post', 'put', 'patch', 'common'],
    function cleanHeaderConfig(method) {
      delete config.headers[method];
    }
  );

  var adapter = config.adapter || defaults.adapter;

  return adapter(config).then(function onAdapterResolution(response) {
    throwIfCancellationRequested(config);

    // Transform response data
    response.data = transformData(
      response.data,
      response.headers,
      config.transformResponse
    );

    return response;
  }, function onAdapterRejection(reason) {
    if (!isCancel(reason)) {
      throwIfCancellationRequested(config);

      // Transform response data
      if (reason && reason.response) {
        reason.response.data = transformData(
          reason.response.data,
          reason.response.headers,
          config.transformResponse
        );
      }
    }

    return Promise.reject(reason);
  });
};


/***/ }),

/***/ "xew0":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _audioplayer = __webpack_require__("es6P");

var _audioplayer2 = _interopRequireDefault(_audioplayer);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  data: function data() {
    return {
      audioArr: [{ 'url': 'http://media.winbaoxian.com/learning/audio/2016/04/20/212402430.mp3' }]
    };
  },

  mounted: function mounted() {
    var self = this;
    self.$nextTick(function () {
      var elements = document.querySelectorAll('.audioplayer');
      for (var i = 0; i < elements.length; i++) {
        // eslint-disable-next-line
        new _audioplayer2.default(elements[i], {
          index: i,
          autoplay: true
        });
      }
    });
  }
}; //
//
//
//
//
//
//
//
//
//
//

module.exports = exports['default'];

/***/ }),

/***/ "xnc9":
/***/ (function(module, exports) {

// IE 8- don't enum bug keys
module.exports = (
  'constructor,hasOwnProperty,isPrototypeOf,propertyIsEnumerable,toLocaleString,toString,valueOf'
).split(',');


/***/ }),

/***/ "zGTM":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "zqqR":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ })

/******/ });


// WEBPACK FOOTER //
// static/js/app.831a6488a063f7782065.js